/* eslint-disable */
// Transcrit par esbuild depuis packages/reasoner/src/kernel-{ode,integral,partial,riemann}.ts (moteur gelé) : ne pas modifier à la main.
var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name2 in all) __defProp(target, name2, { get: all[name2], enumerable: true });
};

// packages/reasoner/src/lexer.ts
var BIN = { '+': 1, '\u2212': 1, '\xD7': 1, '\xF7': 1, '^': 1, parmi: 1 };
var PARMI = 'parmi';
var FUNCS = {
  ln: 1,
  exp: 1,
  cos: 1,
  sin: 1,
  tan: 1,
  arg: 1,
  // moteur v17 : fonctions réciproques, en degrés (collège : B = arccos(0,8) ≈ 37°)
  arccos: 1,
  arcsin: 1,
  arctan: 1,
  // moteur v45 : logarithme décimal (log(1000) = 3)
  log: 1,
};
var CONSTS = { π: Math.PI };
var CMP = { '>': 1, '<': 1, '\u2265': 1, '\u2264': 1, '\u2248': 1 };
function isCmp(a) {
  return a !== void 0 && CMP[a] === 1;
}
var LOWER_CMP = { '<': true, '\u2264': true, '>': false, '\u2265': false };
function isFunc(a) {
  return !!a && FUNCS[a] === 1;
}
function isConst(a) {
  return !!a && CONSTS[a] !== void 0;
}
var LETTER =
  'A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0391-\u03A9\u03B1-\u03C9\u2113\u0108\u011C\u0124\u0134\u015C\u0174\u0176';
var SUB = '\u2080-\u209C';
var SUP = '\u2070\xB9\xB2\xB3\u2074-\u2079\u207A\u207B\u207F';
var RE_LETTER = new RegExp('[' + LETTER + ']');
var RE_WORD = new RegExp('^[' + LETTER + '][' + LETTER + SUB + '\\u0302\\u0304]*');
var RE_SUP = new RegExp('^[' + SUP + ']+');
var RE_POW = new RegExp('^\\d+[' + SUP + ']+$');
function isMod(a) {
  return /^\[\d+\]$/.test(a || '');
}
function modValue(a) {
  return Number(a.slice(1, -1));
}
function isNum(a) {
  return /^\d+(?:,\d+)?$/.test(a || '');
}
function isVar(a) {
  return (
    RE_LETTER.test((a || '')[0] || '') && a !== 'ou' && a !== PARMI && !isFunc(a) && !isConst(a)
  );
}
function isPow(a) {
  return RE_POW.test(a || '');
}
var SUP_DIGITS = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
function isSupPow(a) {
  return !!a && a !== '\xB2' && [...a].every((c) => SUP_DIGITS.includes(c));
}
function supPowValue(a) {
  return Number([...a].map((c) => String(SUP_DIGITS.indexOf(c))).join(''));
}
function isOperand(a) {
  return isNum(a) || isVar(a) || isPow(a) || isConst(a);
}
var RE_COMPOUND = new RegExp(
  "^(card|[A-Za-z\u03B1-\u03C9\u0391-\u03A9]{1,2})([\u2032'\u2019]{0,2}|\u2033)(_[A-Za-z\u0100-\u017F][\\u0300-\\u036F]?[\u2080-\u2089]*)?\\(\\s*(\u2212|-)?([A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u017F\u03B1-\u03C9\u0391-\u03A9\\u0300-\\u036F0-9\u2080-\u2089\u2229\u222A\xD7|,;\\s]+?)\\s*\\)",
);
function compoundAt(s) {
  const m = RE_COMPOUND.exec(s);
  if (!m) return null;
  const base = m[1];
  if (isFunc(base) || base === 'ou') return null;
  const inner2 = m[5].replace(/\s+/g, '');
  if (!inner2) return null;
  const prime = '\u2032'.repeat(m[2] === '\u2033' ? 2 : (m[2] ?? '').length);
  const sub4 = m[3] ?? '';
  const minus = m[4] ? '\u2212' : '';
  return { atom: `${base}${prime}${sub4}(${minus}${inner2})`, len: m[0].length };
}
function formatNumber(v) {
  if (!isFinite(v)) return '?';
  const av = Math.abs(v);
  if (av >= 1e-9 && av < 1e-4) {
    const digits = Math.min(20, Math.ceil(-Math.log10(av)) + 9);
    const small = Number(av.toPrecision(10)).toFixed(digits).replace(/0+$/, '').replace('.', ',');
    return (v < 0 ? '\u2212' : '') + small;
  }
  const r = Math.round(v * 1e6) / 1e6;
  const neg4 = r < 0;
  const a = Math.abs(r);
  let s = Number.isInteger(a) ? String(a) : String(Number(a.toFixed(6)));
  s = s.replace('.', ',');
  return (neg4 ? '\u2212' : '') + s;
}
function canonNumber(s) {
  const m = /^(\d+)(?:[.,](\d+))?$/.exec(String(s));
  if (m) {
    const int = m[1].replace(/^0+(?=\d)/, '');
    const frac = (m[2] ?? '').replace(/0+$/, '');
    return frac ? `${int},${frac}` : int;
  }
  const n = Number(String(s).replace(',', '.'));
  if (!isFinite(n)) return String(s);
  return formatNumber(n);
}
function lex(str) {
  const out = [];
  let i = 0;
  const s = String(str);
  while (i < s.length) {
    const c = s[i];
    if (/\s/.test(c)) {
      i++;
      continue;
    }
    if (/\d/.test(c)) {
      const m = /^\d+(?:[.,]\d+)?/.exec(s.slice(i));
      i += m[0].length;
      const sup = RE_SUP.exec(s.slice(i));
      if (sup && sup[0] !== '\xB2' && /^\d+$/.test(m[0])) {
        out.push(m[0] + sup[0]);
        i += sup[0].length;
      } else {
        out.push(canonNumber(m[0]));
      }
      continue;
    }
    if (RE_LETTER.test(c)) {
      const rest = s.slice(i);
      if (c === 'e' && s[i + 1] === '^' && !RE_LETTER.test(s[i - 1] ?? '')) {
        out.push('exp');
        i += 2;
        continue;
      }
      const comp = compoundAt(rest);
      if (comp) {
        out.push(comp.atom);
        i += comp.len;
        continue;
      }
      const w = RE_WORD.exec(rest)[0];
      const fn2 = Object.keys(FUNCS).find(
        (f) => w.length === f.length + 1 && w.startsWith(f) && /[xtθ]$/.test(w),
      );
      if (fn2 && !RE_LETTER.test(s[i - 1] ?? '')) {
        out.push(fn2);
        i += fn2.length;
        continue;
      }
      const pi = w.indexOf('\u03C0');
      if (pi >= 0 && w.length > 1) {
        const head = pi === 0 ? '\u03C0' : w.slice(0, pi);
        out.push(head);
        i += head.length;
        continue;
      }
      out.push(w);
      i += w.length;
      continue;
    }
    if (c === '-' || c === '\u2212') {
      out.push('\u2212');
      i++;
      continue;
    }
    if (c === '*' || c === '\xD7') {
      out.push('\xD7');
      i++;
      continue;
    }
    if (c === '/' || c === '\xF7') {
      out.push('\xF7');
      i++;
      continue;
    }
    if (c === '^' && s[i + 1] === '2' && !/[\d.,]/.test(s[i + 2] ?? '')) {
      out.push('\xB2');
      i += 2;
      continue;
    }
    if (c === '^') {
      out.push('^');
      i++;
      continue;
    }
    if (c === '[') {
      const m = /^\[\s*(\d+)\s*\]/.exec(s.slice(i));
      if (m) {
        out.push('[' + m[1] + ']');
        i += m[0].length;
        continue;
      }
    }
    if (c === '\u2261') {
      out.push('\u2261');
      i++;
      continue;
    }
    if (c === '|') {
      out.push('|');
      i++;
      continue;
    }
    if (c === '\u2248' || c === '\u2243' || (c === '~' && s[i + 1] === '=')) {
      out.push('\u2248');
      i += c === '~' ? 2 : 1;
      continue;
    }
    if (c === '>' || c === '<' || c === '\u2265' || c === '\u2264') {
      if ((c === '>' || c === '<') && s[i + 1] === '=') {
        out.push(c === '>' ? '\u2265' : '\u2264');
        i += 2;
      } else {
        out.push(c);
        i++;
      }
      continue;
    }
    if (c === '!') {
      out.push('!');
      i++;
      continue;
    }
    if (c === '\xB0') {
      out.push('\xB0');
      i++;
      continue;
    }
    if (SUP_DIGITS.includes(c)) {
      const p = out[out.length - 1];
      const run = /^[⁰¹²³⁴⁵⁶⁷⁸⁹]+/.exec(s.slice(i))[0];
      if (p !== void 0 && (p === ')' || isVar(p) || isConst(p) || isNum(p)) && run !== '\xB2') {
        out.push(run);
        i += run.length;
        continue;
      }
    }
    if ('+=()\xB2\u221A%'.indexOf(c) >= 0) {
      out.push(c);
      i++;
      continue;
    }
    if ('\u2070\xB9\xB3\u2074\u2075\u2076\u2077\u2078\u2079\u207B'.indexOf(c) >= 0) {
      out.push(c);
      i++;
      continue;
    }
    i++;
  }
  return out;
}
function endsOperand(a) {
  return (
    isOperand(a) ||
    a === ')' ||
    a === '\xB2' ||
    isSupPow(a) ||
    a === '%' ||
    a === '\xB0' ||
    a === '!'
  );
}
function startsOperandImplicit(a) {
  return isVar(a) || isConst(a) || isFunc(a) || a === '(' || a === '\u221A';
}
function normalizeChips(chips) {
  const atoms = [];
  const src = [];
  let barOpen = false;
  let prevClosingBar = false;
  chips.forEach((chip, ci) => {
    chip.atoms.forEach((a) => {
      const prev = atoms[atoms.length - 1];
      const prevEnds = prev !== void 0 && (endsOperand(prev) || prevClosingBar);
      const opensBar = a === '|' && !barOpen;
      if (prevEnds && (startsOperandImplicit(a) || opensBar)) {
        atoms.push('\xD7');
        src.push(ci);
      }
      prevClosingBar = a === '|' && barOpen;
      if (a === '|') barOpen = !barOpen;
      atoms.push(a);
      src.push(ci);
    });
  });
  return { atoms, src };
}
function normalize(atoms) {
  return normalizeChips([{ atoms }]).atoms;
}
function checkSyntax(atoms, opts) {
  const chains = !!opts?.chains;
  let expect = true;
  let depth = 0;
  let seenEq = false;
  let cong = false;
  let modded = false;
  let cmp2 = false;
  let lastCmp = '';
  let bars = 0;
  const err = (index, msg) => ({ ok: false, index, msg });
  for (let i = 0; i < atoms.length; i++) {
    const a = atoms[i];
    if (expect) {
      if (isOperand(a)) {
        expect = false;
        continue;
      }
      if (a === '(') {
        depth++;
        continue;
      }
      if (a === '\u221A' || isFunc(a)) continue;
      if (a === '|') {
        bars++;
        continue;
      }
      if (a === '\u2212' || a === '+') {
        const p = atoms[i - 1];
        if (p === '\u2212' || p === '+')
          return err(i, 'Deux signes \xE0 la suite : il manque un nombre entre les deux.');
        continue;
      }
      if (a === '=' || a === '\u2261' || isCmp(a))
        return err(
          i,
          i === 0
            ? 'Une ligne ne commence pas par \xAB ' + a + ' \xBB.'
            : 'Il manque un nombre ou une lettre avant \xAB ' + a + ' \xBB.',
        );
      if (isMod(a))
        return err(
          i,
          '\xAB ' +
            a +
            ' \xBB se place \xE0 la fin d\u2019une congruence, apr\xE8s un nombre ou une lettre.',
        );
      if (BIN[a])
        return err(i, 'Deux op\xE9rations \xE0 la suite : il manque un nombre entre les deux.');
      if (a === ')')
        return err(i, 'Parenth\xE8se ferm\xE9e trop t\xF4t : il manque quelque chose dedans.');
      if (a === '\xB2' || isSupPow(a) || a === '%' || a === '\xB0' || a === '!')
        return err(
          i,
          '\xAB ' + a + ' \xBB se place juste apr\xE8s un nombre, une lettre ou une parenth\xE8se.',
        );
      if (a === 'ou') return err(i, '\xAB ou \xBB relie deux \xE9galit\xE9s compl\xE8tes.');
      return err(i, 'Ce bout ne peut pas venir ici.');
    }
    if (modded && a !== 'ou')
      return err(
        i,
        'Le modulo \xAB ' + atoms[i - 1] + ' \xBB termine la congruence : rien ne vient apr\xE8s.',
      );
    if (BIN[a]) {
      expect = true;
      continue;
    }
    if (a === '|' && bars > 0) {
      bars--;
      continue;
    }
    if (isCmp(a)) {
      if (depth > 0) return err(i, 'Ferme la parenth\xE8se avant \xAB ' + a + ' \xBB.');
      if (chains && cmp2 && a !== '\u2248') {
        if (LOWER_CMP[a] !== LOWER_CMP[lastCmp])
          return err(
            i,
            'Une cha\xEEne de comparaisons va dans un seul sens : \xAB a < x < b \xBB.',
          );
        lastCmp = a;
        expect = true;
        continue;
      }
      if (seenEq || cmp2)
        return err(
          i,
          chains
            ? 'Une comparaison relie deux membres : pas de \xAB = \xBB en plus.'
            : 'Une comparaison relie deux membres : une seule par ligne, sans \xAB = \xBB.',
        );
      lastCmp = a;
      cmp2 = true;
      seenEq = true;
      expect = true;
      continue;
    }
    if (a === '=' || a === '\u2261') {
      if (depth > 0) return err(i, 'Ferme la parenth\xE8se avant \xAB ' + a + ' \xBB.');
      if (cmp2) return err(i, 'Une comparaison relie deux membres : pas de \xAB = \xBB en plus.');
      seenEq = true;
      if (a === '\u2261') cong = true;
      expect = true;
      continue;
    }
    if (isMod(a)) {
      if (depth > 0) return err(i, 'Ferme la parenth\xE8se avant le modulo \xAB ' + a + ' \xBB.');
      if (!cong)
        return err(
          i,
          'Le modulo \xAB ' +
            a +
            ' \xBB suit une congruence : \xE9cris d\u2019abord \xAB \u2261 \xBB.',
        );
      modded = true;
      continue;
    }
    if (a === ')') {
      if (depth === 0)
        return err(i, 'Cette parenth\xE8se fermante n\u2019a pas de parenth\xE8se ouvrante.');
      depth--;
      continue;
    }
    if (a === '\xB2' || isSupPow(a) || a === '%' || a === '\xB0' || a === '!') continue;
    if (a === 'ou') {
      if (depth > 0) return err(i, 'Ferme la parenth\xE8se avant \xAB ou \xBB.');
      if (!seenEq)
        return err(i, '\xC9cris d\u2019abord une \xE9galit\xE9 compl\xE8te avant \xAB ou \xBB.');
      if (cong && !modded)
        return err(i, 'Termine la congruence par son modulo (\xAB [7] \xBB) avant \xAB ou \xBB.');
      seenEq = false;
      cong = false;
      modded = false;
      cmp2 = false;
      expect = true;
      continue;
    }
    if (isNum(a) || isPow(a))
      return err(i, 'Deux nombres coll\xE9s : ajoute une op\xE9ration entre les deux.');
    return err(i, 'Ce bout ne peut pas venir ici.');
  }
  return {
    ok: true,
    complete: !expect && depth === 0 && bars === 0 && (!cong || modded),
    hasEq: seenEq,
  };
}

// packages/reasoner/src/tree.ts
function num(v) {
  return { k: 'n', v };
}
function sym(n) {
  return { k: 's', n };
}
function nary(k, c) {
  let out = [];
  c.forEach((x) => {
    if (x.k === k) out = out.concat(x.c);
    else out.push(x);
  });
  return out.length === 1 ? out[0] : { k, c: out };
}
function neg(a) {
  if (a.k === 'n') return num(-a.v);
  if (a.k === 'neg') return a.a;
  return { k: 'neg', a };
}
function un(k, a) {
  return { k, a };
}
function bin(k, a, b) {
  return { k, a, b };
}
function dv(a, b) {
  return bin('div', a, b);
}
function pw(a, b) {
  return bin('pow', a, b);
}
var SUPMAP = {
  '\u2070': '0',
  '\xB9': '1',
  '\xB2': '2',
  '\xB3': '3',
  '\u2074': '4',
  '\u2075': '5',
  '\u2076': '6',
  '\u2077': '7',
  '\u2078': '8',
  '\u2079': '9',
  '\u207A': '+',
  '\u207B': '\u2212',
  ⁿ: 'n',
};
var SUPINV = {};
Object.keys(SUPMAP).forEach((k) => {
  SUPINV[SUPMAP[k]] = k;
});
function splitAt(atoms, sep) {
  const parts = [[]];
  let depth = 0;
  atoms.forEach((a) => {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth === 0 && a === sep) parts.push([]);
    else parts[parts.length - 1].push(a);
  });
  return parts;
}
function parsePow(a) {
  const m = /^(\d+)(.+)$/.exec(a);
  const exp = m[2]
    .split('')
    .map((c) => SUPMAP[c] || '')
    .join('');
  return pw(num(Number(m[1])), parseExpr(normalize(lex(exp))));
}
function parseExpr(atoms) {
  let pos = 0;
  const peek = () => atoms[pos];
  const next = () => atoms[pos++];
  function sum() {
    const terms = [term()];
    while (peek() === '+' || peek() === '\u2212') {
      const op = next();
      const t2 = term();
      terms.push(op === '\u2212' ? neg(t2) : t2);
    }
    return nary('add', terms);
  }
  function term() {
    let node = parmi();
    while (peek() === '\xD7' || peek() === '\xF7') {
      const op = next();
      const r = parmi();
      node = op === '\xD7' ? nary('mul', [node, r]) : dv(node, r);
    }
    return node;
  }
  function parmi() {
    let node = unary();
    while (peek() === 'parmi') {
      next();
      node = bin('binom', node, unary());
    }
    return node;
  }
  function unary() {
    if (peek() === '\u2212') {
      next();
      return neg(unary());
    }
    if (peek() === '+') {
      next();
      return unary();
    }
    return postfix();
  }
  function postfix() {
    let n = primary();
    for (;;) {
      if (peek() === '\xB2' || peek() === '%') n = un(next() === '\xB2' ? 'sq' : 'pct', n);
      else if (peek() === '\xB0') {
        next();
        n = un('deg', n);
      } else if (peek() === '!') {
        next();
        n = un('fact', n);
      } else if (peek() === '^') {
        next();
        n = pw(n, unary());
      } else if (isSupPow(peek())) {
        n = pw(n, num(supPowValue(next())));
      } else break;
    }
    return n;
  }
  function primary() {
    const a = next();
    if (a === void 0) throw new Error('fin');
    if (isPow(a)) return parsePow(a);
    if (isNum(a)) return num(Number(a.replace(',', '.')));
    if (isVar(a) || isConst(a)) return sym(a);
    if (isFunc(a)) {
      if (peek() === '\u2212') {
        next();
        return un(a, neg(primary()));
      }
      return un(a, primary());
    }
    if (a === '(') {
      const n = sum();
      if (next() !== ')') throw new Error('parenth\xE8se');
      return n;
    }
    if (a === '\u221A') return un('sqrt', postfix());
    if (a === '|') {
      const n = sum();
      if (next() !== '|') throw new Error('barre');
      return un('abs', n);
    }
    throw new Error('inattendu');
  }
  const t = sum();
  if (pos !== atoms.length) throw new Error('reste');
  return t;
}
function parseLine(atoms, opts) {
  return { dis: splitAt(atoms, 'ou').map((d2) => parseEq(d2, !!opts?.chains)) };
}
var LOWER = { '<': 1, '\u2264': 1 };
var UPPER = { '>': 1, '\u2265': 1 };
function parseEq(d2, chains = false) {
  const last = d2[d2.length - 1];
  const mod = last !== void 0 && isMod(last) ? modValue(last) : void 0;
  const body = mod === void 0 ? d2 : d2.slice(0, -1);
  const ci = topIndex(body, isCmp);
  if (ci >= 0) {
    if (mod !== void 0 || body.indexOf('=') >= 0 || body.indexOf('\u2261') >= 0)
      throw new Error('comparaison m\xEAl\xE9e \xE0 une \xE9galit\xE9');
    if (topIndex(body.slice(ci + 1), isCmp) >= 0) {
      if (!chains) throw new Error('deux comparaisons');
      return parseChain(body);
    }
    return {
      sides: [parseExpr(body.slice(0, ci)), parseExpr(body.slice(ci + 1))],
      cmp: body[ci],
    };
  }
  if (mod === void 0 && body.indexOf('\u2261') < 0)
    return { sides: splitAt(body, '=').map(parseExpr) };
  const sides = [[]];
  const rels = [];
  let depth = 0;
  body.forEach((a) => {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth === 0 && (a === '=' || a === '\u2261')) {
      rels.push(a);
      sides.push([]);
    } else sides[sides.length - 1].push(a);
  });
  const eq2 = { sides: sides.map(parseExpr), rels };
  if (mod !== void 0) eq2.mod = mod;
  return eq2;
}
function parseChain(body) {
  const sides = [[]];
  const chain = [];
  let depth = 0;
  body.forEach((a) => {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth === 0 && isCmp(a)) {
      if (a === '\u2248') throw new Error('\xAB \u2248 \xBB dans une cha\xEEne');
      chain.push(a);
      sides.push([]);
    } else sides[sides.length - 1].push(a);
  });
  const lower = chain.every((r) => LOWER[r]);
  const upper = chain.every((r) => UPPER[r]);
  if (!lower && !upper) throw new Error('cha\xEEne dans les deux sens');
  return { sides: sides.map(parseExpr), chain };
}
function topIndex(atoms, test) {
  let depth = 0;
  for (let i = 0; i < atoms.length; i++) {
    const a = atoms[i];
    if (a === '(') depth++;
    else if (a === ')') depth--;
    else if (depth === 0 && test(a)) return i;
  }
  return -1;
}
function parseText(text) {
  return parseLine(normalize(lex(text)), { chains: true });
}
function atomsText(atoms) {
  let out = '';
  let barOpen = false;
  let prevOpeningBar = false;
  atoms.forEach((a, i) => {
    const p = atoms[i - 1];
    const pp = atoms[i - 2];
    if (a === '\xF7') {
      out += '/';
      prevOpeningBar = false;
      return;
    }
    const closingBar = a === '|' && barOpen;
    if (i && (prevOpeningBar || closingBar)) {
      out += a;
      prevOpeningBar = false;
      if (a === '|') barOpen = !barOpen;
      return;
    }
    prevOpeningBar = a === '|' && !barOpen;
    if (a === '|') barOpen = !barOpen;
    if (i) {
      if (a[0] === '\u2009') out += '';
      else if (
        a === '\xB2' ||
        a === ')' ||
        p === '\xF7' ||
        a === '^' ||
        p === '^' ||
        a === '\xB0' ||
        a === '!'
      )
        out += '';
      else if (isFunc(p) && a === '(') out += '';
      else if (a === '%') out += '\u202F';
      else if (p === '(' || p === '\u221A') out += '';
      else if (
        p === '\u2212' &&
        (pp === void 0 || pp === '=' || pp === '(' || pp === 'ou' || /^[+−×÷]$/.test(pp))
      )
        out += '';
      else if (p === '+' && pp === '(') out += '';
      else if (
        (isNum(p) || p === ')' || p === '\xB2') &&
        (isVar(a) || isConst(a) || isFunc(a) || a === '(')
      )
        out += '';
      else if (isVar(p) && a === '(') out += '';
      else if (isVar(p) && isVar(a) && p.length === 1 && a.length === 1) out += '';
      else out += ' ';
    }
    out += a;
  });
  return out;
}

// packages/reasoner/src/kernel/exact.ts
var RAT_TEXT_RE = /^-?(0|[1-9]\d*)(\/[1-9]\d*)?$/;
var MAX_RADICAND = 10n ** 12n;
var MAX_POW = 4096;
function babs(a) {
  return a < 0n ? -a : a;
}
function gcd(a, b) {
  a = babs(a);
  b = babs(b);
  while (b !== 0n) [a, b] = [b, a % b];
  return a;
}
function toBig(v) {
  if (typeof v === 'bigint') return v;
  if (!Number.isSafeInteger(v)) throw new RangeError(`entier attendu : ${v}`);
  return BigInt(v);
}
function rat(n, d2 = 1n) {
  let nn = toBig(n);
  let dd = toBig(d2);
  if (dd === 0n) throw new RangeError('d\xE9nominateur nul');
  if (dd < 0n) {
    nn = -nn;
    dd = -dd;
  }
  const g = gcd(nn, dd) || 1n;
  return { n: nn / g, d: dd / g };
}
var ZERO = rat(0);
var ONE = rat(1);
function add(a, b) {
  return rat(a.n * b.d + b.n * a.d, a.d * b.d);
}
function mul(a, b) {
  return rat(a.n * b.n, a.d * b.d);
}
function div(a, b) {
  if (b.n === 0n) return null;
  return rat(a.n * b.d, a.d * b.n);
}
function neg2(a) {
  return { n: -a.n, d: a.d };
}
function abs(a) {
  return a.n < 0n ? neg2(a) : a;
}
function sign(a) {
  return a.n === 0n ? 0 : a.n < 0n ? -1 : 1;
}
function cmp(a, b) {
  const x = a.n * b.d - b.n * a.d;
  return x === 0n ? 0 : x < 0n ? -1 : 1;
}
function eq(a, b) {
  return a.n === b.n && a.d === b.d;
}
function isZero(a) {
  return a.n === 0n;
}
function isInteger(a) {
  return a.d === 1n;
}
function pow(a, k) {
  if (!Number.isInteger(k) || Math.abs(k) > MAX_POW) return null;
  if (k < 0) {
    if (a.n === 0n) return null;
    return pow(rat(a.d, a.n), -k);
  }
  const e = BigInt(k);
  return rat(a.n ** e, a.d ** e);
}
function ratToText(a) {
  return a.d === 1n ? a.n.toString() : `${a.n}/${a.d}`;
}
function ratFromText(s) {
  if (!RAT_TEXT_RE.test(s)) return null;
  const [p, q] = s.split('/');
  return rat(BigInt(p), q === void 0 ? 1n : BigInt(q));
}
var DECIMAL_RE = /^([+\-−]?)(\d{1,40})(?:[.,](\d{1,40}))?$/;
function parseDecimal(text) {
  const m = DECIMAL_RE.exec(text.trim());
  if (!m) return null;
  const frac = m[3] ?? '';
  const n = BigInt(m[2] + frac);
  const r = rat(n, 10n ** BigInt(frac.length));
  return m[1] === '-' || m[1] === '\u2212' ? neg2(r) : r;
}
function ratToNumber(a) {
  return Number(a.n) / Number(a.d);
}
function squarefreePart(n) {
  if (n < 1n || n > MAX_RADICAND) return null;
  let m = Number(n);
  let square = 1;
  let free = 1;
  for (let p = 2; p * p <= m; p += p === 2 ? 1 : 2) {
    let e = 0;
    while (m % p === 0) {
      m /= p;
      e++;
    }
    if (e > 0) {
      square *= p ** Math.floor(e / 2);
      if (e % 2 === 1) free *= p;
    }
  }
  if (m > 1) free *= m;
  return { square: BigInt(square), free: BigInt(free) };
}
function radical(coef2, rad) {
  if (rad < 0n) return null;
  if (coef2.n === 0n || rad === 0n) return { coef: ZERO, rad: 1n };
  const sf = squarefreePart(rad);
  if (!sf) return null;
  return { coef: mul(coef2, rat(sf.square)), rad: sf.free };
}
function sqrtRat(q) {
  if (q.n < 0n) return null;
  return radical(rat(1n, q.d), q.n * q.d);
}
function radIsRational(a) {
  return a.rad === 1n || a.coef.n === 0n;
}

// packages/reasoner/src/kernel/term.ts
var num2 = (v) => ({
  k: 'num',
  v: typeof v === 'number' ? rat(v) : v,
});
var sym2 = (n) => ({ k: 'sym', n });
var add2 = (...c) => ({ k: 'add', c });
var mul2 = (...c) => ({ k: 'mul', c });
var div2 = (a, b) => ({ k: 'div', a, b });
var pow2 = (a, b) => ({ k: 'pow', a, b });
var fn = (f, a) => ({ k: 'fn', f, a });
var binom = (k, n) => ({ k: 'binom', a: k, b: n });
var neg3 = (a) => (a.k === 'num' ? num2(neg2(a.v)) : mul2(num2(-1), a));
var CONSTANTS = { π: 1 };
var UnsupportedTerm = class extends Error {
  constructor(what) {
    super(`non pris en charge : ${what}`);
    this.what = what;
  }
};
function plainDecimal(v) {
  const s = String(v);
  const m = /^(-?)(\d+)(?:\.(\d+))?e([+-]\d+)$/.exec(s);
  if (!m) return s;
  const digits = m[2] + (m[3] ?? '');
  const point = m[2].length + Number(m[4]);
  const body =
    point <= 0
      ? '0.' + '0'.repeat(-point) + digits
      : point >= digits.length
        ? digits + '0'.repeat(point - digits.length)
        : digits.slice(0, point) + '.' + digits.slice(point);
  return m[1] + body;
}
function exactFromFloat(v) {
  if (!Number.isFinite(v)) throw new UnsupportedTerm('nombre infini');
  const r = parseDecimal(plainDecimal(v));
  if (!r) throw new UnsupportedTerm(`nombre ${v}`);
  return r;
}
function fromNode(n) {
  switch (n.k) {
    case 'n':
      return num2(exactFromFloat(n.v));
    case 's':
      return sym2(n.n);
    case 'add':
      return add2(...n.c.map(fromNode));
    case 'mul':
      return mul2(...n.c.map(fromNode));
    case 'div':
      return div2(fromNode(n.a), fromNode(n.b));
    case 'pow':
      return pow2(fromNode(n.a), fromNode(n.b));
    case 'neg':
      return neg3(fromNode(n.a));
    case 'sq':
      return pow2(fromNode(n.a), num2(2));
    case 'pct':
      return div2(fromNode(n.a), num2(100));
    case 'binom':
      return binom(fromNode(n.a), fromNode(n.b));
    case 'sqrt':
    case 'abs':
    case 'fact':
    case 'deg':
    case 'ln':
    case 'exp':
    case 'cos':
    case 'sin':
    case 'tan':
    case 'arg':
    case 'arccos':
    case 'arcsin':
    case 'arctan':
    case 'log':
      return fn(n.k, fromNode(n.a));
  }
  throw new UnsupportedTerm(n.k);
}
function chainOf(eq2) {
  if (!eq2.chain || eq2.chain.length !== eq2.sides.length - 1) return null;
  const sides = eq2.sides.map(fromNode);
  return eq2.chain.map((rel, i) => ({ rel, l: sides[i], r: sides[i + 1] }));
}
function relationOf(eq2) {
  if (eq2.chain) return null;
  if (eq2.rels || eq2.mod !== void 0) return null;
  if (eq2.cmp) {
    if (eq2.cmp === '\u2248') return null;
    return { rel: eq2.cmp, l: fromNode(eq2.sides[0]), r: fromNode(eq2.sides[1]) };
  }
  if (eq2.sides.length === 1) return fromNode(eq2.sides[0]);
  if (eq2.sides.length === 2)
    return { rel: '=', l: fromNode(eq2.sides[0]), r: fromNode(eq2.sides[1]) };
  return null;
}
function parseStatement(text) {
  let line;
  try {
    line = parseText(text);
  } catch {
    return { ok: false, reason: 'unparsable' };
  }
  return statementOfLine(line);
}
function statementOfLine(line) {
  try {
    const isSet =
      line.dis.some((d2) => d2.chain) ||
      (line.dis.length > 1 && line.dis.some((d2) => d2.cmp && d2.cmp !== '\u2248'));
    if (isSet) {
      const clauses = [];
      for (const d2 of line.dis) {
        const chain = chainOf(d2);
        if (chain) {
          clauses.push(chain);
          continue;
        }
        const r2 = relationOf(d2);
        if (!r2 || !('rel' in r2)) return { ok: false, reason: 'unsupported' };
        clauses.push([r2]);
      }
      return { ok: true, s: { k: 'set', clauses } };
    }
    if (line.dis.length > 1) {
      const items = [];
      for (const d2 of line.dis) {
        const r2 = relationOf(d2);
        if (!r2 || !('rel' in r2) || r2.rel !== '=') return { ok: false, reason: 'unsupported' };
        items.push(r2);
      }
      return { ok: true, s: { k: 'or', items } };
    }
    const r = relationOf(line.dis[0]);
    if (r === null) return { ok: false, reason: 'unsupported' };
    return { ok: true, s: 'rel' in r ? { k: 'rel', ...r } : { k: 'expr', e: r } };
  } catch (e) {
    if (e instanceof UnsupportedTerm) return { ok: false, reason: 'unsupported' };
    throw e;
  }
}
function involvesMatrix(t, sorts) {
  switch (t.k) {
    case 'num':
      return false;
    case 'sym':
      return sorts[t.n] === 'matrix';
    case 'add':
    case 'mul':
      return t.c.some((c) => involvesMatrix(c, sorts));
    case 'div':
    case 'pow':
      return involvesMatrix(t.a, sorts) || involvesMatrix(t.b, sorts);
    case 'fn':
    case 'binom':
      return false;
  }
}
function termKey(t) {
  switch (t.k) {
    case 'num':
      return ratToText(t.v);
    case 'sym':
      return `$${t.n}`;
    case 'add':
      return `+(${t.c.map(termKey).join(',')})`;
    case 'mul':
      return `*(${t.c.map(termKey).join(',')})`;
    case 'div':
      return `/(${termKey(t.a)},${termKey(t.b)})`;
    case 'pow':
      return `^(${termKey(t.a)},${termKey(t.b)})`;
    case 'fn':
      return `${t.f}(${termKey(t.a)})`;
    case 'binom':
      return `C(${termKey(t.a)},${termKey(t.b)})`;
  }
}
var MAX_EXACT_POW = 64n;
function exactSqrt(q) {
  const r = sqrtRat(q);
  return r && radIsRational(r) ? r.coef : null;
}
function canon(t, sorts = {}) {
  switch (t.k) {
    case 'num':
    case 'sym':
      return t;
    case 'add': {
      const flat = [];
      let k = ZERO;
      for (const c of t.c.map((x) => canon(x, sorts))) {
        for (const d2 of c.k === 'add' ? c.c : [c]) {
          if (d2.k === 'num') k = add(k, d2.v);
          else flat.push(d2);
        }
      }
      const terms = flat.sort(byKey);
      if (!isZero(k)) terms.push(num2(k));
      if (terms.length === 0) return num2(0);
      if (terms.length === 1) return terms[0];
      return { k: 'add', c: terms };
    }
    case 'mul': {
      const flat = [];
      let k = ONE;
      for (const c of t.c.map((x) => canon(x, sorts))) {
        for (const d2 of c.k === 'mul' ? c.c : [c]) {
          if (d2.k === 'num') k = mul(k, d2.v);
          else flat.push(d2);
        }
      }
      if (isZero(k)) return num2(0);
      const commutative = !flat.some((f) => involvesMatrix(f, sorts));
      const rest = commutative ? mergePowers(flat, sorts).sort(byKey) : flat;
      if (rest.length === 0) return num2(k);
      if (eq(k, ONE)) return rest.length === 1 ? rest[0] : { k: 'mul', c: rest };
      return { k: 'mul', c: [num2(k), ...rest] };
    }
    case 'div': {
      const a = canon(t.a, sorts);
      const b = canon(t.b, sorts);
      if (b.k === 'num' && eq(b.v, ONE)) return a;
      if (a.k === 'num' && b.k === 'num') {
        const q = div(a.v, b.v);
        if (q) return num2(q);
      }
      return { k: 'div', a, b };
    }
    case 'pow': {
      const a = canon(t.a, sorts);
      const b = canon(t.b, sorts);
      if (b.k === 'num' && eq(b.v, ONE)) return a;
      if (a.k === 'num' && b.k === 'num' && isInteger(b.v) && abs(b.v).n <= MAX_EXACT_POW) {
        const p = pow(a.v, Number(b.v.n));
        if (p) return num2(p);
      }
      return { k: 'pow', a, b };
    }
    case 'fn': {
      const a = canon(t.a, sorts);
      if (a.k === 'num') {
        if (t.f === 'sqrt') {
          const r = exactSqrt(a.v);
          if (r) return num2(r);
        }
        if (t.f === 'abs') return num2(abs(a.v));
        if (t.f === 'fact' && isInteger(a.v) && a.v.n >= 0n && a.v.n <= 20n) {
          let f = 1n;
          for (let i = 2n; i <= a.v.n; i++) f *= i;
          return num2(rat(f));
        }
      }
      return { k: 'fn', f: t.f, a };
    }
    case 'binom': {
      const k = canon(t.a, sorts);
      const n = canon(t.b, sorts);
      if (k.k === 'num' && n.k === 'num') {
        const v = binomialExact(n.v, k.v);
        if (v !== null) return num2(v);
      }
      return { k: 'binom', a: k, b: n };
    }
  }
}
var MAX_EXACT_FACT = 1000n;
function binomialExact(n, k) {
  if (!isInteger(n) || !isInteger(k) || n.n < 0n || k.n < 0n || n.n > MAX_EXACT_FACT) return null;
  if (k.n > n.n) return ZERO;
  const kk = k.n < n.n - k.n ? k.n : n.n - k.n;
  let r = 1n;
  for (let i = 1n; i <= kk; i++) r = (r * (n.n - kk + i)) / i;
  return rat(r);
}
function mergePowers(fs, sorts) {
  const groups = /* @__PURE__ */ new Map();
  const order = [];
  for (const f of fs) {
    const intPow = f.k === 'pow' && f.b.k === 'num' && isInteger(f.b.v);
    const base = intPow ? f.a : f;
    const e = intPow ? f.b.v : ONE;
    const key = termKey(base);
    const g = groups.get(key);
    if (g) {
      g.e = add(g.e, e);
      g.n++;
    } else {
      groups.set(key, { base, e, n: 1 });
      order.push(key);
    }
  }
  const out = [];
  for (const key of order) {
    const g = groups.get(key);
    if (g.n === 1) {
      out.push(eq(g.e, ONE) ? g.base : { k: 'pow', a: g.base, b: num2(g.e) });
      continue;
    }
    if (isZero(g.e)) continue;
    out.push(canon(eq(g.e, ONE) ? g.base : { k: 'pow', a: g.base, b: num2(g.e) }, sorts));
  }
  return out;
}
function byKey(a, b) {
  const ka = termKey(a);
  const kb = termKey(b);
  return ka < kb ? -1 : ka > kb ? 1 : 0;
}
function symbolsOf(t, acc = /* @__PURE__ */ new Set()) {
  switch (t.k) {
    case 'sym':
      if (!CONSTANTS[t.n]) acc.add(t.n);
      break;
    case 'add':
    case 'mul':
      t.c.forEach((c) => symbolsOf(c, acc));
      break;
    case 'div':
    case 'pow':
    case 'binom':
      symbolsOf(t.a, acc);
      symbolsOf(t.b, acc);
      break;
    case 'fn':
      symbolsOf(t.a, acc);
      break;
    default:
      break;
  }
  return acc;
}
function substitute(t, map) {
  switch (t.k) {
    case 'num':
      return t;
    case 'sym':
      return map[t.n] ?? t;
    case 'add':
      return add2(...t.c.map((c) => substitute(c, map)));
    case 'mul':
      return mul2(...t.c.map((c) => substitute(c, map)));
    case 'div':
      return div2(substitute(t.a, map), substitute(t.b, map));
    case 'pow':
      return pow2(substitute(t.a, map), substitute(t.b, map));
    case 'fn':
      return fn(t.f, substitute(t.a, map));
    case 'binom':
      return binom(substitute(t.a, map), substitute(t.b, map));
  }
}

// packages/reasoner/src/kernel/normal.ts
var NormalFail = class extends Error {
  constructor(code) {
    super(code);
    this.code = code;
  }
};
var MAX_POLY_TERMS = 4e3;
var MAX_EXPANDED_POW = 24;
var MAX_ROOT_INPUT = 1e12;
function symAtom(name2) {
  if (CONSTANTS[name2])
    return { key: `$${name2}`, kind: 'opaque', term: sym2(name2), constant: true, value: Math.PI };
  return { key: `$${name2}`, kind: 'sym', term: sym2(name2), constant: false, symbol: name2 };
}
function rootAtom(p) {
  return {
    key: `\u221A${p}`,
    kind: 'root',
    term: fn('sqrt', num2(p)),
    constant: true,
    value: Math.sqrt(p),
    prime: p,
  };
}
function opaqueAtom(t) {
  const free = hasSymbol(t);
  const a = { key: termKey(t), kind: 'opaque', term: t, constant: !free };
  if (!free) a.value = evalFloat(t, {});
  return a;
}
function hasSymbol(t) {
  switch (t.k) {
    case 'num':
      return false;
    case 'sym':
      return !CONSTANTS[t.n];
    case 'add':
    case 'mul':
      return t.c.some(hasSymbol);
    case 'div':
    case 'pow':
    case 'binom':
      return hasSymbol(t.a) || hasSymbol(t.b);
    case 'fn':
      return hasSymbol(t.a);
  }
}
function monoKey(m) {
  return m.map((f) => (f.e === 1 ? f.a.key : `${f.a.key}^${f.e}`)).join('\xB7');
}
function monoMul(x, y) {
  const out = [];
  let c = ONE;
  let i = 0;
  let j = 0;
  const push = (a, e) => {
    if (a.kind === 'root') {
      const half = Math.floor(e / 2);
      if (half > 0) c = mul(c, pow(rat(a.prime), half));
      if (e % 2 === 1) out.push({ a, e: 1 });
    } else out.push({ a, e });
  };
  while (i < x.length || j < y.length) {
    const fx = x[i];
    const fy = y[j];
    if (fx && (!fy || fx.a.key < fy.a.key)) {
      push(fx.a, fx.e);
      i++;
    } else if (fy && (!fx || fy.a.key < fx.a.key)) {
      push(fy.a, fy.e);
      j++;
    } else {
      push(fx.a, fx.e + fy.e);
      i++;
      j++;
    }
  }
  return { c, m: out };
}
function monoCmp(x, y) {
  let i = 0;
  let j = 0;
  while (i < x.length || j < y.length) {
    const fx = x[i];
    const fy = y[j];
    if (fx && (!fy || fx.a.key < fy.a.key)) return 1;
    if (fy && (!fx || fy.a.key < fx.a.key)) return -1;
    if (fx.e !== fy.e) return fx.e > fy.e ? 1 : -1;
    i++;
    j++;
  }
  return 0;
}
function monoDiv(x, y) {
  const out = [];
  let j = 0;
  for (const f of x) {
    const g = y[j];
    if (g && g.a.key < f.a.key) return null;
    if (g && g.a.key === f.a.key) {
      if (g.e > f.e) return null;
      if (f.e > g.e) out.push({ a: f.a, e: f.e - g.e });
      j++;
    } else out.push(f);
  }
  return j === y.length ? out : null;
}
function monoDegree(m) {
  return m.reduce((s, f) => s + f.e, 0);
}
var ZERO_POLY = { t: /* @__PURE__ */ new Map() };
function constPoly(c) {
  return isZero(c)
    ? { t: /* @__PURE__ */ new Map() }
    : { t: /* @__PURE__ */ new Map([['', { m: [], c }]]) };
}
function atomPoly(a) {
  const m = [{ a, e: 1 }];
  return { t: /* @__PURE__ */ new Map([[monoKey(m), { m, c: ONE }]]) };
}
function addTerm(map, m, c) {
  if (isZero(c)) return;
  const k = monoKey(m);
  const old = map.get(k);
  if (!old) map.set(k, { m, c });
  else {
    const s = add(old.c, c);
    if (isZero(s)) map.delete(k);
    else map.set(k, { m, c: s });
  }
}
function polyAdd(p, q) {
  const t = new Map(p.t);
  for (const { m, c } of q.t.values()) addTerm(t, m, c);
  if (t.size > MAX_POLY_TERMS) throw new NormalFail('too_big');
  return { t };
}
function polyScale(p, k) {
  if (isZero(k)) return ZERO_POLY;
  const t = /* @__PURE__ */ new Map();
  for (const [key, { m, c }] of p.t) t.set(key, { m, c: mul(c, k) });
  return { t };
}
function polyNeg(p) {
  return polyScale(p, rat(-1));
}
function polySub(p, q) {
  return polyAdd(p, polyNeg(q));
}
function polyMul(p, q) {
  if (p.t.size * q.t.size > MAX_POLY_TERMS * 8) throw new NormalFail('too_big');
  const t = /* @__PURE__ */ new Map();
  for (const x of p.t.values())
    for (const y of q.t.values()) {
      const r = monoMul(x.m, y.m);
      addTerm(t, r.m, mul(mul(x.c, y.c), r.c));
    }
  if (t.size > MAX_POLY_TERMS) throw new NormalFail('too_big');
  return { t };
}
function polyPow(p, k) {
  let out = constPoly(ONE);
  for (let i = 0; i < k; i++) out = polyMul(out, p);
  return out;
}
function polyIsZero(p) {
  return p.t.size === 0;
}
function polyEqual(p, q) {
  return polyIsZero(polySub(p, q));
}
function polyRat(p) {
  if (p.t.size === 0) return ZERO;
  if (p.t.size === 1 && p.t.has('')) return p.t.get('').c;
  return null;
}
function polyIsConstant(p) {
  for (const { m } of p.t.values()) if (m.some((f) => !f.a.constant)) return false;
  return true;
}
function polyFloat(p) {
  let s = 0;
  for (const { m, c } of p.t.values())
    s += ratToNumber(c) * m.reduce((v, f) => v * f.a.value ** f.e, 1);
  return s;
}
function leading(p) {
  let best = null;
  for (const x of p.t.values()) if (!best || monoCmp(x.m, best.m) > 0) best = x;
  return best;
}
function polyTerms(p) {
  return [...p.t.values()].sort((x, y) => monoDegree(y.m) - monoDegree(x.m) || monoCmp(y.m, x.m));
}
function polyDivExact(p, q) {
  if (polyIsZero(q)) return null;
  const lq = leading(q);
  let r = p;
  let quo = ZERO_POLY;
  for (let guard = 0; guard < 2e3; guard++) {
    if (polyIsZero(r)) return polyEqual(polyMul(quo, q), p) ? quo : null;
    const lr = leading(r);
    const m = monoDiv(lr.m, lq.m);
    if (!m) return null;
    const step = { t: /* @__PURE__ */ new Map([[monoKey(m), { m, c: div(lr.c, lq.c) }]]) };
    quo = polyAdd(quo, step);
    const next = polySub(r, polyMul(step, q));
    if (next.t.has(monoKey(lr.m)) && eq(next.t.get(monoKey(lr.m)).c, lr.c)) return null;
    r = next;
  }
  return null;
}
var ONE_POLY = () => constPoly(ONE);
function rf(n, d2 = ONE_POLY()) {
  const k = polyRat(d2);
  if (k !== null) {
    if (isZero(k)) throw new NormalFail('division_by_zero');
    return { n: polyScale(n, div(ONE, k)), d: ONE_POLY() };
  }
  return { n, d: d2 };
}
function sameDen(a, b) {
  return polyEqual(a, b);
}
function rfAdd(a, b) {
  if (sameDen(a.d, b.d)) return rf(polyAdd(a.n, b.n), a.d);
  return rf(polyAdd(polyMul(a.n, b.d), polyMul(b.n, a.d)), polyMul(a.d, b.d));
}
function rfSub(a, b) {
  return rfAdd(a, { n: polyNeg(b.n), d: b.d });
}
function rfMul(a, b) {
  return rf(polyMul(a.n, b.n), polyMul(a.d, b.d));
}
function rfDiv(a, b) {
  if (polyIsZero(b.n)) throw new NormalFail('division_by_zero');
  return rf(polyMul(a.n, b.d), polyMul(a.d, b.n));
}
function rfRat(a) {
  const n = polyRat(a.n);
  const d2 = polyRat(a.d);
  return n !== null && d2 !== null ? div(n, d2) : null;
}
function rfSimplify(a) {
  let { n, d: d2 } = a;
  if (polyRat(d2) !== null) return rf(n, d2);
  const common = commonMono([...n.t.values(), ...d2.t.values()]);
  if (common.length) {
    n = divideMono(n, common);
    d2 = divideMono(d2, common);
  }
  const q = polyDivExact(n, d2);
  if (q) return rf(q);
  const ld = leading(d2);
  return { n: polyScale(n, div(ONE, ld.c)), d: polyScale(d2, div(ONE, ld.c)) };
}
function commonMono(terms) {
  if (!terms.length) return [];
  let acc = terms[0].m.filter((f) => f.a.kind !== 'root');
  for (const x of terms.slice(1)) {
    acc = acc
      .map((f) => {
        const g = x.m.find((h) => h.a.key === f.a.key);
        return g ? { a: f.a, e: Math.min(f.e, g.e) } : null;
      })
      .filter((f) => f !== null);
  }
  return acc;
}
function divideMono(p, m) {
  const t = /* @__PURE__ */ new Map();
  for (const x of p.t.values()) {
    const q = monoDiv(x.m, m);
    t.set(monoKey(q), { m: q, c: x.c });
  }
  return { t };
}
function toRatFn(t, opts = {}) {
  const r = conv(canon(t, opts.sorts ?? {}), opts.sorts ?? {});
  return hasFactAtom(r) ? rfSimplify(r) : r;
}
function hasFactAtom(r) {
  for (const p of [r.n, r.d])
    for (const x of p.t.values()) if (x.m.some((f) => f.a.key.startsWith('fact('))) return true;
  return false;
}
function normalize2(t, opts = {}) {
  try {
    return { ok: true, rf: toRatFn(t, opts) };
  } catch (e) {
    if (e instanceof NormalFail) return { ok: false, code: e.code };
    throw e;
  }
}
function conv(t, sorts) {
  switch (t.k) {
    case 'num':
      return rf(constPoly(t.v));
    case 'sym':
      return rf(atomPoly(symAtom(t.n)));
    case 'add':
      return t.c.map((c) => conv(c, sorts)).reduce(rfAdd);
    case 'mul': {
      if (t.c.filter((c) => involvesMatrix(c, sorts)).length > 1)
        throw new NormalFail('noncommutative');
      return t.c.map((c) => conv(c, sorts)).reduce(rfMul);
    }
    case 'div':
      return rfDiv(conv(t.a, sorts), conv(t.b, sorts));
    case 'pow':
      return convPow(t.a, t.b, sorts);
    case 'fn':
      return convFn(t.f, t.a, sorts);
    case 'binom':
      return convBinom(t.a, t.b, sorts);
  }
}
var MAX_FACT_SHIFT = 64;
var MAX_FACT_VALUE = 1000n;
function factBig(n) {
  let f = 1n;
  for (let i = 2n; i <= n; i++) f *= i;
  return f;
}
function factOf(inner2) {
  const v = rfRat(inner2);
  if (v !== null) {
    if (!isInteger(v) || v.n < 0n) throw new NormalFail('undefined_value');
    if (v.n > MAX_FACT_VALUE) throw new NormalFail('too_big');
    return rf(constPoly(rat(factBig(v.n))));
  }
  const d2 = polyRat(inner2.d);
  const opaque = () => rf(atomPoly(opaqueAtom(fn('fact', rfToTerm(rfSimplify(inner2))))));
  if (d2 === null) return opaque();
  const p = polyScale(inner2.n, div(ONE, d2));
  const c = polyRat({ t: new Map([...p.t].filter(([k]) => k === '')) }) ?? ZERO;
  if (!isInteger(c) || abs(c).n > BigInt(MAX_FACT_SHIFT)) return opaque();
  const base = polySub(p, constPoly(c));
  const F = rf(atomPoly(opaqueAtom(fn('fact', polyToTerm(base)))));
  const shift = Number(c.n);
  let out = F;
  for (let j = 1; j <= Math.abs(shift); j++) {
    const k = shift > 0 ? j : 1 - j;
    const f = rf(polyAdd(base, constPoly(rat(k))));
    out = shift > 0 ? rfMul(out, f) : rfDiv(out, f);
  }
  return out;
}
function convBinom(k, n, sorts) {
  const kr = rfSimplify(conv(k, sorts));
  const nr = rfSimplify(conv(n, sorts));
  const kv = rfRat(kr);
  const nv = rfRat(nr);
  if (kv !== null && nv !== null) {
    if (!isInteger(kv) || !isInteger(nv) || kv.n < 0n || nv.n < 0n)
      throw new NormalFail('undefined_value');
    if (kv.n > nv.n) return rf(ZERO_POLY);
  }
  if (kv !== null && (!isInteger(kv) || kv.n < 0n)) throw new NormalFail('undefined_value');
  return rfDiv(factOf(nr), rfMul(factOf(kr), factOf(rfSub(nr, kr))));
}
function innerTerm(t, sorts) {
  return rfToTerm(rfSimplify(conv(t, sorts)));
}
function convPow(a, b, sorts) {
  const base = conv(a, sorts);
  const ex = conv(b, sorts);
  const k = rfRat(ex);
  if (k !== null && isInteger(k)) {
    const e = Number(k.n);
    if (Math.abs(e) > MAX_EXPANDED_POW) {
      const br2 = rfRat(base);
      if (br2 !== null) {
        const p = pow(br2, e);
        if (p === null) throw new NormalFail(isZero(br2) ? 'division_by_zero' : 'too_big');
        return rf(constPoly(p));
      }
      throw new NormalFail('too_big');
    }
    const pn = polyPow(base.n, Math.abs(e));
    const pd = polyPow(base.d, Math.abs(e));
    return e >= 0 ? rf(pn, pd) : rfDiv(rf(ONE_POLY()), rf(pn, pd));
  }
  const br = rfRat(base);
  if (k !== null && br !== null) {
    const root = exactRationalPower(br, k);
    if (root) return root;
  }
  if (k === null && br !== null && sign(br) > 0)
    return convFn('exp', { k: 'mul', c: [b, { k: 'fn', f: 'ln', a }] }, sorts);
  return rf(atomPoly(opaqueAtom(pow2(innerTerm(a, sorts), innerTerm(b, sorts)))));
}
function exactRationalPower(q, k) {
  if (q.n < 0n) return null;
  const r = Number(k.d);
  if (r === 2) {
    const rad = sqrtOfRat(pow(q, Number(k.n)));
    return rad;
  }
  const nr = intRoot(q.n, r);
  const dr = intRoot(q.d, r);
  if (nr === null || dr === null) return null;
  const p = pow(rat(nr, dr), Number(k.n));
  return p ? rf(constPoly(p)) : null;
}
function intRoot(n, r) {
  if (n < 0n || r < 2 || r > 64) return null;
  if (n < 2n) return n;
  const x = BigInt(Math.round(Number(n) ** (1 / r)));
  for (const c of [x - 1n, x, x + 1n]) if (c >= 0n && c ** BigInt(r) === n) return c;
  return null;
}
function sqrtOfRat(q) {
  if (q.n < 0n) throw new NormalFail('undefined_value');
  const rad = sqrtRat(q);
  if (!rad) return null;
  if (rad.rad === 1n) return rf(constPoly(rad.coef));
  if (rad.rad > BigInt(MAX_ROOT_INPUT)) return null;
  const primes = primeFactors(Number(rad.rad));
  if (!primes) return null;
  let p = constPoly(rad.coef);
  for (const pr of primes) p = polyMul(p, atomPoly(rootAtom(pr)));
  return rf(p);
}
function primeFactors(n) {
  if (n > MAX_ROOT_INPUT) return null;
  const out = [];
  let m = n;
  for (let p = 2; p * p <= m; p += p === 2 ? 1 : 2) {
    while (m % p === 0) {
      out.push(p);
      m /= p;
    }
  }
  if (m > 1) out.push(m);
  return out;
}
var EXACT_AT_ZERO = {
  exp: ONE,
  cos: ONE,
  sin: ZERO,
  tan: ZERO,
  arcsin: ZERO,
  arctan: ZERO,
};
function piMultiple(r) {
  const d2 = polyRat(r.d);
  if (d2 === null) return null;
  const terms = [...r.n.t.values()];
  if (!terms.length) return ZERO;
  if (terms.length !== 1) return null;
  const t = terms[0];
  if (t.m.length !== 1 || t.m[0].a.key !== '$\u03C0' || t.m[0].e !== 1) return null;
  return div(t.c, d2);
}
var rootRf = (p, k) => rf(polyScale(atomPoly(rootAtom(p)), k));
var ratRf = (q) => rf(constPoly(q));
function cosDeg(d0) {
  const d2 = ((d0 % 360) + 360) % 360;
  const [ref, sign2] =
    d2 <= 90 ? [d2, 1] : d2 <= 180 ? [180 - d2, -1] : d2 <= 270 ? [d2 - 180, -1] : [360 - d2, 1];
  const s = rat(sign2);
  switch (ref) {
    case 0:
      return ratRf(s);
    case 30:
      return rootRf(3, mul(s, rat(1, 2)));
    case 45:
      return rootRf(2, mul(s, rat(1, 2)));
    case 60:
      return ratRf(mul(s, rat(1, 2)));
    default:
      return ratRf(ZERO);
  }
}
function remarkableDegrees(angle) {
  const k = piMultiple(angle);
  if (k === null) return null;
  const twelfths = mul(k, rat(12));
  if (!isInteger(twelfths)) return null;
  const n = Number(twelfths.n);
  if (!Number.isSafeInteger(n) || (n % 2 !== 0 && n % 3 !== 0)) return null;
  return n * 15;
}
function trigExact(f, angle) {
  const d2 = remarkableDegrees(angle);
  if (d2 === null) return null;
  if (f === 'cos') return cosDeg(d2);
  if (f === 'sin') return cosDeg(90 - d2);
  const c = cosDeg(d2);
  if (polyIsZero(c.n)) throw new NormalFail('undefined_value');
  return rfSimplify(rfDiv(cosDeg(90 - d2), c));
}
var sameRf = (a, b) => polyIsZero(polySub(polyMul(a.n, b.d), polyMul(b.n, a.d)));
function arcExact(f, v) {
  const range =
    f === 'arccos'
      ? [0, 30, 45, 60, 90, 120, 135, 150, 180]
      : f === 'arcsin'
        ? [-90, -60, -45, -30, 0, 30, 45, 60, 90]
        : [-60, -45, -30, 0, 30, 45, 60];
  for (const d2 of range) {
    const val5 =
      f === 'arccos'
        ? cosDeg(d2)
        : f === 'arcsin'
          ? cosDeg(90 - d2)
          : rfSimplify(rfDiv(cosDeg(90 - d2), cosDeg(d2)));
    if (sameRf(v, val5)) return ratRf(rat(d2));
  }
  return null;
}
function primePowers(n) {
  if (n > BigInt(MAX_ROOT_INPUT)) return null;
  const out = /* @__PURE__ */ new Map();
  for (const p of primeFactors(Number(n)) ?? []) out.set(p, (out.get(p) ?? 0) + 1);
  return out;
}
var lnAtom = (p) => opaqueAtom(fn('ln', num2(p)));
function lnOfRat(q) {
  const num_ = primePowers(q.n);
  const den = primePowers(q.d);
  if (!num_ || !den) return null;
  let p = ZERO_POLY;
  for (const [pr, e] of num_) p = polyAdd(p, polyScale(atomPoly(lnAtom(pr)), rat(e)));
  for (const [pr, e] of den) p = polyAdd(p, polyScale(atomPoly(lnAtom(pr)), rat(-e)));
  return rf(p);
}
function lnOfConstant(r, sorts) {
  const nt = [...r.n.t.values()];
  const dt = [...r.d.t.values()];
  if (nt.length !== 1 || dt.length !== 1) return null;
  const c = div(nt[0].c, dt[0].c);
  if (sign(c) <= 0) return null;
  let acc = lnOfRat(c);
  if (!acc) return null;
  for (const [mono, sign2] of [
    [nt[0].m, 1],
    [dt[0].m, -1],
  ])
    for (const f of mono) {
      const k = rat(sign2 * f.e);
      if (f.a.kind === 'root')
        acc = rfAdd(acc, rf(polyScale(atomPoly(lnAtom(f.a.prime)), mul(k, rat(1, 2)))));
      else if (f.a.kind === 'opaque' && f.a.term.k === 'fn' && f.a.term.f === 'exp')
        acc = rfAdd(acc, rfMul(rf(constPoly(k)), conv(f.a.term.a, sorts)));
      else return null;
    }
  return acc;
}
var expAtom = (t) => opaqueAtom(fn('exp', t));
function atomPower(a, k) {
  const p = polyPow(atomPoly(a), Math.abs(k));
  return k >= 0 ? rf(p) : rfDiv(rf(ONE_POLY()), rf(p));
}
function expOf(inner2) {
  const d2 = polyRat(inner2.d);
  if (d2 === null) return null;
  let acc = rf(ONE_POLY());
  const rest = [];
  for (const t of inner2.n.t.values()) {
    const r = div(t.c, d2);
    const small = isInteger(r) && Math.abs(Number(r.n)) <= MAX_EXPANDED_POW;
    if (!t.m.length) {
      if (small) acc = rfMul(acc, atomPower(expAtom(num2(1)), Number(r.n)));
      else rest.push({ m: [], c: r });
      continue;
    }
    const f = t.m[0];
    const lnPrime =
      t.m.length === 1 &&
      f.e === 1 &&
      f.a.term.k === 'fn' &&
      f.a.term.f === 'ln' &&
      f.a.term.a.k === 'num'
        ? f.a.term.a.v
        : null;
    if (lnPrime && small) {
      acc = rfMul(acc, ratRf(pow(lnPrime, Number(r.n))));
      continue;
    }
    if (lnPrime) {
      const p = exactRationalPower(lnPrime, r);
      if (p) {
        acc = rfMul(acc, p);
        continue;
      }
    }
    if (small) {
      const m = polyToTerm({ t: /* @__PURE__ */ new Map([[monoKey(t.m), { m: t.m, c: ONE }]]) });
      acc = rfMul(acc, atomPower(expAtom(m), Number(r.n)));
    } else rest.push({ m: t.m, c: r });
  }
  if (rest.length) {
    const p = { t: new Map(rest.map((x) => [monoKey(x.m), x])) };
    acc = rfMul(acc, rf(atomPoly(expAtom(polyToTerm(p)))));
  }
  return acc;
}
function convFn(f, a, sorts) {
  if (f === 'log')
    return conv(
      { k: 'div', a: { k: 'fn', f: 'ln', a }, b: { k: 'fn', f: 'ln', a: num2(10) } },
      sorts,
    );
  if (f === 'ln' && a.k === 'fn' && a.f === 'exp') return conv(a.a, sorts);
  if (f === 'exp' && a.k === 'fn' && a.f === 'ln') {
    const c = rfSimplify(conv(a.a, sorts));
    if (polyIsConstant(c.n) && polyIsConstant(c.d)) {
      const x = polyFloat(c.n) / polyFloat(c.d);
      if (Number.isFinite(x) && x > 1e-9) return c;
    }
  }
  const inner2 = rfSimplify(conv(a, sorts));
  const v = rfRat(inner2);
  switch (f) {
    case 'cos':
    case 'sin':
    case 'tan': {
      const t = trigExact(f, inner2);
      if (t) return t;
      break;
    }
    case 'arccos':
    case 'arcsin':
    case 'arctan': {
      if (v !== null && f !== 'arctan' && ratToNumber(abs(v)) > 1)
        throw new NormalFail('undefined_value');
      const t = arcExact(f, inner2);
      if (t) return t;
      break;
    }
    case 'exp': {
      const e = expOf(inner2);
      if (e) return e;
      break;
    }
  }
  switch (f) {
    case 'sqrt': {
      if (v !== null) {
        const r = sqrtOfRat(v);
        if (r) return r;
      }
      break;
    }
    case 'abs': {
      if (v !== null) return rf(constPoly(abs(v)));
      if (polyIsConstant(inner2.n) && polyIsConstant(inner2.d)) {
        const x = polyFloat(inner2.n) / polyFloat(inner2.d);
        if (Math.abs(x) > 1e-9) return x > 0 ? inner2 : rfMul(rf(constPoly(rat(-1))), inner2);
      }
      break;
    }
    case 'deg':
      return rfMul(inner2, rf(polyScale(atomPoly(symAtom('\u03C0')), rat(1, 180))));
    case 'fact':
      return factOf(inner2);
    case 'ln': {
      if (v !== null && sign(v) <= 0) throw new NormalFail('undefined_value');
      if (v !== null && eq(v, ONE)) return rf(ZERO_POLY);
      const l = v !== null ? lnOfRat(v) : lnOfConstant(inner2, sorts);
      if (l) return l;
      break;
    }
    default:
      if (v !== null && isZero(v) && EXACT_AT_ZERO[f]) return rf(constPoly(EXACT_AT_ZERO[f]));
  }
  return rf(atomPoly(opaqueAtom(fn(f, rfToTerm(rfSimplify(inner2))))));
}
function monoTerm(m) {
  const out = [];
  let radicand = 1;
  for (const f of m) {
    if (f.a.kind === 'root') radicand *= f.a.prime;
    else out.push(f.e === 1 ? f.a.term : pow2(f.a.term, num2(f.e)));
  }
  if (radicand > 1) out.unshift(fn('sqrt', num2(radicand)));
  return out;
}
function polyToTerm(p) {
  const terms = polyTerms(p).map(({ m, c }) => {
    const fs = monoTerm(m);
    if (!fs.length) return num2(c);
    return eq(c, ONE)
      ? fs.length === 1
        ? fs[0]
        : { k: 'mul', c: fs }
      : { k: 'mul', c: [num2(c), ...fs] };
  });
  if (!terms.length) return num2(0);
  return canon(terms.length === 1 ? terms[0] : { k: 'add', c: terms });
}
function rfToTerm(a) {
  const d2 = polyRat(a.d);
  if (d2 !== null) return polyToTerm(polyScale(a.n, div(ONE, d2)));
  return canon({ k: 'div', a: polyToTerm(a.n), b: polyToTerm(a.d) });
}
var RADIAN_ARCS = false;
function withRadianArcs(f) {
  const prev = RADIAN_ARCS;
  RADIAN_ARCS = true;
  try {
    return f();
  } finally {
    RADIAN_ARCS = prev;
  }
}
var fromRad = (r) => (RADIAN_ARCS ? r : (r * 180) / Math.PI);
function evalFloat(t, env) {
  switch (t.k) {
    case 'num':
      return ratToNumber(t.v);
    case 'sym':
      return t.n in env ? env[t.n] : t.n === '\u03C0' ? Math.PI : NaN;
    case 'add':
      return t.c.reduce((s, c) => s + evalFloat(c, env), 0);
    case 'mul':
      return t.c.reduce((s, c) => s * evalFloat(c, env), 1);
    case 'div': {
      const d2 = evalFloat(t.b, env);
      return d2 === 0 ? NaN : evalFloat(t.a, env) / d2;
    }
    case 'pow':
      return realPow(evalFloat(t.a, env), evalFloat(t.b, env));
    case 'binom': {
      const k = evalFloat(t.a, env);
      const n = evalFloat(t.b, env);
      if (!Number.isInteger(k) || !Number.isInteger(n) || k < 0 || n < 0) return NaN;
      if (k > n) return 0;
      const kk = Math.min(k, n - k);
      let r = 1;
      for (let i = 1; i <= kk; i++) r = (r * (n - kk + i)) / i;
      return r;
    }
    case 'fn': {
      const x = evalFloat(t.a, env);
      switch (t.f) {
        case 'sqrt':
          return x < 0 ? NaN : Math.sqrt(x);
        case 'abs':
          return Math.abs(x);
        case 'fact': {
          if (!Number.isInteger(x) || x < 0 || x > 170) return NaN;
          let f = 1;
          for (let i = 2; i <= x; i++) f *= i;
          return f;
        }
        case 'deg':
          return (x * Math.PI) / 180;
        case 'ln':
          return x <= 0 ? NaN : Math.log(x);
        case 'log':
          return x <= 0 ? NaN : Math.log10(x);
        case 'exp':
          return Math.exp(x);
        case 'cos':
          return Math.cos(x);
        case 'sin':
          return Math.sin(x);
        case 'tan':
          return Math.tan(x);
        case 'arccos':
          return fromRad(Math.acos(x));
        case 'arcsin':
          return fromRad(Math.asin(x));
        case 'arctan':
          return fromRad(Math.atan(x));
        case 'arg':
          return NaN;
      }
    }
  }
}
function realPow(a, b) {
  if (a >= 0 || Number.isInteger(b)) return a ** b;
  const inv = 1 / b;
  if (
    Number.isInteger(Math.round(inv)) &&
    Math.abs(inv - Math.round(inv)) < 1e-12 &&
    Math.round(inv) % 2 !== 0
  )
    return -((-a) ** b);
  return NaN;
}

// packages/reasoner/src/kernel/calculus.ts
var CalculusUnsupported = class extends Error {
  constructor(what) {
    super(`d\xE9rivation non prise en charge : ${what}`);
    this.what = what;
  }
};
var dependsOn = (t, x) => symbolsOf(t).has(x);
var ARCS = false;
var ARC_NAMES = /* @__PURE__ */ new Set(['arctan', 'arcsin', 'arccos']);
function withArcDerivatives(f) {
  const prev = ARCS;
  ARCS = true;
  try {
    return withRadianArcs(f);
  } finally {
    ARCS = prev;
  }
}
var arcsOn = (f) => ARCS && ARC_NAMES.has(f);
var ZERO2 = num2(0);
var ONE2 = num2(1);
var isZeroTerm = (t) => t.k === 'num' && isZero(t.v);
function derive(t, x) {
  return canon(d(t, x));
}
function d(t, x) {
  if (!dependsOn(t, x)) return ZERO2;
  switch (t.k) {
    case 'num':
      return ZERO2;
    case 'sym':
      return t.n === x ? ONE2 : ZERO2;
    case 'add':
      return add2(...t.c.map((c) => d(c, x)));
    case 'mul': {
      const terms = [];
      t.c.forEach((c, i) => {
        if (!dependsOn(c, x)) return;
        terms.push(mul2(...t.c.map((o, j) => (j === i ? d(c, x) : o))));
      });
      return add2(...terms);
    }
    case 'div': {
      const { a, b } = t;
      if (!dependsOn(b, x)) return div2(d(a, x), b);
      if (!dependsOn(a, x)) return div2(mul2(num2(-1), a, d(b, x)), pow2(b, num2(2)));
      return div2(add2(mul2(d(a, x), b), mul2(num2(-1), a, d(b, x))), pow2(b, num2(2)));
    }
    case 'pow': {
      const { a, b } = t;
      if (!dependsOn(b, x)) return mul2(b, pow2(a, add2(b, num2(-1))), d(a, x));
      if (!dependsOn(a, x)) return mul2(fn('ln', a), t, d(b, x));
      return mul2(t, add2(mul2(d(b, x), fn('ln', a)), div2(mul2(b, d(a, x)), a)));
    }
    case 'fn':
      return mul2(d(t.a, x), outer(t.f, t.a));
    case 'binom':
      throw new CalculusUnsupported('k parmi n');
  }
}
function outer(f, u) {
  switch (f) {
    case 'sqrt':
      return div2(ONE2, mul2(num2(2), fn('sqrt', u)));
    case 'exp':
      return fn('exp', u);
    case 'ln':
      return div2(ONE2, u);
    case 'cos':
      return mul2(num2(-1), fn('sin', u));
    case 'sin':
      return fn('cos', u);
    case 'tan':
      return div2(ONE2, pow2(fn('cos', u), num2(2)));
    case 'abs':
      return div2(u, fn('abs', u));
    // moteur v60 : en radians, seulement dans `withArcDerivatives`
    case 'arctan':
      if (!ARCS) throw new CalculusUnsupported(f);
      return div2(ONE2, add2(ONE2, pow2(u, num2(2))));
    case 'arcsin':
      if (!ARCS) throw new CalculusUnsupported(f);
      return div2(ONE2, fn('sqrt', add2(ONE2, mul2(num2(-1), pow2(u, num2(2))))));
    case 'arccos':
      if (!ARCS) throw new CalculusUnsupported(f);
      return div2(num2(-1), fn('sqrt', add2(ONE2, mul2(num2(-1), pow2(u, num2(2))))));
    default:
      throw new CalculusUnsupported(f);
  }
}
function isAffine(t, x) {
  if (!dependsOn(t, x)) return false;
  try {
    return !dependsOn(derive(t, x), x);
  } catch {
    return false;
  }
}
function termsOf(t) {
  const c = canon(t);
  if (isZeroTerm(c)) return [];
  return c.k === 'add' ? c.c : [c];
}
function splitConstant(t, x) {
  const k = canon(t);
  const fs = k.k === 'mul' ? k.c : [k];
  const c = [];
  const core = [];
  for (const f of fs) {
    if (!dependsOn(f, x)) c.push(f);
    else if (f.k === 'div' && !dependsOn(f.b, x)) {
      c.push(div2(ONE2, f.b));
      core.push(f.a);
    } else core.push(f);
  }
  return { c, core };
}
function usualDerivative(t, x) {
  try {
    const r = usual(canon(t), x);
    return r === null ? null : canon(r);
  } catch {
    return null;
  }
}
function usual(t, x) {
  if (!dependsOn(t, x)) return ZERO2;
  switch (t.k) {
    case 'sym':
      return t.n === x ? ONE2 : ZERO2;
    case 'add': {
      const ds = t.c.map((c) => usual(c, x));
      return ds.every((v) => v !== null) ? add2(...ds) : null;
    }
    case 'mul': {
      const { c, core } = splitConstant(t, x);
      if (core.length !== 1) return null;
      const dc = usual(core[0], x);
      return dc === null ? null : mul2(...c, dc);
    }
    case 'div': {
      if (!dependsOn(t.b, x)) {
        const da = usual(t.a, x);
        return da === null ? null : div2(da, t.b);
      }
      if (dependsOn(t.a, x)) return null;
      const { c: dc, core: dcore } = splitConstant(t.b, x);
      if (dcore.length !== 1) return null;
      const base = powerBase(dcore[0], x);
      if (!base) return null;
      return mul2(
        div2(t.a, dc.length ? mul2(...dc) : ONE2),
        d(pow2(base.b, num2(neg2(base.n))), x),
      );
    }
    case 'pow': {
      if (!dependsOn(t.b, x))
        return isAffine(t.a, x) || (t.a.k === 'sym' && t.a.n === x) ? d(t, x) : null;
      if (!dependsOn(t.a, x)) return isAffine(t.b, x) ? d(t, x) : null;
      return null;
    }
    case 'fn':
      if (!['sqrt', 'exp', 'ln', 'cos', 'sin', 'tan'].includes(t.f) && !arcsOn(t.f)) return null;
      return isAffine(t.a, x) ? d(t, x) : null;
    default:
      return null;
  }
}
function powerBase(b, x) {
  if (isAffine(b, x)) return { b, n: ONE };
  if (b.k === 'pow' && b.b.k === 'num' && isAffine(b.a, x)) return { b: b.a, n: b.b.v };
  if (b.k === 'fn' && b.f === 'sqrt' && isAffine(b.a, x)) return { b: b.a, n: rat(1, 2) };
  return null;
}
function inner(part, x, known2, nested) {
  const u = usualDerivative(part, x);
  if (u) return u;
  const k = known2(part);
  if (k) return k;
  nested.push(part);
  return derive(part, x);
}
function stepTemplate(f, x, known2) {
  try {
    const terms = termsOf(f);
    const out = { pieces: [], rules: [], nested: [] };
    if (terms.length === 1) {
      const q = quotientTemplate(terms[0], x, known2);
      if (q) return q;
    }
    for (const t of terms) {
      const r = termTemplate(t, x, known2, out.nested);
      if (!r) return null;
      out.pieces.push(...r.pieces.filter((p) => !isZeroTerm(canon(p))));
      if (!out.rules.includes(r.rule)) out.rules.push(r.rule);
    }
    if (out.rules.length > 1) out.rules = out.rules.filter((r) => r !== 'usual');
    return out;
  } catch {
    return null;
  }
}
function termTemplate(t, x, known2, nested) {
  const u = usualDerivative(t, x);
  if (u) return { pieces: [u], rule: 'usual' };
  const { c, core } = splitConstant(t, x);
  if (core.length >= 2) {
    const ds = core.map((f) => inner(f, x, known2, nested));
    return {
      pieces: core.map((_, i) => mul2(...c, ...core.map((g2, j) => (i === j ? ds[i] : g2)))),
      rule: 'product',
    };
  }
  const g = core[0];
  if (!g) return { pieces: [], rule: 'usual' };
  if (g.k === 'div') {
    if (!dependsOn(g.a, x)) {
      const dv3 = inner(g.b, x, known2, nested);
      return {
        pieces: [div2(mul2(num2(-1), ...c, g.a, dv3), pow2(g.b, num2(2)))],
        rule: 'inverse',
      };
    }
    const du = inner(g.a, x, known2, nested);
    const dv2 = inner(g.b, x, known2, nested);
    return {
      pieces: [div2(mul2(...c, add2(mul2(du, g.b), mul2(num2(-1), g.a, dv2))), pow2(g.b, num2(2)))],
      rule: 'quotient',
    };
  }
  if (g.k === 'pow' && !dependsOn(g.b, x)) {
    const du = inner(g.a, x, known2, nested);
    return {
      pieces: [mul2(...c, g.b, du, pow2(g.a, add2(g.b, num2(-1))))],
      rule: 'chain_pow',
    };
  }
  if (g.k === 'pow' && !dependsOn(g.a, x)) {
    const du = inner(g.b, x, known2, nested);
    return { pieces: [mul2(...c, fn('ln', g.a), du, g)], rule: 'chain_exp' };
  }
  if (g.k === 'fn' && ['sqrt', 'exp', 'ln', 'cos', 'sin', 'tan'].includes(g.f)) {
    const du = inner(g.a, x, known2, nested);
    const rule =
      g.f === 'exp'
        ? 'chain_exp'
        : g.f === 'ln'
          ? 'chain_ln'
          : g.f === 'sqrt'
            ? 'chain_sqrt'
            : 'chain_trig';
    return { pieces: [mul2(...c, du, outer(g.f, g.a))], rule };
  }
  if (g.k === 'fn' && arcsOn(g.f)) {
    const du = inner(g.a, x, known2, nested);
    return { pieces: [mul2(...c, du, outer(g.f, g.a))], rule: 'chain_arc' };
  }
  return null;
}
function quotientTemplate(t, x, known2) {
  const { c, core } = splitConstant(t, x);
  if (core.length !== 1) return null;
  const g = core[0];
  if (g.k !== 'div' || !dependsOn(g.a, x) || !dependsOn(g.b, x)) return null;
  if (usualDerivative(t, x)) return null;
  const nested = [];
  const du = inner(g.a, x, known2, nested);
  const dv2 = inner(g.b, x, known2, nested);
  return {
    pieces: [mul2(...c, du, g.b), mul2(num2(-1), ...c, g.a, dv2)],
    den: pow2(g.b, num2(2)),
    rules: ['quotient'],
    nested,
  };
}
function closeTo(a, b) {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return false;
  return Math.abs(a - b) <= 1e-9 * Math.max(1, Math.abs(a), Math.abs(b));
}

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/external.js
var external_exports = {};
__export(external_exports, {
  BRAND: () => BRAND,
  DIRTY: () => DIRTY,
  EMPTY_PATH: () => EMPTY_PATH,
  INVALID: () => INVALID,
  NEVER: () => NEVER,
  OK: () => OK,
  ParseStatus: () => ParseStatus,
  Schema: () => ZodType,
  ZodAny: () => ZodAny,
  ZodArray: () => ZodArray,
  ZodBigInt: () => ZodBigInt,
  ZodBoolean: () => ZodBoolean,
  ZodBranded: () => ZodBranded,
  ZodCatch: () => ZodCatch,
  ZodDate: () => ZodDate,
  ZodDefault: () => ZodDefault,
  ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
  ZodEffects: () => ZodEffects,
  ZodEnum: () => ZodEnum,
  ZodError: () => ZodError,
  ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind,
  ZodFunction: () => ZodFunction,
  ZodIntersection: () => ZodIntersection,
  ZodIssueCode: () => ZodIssueCode,
  ZodLazy: () => ZodLazy,
  ZodLiteral: () => ZodLiteral,
  ZodMap: () => ZodMap,
  ZodNaN: () => ZodNaN,
  ZodNativeEnum: () => ZodNativeEnum,
  ZodNever: () => ZodNever,
  ZodNull: () => ZodNull,
  ZodNullable: () => ZodNullable,
  ZodNumber: () => ZodNumber,
  ZodObject: () => ZodObject,
  ZodOptional: () => ZodOptional,
  ZodParsedType: () => ZodParsedType,
  ZodPipeline: () => ZodPipeline,
  ZodPromise: () => ZodPromise,
  ZodReadonly: () => ZodReadonly,
  ZodRecord: () => ZodRecord,
  ZodSchema: () => ZodType,
  ZodSet: () => ZodSet,
  ZodString: () => ZodString,
  ZodSymbol: () => ZodSymbol,
  ZodTransformer: () => ZodEffects,
  ZodTuple: () => ZodTuple,
  ZodType: () => ZodType,
  ZodUndefined: () => ZodUndefined,
  ZodUnion: () => ZodUnion,
  ZodUnknown: () => ZodUnknown,
  ZodVoid: () => ZodVoid,
  addIssueToContext: () => addIssueToContext,
  any: () => anyType,
  array: () => arrayType,
  bigint: () => bigIntType,
  boolean: () => booleanType,
  coerce: () => coerce,
  custom: () => custom,
  date: () => dateType,
  datetimeRegex: () => datetimeRegex,
  defaultErrorMap: () => en_default,
  discriminatedUnion: () => discriminatedUnionType,
  effect: () => effectsType,
  enum: () => enumType,
  function: () => functionType,
  getErrorMap: () => getErrorMap,
  getParsedType: () => getParsedType,
  instanceof: () => instanceOfType,
  intersection: () => intersectionType,
  isAborted: () => isAborted,
  isAsync: () => isAsync,
  isDirty: () => isDirty,
  isValid: () => isValid,
  late: () => late,
  lazy: () => lazyType,
  literal: () => literalType,
  makeIssue: () => makeIssue,
  map: () => mapType,
  nan: () => nanType,
  nativeEnum: () => nativeEnumType,
  never: () => neverType,
  null: () => nullType,
  nullable: () => nullableType,
  number: () => numberType,
  object: () => objectType,
  objectUtil: () => objectUtil,
  oboolean: () => oboolean,
  onumber: () => onumber,
  optional: () => optionalType,
  ostring: () => ostring,
  pipeline: () => pipelineType,
  preprocess: () => preprocessType,
  promise: () => promiseType,
  quotelessJson: () => quotelessJson,
  record: () => recordType,
  set: () => setType,
  setErrorMap: () => setErrorMap,
  strictObject: () => strictObjectType,
  string: () => stringType,
  symbol: () => symbolType,
  transformer: () => effectsType,
  tuple: () => tupleType,
  undefined: () => undefinedType,
  union: () => unionType,
  unknown: () => unknownType,
  util: () => util,
  void: () => voidType,
});

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/util.js
var util;
(function (util2) {
  util2.assertEqual = (_) => {};
  function assertIs(_arg) {}
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== 'number');
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function (e) {
      return obj[e];
    });
  };
  util2.objectKeys =
    typeof Object.keys === 'function'
      ? (obj) => Object.keys(obj)
      : (object) => {
          const keys = [];
          for (const key in object) {
            if (Object.prototype.hasOwnProperty.call(object, key)) {
              keys.push(key);
            }
          }
          return keys;
        };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item)) return item;
    }
    return void 0;
  };
  util2.isInteger =
    typeof Number.isInteger === 'function'
      ? (val5) => Number.isInteger(val5)
      : (val5) => typeof val5 === 'number' && Number.isFinite(val5) && Math.floor(val5) === val5;
  function joinValues(array, separator = ' | ') {
    return array.map((val5) => (typeof val5 === 'string' ? `'${val5}'` : val5)).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === 'bigint') {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function (objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second,
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  'string',
  'nan',
  'number',
  'integer',
  'float',
  'boolean',
  'date',
  'bigint',
  'symbol',
  'function',
  'undefined',
  'null',
  'array',
  'object',
  'unknown',
  'promise',
  'void',
  'never',
  'map',
  'set',
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case 'undefined':
      return ZodParsedType.undefined;
    case 'string':
      return ZodParsedType.string;
    case 'number':
      return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case 'boolean':
      return ZodParsedType.boolean;
    case 'function':
      return ZodParsedType.function;
    case 'bigint':
      return ZodParsedType.bigint;
    case 'symbol':
      return ZodParsedType.symbol;
    case 'object':
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (
        data.then &&
        typeof data.then === 'function' &&
        data.catch &&
        typeof data.catch === 'function'
      ) {
        return ZodParsedType.promise;
      }
      if (typeof Map !== 'undefined' && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== 'undefined' && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== 'undefined' && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/ZodError.js
var ZodIssueCode = util.arrayToEnum([
  'invalid_type',
  'invalid_literal',
  'custom',
  'invalid_union',
  'invalid_union_discriminator',
  'invalid_enum_value',
  'unrecognized_keys',
  'invalid_arguments',
  'invalid_return_type',
  'invalid_date',
  'invalid_string',
  'too_small',
  'too_big',
  'invalid_intersection_types',
  'not_multiple_of',
  'not_finite',
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, '$1:');
};
var ZodError = class _ZodError extends Error {
  get errors() {
    return this.issues;
  }
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub4) => {
      this.issues = [...this.issues, sub4];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = 'ZodError';
    this.issues = issues;
  }
  format(_mapper) {
    const mapper =
      _mapper ||
      function (issue) {
        return issue.message;
      };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === 'invalid_union') {
          issue.unionErrors.map(processError);
        } else if (issue.code === 'invalid_return_type') {
          processError(issue.returnTypeError);
        } else if (issue.code === 'invalid_arguments') {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  static assert(value) {
    if (!(value instanceof _ZodError)) {
      throw new Error(`Not a ZodError: ${value}`);
    }
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub4 of this.issues) {
      if (sub4.path.length > 0) {
        const firstEl = sub4.path[0];
        fieldErrors[firstEl] = fieldErrors[firstEl] || [];
        fieldErrors[firstEl].push(mapper(sub4));
      } else {
        formErrors.push(mapper(sub4));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/locales/en.js
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = 'Required';
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ', ')}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === 'object') {
        if ('includes' in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === 'number') {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ('startsWith' in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ('endsWith' in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== 'regex') {
        message = `Invalid ${issue.validation}`;
      } else {
        message = 'Invalid';
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === 'array')
        message = `Array must contain ${issue.exact ? 'exactly' : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === 'string')
        message = `String must contain ${issue.exact ? 'exactly' : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === 'number')
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === 'bigint')
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === 'date')
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else message = 'Invalid input';
      break;
    case ZodIssueCode.too_big:
      if (issue.type === 'array')
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === 'string')
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === 'number')
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === 'bigint')
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === 'date')
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else message = 'Invalid input';
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = 'Number must be finite';
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var en_default = errorMap;

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/errors.js
var overrideErrorMap = en_default;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/parseUtil.js
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...(issueData.path || [])];
  const fullIssue = {
    ...issueData,
    path: fullPath,
  };
  if (issueData.message !== void 0) {
    return {
      ...issueData,
      path: fullPath,
      message: issueData.message,
    };
  }
  let errorMessage = '';
  const maps = errorMaps
    .filter((m) => !!m)
    .slice()
    .reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: errorMessage,
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const overrideMap = getErrorMap();
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      // contextual error map is first priority
      ctx.schemaErrorMap,
      // then schema-bound map if available
      overrideMap,
      // then global override map
      overrideMap === en_default ? void 0 : en_default,
      // then global default map
    ].filter((x) => !!x),
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = 'valid';
  }
  dirty() {
    if (this.value === 'valid') this.value = 'dirty';
  }
  abort() {
    if (this.value !== 'aborted') this.value = 'aborted';
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === 'aborted') return INVALID;
      if (s.status === 'dirty') status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      const key = await pair.key;
      const value = await pair.value;
      syncPairs.push({
        key,
        value,
      });
    }
    return _ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === 'aborted') return INVALID;
      if (value.status === 'aborted') return INVALID;
      if (key.status === 'dirty') status.dirty();
      if (value.status === 'dirty') status.dirty();
      if (key.value !== '__proto__' && (typeof value.value !== 'undefined' || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: 'aborted',
});
var DIRTY = (value) => ({ status: 'dirty', value });
var OK = (value) => ({ status: 'valid', value });
var isAborted = (x) => x.status === 'aborted';
var isDirty = (x) => x.status === 'dirty';
var isValid = (x) => x.status === 'valid';
var isAsync = (x) => typeof Promise !== 'undefined' && x instanceof Promise;

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/helpers/errorUtil.js
var errorUtil;
(function (errorUtil2) {
  errorUtil2.errToObj = (message) => (typeof message === 'string' ? { message } : message || {});
  errorUtil2.toString = (message) => (typeof message === 'string' ? message : message?.message);
})(errorUtil || (errorUtil = {}));

// node_modules/.pnpm/zod@3.25.76/node_modules/zod/v3/types.js
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (Array.isArray(this._key)) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error('Validation failed but no issues detected.');
    }
    return {
      success: false,
      get error() {
        if (this._error) return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      },
    };
  }
};
function processCreateParams(params) {
  if (!params) return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(
      `Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`,
    );
  }
  if (errorMap2) return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    const { message } = params;
    if (iss.code === 'invalid_enum_value') {
      return { message: message ?? ctx.defaultError };
    }
    if (typeof ctx.data === 'undefined') {
      return { message: message ?? required_error ?? ctx.defaultError };
    }
    if (iss.code !== 'invalid_type') return { message: ctx.defaultError };
    return { message: message ?? invalid_type_error ?? ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return (
      ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent,
      }
    );
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent,
      },
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error('Synchronous parse encountered promise.');
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success) return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    const ctx = {
      common: {
        issues: [],
        async: params?.async ?? false,
        contextualErrorMap: params?.errorMap,
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data),
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  '~validate'(data) {
    const ctx = {
      common: {
        issues: [],
        async: !!this['~standard'].async,
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data),
    };
    if (!this['~standard'].async) {
      try {
        const result = this._parseSync({ data, path: [], parent: ctx });
        return isValid(result)
          ? {
              value: result.value,
            }
          : {
              issues: ctx.common.issues,
            };
      } catch (err) {
        if (err?.message?.toLowerCase()?.includes('encountered')) {
          this['~standard'].async = true;
        }
        ctx.common = {
          issues: [],
          async: true,
        };
      }
    }
    return this._parseAsync({ data, path: [], parent: ctx }).then((result) =>
      isValid(result)
        ? {
            value: result.value,
          }
        : {
            issues: ctx.common.issues,
          },
    );
  }
  async parseAsync(data, params) {
    const result = await this.safeParseAsync(data, params);
    if (result.success) return result.data;
    throw result.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params?.errorMap,
        async: true,
      },
      path: params?.path || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data),
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result = await (isAsync(maybeAsyncResult)
      ? maybeAsyncResult
      : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result);
  }
  refine(check, message) {
    const getIssueProperties = (val5) => {
      if (typeof message === 'string' || typeof message === 'undefined') {
        return { message };
      } else if (typeof message === 'function') {
        return message(val5);
      } else {
        return message;
      }
    };
    return this._refinement((val5, ctx) => {
      const result = check(val5);
      const setError = () =>
        ctx.addIssue({
          code: ZodIssueCode.custom,
          ...getIssueProperties(val5),
        });
      if (typeof Promise !== 'undefined' && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val5, ctx) => {
      if (!check(val5)) {
        ctx.addIssue(
          typeof refinementData === 'function' ? refinementData(val5, ctx) : refinementData,
        );
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: 'refinement', refinement },
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this['~standard'] = {
      version: 1,
      vendor: 'zod',
      validate: (data) => this['~validate'](data),
    };
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: 'transform', transform },
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === 'function' ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault,
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def),
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === 'function' ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch,
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description,
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
var uuidRegex =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex =
  /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
var emailRegex =
  /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex =
  /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex =
  /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
var ipv6Regex =
  /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex =
  /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
var dateRegex = new RegExp(`^${dateRegexSource}$`);
function timeRegexSource(args) {
  let secondsRegexSource = `[0-5]\\d`;
  if (args.precision) {
    secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
  } else if (args.precision == null) {
    secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
  }
  const secondsQuantifier = args.precision ? '+' : '?';
  return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
}
function timeRegex(args) {
  return new RegExp(`^${timeRegexSource(args)}$`);
}
function datetimeRegex(args) {
  let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
  const opts = [];
  opts.push(args.local ? `Z?` : `Z`);
  if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
  regex = `${regex}(${opts.join('|')})`;
  return new RegExp(`^${regex}$`);
}
function isValidIP(ip, version) {
  if ((version === 'v4' || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === 'v6' || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt)) return false;
  try {
    const [header] = jwt.split('.');
    if (!header) return false;
    const base64 = header
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(header.length + ((4 - (header.length % 4)) % 4), '=');
    const decoded = JSON.parse(atob(base64));
    if (typeof decoded !== 'object' || decoded === null) return false;
    if ('typ' in decoded && decoded?.typ !== 'JWT') return false;
    if (!decoded.alg) return false;
    if (alg && decoded.alg !== alg) return false;
    return true;
  } catch {
    return false;
  }
}
function isValidCidr(ip, version) {
  if ((version === 'v4' || !version) && ipv4CidrRegex.test(ip)) {
    return true;
  }
  if ((version === 'v6' || !version) && ipv6CidrRegex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.string,
        received: ctx2.parsedType,
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === 'min') {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: 'string',
            inclusive: true,
            exact: false,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'max') {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: 'string',
            inclusive: true,
            exact: false,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'length') {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: 'string',
              inclusive: true,
              exact: true,
              message: check.message,
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: 'string',
              inclusive: true,
              exact: true,
              message: check.message,
            });
          }
          status.dirty();
        }
      } else if (check.kind === 'email') {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'email',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'emoji') {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, 'u');
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'emoji',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'uuid') {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'uuid',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'nanoid') {
        if (!nanoidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'nanoid',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'cuid') {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'cuid',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'cuid2') {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'cuid2',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'ulid') {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'ulid',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'url') {
        try {
          new URL(input.data);
        } catch {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'url',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'regex') {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'regex',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'trim') {
        input.data = input.data.trim();
      } else if (check.kind === 'includes') {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'toLowerCase') {
        input.data = input.data.toLowerCase();
      } else if (check.kind === 'toUpperCase') {
        input.data = input.data.toUpperCase();
      } else if (check.kind === 'startsWith') {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'endsWith') {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'datetime') {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: 'datetime',
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'date') {
        const regex = dateRegex;
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: 'date',
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'time') {
        const regex = timeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: 'time',
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'duration') {
        if (!durationRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'duration',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'ip') {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'ip',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'jwt') {
        if (!isValidJWT(input.data, check.alg)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'jwt',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'cidr') {
        if (!isValidCidr(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'cidr',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'base64') {
        if (!base64Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'base64',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'base64url') {
        if (!base64urlRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: 'base64url',
            code: ZodIssueCode.invalid_string,
            message: check.message,
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message),
    });
  }
  _addCheck(check) {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, check],
    });
  }
  email(message) {
    return this._addCheck({ kind: 'email', ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: 'url', ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: 'emoji', ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: 'uuid', ...errorUtil.errToObj(message) });
  }
  nanoid(message) {
    return this._addCheck({ kind: 'nanoid', ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: 'cuid', ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: 'cuid2', ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: 'ulid', ...errorUtil.errToObj(message) });
  }
  base64(message) {
    return this._addCheck({ kind: 'base64', ...errorUtil.errToObj(message) });
  }
  base64url(message) {
    return this._addCheck({
      kind: 'base64url',
      ...errorUtil.errToObj(message),
    });
  }
  jwt(options) {
    return this._addCheck({ kind: 'jwt', ...errorUtil.errToObj(options) });
  }
  ip(options) {
    return this._addCheck({ kind: 'ip', ...errorUtil.errToObj(options) });
  }
  cidr(options) {
    return this._addCheck({ kind: 'cidr', ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    if (typeof options === 'string') {
      return this._addCheck({
        kind: 'datetime',
        precision: null,
        offset: false,
        local: false,
        message: options,
      });
    }
    return this._addCheck({
      kind: 'datetime',
      precision: typeof options?.precision === 'undefined' ? null : options?.precision,
      offset: options?.offset ?? false,
      local: options?.local ?? false,
      ...errorUtil.errToObj(options?.message),
    });
  }
  date(message) {
    return this._addCheck({ kind: 'date', message });
  }
  time(options) {
    if (typeof options === 'string') {
      return this._addCheck({
        kind: 'time',
        precision: null,
        message: options,
      });
    }
    return this._addCheck({
      kind: 'time',
      precision: typeof options?.precision === 'undefined' ? null : options?.precision,
      ...errorUtil.errToObj(options?.message),
    });
  }
  duration(message) {
    return this._addCheck({ kind: 'duration', ...errorUtil.errToObj(message) });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: 'regex',
      regex,
      ...errorUtil.errToObj(message),
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: 'includes',
      value,
      position: options?.position,
      ...errorUtil.errToObj(options?.message),
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: 'startsWith',
      value,
      ...errorUtil.errToObj(message),
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: 'endsWith',
      value,
      ...errorUtil.errToObj(message),
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: 'min',
      value: minLength,
      ...errorUtil.errToObj(message),
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: 'max',
      value: maxLength,
      ...errorUtil.errToObj(message),
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: 'length',
      value: len,
      ...errorUtil.errToObj(message),
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: 'trim' }],
    });
  }
  toLowerCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: 'toLowerCase' }],
    });
  }
  toUpperCase() {
    return new _ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: 'toUpperCase' }],
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === 'datetime');
  }
  get isDate() {
    return !!this._def.checks.find((ch) => ch.kind === 'date');
  }
  get isTime() {
    return !!this._def.checks.find((ch) => ch.kind === 'time');
  }
  get isDuration() {
    return !!this._def.checks.find((ch) => ch.kind === 'duration');
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === 'email');
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === 'url');
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === 'emoji');
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === 'uuid');
  }
  get isNANOID() {
    return !!this._def.checks.find((ch) => ch.kind === 'nanoid');
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === 'cuid');
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === 'cuid2');
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === 'ulid');
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === 'ip');
  }
  get isCIDR() {
    return !!this._def.checks.find((ch) => ch.kind === 'cidr');
  }
  get isBase64() {
    return !!this._def.checks.find((ch) => ch.kind === 'base64');
  }
  get isBase64url() {
    return !!this._def.checks.find((ch) => ch.kind === 'base64url');
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'min') {
        if (min === null || ch.value > min) min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'max') {
        if (max === null || ch.value < max) max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params),
  });
};
function floatSafeRemainder(val5, step) {
  const valDecCount = (val5.toString().split('.')[1] || '').length;
  const stepDecCount = (step.toString().split('.')[1] || '').length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = Number.parseInt(val5.toFixed(decCount).replace('.', ''));
  const stepInt = Number.parseInt(step.toFixed(decCount).replace('.', ''));
  return (valInt % stepInt) / 10 ** decCount;
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType,
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === 'int') {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: 'integer',
            received: 'float',
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'min') {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: 'number',
            inclusive: check.inclusive,
            exact: false,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'max') {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: 'number',
            inclusive: check.inclusive,
            exact: false,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'multipleOf') {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'finite') {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message,
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit('min', value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit('min', value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit('max', value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit('max', value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message),
        },
      ],
    });
  }
  _addCheck(check) {
    return new _ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check],
    });
  }
  int(message) {
    return this._addCheck({
      kind: 'int',
      message: errorUtil.toString(message),
    });
  }
  positive(message) {
    return this._addCheck({
      kind: 'min',
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message),
    });
  }
  negative(message) {
    return this._addCheck({
      kind: 'max',
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message),
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: 'max',
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message),
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: 'min',
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message),
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: 'multipleOf',
      value,
      message: errorUtil.toString(message),
    });
  }
  finite(message) {
    return this._addCheck({
      kind: 'finite',
      message: errorUtil.toString(message),
    });
  }
  safe(message) {
    return this._addCheck({
      kind: 'min',
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message),
    })._addCheck({
      kind: 'max',
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message),
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'min') {
        if (min === null || ch.value > min) min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'max') {
        if (max === null || ch.value < max) max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find(
      (ch) => ch.kind === 'int' || (ch.kind === 'multipleOf' && util.isInteger(ch.value)),
    );
  }
  get isFinite() {
    let max = null;
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'finite' || ch.kind === 'int' || ch.kind === 'multipleOf') {
        return true;
      } else if (ch.kind === 'min') {
        if (min === null || ch.value > min) min = ch.value;
      } else if (ch.kind === 'max') {
        if (max === null || ch.value < max) max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: params?.coerce || false,
    ...processCreateParams(params),
  });
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      try {
        input.data = BigInt(input.data);
      } catch {
        return this._getInvalidInput(input);
      }
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      return this._getInvalidInput(input);
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === 'min') {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: 'bigint',
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'max') {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: 'bigint',
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message,
          });
          status.dirty();
        }
      } else if (check.kind === 'multipleOf') {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message,
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _getInvalidInput(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.bigint,
      received: ctx.parsedType,
    });
    return INVALID;
  }
  gte(value, message) {
    return this.setLimit('min', value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit('min', value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit('max', value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit('max', value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message),
        },
      ],
    });
  }
  _addCheck(check) {
    return new _ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check],
    });
  }
  positive(message) {
    return this._addCheck({
      kind: 'min',
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message),
    });
  }
  negative(message) {
    return this._addCheck({
      kind: 'max',
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message),
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: 'max',
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message),
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: 'min',
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message),
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: 'multipleOf',
      value,
      message: errorUtil.toString(message),
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'min') {
        if (min === null || ch.value > min) min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'max') {
        if (max === null || ch.value < max) max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: params?.coerce ?? false,
    ...processCreateParams(params),
  });
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: params?.coerce || false,
    ...processCreateParams(params),
  });
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType,
      });
      return INVALID;
    }
    if (Number.isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date,
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === 'min') {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: 'date',
          });
          status.dirty();
        }
      } else if (check.kind === 'max') {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: 'date',
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime()),
    };
  }
  _addCheck(check) {
    return new _ZodDate({
      ...this._def,
      checks: [...this._def.checks, check],
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: 'min',
      value: minDate.getTime(),
      message: errorUtil.toString(message),
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: 'max',
      value: maxDate.getTime(),
      message: errorUtil.toString(message),
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'min') {
        if (min === null || ch.value > min) min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === 'max') {
        if (max === null || ch.value < max) max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: params?.coerce || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params),
  });
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params),
  });
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params),
  });
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params),
  });
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params),
  });
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params),
  });
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType,
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params),
  });
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params),
  });
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: 'array',
          inclusive: true,
          exact: true,
          message: def.exactLength.message,
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: 'array',
          inclusive: true,
          exact: false,
          message: def.minLength.message,
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: 'array',
          inclusive: true,
          exact: false,
          message: def.maxLength.message,
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all(
        [...ctx.data].map((item, i) => {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        }),
      ).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) },
    });
  }
  max(maxLength, message) {
    return new _ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) },
    });
  }
  length(len, message) {
    return new _ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) },
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params),
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape,
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element),
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const shape2 = this._def.shape();
    const keys = util.objectKeys(shape2);
    this._cached = { shape: shape2, keys };
    return this._cached;
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType,
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape: shape2, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === 'strip')) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape2[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: 'valid', value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data,
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === 'passthrough') {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: 'valid', value: key },
            value: { status: 'valid', value: ctx.data[key] },
          });
        }
      } else if (unknownKeys === 'strict') {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys,
          });
          status.dirty();
        }
      } else if (unknownKeys === 'strip') {
      } else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: 'valid', value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key),
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data,
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve()
        .then(async () => {
          const syncPairs = [];
          for (const pair of pairs) {
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
              key,
              value,
              alwaysSet: pair.alwaysSet,
            });
          }
          return syncPairs;
        })
        .then((syncPairs) => {
          return ParseStatus.mergeObjectSync(status, syncPairs);
        });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject({
      ...this._def,
      unknownKeys: 'strict',
      ...(message !== void 0
        ? {
            errorMap: (issue, ctx) => {
              const defaultError = this._def.errorMap?.(issue, ctx).message ?? ctx.defaultError;
              if (issue.code === 'unrecognized_keys')
                return {
                  message: errorUtil.errToObj(message).message ?? defaultError,
                };
              return {
                message: defaultError,
              };
            },
          }
        : {}),
    });
  }
  strip() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: 'strip',
    });
  }
  passthrough() {
    return new _ZodObject({
      ...this._def,
      unknownKeys: 'passthrough',
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation,
      }),
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape(),
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject,
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject({
      ...this._def,
      catchall: index,
    });
  }
  pick(mask) {
    const shape2 = {};
    for (const key of util.objectKeys(mask)) {
      if (mask[key] && this.shape[key]) {
        shape2[key] = this.shape[key];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape2,
    });
  }
  omit(mask) {
    const shape2 = {};
    for (const key of util.objectKeys(this.shape)) {
      if (!mask[key]) {
        shape2[key] = this.shape[key];
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => shape2,
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    for (const key of util.objectKeys(this.shape)) {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape,
    });
  }
  required(mask) {
    const newShape = {};
    for (const key of util.objectKeys(this.shape)) {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    }
    return new _ZodObject({
      ...this._def,
      shape: () => newShape,
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape2, params) => {
  return new ZodObject({
    shape: () => shape2,
    unknownKeys: 'strip',
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params),
  });
};
ZodObject.strictCreate = (shape2, params) => {
  return new ZodObject({
    shape: () => shape2,
    unknownKeys: 'strict',
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params),
  });
};
ZodObject.lazycreate = (shape2, params) => {
  return new ZodObject({
    shape: shape2,
    unknownKeys: 'strip',
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params),
  });
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === 'valid') {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === 'dirty') {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors,
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(
        options.map(async (option) => {
          const childCtx = {
            ...ctx,
            common: {
              ...ctx.common,
              issues: [],
            },
            parent: null,
          };
          return {
            result: await option._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx,
            }),
            ctx: childCtx,
          };
        }),
      ).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: [],
          },
          parent: null,
        };
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx,
        });
        if (result.status === 'valid') {
          return result;
        } else if (result.status === 'dirty' && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors,
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params),
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [void 0, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodNullable) {
    return [null, ...getDiscriminator(type.unwrap())];
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator],
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx,
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx,
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues.length) {
        throw new Error(
          `A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`,
        );
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(
            `Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`,
          );
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params),
    });
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types,
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        }),
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(
        this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        }),
        this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        }),
      );
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params),
  });
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: 'array',
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: 'array',
      });
      status.dirty();
    }
    const items = [...ctx.data]
      .map((item, itemIndex) => {
        const schema = this._def.items[itemIndex] || this._def.rest;
        if (!schema) return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      })
      .filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple({
      ...this._def,
      rest,
    });
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error('You must pass an array of schemas to z.tuple([ ... ])');
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params),
  });
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
        alwaysSet: key in ctx.data,
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third),
      });
    }
    return new _ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second),
    });
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, 'key'])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, 'value'])),
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === 'aborted' || value.status === 'aborted') {
            return INVALID;
          }
          if (key.status === 'dirty' || value.status === 'dirty') {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === 'aborted' || value.status === 'aborted') {
          return INVALID;
        }
        if (key.status === 'dirty' || value.status === 'dirty') {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params),
  });
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: 'set',
          inclusive: true,
          exact: false,
          message: def.minSize.message,
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: 'set',
          inclusive: true,
          exact: false,
          message: def.maxSize.message,
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === 'aborted') return INVALID;
        if (element.status === 'dirty') status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) =>
      valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)),
    );
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) },
    });
  }
  max(maxSize, message) {
    return new _ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) },
    });
  }
  size(size3, message) {
    return this.min(size3, message).max(size3, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params),
  });
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          en_default,
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error,
        },
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          en_default,
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error,
        },
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn2 = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function (...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result = await Reflect.apply(fn2, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type
          .parseAsync(result, params)
          .catch((e) => {
            error.addIssue(makeReturnsIssue(result, e));
            throw error;
          });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function (...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn2, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create()),
    });
  }
  returns(returnType) {
    return new _ZodFunction({
      ...this._def,
      returns: returnType,
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params),
    });
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params),
  });
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value,
      });
      return INVALID;
    }
    return { status: 'valid', value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params),
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params),
  });
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== 'string') {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type,
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(this._def.values);
    }
    if (!this._cache.has(input.data)) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues,
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val5 of this._def.values) {
      enumValues[val5] = val5;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val5 of this._def.values) {
      enumValues[val5] = val5;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val5 of this._def.values) {
      enumValues[val5] = val5;
    }
    return enumValues;
  }
  extract(values, newDef = this._def) {
    return _ZodEnum.create(values, {
      ...this._def,
      ...newDef,
    });
  }
  exclude(values, newDef = this._def) {
    return _ZodEnum.create(
      this.options.filter((opt) => !values.includes(opt)),
      {
        ...this._def,
        ...newDef,
      },
    );
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type,
      });
      return INVALID;
    }
    if (!this._cache) {
      this._cache = new Set(util.getValidEnumValues(this._def.values));
    }
    if (!this._cache.has(input.data)) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues,
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params),
  });
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    const promisified =
      ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(
      promisified.then((data) => {
        return this._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap,
        });
      }),
    );
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params),
  });
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
      ? this._def.schema.sourceType()
      : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      },
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === 'preprocess') {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.async) {
        return Promise.resolve(processed).then(async (processed2) => {
          if (status.value === 'aborted') return INVALID;
          const result = await this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx,
          });
          if (result.status === 'aborted') return INVALID;
          if (result.status === 'dirty') return DIRTY(result.value);
          if (status.value === 'dirty') return DIRTY(result.value);
          return result;
        });
      } else {
        if (status.value === 'aborted') return INVALID;
        const result = this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx,
        });
        if (result.status === 'aborted') return INVALID;
        if (result.status === 'dirty') return DIRTY(result.value);
        if (status.value === 'dirty') return DIRTY(result.value);
        return result;
      }
    }
    if (effect.type === 'refinement') {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error(
            'Async refinement encountered during synchronous parse operation. Use .parseAsync instead.',
          );
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner2 = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        });
        if (inner2.status === 'aborted') return INVALID;
        if (inner2.status === 'dirty') status.dirty();
        executeRefinement(inner2.value);
        return { status: status.value, value: inner2.value };
      } else {
        return this._def.schema
          ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
          .then((inner2) => {
            if (inner2.status === 'aborted') return INVALID;
            if (inner2.status === 'dirty') status.dirty();
            return executeRefinement(inner2.value).then(() => {
              return { status: status.value, value: inner2.value };
            });
          });
      }
    }
    if (effect.type === 'transform') {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        });
        if (!isValid(base)) return INVALID;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(
            `Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`,
          );
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema
          ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
          .then((base) => {
            if (!isValid(base)) return INVALID;
            return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({
              status: status.value,
              value: result,
            }));
          });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params),
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: 'preprocess', transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params),
  });
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params),
  });
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params),
  });
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx,
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === 'function' ? params.default : () => params.default,
    ...processCreateParams(params),
  });
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: [],
      },
    };
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx,
      },
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: 'valid',
          value:
            result2.status === 'valid'
              ? result2.value
              : this._def.catchValue({
                  get error() {
                    return new ZodError(newCtx.common.issues);
                  },
                  input: newCtx.data,
                }),
        };
      });
    } else {
      return {
        status: 'valid',
        value:
          result.status === 'valid'
            ? result.value
            : this._def.catchValue({
                get error() {
                  return new ZodError(newCtx.common.issues);
                },
                input: newCtx.data,
              }),
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === 'function' ? params.catch : () => params.catch,
    ...processCreateParams(params),
  });
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType,
      });
      return INVALID;
    }
    return { status: 'valid', value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params),
  });
};
var BRAND = Symbol('zod_brand');
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx,
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx,
        });
        if (inResult.status === 'aborted') return INVALID;
        if (inResult.status === 'dirty') {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx,
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx,
      });
      if (inResult.status === 'aborted') return INVALID;
      if (inResult.status === 'dirty') {
        status.dirty();
        return {
          status: 'dirty',
          value: inResult.value,
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx,
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline,
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    const freeze = (data) => {
      if (isValid(data)) {
        data.value = Object.freeze(data.value);
      }
      return data;
    };
    return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params),
  });
};
function cleanParams(params, data) {
  const p =
    typeof params === 'function'
      ? params(data)
      : typeof params === 'string'
        ? { message: params }
        : params;
  const p2 = typeof p === 'string' ? { message: p } : p;
  return p2;
}
function custom(check, _params = {}, fatal) {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      const r = check(data);
      if (r instanceof Promise) {
        return r.then((r2) => {
          if (!r2) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({ code: 'custom', ...params, fatal: _fatal });
          }
        });
      }
      if (!r) {
        const params = cleanParams(_params, data);
        const _fatal = params.fatal ?? fatal ?? true;
        ctx.addIssue({ code: 'custom', ...params, fatal: _fatal });
      }
      return;
    });
  return ZodAny.create();
}
var late = {
  object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2['ZodString'] = 'ZodString';
  ZodFirstPartyTypeKind2['ZodNumber'] = 'ZodNumber';
  ZodFirstPartyTypeKind2['ZodNaN'] = 'ZodNaN';
  ZodFirstPartyTypeKind2['ZodBigInt'] = 'ZodBigInt';
  ZodFirstPartyTypeKind2['ZodBoolean'] = 'ZodBoolean';
  ZodFirstPartyTypeKind2['ZodDate'] = 'ZodDate';
  ZodFirstPartyTypeKind2['ZodSymbol'] = 'ZodSymbol';
  ZodFirstPartyTypeKind2['ZodUndefined'] = 'ZodUndefined';
  ZodFirstPartyTypeKind2['ZodNull'] = 'ZodNull';
  ZodFirstPartyTypeKind2['ZodAny'] = 'ZodAny';
  ZodFirstPartyTypeKind2['ZodUnknown'] = 'ZodUnknown';
  ZodFirstPartyTypeKind2['ZodNever'] = 'ZodNever';
  ZodFirstPartyTypeKind2['ZodVoid'] = 'ZodVoid';
  ZodFirstPartyTypeKind2['ZodArray'] = 'ZodArray';
  ZodFirstPartyTypeKind2['ZodObject'] = 'ZodObject';
  ZodFirstPartyTypeKind2['ZodUnion'] = 'ZodUnion';
  ZodFirstPartyTypeKind2['ZodDiscriminatedUnion'] = 'ZodDiscriminatedUnion';
  ZodFirstPartyTypeKind2['ZodIntersection'] = 'ZodIntersection';
  ZodFirstPartyTypeKind2['ZodTuple'] = 'ZodTuple';
  ZodFirstPartyTypeKind2['ZodRecord'] = 'ZodRecord';
  ZodFirstPartyTypeKind2['ZodMap'] = 'ZodMap';
  ZodFirstPartyTypeKind2['ZodSet'] = 'ZodSet';
  ZodFirstPartyTypeKind2['ZodFunction'] = 'ZodFunction';
  ZodFirstPartyTypeKind2['ZodLazy'] = 'ZodLazy';
  ZodFirstPartyTypeKind2['ZodLiteral'] = 'ZodLiteral';
  ZodFirstPartyTypeKind2['ZodEnum'] = 'ZodEnum';
  ZodFirstPartyTypeKind2['ZodEffects'] = 'ZodEffects';
  ZodFirstPartyTypeKind2['ZodNativeEnum'] = 'ZodNativeEnum';
  ZodFirstPartyTypeKind2['ZodOptional'] = 'ZodOptional';
  ZodFirstPartyTypeKind2['ZodNullable'] = 'ZodNullable';
  ZodFirstPartyTypeKind2['ZodDefault'] = 'ZodDefault';
  ZodFirstPartyTypeKind2['ZodCatch'] = 'ZodCatch';
  ZodFirstPartyTypeKind2['ZodPromise'] = 'ZodPromise';
  ZodFirstPartyTypeKind2['ZodBranded'] = 'ZodBranded';
  ZodFirstPartyTypeKind2['ZodPipeline'] = 'ZodPipeline';
  ZodFirstPartyTypeKind2['ZodReadonly'] = 'ZodReadonly';
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (
  cls,
  params = {
    message: `Input not instance of ${cls.name}`,
  },
) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) =>
    ZodBoolean.create({
      ...arg,
      coerce: true,
    }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true }),
};
var NEVER = INVALID;

// packages/reasoner/src/kernel/types.ts
var KERNEL_SCHEMA_VERSION = 1;
var SORTS = ['real', 'integer', 'natural', 'rational', 'complex', 'vector', 'matrix', 'bool'];
var SortSchema = external_exports.enum(SORTS);
var MathTextSchema = external_exports.string().trim().min(1).max(400);
var CONDITION_KINDS = [
  'real',
  'integer',
  'natural',
  'nonzero',
  'positive',
  'negative',
  'nonnegative',
  /** nul : sert aux branches d'un cas « a > 0 / a < 0 / a = 0 » (lot 2, additif) */
  'zero',
  'distinct',
  'defined_on',
];
var ConditionKindSchema = external_exports.enum(CONDITION_KINDS);
var IntervalSchema = external_exports
  .object({
    lo: external_exports.string().regex(RAT_TEXT_RE).nullable(),
    hi: external_exports.string().regex(RAT_TEXT_RE).nullable(),
    loOpen: external_exports.boolean(),
    hiOpen: external_exports.boolean(),
  })
  .strict()
  .superRefine((iv, ctx) => {
    if (iv.lo === null && !iv.loOpen)
      ctx.addIssue({ code: 'custom', path: ['loOpen'], message: 'borne infinie ferm\xE9e' });
    if (iv.hi === null && !iv.hiOpen)
      ctx.addIssue({ code: 'custom', path: ['hiOpen'], message: 'borne infinie ferm\xE9e' });
    if (iv.lo !== null && iv.hi !== null) {
      const c = cmp(ratFromText(iv.lo), ratFromText(iv.hi));
      if (c > 0 || (c === 0 && (iv.loOpen || iv.hiOpen)))
        ctx.addIssue({ code: 'custom', path: ['hi'], message: 'intervalle vide' });
    }
  });
var ConditionSchema = external_exports
  .object({
    kind: ConditionKindSchema,
    of: external_exports.array(MathTextSchema).min(1).max(8),
    domain: IntervalSchema.optional(),
  })
  .strict()
  .superRefine((c, ctx) => {
    if (c.kind === 'distinct' ? c.of.length < 2 : c.of.length !== 1)
      ctx.addIssue({
        code: 'custom',
        path: ['of'],
        message: c.kind === 'distinct' ? 'au moins deux termes' : 'un seul terme',
      });
    if ((c.kind === 'defined_on') !== (c.domain !== void 0))
      ctx.addIssue({
        code: 'custom',
        path: ['domain'],
        message: 'domaine requis pour defined_on, interdit sinon',
      });
  });
var CORE_GOALS = [
  'factor',
  'expand',
  'simplify',
  'solve',
  'isolate_variable',
  'compute',
  'compare',
  'prove',
  'differentiate',
  'integrate',
  'find_antiderivative',
  'find_limit',
  'model',
  'verify_program',
];
var PLUGIN_GOAL_RE = /^[a-z][a-z0-9-]{1,39}\.[a-z][a-z0-9_]{1,39}$/;
var GoalKindSchema = external_exports.union([
  external_exports.enum(CORE_GOALS),
  external_exports.string().regex(PLUGIN_GOAL_RE),
]);
var GoalSchema = external_exports
  .object({ kind: GoalKindSchema, target: MathTextSchema.optional() })
  .strict()
  .superRefine((g, ctx) => {
    if (g.kind === 'isolate_variable' && g.target === void 0)
      ctx.addIssue({ code: 'custom', path: ['target'], message: 'variable \xE0 isoler requise' });
  });
var STEP_STATUSES = ['valid', 'invalid', 'conditional', 'unknown', 'unsupported'];
var StepStatusSchema = external_exports.enum(STEP_STATUSES);
var STEP_RELATIONS = [
  'identity',
  'equivalent',
  'implies',
  'deduction',
  'evaluation',
  'approximation',
  'none',
];
var StepRelationSchema = external_exports.enum(STEP_RELATIONS);
var PROOFS = ['exact', 'rule', 'sampled', 'none'];
var ProofSchema = external_exports.enum(PROOFS);
var RULE_ID_RE = /^[a-z][a-z0-9_]{0,39}(\.[a-z][a-z0-9_]{0,39}){1,3}$/;
var QUALIFIED_RULE_ID_RE = /^[a-z][a-z0-9_]{0,39}(\.[a-z][a-z0-9_]{0,39}){1,3}@[1-9]\d{0,2}$/;
var QUALIFIED_PACK_ID_RE = /^[a-z][a-z0-9-]{1,39}@[1-9]\d{0,2}$/;
var ExplanationSchema = external_exports
  .object({
    code: external_exports.string().regex(/^[a-z][a-z0-9_]{0,63}$/),
    params: external_exports
      .record(
        external_exports.string().regex(/^[a-z][a-zA-Z0-9_]{0,31}$/),
        external_exports.string().max(400),
      )
      .optional(),
  })
  .strict();
var TraceStepSchema = external_exports
  .object({
    from: MathTextSchema,
    to: MathTextSchema,
    relation: StepRelationSchema,
    ruleId: external_exports.string().regex(QUALIFIED_RULE_ID_RE).optional(),
    explanation: ExplanationSchema.optional(),
  })
  .strict();
var BranchSchema = external_exports.lazy(() =>
  external_exports
    .object({ when: external_exports.array(ConditionSchema).min(1).max(8), check: StepCheckSchema })
    .strict(),
);
var StepCheckSchema = external_exports.lazy(() =>
  external_exports
    .object({
      status: StepStatusSchema,
      relation: StepRelationSchema,
      proof: ProofSchema,
      ruleId: external_exports.string().regex(QUALIFIED_RULE_ID_RE).optional(),
      explanation: ExplanationSchema.optional(),
      conditions: external_exports.array(ConditionSchema).max(16).optional(),
      branches: external_exports.array(BranchSchema).min(2).max(8).optional(),
      trace: external_exports.array(TraceStepSchema).max(64).optional(),
    })
    .strict(),
);
var BudgetSchema = external_exports
  .object({
    /** temps de calcul (ms) ; 0 = déjà épuisé */
    ms: external_exports.number().int().min(0).max(6e4),
    /** nœuds explorés au plus */
    nodes: external_exports.number().int().min(1).max(1e7),
    /** profondeur de recherche */
    depth: external_exports.number().int().min(1).max(64),
    /** branches de cas au plus */
    branches: external_exports.number().int().min(0).max(64),
  })
  .strict();
var ReasoningStateSchema = external_exports
  .object({
    statement: MathTextSchema,
    sort: SortSchema,
    hypotheses: external_exports.array(ConditionSchema).max(32),
    conditions: external_exports.array(ConditionSchema).max(32),
    goal: GoalSchema.optional(),
  })
  .strict();
var StepInputSchema = external_exports
  .object({
    sort: SortSchema,
    from: MathTextSchema,
    to: MathTextSchema,
    goal: GoalSchema.optional(),
    hypotheses: external_exports.array(ConditionSchema).max(32).optional(),
  })
  .strict();
var EnvelopeBase = {
  v: external_exports.literal(KERNEL_SCHEMA_VERSION),
  /** paquets de règles utilisés (« algebra-core@1 ») : rejouer avec les mêmes */
  packs: external_exports.array(external_exports.string().regex(QUALIFIED_PACK_ID_RE)).max(32),
};
var EnvelopeSchema = external_exports.discriminatedUnion('kind', [
  external_exports
    .object({
      ...EnvelopeBase,
      kind: external_exports.literal('state'),
      body: ReasoningStateSchema,
    })
    .strict(),
  external_exports
    .object({ ...EnvelopeBase, kind: external_exports.literal('check'), body: StepCheckSchema })
    .strict(),
]);

// packages/reasoner/src/kernel/conditions.ts
var SIGN = {
  pos: { pos: true, zero: false, neg: false },
  neg: { pos: false, zero: false, neg: true },
  zero: { pos: false, zero: true, neg: false },
  nonzero: { pos: true, zero: false, neg: true },
  nonneg: { pos: true, zero: true, neg: false },
  nonpos: { pos: false, zero: true, neg: true },
  any: { pos: true, zero: true, neg: true },
};
var KIND_SIGN = {
  positive: SIGN.pos,
  negative: SIGN.neg,
  nonzero: SIGN.nonzero,
  nonnegative: SIGN.nonneg,
  zero: SIGN.zero,
  natural: SIGN.nonneg,
};

// packages/reasoner/src/kernel/witness.ts
var SAMPLE_POOL = [
  [2, 1],
  [3, 1],
  [-1, 1],
  [1, 2],
  [-2, 1],
  [5, 3],
  [1, 1],
  [-3, 2],
  [4, 1],
  [-5, 1],
  [7, 2],
  [1, 3],
  [-2, 3],
  [6, 1],
  [-7, 1],
  [10, 1],
  [0, 1],
  [9, 4],
  [-1, 2],
  [11, 1],
].map(([n, d2]) => rat(n, d2));

// packages/reasoner/src/kernel/trig.ts
var PI = sym2('\u03C0');
var TWO = rat(2);

// packages/reasoner/src/kernel-claims-gestures.ts
var CLAIM_FORMS = ['irreducible', 'scientific', 'primes', 'prime'];

// packages/reasoner/src/kernel-claims.ts
var CLAIMS_STEP_IDS = {
  compute: 'kernel.compute@1',
  expand: 'kernel.expand@1',
  replace: 'kernel.substitute@1',
  signs: 'claims.signs@1',
  power: 'claims.power@1',
  fraction: 'claims.fraction@1',
  trig: 'claims.trig@1',
  root: 'claims.root@1',
  factor: 'claims.factor@1',
  scientific: 'claims.scientific@1',
  euclid: 'claims.euclid@1',
  ln: 'claims.ln@1',
  /** moteur v53 : décomposer le numérateur et le dénominateur en facteurs premiers */
  fractionPrimes: 'claims.fraction_primes@1',
  decide: 'claims.decide@1',
};
var CARD = 'Calcul';
var STEP = {
  compute: {
    id: CLAIMS_STEP_IDS.compute,
    label: 'Calculer',
    hora: 1,
    why: 'On fait un calcul (un seul par endroit) : la valeur ne change pas, elle s\u2019\xE9crit plus simplement.',
  },
  expand: {
    id: CLAIMS_STEP_IDS.expand,
    label: 'D\xE9velopper',
    hora: 1,
    why: 'On distribue : k \xD7 (a + b) = k \xD7 a + k \xD7 b.',
  },
  // moteur v50 : affirmations en lettres
  expandLetters: {
    id: CLAIMS_STEP_IDS.expand,
    label: 'D\xE9velopper',
    hora: 1,
    why: 'On d\xE9veloppe un produit (k(a + b) = ka + kb, (a + b)(c + d) = ac + ad + bc + bd, (a \u2212 b)\xB2 = a\xB2 \u2212 2ab + b\xB2\u2026) : l\u2019expression ne change pas, elle s\u2019\xE9crit autrement.',
  },
  parens: {
    id: CLAIMS_STEP_IDS.expand,
    label: 'Enlever les parenth\xE8ses',
    hora: 1,
    why: 'Des parenth\xE8ses pr\xE9c\xE9d\xE9es de \xAB + \xBB s\u2019enl\xE8vent sans rien changer ; pr\xE9c\xE9d\xE9es de \xAB \u2212 \xBB, on change le signe de chaque terme.',
  },
  reduce: {
    id: CLAIMS_STEP_IDS.compute,
    label: 'R\xE9duire',
    hora: 1,
    why: 'On calcule les nombres et on regroupe les termes semblables (5x + 5x = 10x, x \xD7 x = x\xB2) : l\u2019expression ne change pas.',
  },
  factorLetters: {
    id: CLAIMS_STEP_IDS.factor,
    label: 'Factoriser',
    hora: 1,
    why: 'On met un facteur commun en \xE9vidence (ka + kb = k(a + b)) ou on reconna\xEEt une identit\xE9 remarquable : l\u2019expression ne change pas.',
  },
  powerRules: {
    id: CLAIMS_STEP_IDS.power,
    label: 'R\xE8gles des puissances',
    hora: 1,
    why: 'a\u207F \xD7 a\u1D50 = a\u207F\u207A\u1D50, a\u207F \xF7 a\u1D50 = a\u207F\u207B\u1D50, (a\u207F)\u1D50 = a\u207F\u02E3\u1D50.',
  },
  replace: {
    id: CLAIMS_STEP_IDS.replace,
    label: 'Remplacer',
    hora: 2,
    why: 'On remplace la lettre par la valeur propos\xE9e.',
  },
  signs: {
    id: CLAIMS_STEP_IDS.signs,
    label: 'R\xE8gle des signes',
    hora: 1,
    why: 'On enl\xE8ve les parenth\xE8ses d\u2019un nombre relatif : soustraire \u22123, c\u2019est ajouter 3 ; ajouter \u22123, c\u2019est soustraire 3.',
  },
  powerNeg: {
    id: CLAIMS_STEP_IDS.power,
    label: 'Puissance n\xE9gative',
    hora: 1,
    why: 'a\u207B\u207F = 1 \xF7 a\u207F.',
  },
  powerProduct: {
    id: CLAIMS_STEP_IDS.power,
    label: 'Produit de puissances',
    hora: 1,
    why: 'a\u1D50 \xD7 a\u207F = a\u1D50\u207A\u207F : on ajoute les exposants.',
  },
  powerQuotient: {
    id: CLAIMS_STEP_IDS.power,
    label: 'Quotient de puissances',
    hora: 1,
    why: 'a\u1D50 \xF7 a\u207F = a\u1D50\u207B\u207F : on soustrait les exposants.',
  },
  powerPower: {
    id: CLAIMS_STEP_IDS.power,
    label: 'Puissance d\u2019une puissance',
    hora: 1,
    why: '(a\u1D50)\u207F = a\u1D50\u02E3\u207F : on multiplie les exposants.',
  },
  powerExpand: {
    id: CLAIMS_STEP_IDS.power,
    label: '\xC9crire la puissance en produit',
    hora: 1,
    why: 'a\u207F = a \xD7 a \xD7 \u2026 \xD7 a : n facteurs \xE9gaux \xE0 a.',
  },
  fracSimplify: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Simplifier la fraction',
    hora: 1,
    why: 'On divise le num\xE9rateur et le d\xE9nominateur par un m\xEAme nombre.',
  },
  fracFactor: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Facteur commun',
    hora: 1,
    why: 'On fait appara\xEEtre un m\xEAme facteur au num\xE9rateur et au d\xE9nominateur.',
  },
  fracCommon: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'M\xEAme d\xE9nominateur',
    hora: 1,
    why: 'On \xE9crit les fractions avec le m\xEAme d\xE9nominateur.',
  },
  fracAdd: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Additionner les num\xE9rateurs',
    hora: 1,
    why: 'M\xEAme d\xE9nominateur : on additionne les num\xE9rateurs, on garde le d\xE9nominateur.',
  },
  fracMul: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Multiplier les fractions',
    hora: 1,
    why: 'On multiplie les num\xE9rateurs entre eux, et les d\xE9nominateurs entre eux.',
  },
  fracInverse: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Multiplier par l\u2019inverse',
    hora: 1,
    why: 'Diviser par une fraction, c\u2019est multiplier par son inverse.',
  },
  trig: {
    id: CLAIMS_STEP_IDS.trig,
    label: 'Angles associ\xE9s',
    hora: 1,
    why: 'cos(\u03C0 \u2212 x) = \u2212cos(x), sin(\u03C0 \u2212 x) = sin(x), cos(\u2212x) = cos(x), sin(\u2212x) = \u2212sin(x), cos(\u03C0 + x) = \u2212cos(x), cos(\u03C0 \xF7 2 \u2212 x) = sin(x)\u2026 : on se ram\xE8ne \xE0 un angle entre 0 et \u03C0 \xF7 2.',
  },
  circle: {
    id: CLAIMS_STEP_IDS.trig,
    label: 'Lire sur le cercle',
    hora: 1,
    why: 'Sur le cercle trigonom\xE9trique, cet angle est associ\xE9 \xE0 un angle entre 0 et \u03C0 \xF7 2 : on y lit sa valeur, avec son signe.',
  },
  rootWrite: {
    id: CLAIMS_STEP_IDS.root,
    label: '\xC9crire comme une racine',
    hora: 1,
    why: 'Un nombre positif a est la racine carr\xE9e de a\xB2 : 3 = \u221A9. On compare ensuite les nombres sous la racine.',
  },
  rootSimplify: {
    id: CLAIMS_STEP_IDS.root,
    label: 'Simplifier la racine',
    hora: 1,
    why: '\u221A(a\xB2 \xD7 b) = a\u221Ab : on sort les carr\xE9s de la racine (\u221A40 = \u221A(4 \xD7 10) = 2\u221A10).',
  },
  decompose: {
    id: CLAIMS_STEP_IDS.factor,
    label: 'D\xE9composer',
    hora: 1,
    why: 'On \xE9crit un nombre comme le produit de deux entiers plus grands que 1 (84 = 2 \xD7 42, puis 42 = 2 \xD7 21\u2026).',
  },
  // moteur v53 (lot 6.57) : une fraction irréductible par les facteurs premiers
  fracPrimes: {
    id: CLAIMS_STEP_IDS.fractionPrimes,
    label: 'D\xE9composer en facteurs premiers',
    hora: 2,
    why: 'On d\xE9compose le num\xE9rateur et le d\xE9nominateur en facteurs premiers : s\u2019ils n\u2019ont aucun facteur commun, la fraction est irr\xE9ductible (16 \xF7 51 = 2\u2074 \xF7 (3 \xD7 17)).',
  },
  powerGroup: {
    id: CLAIMS_STEP_IDS.power,
    label: 'Regrouper en puissance',
    hora: 1,
    why: 'Un m\xEAme facteur r\xE9p\xE9t\xE9 s\u2019\xE9crit avec une puissance : 2 \xD7 2 \xD7 2 = 2\xB3.',
  },
  cancel: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Barrer les facteurs communs',
    hora: 1,
    why: 'On barre un m\xEAme facteur en haut et en bas de la fraction : (2 \xD7 2 \xD7 3) \xF7 (2 \xD7 3 \xD7 5) = 2 \xF7 5.',
  },
  decimalFrac: {
    id: CLAIMS_STEP_IDS.fraction,
    label: 'Fraction d\xE9cimale',
    hora: 1,
    why: 'Un nombre d\xE9cimal s\u2019\xE9crit comme une fraction de d\xE9nominateur 10, 100, 1000\u2026 : 0,125 = 125 \xF7 1000.',
  },
  euclid: {
    id: CLAIMS_STEP_IDS.euclid,
    label: 'Division euclidienne',
    hora: 1,
    why: 'On \xE9crit la division euclidienne : nombre = diviseur \xD7 quotient + reste, le reste entre 1 et le diviseur moins 1 (17 = 5 \xD7 3 + 2).',
  },
  sciWrite: {
    id: CLAIMS_STEP_IDS.scientific,
    label: 'Puissance de 10',
    hora: 1,
    why: 'On d\xE9place la virgule et l\u2019exposant de 10 compte les rangs : 45 000 = 4,5 \xD7 10\u2074, 0,5 \xD7 10\u207B\xB3 = 5 \xD7 10\u207B\u2074.',
  },
  // moteur v45 (lot 6.43) : les règles de ln
  lnProduct: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Logarithme d\u2019un produit',
    hora: 1,
    why: 'ln(a \xD7 b) = ln(a) + ln(b), pour a > 0 et b > 0 (de m\xEAme avec log).',
  },
  lnQuotient: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Logarithme d\u2019un quotient',
    hora: 1,
    why: 'ln(a \xF7 b) = ln(a) \u2212 ln(b), pour a > 0 et b > 0 (de m\xEAme avec log).',
  },
  lnPower: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Logarithme d\u2019une puissance',
    hora: 1,
    why: 'ln(a\u207F) = n \xD7 ln(a), pour a > 0 (de m\xEAme avec log).',
  },
  lnRoot: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Logarithme d\u2019une racine',
    hora: 1,
    why: 'ln(\u221Aa) = (1 \xF7 2) \xD7 ln(a), pour a > 0 (de m\xEAme avec log).',
  },
  lnInverse: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Logarithme d\u2019un inverse',
    hora: 1,
    why: 'ln(1 \xF7 a) = \u2212ln(a), pour a > 0 (de m\xEAme avec log).',
  },
  lnValue: {
    id: CLAIMS_STEP_IDS.ln,
    label: 'Valeur \xE0 conna\xEEtre',
    hora: 1,
    why: 'ln(1) = 0, ln(e) = 1, ln(e\u02E3) = x ; log(1) = 0, log(10) = 1, log(10\u02E3) = x.',
  },
  lnWrite: {
    id: CLAIMS_STEP_IDS.ln,
    label: '\xC9crire comme une puissance',
    hora: 1,
    why: 'On \xE9crit le nombre comme une puissance (8 = 2\xB3, 0,01 = 10\u207B\xB2, \u221Ae = e^(1 \xF7 2)) pour se servir de ln(a\u207F) = n \xD7 ln(a).',
  },
};
var DECIDE = {
  id: CLAIMS_STEP_IDS.decide,
  card: CARD,
  label: 'Trancher',
  hora: 1,
  why: '',
};

// packages/reasoner/src/kernel-python.ts
var PYTHON_STEP_IDS = {
  block: 'python.block@1',
  iteration: 'python.iteration@1',
  branch: 'python.branch@1',
  return: 'python.return@1',
  assign: 'python.assign@1',
  condition: 'python.condition@1',
  call: 'python.call@1',
  conclude: 'python.conclude@1',
  // moteur v29
  eval: 'python.eval@1',
  jump: 'python.jump@1',
  complete: 'python.complete@1',
};
var CMPS = ['<', '>', '\u2264', '\u2265', '\u2260'];
var ARITH = ['+', '\u2212', '\xD7', '\xF7', '%'];
var LIST_SIGNS = ['[', ']', ','];
var OPS = /* @__PURE__ */ new Set(['=', '\u2248', ';', '(', ')', ...LIST_SIGNS, ...CMPS, ...ARITH]);
var UNIT_LABEL = {
  block: {
    id: PYTHON_STEP_IDS.block,
    label: 'Ex\xE9cuter les instructions',
    why: (s) => `Les instructions s\u2019ex\xE9cutent dans l\u2019ordre : ${s}.`,
  },
  iteration: {
    id: PYTHON_STEP_IDS.iteration,
    label: 'Un tour de boucle',
    why: (s) => `Apr\xE8s ce tour de boucle : ${s}.`,
  },
  branch: {
    id: PYTHON_STEP_IDS.branch,
    label: 'Ex\xE9cuter le bloc',
    why: (s) => `Le test choisit le bloc \xE0 ex\xE9cuter : ${s}.`,
  },
  return: {
    id: PYTHON_STEP_IDS.return,
    label: 'La valeur renvoy\xE9e',
    why: (s) => `La fonction renvoie sa valeur : ${s}.`,
  },
};

// packages/reasoner/src/kernel/matrix.ts
var SUP_DIGITS2 = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
var SUB_DIGITS = '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089';
var MATRIX_NAME_RE = new RegExp(`^([A-Z]|\u03C0)[${SUB_DIGITS}]*$`);
var SUP_RE = new RegExp(`^(\u207B\xB9|\u1D40|[${SUP_DIGITS2}]+)$`);
var ENTRY_RE = new RegExp(`^[${SUB_DIGITS}]+$`);
var ENTRY_TEXT_RE = new RegExp(`\\)[${SUB_DIGITS}]`);
var IDENTITY_RE = new RegExp(`^I([${SUB_DIGITS}]*)$`);

// packages/reasoner/src/named-products.ts
var LETTER_RE = /^[A-Za-zÀ-ÖØ-öø-ÿΑ-Ωα-ορ-ω]$/;
var RUN_RE = /[A-Za-zÀ-ÖØ-öø-ÿΑ-Ωα-ορ-ω]+/g;
var GLUE_RE = /[\u2080-\u209c′'’_]|\p{M}/u;
var RESERVED = /* @__PURE__ */ new Set([
  ...Object.keys(FUNCS),
  PARMI,
  'ou',
  'et',
  'det',
  'card',
  'pgcd',
  'PGCD',
  'ppcm',
  'PPCM',
  'mod',
]);
var LITERAL_PLUGINS = /* @__PURE__ */ new Set(['algebra', 'formula', 'claims', 'analysis']);
var single = (n) => !!n && LETTER_RE.test(n);
function namedLetters(model) {
  const out = /* @__PURE__ */ new Set();
  const add3 = (n) => {
    if (single(n)) out.add(n);
  };
  Object.keys(model.symbols ?? {}).forEach(add3);
  const k = model.kernel;
  add3(k?.goal?.target);
  (k?.hypotheses ?? []).forEach((h) => add3(h.of));
  (k?.system?.unknowns ?? []).forEach(add3);
  add3(k?.induction?.variable);
  (k?.claims ?? []).forEach((c) => Object.keys(c.at ?? {}).forEach(add3));
  const statement = [
    k?.start,
    ...(k?.givens ?? []),
    ...(k?.system?.equations ?? []),
    ...(model.givens ?? []),
  ];
  for (const t of statement) {
    if (!t) continue;
    try {
      lex(t).forEach(add3);
    } catch {}
  }
  return out;
}
function splits(word, known2, names) {
  if (word.length < 2 || RESERVED.has(word) || names.has(word)) return false;
  return [...word].every((c) => known2.has(c));
}
function splitNamedProducts(text, known2, names = /* @__PURE__ */ new Set()) {
  if (!known2.size) return text;
  return text.replace(RUN_RE, (word, offset, s) => {
    if (!splits(word, known2, names)) return word;
    const before = s[offset - 1] ?? '';
    const after = s[offset + word.length] ?? '';
    if (GLUE_RE.test(before) || GLUE_RE.test(after)) return word;
    if (after === '(' && compoundAt(s.slice(offset))) return word;
    return [...word].join(' ');
  });
}
function withNamedProducts(model) {
  const k = model.kernel;
  if (!k || !LITERAL_PLUGINS.has(k.plugin ?? '')) return model;
  const known2 = namedLetters(model);
  if (known2.size < 2) return model;
  const names = new Set(Object.keys(model.symbols ?? {}));
  let changed = false;
  const f = (t) => {
    if (typeof t !== 'string') return t;
    const r = splitNamedProducts(t, known2, names);
    if (r !== t) changed = true;
    return r;
  };
  const fa = (a) => a?.map((t) => f(t));
  const fl = (a) => a?.map((x) => (x.line === void 0 ? x : { ...x, line: f(x.line) }));
  const kernel = {
    ...k,
    start: f(k.start),
    answer: f(k.answer),
    path: fa(k.path),
    givens: fa(k.givens),
    domain: f(k.domain),
    ...(k.system ? { system: { ...k.system, equations: fa(k.system.equations) } } : {}),
    ...(k.claims ? { claims: k.claims.map((c) => ({ ...c, rels: fa(c.rels) })) } : {}),
    ...(k.induction
      ? { induction: { ...k.induction, hypothesis: f(k.induction.hypothesis) } }
      : {}),
  };
  const out = {
    ...model,
    kernel,
    givens: fa(model.givens),
    admitted: fa(model.admitted),
    answers: fa(model.answers),
    path: fa(model.path),
    preds: fl(model.preds),
    traps: fl(model.traps),
    checks: fl(model.checks),
    choices: fl(model.choices),
  };
  if (!changed) return model;
  const clean = (o, from) => {
    Object.keys(o).forEach((key) => {
      if (o[key] === void 0 && !(key in from)) delete o[key];
    });
  };
  clean(out, model);
  clean(kernel, k);
  return out;
}

// packages/reasoner/src/kernel/series.ts
var FACT = (() => {
  const f = [1n];
  for (let i = 1; i <= 40; i++) f.push(f[i - 1] * BigInt(i));
  return f;
})();

// packages/reasoner/src/kernel/limit.ts
var DEG_TO_RAD = { k: 'div', a: { k: 'sym', n: '\u03C0' }, b: num2(180) };
var NICE = (() => {
  const out = [];
  for (let n = -60; n <= 60; n++) for (const d2 of [1, 2, 3, 4, 5, 6, 8, 10]) out.push(n / d2);
  for (const c of [
    Math.E,
    1 / Math.E,
    Math.sqrt(Math.E),
    Math.exp(-0.5),
    Math.LN2,
    Math.PI,
    Math.SQRT2,
  ])
    out.push(c, -c, 2 * c);
  return [...new Set(out.map((v) => Math.round(v * 1e12) / 1e12))];
})();

// packages/reasoner/src/model.ts
var KERNEL_METHODS = ['factor', 'trig', 'test'];
var KERNEL_SPECIAL_PLUGINS = ['units', 'congruence', 'complex', 'bounds'];
var KERNEL_SPECIAL_GOALS = {
  units: 'convert',
  congruence: 'residue',
  complex: 'calculate',
  bounds: 'bound',
};
function kernelSpecialPlugin(model) {
  const p = model.kernel?.plugin;
  return KERNEL_SPECIAL_PLUGINS.includes(p ?? '') ? p : null;
}
var name = external_exports.string().min(1).max(40);
var lineText = external_exports.string().min(1).max(400);
var SymbolSpecSchema = external_exports.object({
  /** grandeur donnée par l'énoncé : sa valeur est connue dès le départ */
  given: external_exports.boolean().optional(),
  /**
   * grandeur de la SKILLCARD (V₀, V₁, k…) : le panneau la range dans les
   * « outils de la carte », un groupe replié — l'énoncé reste léger.
   */
  tool: external_exports.boolean().optional(),
  /** sens de la lettre, affiché dans les notations de la feuille : « taux d'évolution » */
  meaning: external_exports.string().min(1).max(80).optional(),
  value: external_exports.number().optional(),
  /** valeur(s) que la grandeur prend dans l'exercice (plusieurs : x₁, x₂, solutions…) */
  values: external_exports.array(external_exports.number()).max(8).optional(),
  /** length = positive (autorise la racine carrée) ; free = variable d'identité ; int = rang */
  kind: external_exports.enum(['length', 'free', 'int']).optional(),
  /**
   * valeurs EXACTES écrites en expression (moteur v2) : « ln(5) ÷ 2 », « √2 ÷ 2 ».
   * Le moteur en calcule `value` (grandeur donnée) ou `values` : le générateur
   * n'écrit jamais d'arrondi.
   */
  exact: external_exports.array(lineText).max(8).optional(),
});
var TrapSpecSchema = external_exports.object({
  line: lineText,
  title: external_exports.string().min(1).max(120),
  why: external_exports.string().min(1).max(600),
  /** erreur type du catalogue `misconceptions` (piège venu d'une règle de SKILLCARD) */
  misconception_id: external_exports.string().min(1).max(80).optional(),
});
var PythagorePredSchema = external_exports.object({
  skill: external_exports.literal('pythagore'),
  /** sommet de l'angle droit */
  right: name,
  /** hypoténuse */
  hyp: name,
  /** les deux autres côtés */
  sides: external_exports.tuple([name, name]),
});
var BaissePredSchema = external_exports.object({
  skill: external_exports.literal('baisse'),
  base: external_exports.union([external_exports.number(), name]),
  taux: external_exports.number().positive().max(100),
  remise: name,
  nouveau: name,
});
var ProduitNulPredSchema = external_exports.object({
  skill: external_exports.literal('produitNul'),
});
var FacteurCommunPredSchema = external_exports.object({
  skill: external_exports.literal('facteurCommun'),
});
var SecondDegrePredSchema = external_exports.object({
  skill: external_exports.literal('secondDegre'),
  a: name,
  b: name,
  c: name,
  delta: name,
  roots: external_exports.tuple([name, name]),
  /** solution double quand Δ = 0 (moteur v12) : x₀ = −b ÷ (2a) */
  double: name.optional(),
});
var DifferenceCarresPredSchema = external_exports.object({
  skill: external_exports.literal('differenceCarres'),
});
var CarreParfaitPredSchema = external_exports.object({
  skill: external_exports.literal('carreParfait'),
});
var FormulePredSchema = external_exports.object({
  skill: external_exports.literal('formule'),
  /** la formule, écrite avec les grandeurs du modèle : « P = 2 × (L + l) » */
  line: lineText,
  label: external_exports.string().max(60).optional(),
  hora: external_exports.number().int().min(1).max(6).optional(),
  why: external_exports.string().max(600).optional(),
  hint: external_exports.string().max(600).optional(),
  /** règle de SKILLCARD dont la formule est tirée : « <card_id>:<rule_key> » (traçabilité) */
  rule: external_exports.string().max(80).optional(),
});
var RecurrencePredSchema = external_exports.object({
  skill: external_exports.literal('recurrence'),
  /** P(n) : « uₙ = 2ⁿ − 1 » */
  hyp: lineText,
  /** P(0) : « u₀ = 2⁰ − 1 » */
  init: lineText,
  /** P(n+1) : « uₙ₊₁ = 2ⁿ⁺¹ − 1 » */
  next: lineText,
  /** instances utiles une fois la récurrence prouvée : « u₁₀ = 2¹⁰ − 1 » */
  inst: external_exports.array(lineText).max(4).optional(),
});
var PredSchema = external_exports.discriminatedUnion('skill', [
  PythagorePredSchema,
  BaissePredSchema,
  ProduitNulPredSchema,
  FacteurCommunPredSchema,
  SecondDegrePredSchema,
  DifferenceCarresPredSchema,
  CarreParfaitPredSchema,
  FormulePredSchema,
  RecurrencePredSchema,
]);
var ChoiceSpecSchema = external_exports.object({
  /** bloc correction (bonne réponse) ou distracteur */
  id: external_exports.string().max(64).optional(),
  label: external_exports.string().min(1).max(200),
  correct: external_exports.boolean(),
  /** réponse sous forme d'égalité (« A = (x + 3)(x − 5) ») */
  line: lineText.optional(),
  /** réponse numérique (valeur de la grandeur cherchée) ; ni line ni value : choix non vérifiable */
  value: external_exports.number().optional(),
  /** réponse numérique EXACTE écrite en expression (moteur v2) : « ln(5) ÷ 2 » → `value` calculée */
  exact: lineText.optional(),
});
var SamplesSpecSchema = external_exports.object({
  /** valeurs des variables libres : { x: [−3, −1, 0, 2, 3.5] } (produit cartésien, 16 environnements au plus) */
  vars: external_exports.record(
    name,
    external_exports.array(external_exports.number()).min(1).max(16),
  ),
  /** définitions « S = expression », évaluées dans l'ordre : « A = (x + 3)(2x − 1) − (x + 3)(x + 4) » */
  defs: external_exports.array(lineText).max(8).optional(),
});
var CongruenceSpecSchema = external_exports.object({
  mod: external_exports.number().int().min(2).max(1e5),
  target: lineText,
  /** reste attendu (calculé si la cible n'a pas d'inconnue) */
  residue: external_exports.number().int().min(0).optional(),
  path: external_exports.array(lineText).min(1).max(12),
});
var ComplexSpecSchema = external_exports.object({
  /** l'expression à calculer, avec i : « (1 + i)^8 » */
  target: lineText,
  /** le corrigé, ligne à ligne (rejoué par la porte) */
  path: external_exports.array(lineText).min(1).max(12),
  /** forme de la réponse : algébrique a + bi (défaut) ou exponentielle r e^(iθ) */
  form: external_exports.enum(['algebraic', 'exponential']).optional(),
  /** équation en z : l'inconnue (la cible est alors l'équation) */
  unknown: name.optional(),
  /** ses solutions, écrites avec i */
  solutions: external_exports.array(lineText).max(6).optional(),
  /** grandeurs définies par une formule : { Δ: '2^2 − 4 × 1 × 5' } */
  defs: external_exports.record(name, lineText).optional(),
});
var UnitsSpecSchema = external_exports.object({
  target: lineText,
  unit: external_exports.string().min(1).max(20),
  valueUnit: external_exports.string().min(1).max(12).optional(),
  path: external_exports.array(lineText).min(1).max(12),
});
var GeometrySpecSchema = external_exports.object({
  goal: lineText,
  path: external_exports.array(lineText).min(1).max(12),
});
var BoundsSpecSchema = external_exports
  .object({
    expr: lineText,
    lower: external_exports.string().min(1).max(20).optional(),
    upper: external_exports.string().min(1).max(20).optional(),
    path: external_exports.array(lineText).min(1).max(12),
  })
  .refine((b) => b.lower !== void 0 || b.upper !== void 0, {
    message: 'au moins une borne',
  });
var KERNEL_HYPOTHESIS_KINDS = [
  'positive',
  'negative',
  'nonzero',
  'nonnegative',
  'integer',
  'natural',
  // moteur v21 : un angle mesuré en degrés, aigu (]0° ; 90°[) ou d'un triangle (]0° ; 180°[)
  'acute',
  'angle',
];
var KernelHypothesisSchema = external_exports.object({
  kind: external_exports.enum(KERNEL_HYPOTHESIS_KINDS),
  /** le terme concerné, écrit avec les grandeurs du modèle : « m − 1 », « a » */
  of: lineText,
});
var KERNEL_GOAL_KINDS = [
  'solve',
  'isolate_variable',
  'simplify',
  'solve_system',
  // moteur v25 : démontrer une propriété de géométrie (plugin « geometry »)
  'prove',
  // moteur v28 : tracer un programme Python (plugin « python »)
  'trace',
  // moteur v29 : écrire la ligne manquante d'un programme Python
  'complete',
  // moteur v30 : calculer (calcul matriciel, plugin « matrix »)
  'compute',
  // moteur v31 : dériver, trouver une primitive (plugin « analysis »)
  'differentiate',
  'antiderivative',
  // moteur v32 : calculer des grandeurs avec les formules de la carte (plugin « formula »)
  'evaluate',
  // moteur v34 : les modes spéciaux de l'ancien moteur, passés au noyau
  'convert',
  'residue',
  'calculate',
  'bound',
  // moteur v35 : arithmétique (plugin « arith ») — PGCD par Euclide, relation de Bézout
  'gcd',
  'bezout',
  // moteur v51 : PGCD et PPCM par les décompositions en facteurs premiers (plugin « arith »)
  'gcd_primes',
  'lcm',
  // moteur v36 : trancher chaque affirmation d'un QCM (plugin « claims »)
  'decide',
  // moteur v42 étendu (lot 6.20) : étudier une fonction, son tableau de variations
  'study',
  // moteur v42 étendu (lot 6.21) : remplir un tableau (statistiques, proportionnalité)
  'fill',
  // moteur v44 (lot 6.42) : l'équation de la tangente en un point (plugin « analysis »)
  'tangent',
  // moteur v54 (lot 6.58) : la limite d'une expression en un point (plugin « limit »)
  'limit',
  // moteur v55 (lot 6.60) : calculer une intégrale (plugin « integral »)
  'integrate',
  // moteur v59 (lot 6.64) : la limite d'une somme de Riemann (plugin « riemann »)
  'riemann',
  // moteur v62 (lot 6.67) : une équation différentielle (plugin « ode »)
  'solve_ode',
  // moteur v64 (lot 6.69) : une dérivée partielle, le gradient, le laplacien (plugin « partial »)
  'partial',
];
var KERNEL_PLUGINS = [
  'algebra',
  'geometry',
  'python',
  'matrix',
  'analysis',
  // moteur v32 (lot 6.1) : grandeurs données, formules de la SKILLCARD, grandeurs à trouver
  'formula',
  // moteur v34 (lot 6.4) : les modes spéciaux de l'ancien moteur, passés au noyau
  'units',
  'congruence',
  'complex',
  'bounds',
  // moteur v35 (lot 5.10) : PGCD par l'algorithme d'Euclide, relation de Bézout
  'arith',
  // moteur v36 (lot 6.8) : vérifier chaque affirmation d'un QCM « coche les vraies »
  'claims',
  // moteur v42 étendu (lot 6.20) : étudier une fonction — tableau de variations
  'variations',
  // moteur v42 étendu (lot 6.21) : remplir un tableau — statistiques, proportionnalité
  'tables',
  // moteur v54 (lot 6.58) : la limite d'une expression en un point
  'limit',
  // moteur v55 (lot 6.60) : une intégrale à calculer
  'integral',
  // moteur v57 (lot 6.62) : trancher des limites affirmées (« Quelles limites valent +∞ ? »)
  'limclaims',
  // moteur v59 (lot 6.64) : la limite d'une somme de Riemann
  'riemann',
  // moteur v62 (lot 6.67) : une équation différentielle linéaire d'ordre 1 ou 2
  'ode',
  // moteur v64 (lot 6.69) : les dérivées partielles d'une fonction de deux variables
  'partial',
];
var MATRIX_NAME_RE2 = /^([A-Z]|π)[₀-₉]*(⁻¹|ᵀ|[⁰¹²³⁴⁵⁶⁷⁸⁹]+)?$/;
var PYTHON_DRAW_RE = /^(True|False|[−-]?\d+(,\d+)?)$/;
var KernelProgramSchema = external_exports.object({
  code: external_exports.string().min(1).max(2e3),
  call: external_exports.string().min(3).max(120).optional(),
  watch: external_exports.array(name).min(1).max(8).optional(),
  /** moteur v29 : tirages imposés par l'énoncé, donnés dans l'ordre aux appels de random */
  draws: external_exports
    .array(external_exports.string().regex(PYTHON_DRAW_RE))
    .min(1)
    .max(40)
    .optional(),
  /** moteur v29 (objectif `complete`) : tests du programme complété (« s = 5050 ») */
  checks: external_exports.array(lineText).min(1).max(6).optional(),
  /** moteur v29 (objectif `complete`) : ce que le programme complété doit afficher */
  output: external_exports
    .array(external_exports.string().min(1).max(200))
    .min(1)
    .max(30)
    .optional(),
  /** moteur v29 : l'algorithme tel que l'énoncé l'écrit (« Tant que n < 20 : … »), affiché */
  display: external_exports.string().min(1).max(2e3).optional(),
});
var coord = external_exports.number().finite().min(-1e3).max(1e3);
var xy = external_exports.tuple([coord, coord]);
var KernelFigureSchema = external_exports.object({
  points: external_exports
    .record(external_exports.string().regex(/^[A-Z]$/), xy)
    .refine((p) => Object.keys(p).length >= 2 && Object.keys(p).length <= 12, {
      message: '2 \xE0 12 points',
    }),
  /** droites nommées « d₁ » : deux points de passage */
  lines: external_exports
    .record(external_exports.string().regex(/^[a-zΔ][₀-₉]*$/), external_exports.tuple([xy, xy]))
    .optional(),
});
var SYSTEM_OUTCOMES = ['unique', 'none', 'infinite'];
var KernelSystemSpecSchema = external_exports.object({
  unknowns: external_exports.array(name).min(2).max(3),
  equations: external_exports.array(lineText).min(2).max(4),
  outcome: external_exports.enum(SYSTEM_OUTCOMES),
});
var KernelInductionSpecSchema = external_exports.object({
  /** P(n) : « uₙ = 3ⁿ », « 0 ≤ uₙ ≤ 2 », « 4ⁿ − 1 = 3k » */
  hypothesis: lineText,
  /** la variable de la récurrence (défaut : n), un entier naturel */
  variable: name.optional(),
  /** premier rang (défaut : 0) */
  from: external_exports.number().int().min(0).max(20).optional(),
});
var KernelClaimSchema = external_exports
  .object({
    rels: external_exports.array(lineText).min(1).max(3),
    at: external_exports
      .record(name, lineText)
      .refine((a) => Object.keys(a).length >= 1 && Object.keys(a).length <= 3, {
        message: '1 \xE0 3 lettres',
      })
      .optional(),
    /**
     * moteur v39 : la FORME exigée du membre de droite (le choix du QCM) — fraction
     * irréductible, notation scientifique, décomposition en facteurs premiers. Avec UNE
     * égalité seulement.
     */
    form: external_exports.enum(CLAIM_FORMS).optional(),
    /**
     * moteur v40 : affirmation de PROPRIÉTÉ — une écriture seule (`rels` : une expression,
     * sans relation) avec sa propriété : une forme (`form`, « nombre premier » compris) ou
     * « divisible par » (`divisibleBy`, un entier ≥ 2). `not` : la propriété est niée
     * (« 51 n'est pas premier »).
     */
    divisibleBy: external_exports
      .string()
      .regex(/^[1-9]\d{0,5}$/)
      .refine((d2) => Number(d2) >= 2, { message: 'un diviseur \u2265 2' })
      .optional(),
    /**
     * 30/10 (moteur v2 seulement) : les DIVISEURS d'un entier (`rels` : l'entier seul) —
     * leur nombre, leur somme ou leur produit vaut `value` ; `proper` : sans l'entier
     * lui-même (« somme des diviseurs de 28 sauf 28 »). Tranchée quand toutes les paires
     * « a × b = n » sont écrites.
     */
    divisors: external_exports
      .object({
        of: external_exports.enum(['count', 'sum', 'product']),
        value: external_exports.string().regex(/^\d{1,30}$/),
        proper: external_exports.literal(true).optional(),
      })
      .optional(),
    not: external_exports.literal(true).optional(),
  })
  .superRefine((c, ctx) => {
    const prop = isPropertyClaim(c);
    if (prop) {
      if ([c.form, c.divisibleBy, c.divisors].filter(Boolean).length !== 1)
        ctx.addIssue({
          code: external_exports.ZodIssueCode.custom,
          path: ['form'],
          message:
            'une affirmation de propri\xE9t\xE9 (une \xE9criture seule) a UNE propri\xE9t\xE9 : `form`, `divisibleBy` ou `divisors`',
        });
      if (c.divisors && (c.not || c.at))
        ctx.addIssue({
          code: external_exports.ZodIssueCode.custom,
          path: ['divisors'],
          message: '`divisors` va avec un entier \xE9crit, sans `not` ni `at`',
        });
      return;
    }
    if (c.divisibleBy || c.divisors || c.not || c.form === 'prime')
      ctx.addIssue({
        code: external_exports.ZodIssueCode.custom,
        path: ['divisibleBy'],
        message:
          '\xAB nombre premier \xBB, `divisibleBy`, `divisors` et `not` vont avec une \xE9criture seule',
      });
    if (c.form && (c.rels.length !== 1 || !/=/.test(c.rels[0]) || /[<>≤≥]/.test(c.rels[0])))
      ctx.addIssue({
        code: external_exports.ZodIssueCode.custom,
        path: ['form'],
        message: 'une forme va avec UNE \xE9galit\xE9 \xAB a = b \xBB',
      });
  });
function isPropertyClaim(c) {
  return c.rels.length === 1 && !/[=<>≤≥≠]/.test(c.rels[0]);
}
var VARIATION_CLAIM_KINDS = [
  'increasing',
  'decreasing',
  'constant',
  'min',
  'max',
  'no_min',
  'no_max',
  'extrema',
  'no_extremum',
  'sign',
  'sequence',
  'other',
];
var KernelVariationClaimSchema = external_exports.object({
  /** l'affirmation telle qu'elle s'affiche en tête de feuille (« f décroissante sur [−2 ; 1] ») */
  text: external_exports.string().min(1).max(120),
  kind: external_exports.enum(VARIATION_CLAIM_KINDS),
  on: external_exports.array(lineText).max(3).optional(),
  at: external_exports.array(lineText).min(1).max(6).optional(),
  value: lineText.optional(),
  local: external_exports.literal(true).optional(),
  sign: external_exports.enum(['+', '\u2212', '0', 'change']).optional(),
  seq: external_exports
    .array(external_exports.enum(['increasing', 'decreasing']))
    .min(1)
    .max(4)
    .optional(),
});
var TABLE_KINDS = ['series', 'proportion', 'cross', 'values', 'freq'];
var KernelTableSpecSchema = external_exports.object({
  kind: external_exports.enum(TABLE_KINDS),
  form: external_exports.enum(['raw', 'counts', 'cumulative']).optional(),
  coef: external_exports.literal(true).optional(),
  exprs: external_exports
    .array(external_exports.string().min(1).max(40).nullable())
    .min(1)
    .max(5)
    .optional(),
  mod: external_exports.number().int().min(2).max(20).optional(),
  percent: external_exports.literal(true).optional(),
});
var TABLE_CLAIM_KINDS = [
  'value',
  'proportional',
  'not_proportional',
  'other',
  'pairs',
  'set',
  'within',
  'avoids',
  'reached',
  'same_rows',
  'largest',
  'same_freq',
];
var cellText = external_exports.string().min(1).max(24);
var KernelTableClaimSchema = external_exports.object({
  text: external_exports.string().min(1).max(120),
  kind: external_exports.enum(TABLE_CLAIM_KINDS),
  stats: external_exports
    .record(external_exports.string().min(1).max(40), external_exports.string().min(1).max(40))
    .refine((r) => Object.keys(r).length <= 4, { message: '4 grandeurs au plus' })
    .optional(),
  pairs: external_exports
    .array(external_exports.tuple([cellText, cellText]))
    .min(1)
    .max(8)
    .optional(),
  values: external_exports.array(cellText).min(1).max(12).optional(),
  row: external_exports.number().int().min(1).max(5).optional(),
  rows: external_exports
    .tuple([
      external_exports.number().int().min(1).max(5),
      external_exports.number().int().min(1).max(5),
    ])
    .optional(),
  cols: external_exports.array(external_exports.string().min(1).max(40)).min(1).max(8).optional(),
  places: external_exports.number().int().min(0).max(6).optional(),
});
var KernelLimitClaimSchema = external_exports.object({
  expr: external_exports.string().min(1).max(200),
  x: external_exports
    .string()
    .regex(/^[a-z]$/, { message: 'une lettre : \xAB x \xBB, \xAB n \xBB, \xAB t \xBB' }),
  point: external_exports.string().regex(/^([+−]∞|−?\d+(,\d+)?[⁺⁻]?)$/, {
    message:
      'un point : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 2 \xBB, \xAB 2\u207A \xBB, \xAB 0\u207B \xBB',
  }),
  value: external_exports.string().regex(/^([+−]∞|−?\d+(,\d+)?|0[⁺⁻])$/, {
    message:
      'une limite : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 0 \xBB, \xAB 3 \xBB, \xAB 0\u207A \xBB',
  }),
});
var KERNEL_FORMS = ['expanded', 'factored', 'canonical', 'fraction'];
var KERNEL_AUXILIARY_OF = ['exp', 'ln'];
var KernelAuxiliarySchema = external_exports.object({
  /** le nom de l'inconnue auxiliaire : une lettre (« X », « u »), jamais « e » */
  name: external_exports.string().regex(/^[A-DF-Za-df-z]$/, {
    message: 'une lettre (\xAB X \xBB, \xAB u \xBB), pas \xAB e \xBB',
  }),
  /** ce qu'elle remplace : `exp` (X = e^x) ou `ln` (X = ln(x)), x étant l'inconnue */
  of: external_exports.enum(KERNEL_AUXILIARY_OF),
});
var KernelOdeSpecSchema = external_exports.object({
  initial: external_exports.array(lineText).max(2).optional(),
  /** moteur v63 : la variable (« t ») ; « x » par défaut */
  variable: external_exports
    .string()
    .regex(/^[a-z]$/, { message: 'la variable : une lettre minuscule (\xAB t \xBB)' })
    .optional(),
  constants: external_exports
    .array(
      external_exports.string().regex(/^[A-Z][₀-₉]?$/, {
        message: 'une constante : \xAB C \xBB, \xAB A \xBB, \xAB C\u2081 \xBB',
      }),
    )
    .min(1)
    .max(3)
    .optional(),
});
var KernelPartialSpecSchema = external_exports.object({
  curve: external_exports
    .object({
      t: external_exports
        .string()
        .regex(/^[a-z]$/, { message: 'la variable : une lettre minuscule (\xAB t \xBB)' }),
      g: external_exports
        .string()
        .regex(/^[a-zA-Z]$/, { message: 'la fonction compos\xE9e : une lettre (\xAB g \xBB)' }),
      x: external_exports.string().min(1).max(80),
      y: external_exports.string().min(1).max(80),
    })
    .optional(),
});
var KernelSpecSchema = external_exports.object({
  /** plugin du noyau : l'algèbre (lot 4) ; la géométrie déductive (moteur v25) */
  plugin: external_exports.enum(KERNEL_PLUGINS),
  /** résoudre (inéquation, équation) ou isoler une grandeur dans une formule */
  goal: external_exports.object({ kind: external_exports.enum(KERNEL_GOAL_KINDS), target: name }),
  /** la ligne de départ, affichée en tête de feuille : « 3x + 2 < 8 » */
  start: lineText,
  /** la ligne d'arrivée attendue : « x < 2 », « x = 3 ÷ (m − 1) » */
  answer: lineText,
  /** hypothèses de l'énoncé : « m − 1 » positif, « a » non nul */
  hypotheses: external_exports.array(KernelHypothesisSchema).max(6).optional(),
  /** corrigé de référence (coup de pouce, plafond HORA) ; absent : celui de la recherche */
  path: external_exports.array(lineText).min(1).max(40).optional(),
  /** moteur v22 : système d'équations (objectif `solve_system`, `start` = 1re équation) */
  system: KernelSystemSpecSchema.optional(),
  /**
   * moteur v23 : `factor` — second degré, produit, quotient. L'avancée se mesure à la
   * forme (tout d'un côté, factorisé, ensemble de solutions), plus à l'inconnue isolée ;
   * Δ, x₁, x₂ (déclarés dans `symbols`) s'y calculent pour le trinôme de la feuille.
   * moteur v24 : `trig` — équation trigonométrique, x réel (radians) ; un entier k
   * (hypothèse `integer`) écrit les familles de solutions.
   */
  method: external_exports.enum(KERNEL_METHODS).optional(),
  /**
   * moteur v33 (objectif `simplify`, plugin « algebra ») : la forme attendue — `expanded`
   * (développer puis réduire, règles des puissances comprises) ou `factored` (factoriser :
   * facteur commun, a² − b², a² ± 2ab + b²) ; moteur v43 : `canonical` (forme canonique
   * a(x − α)² + β d'un trinôme en une lettre). `path` obligatoire.
   */
  form: external_exports.enum(KERNEL_FORMS).optional(),
  /**
   * moteur v24 : l'intervalle de l'énoncé (« −π < x ≤ π », « 0 ≤ x < 2π »), affiché en
   * tête de feuille ; absent : on résout sur ℝ.
   */
  domain: lineText.optional(),
  /**
   * moteur v44 (plugin « analysis », objectif `tangent`) : l'abscisse a du point de
   * tangence, telle qu'elle s'écrit dans « f(a) » (« 0 », « 2 », « e »).
   */
  at: external_exports
    .string()
    .regex(/^(−?\d+(,\d+)?|e|π)$/, {
      message: 'une abscisse : un nombre, \xAB e \xBB ou \xAB \u03C0 \xBB',
    })
    .optional(),
  /**
   * moteur v54 (plugin « limit ») : le point où l'on cherche la limite — « +∞ », « −∞ »,
   * un réel (« 2 », « 0,5 ») des deux côtés, ou d'un côté (« 2⁺ », « 0⁻ »).
   */
  point: external_exports
    .string()
    .regex(/^([+−]∞|−?\d+(,\d+)?[⁺⁻]?)$/, {
      message:
        'un point : \xAB +\u221E \xBB, \xAB \u2212\u221E \xBB, \xAB 2 \xBB, \xAB 2\u207A \xBB, \xAB 0\u207B \xBB',
    })
    .optional(),
  /**
   * moteur v44 (plugin « analysis », objectif `antiderivative`) : la condition qui fixe la
   * primitive, « F(0) = 2 » (la tête est la cible, en un point écrit comme `at`).
   */
  condition: lineText.optional(),
  /**
   * moteur v25 (plugin « geometry ») : la figure de référence. L'énoncé est `start`
   * (1re propriété) puis `givens` ; `answer` est la propriété à démontrer
   * (« (MN) ∦ (BC) ») ou la longueur cherchée (« IJ = 4 ») ; `path` est obligatoire.
   */
  figure: KernelFigureSchema.optional(),
  /**
   * moteur v26 (objectif `prove`, plugin « algebra ») : l'hérédité d'une récurrence.
   * `start` = la définition de la suite (ou P(n) elle-même), `answer` = P(n + 1),
   * `path` obligatoire.
   */
  induction: KernelInductionSpecSchema.optional(),
  /**
   * moteur v28 (plugin « python », objectif `trace`) : le programme à tracer. `start` =
   * l'appel suivi (`program.call`) ou la variable cherchée ; `answer` = « c = 2 »,
   * « pgcd(84, 36) = 12 », « a = 1,5 ; b = 2 » ; `path` = la trace, obligatoire.
   */
  program: KernelProgramSchema.optional(),
  /**
   * moteur v30 (plugin « matrix », objectif `compute`) : les matrices de l'énoncé, en
   * écriture « [1, 2 ; 3, 4] » (lignes séparées par « ; », coefficients par « , ») ou en
   * expression des précédentes (« B = A − 2I »). `start` = le calcul demandé (« AB ») ou
   * l'équation « AX = B » ; `answer` = « AB = [8 ; 9] » ; `path` obligatoire.
   */
  matrices: external_exports
    .record(external_exports.string().regex(MATRIX_NAME_RE2), lineText)
    .refine((m) => Object.keys(m).length <= 8, { message: '8 matrices au plus' })
    .optional(),
  /**
   * moteur v36 (plugin « claims », objectif `decide`) : une affirmation par choix du QCM,
   * dans l'ordre des choix. `start` = la 1re relation de la 1re affirmation ; `answer` =
   * les lettres des affirmations vraies, dans l'ordre (« A, C ») ; `path` obligatoire.
   */
  claims: external_exports.array(KernelClaimSchema).min(2).max(8).optional(),
  /**
   * moteur v40 : QCM à réponse UNIQUE (affiché « Réponse unique ») — les affirmations se
   * tranchent aussi par élimination : une vraie trouvée, les autres sont fausses ; toutes
   * fausses sauf une, elle est vraie.
   */
  single: external_exports.literal(true).optional(),
  /**
   * moteur v42 étendu (plugin « variations », objectif `study`) : une affirmation sur la
   * fonction par choix du QCM, dans l'ordre des choix. `start` = « f(x) = … » (ou
   * « f′(x) = … » quand l'énoncé ne donne que f′) ; f′ donnée par l'énoncé : dans `givens` ;
   * `answer` = les lettres des affirmations vraies (« A ») ; `path` obligatoire (dériver si
   * besoin, puis le tableau de variations).
   */
  vclaims: external_exports.array(KernelVariationClaimSchema).min(2).max(8).optional(),
  /**
   * moteur v42 étendu (plugin « tables », objectif `fill`) : le tableau de l'énoncé
   * (`start` = « ⊟{…} ») et comment le lire.
   */
  table: KernelTableSpecSchema.optional(),
  /** moteur v42 étendu (plugin « tables ») : une affirmation par choix du QCM, dans l'ordre */
  tclaims: external_exports.array(KernelTableClaimSchema).min(2).max(8).optional(),
  /**
   * moteur v57 (plugin « limclaims », objectif `decide`) : une limite affirmée par choix du
   * QCM, dans l'ordre des choix. `start` = l'expression de la 1re ; `answer` = les lettres
   * des affirmations vraies (« A, B ») ; `path` obligatoire (les limites à établir).
   */
  lclaims: external_exports.array(KernelLimitClaimSchema).min(2).max(8).optional(),
  /**
   * moteur v62 (plugin « ode », objectif `solve_ode`) : `start` = l'équation (« y′ = −2y + 8 »),
   * `answer` = l'équation réécrite (« y′ = … »), toutes les solutions (« y = C × e^(−2x) + 4 »)
   * ou une solution (« y = −3 × e^(−2x) + 4 ») ; `goal.target` = la fonction (« y ») ;
   * `domain` facultatif (« x > 0 ») ; `path` obligatoire.
   */
  ode: KernelOdeSpecSchema.optional(),
  /**
   * moteur v64 (plugin « partial », objectif `partial`) : `start` = la fonction
   * (« f(x, y) = x² × y »), `goal.target` = la dérivée demandée (« ∂f/∂x », « ∂²f/∂x∂y »,
   * « ∇f », « Δf », « ∂f/∂x(1, 2) », « g′(t) »…), `answer` = « question = valeur » ;
   * `curve` facultatif (règle de la chaîne) ; `path` obligatoire.
   */
  partial: KernelPartialSpecSchema.optional(),
  /**
   * moteur v47 (plugin « algebra », méthode `factor`) : une INCONNUE AUXILIAIRE — `name`
   * (« X ») remplace `of` (« eˣ », « ln(x) ») : « e^(2x) − 3eˣ + 2 = 0 » se résout comme
   * « X² − 3X + 2 = 0 » ; l'élève peut écrire en X (« On pose X = eˣ ») ou garder eˣ.
   */
  auxiliary: KernelAuxiliarySchema.optional(),
  /**
   * moteur v47 : version minimale DÉCLARÉE par la feuille (≥ 47) — ce que le modèle ne
   * montre pas (libellés lisibles : « Diviser par 0,4 », « Diviser par e^(−6) »).
   */
  minEngine: external_exports.number().int().min(47).max(999).optional(),
  /**
   * moteur v49 (plugin « algebra », objectif `solve`) : les CONDITIONS que l'élève doit
   * écrire sur leur ligne (« x > 0 » pour ln(x), « x ≥ 0 » pour √x, « x − 3 ≥ 0 » quand
   * √(x + 3) = x − 3) : une conséquence du départ, en l'inconnue seule. Écrite, une
   * condition rend juste le pas qui en a besoin (composer par exp, élever au carré) ; la
   * réponse en tient compte (« 0 < x < e »). Jamais affichées.
   */
  conditions: external_exports.array(lineText).min(1).max(4).optional(),
});
var CheckSpecSchema = external_exports.object({
  /** la comparaison, avec les grandeurs du modèle : « Δ > 0 » */
  line: lineText,
  /** étiquette de la ligne validée : « Signe du discriminant » */
  label: external_exports.string().min(1).max(60),
  /** pourquoi elle compte : « Δ > 0 : l'équation a deux solutions. » */
  why: external_exports.string().min(1).max(400),
  hora: external_exports.number().int().min(1).max(6).optional(),
});
var RoundingSpecSchema = external_exports.object({
  /** chiffres après la virgule : 0 à l'unité, 1 au dixième, 2 au centième… */
  places: external_exports.number().int().min(0).max(4),
  /** grandeur arrondie (par défaut, la première du but) */
  symbol: name.optional(),
  hora: external_exports.number().int().min(1).max(6).optional(),
});
var ScratchModelSchema = external_exports
  .object({
    symbols: external_exports.record(name, SymbolSpecSchema),
    /** grandeur(s) cherchée(s) par la question */
    goal: external_exports.array(name).min(1).max(4),
    /** valeurs attendues quand plusieurs solutions (x₁ et x₂…) */
    goalValues: external_exports.array(external_exports.number()).max(8).optional(),
    /** la question attend une EXPRESSION (« A = (x + 3)(x − 5) »), pas une valeur */
    answers: external_exports.array(lineText).max(8).optional(),
    aim: external_exports.enum(['factor', 'expand']).optional(),
    /** moteur v15 : l'opération s'écrit avant son résultat (« x = 12 ÷ 3 » puis « x = 4 ») */
    stepwise: external_exports.boolean().optional(),
    /** moteur v16 : corrigé écrit à la main, rejoué par le juge (le solveur ne le cherche pas) */
    path: external_exports.array(lineText).min(1).max(16).optional(),
    factorHint: external_exports.string().max(300).optional(),
    /** égalités de l'énoncé affichées en tête de feuille */
    givens: external_exports.array(lineText).max(8).optional(),
    /** résultats des questions précédentes, admis (« on admet que BC = 10 ») */
    admitted: external_exports.array(lineText).max(8).optional(),
    preds: external_exports.array(PredSchema).max(6).optional(),
    /** échantillons de valeurs pour juger une égalité « pour tout x » (identités, récurrence) */
    envs: external_exports
      .array(external_exports.record(name, external_exports.number()))
      .min(2)
      .max(16)
      .optional(),
    /** forme compacte des `envs`, développée par `materializeModel` */
    samples: SamplesSpecSchema.optional(),
    traps: external_exports.array(TrapSpecSchema).max(16).optional(),
    /** comparaisons décisives (moteur v5) : « Δ > 0 » */
    checks: external_exports.array(CheckSpecSchema).max(6).optional(),
    /** les choix du QCM de la question */
    choices: external_exports.array(ChoiceSpecSchema).max(8).optional(),
    /** question de congruences (moteur v3) */
    congruence: CongruenceSpecSchema.optional(),
    /** nombres complexes (moteur v11) */
    complex: ComplexSpecSchema.optional(),
    /** question de grandeurs et d'unités (moteur v4) */
    units: UnitsSpecSchema.optional(),
    /** question de raisonnement géométrique (moteur v4) */
    geometry: GeometrySpecSchema.optional(),
    /** réponse ARRONDIE (moteur v10) : « AC ≈ 8,4 » au dixième (places = 1) */
    rounding: RoundingSpecSchema.optional(),
    /** encadrer une racine carrée (moteur v13) */
    bounds: BoundsSpecSchema.optional(),
    /** feuille jugée par le noyau (moteur v18) */
    kernel: KernelSpecSchema.optional(),
  })
  .superRefine((m, ctx) => {
    if (m.kernel && (m.kernel.goal.kind === 'solve_system') !== !!m.kernel.system)
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'system'],
        message: 'un syst\xE8me (`system`) va avec l\u2019objectif solve_system, et seulement lui',
      });
    if (m.kernel?.system && !m.kernel.system.unknowns.includes(m.kernel.goal.target))
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'goal', 'target'],
        message: `l'inconnue ${m.kernel.goal.target} doit \xEAtre une inconnue du syst\xE8me`,
      });
    if (
      m.kernel?.conditions &&
      (m.kernel.plugin !== 'algebra' ||
        m.kernel.goal.kind !== 'solve' ||
        m.kernel.auxiliary ||
        m.kernel.method === 'test' ||
        m.kernel.method === 'trig')
    )
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'conditions'],
        message:
          'des conditions (`conditions`) vont avec le plugin \xAB algebra \xBB et l\u2019objectif solve (sans inconnue auxiliaire, ni m\xE9thode \xAB test \xBB ou \xAB trig \xBB)',
      });
    if (m.kernel?.method && m.kernel.goal.kind !== 'solve')
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'method'],
        message: `la m\xE9thode \xAB ${m.kernel.method} \xBB r\xE9sout une \xE9quation ou une in\xE9quation (objectif solve)`,
      });
    if (
      m.kernel?.form &&
      (m.kernel.plugin !== 'algebra' || m.kernel.goal.kind !== 'simplify' || !m.kernel.path)
    )
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'form'],
        message:
          'une forme (`form`) va avec le plugin \xAB algebra \xBB, l\u2019objectif simplify et un corrig\xE9 (`path`)',
      });
    if (
      m.kernel?.domain &&
      m.kernel.method !== 'trig' &&
      m.kernel.plugin !== 'analysis' &&
      m.kernel.plugin !== 'variations' &&
      m.kernel.plugin !== 'ode'
    )
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'domain'],
        message:
          'un intervalle (`domain`) va avec la m\xE9thode \xAB trig \xBB ou les plugins \xAB analysis \xBB, \xAB variations \xBB et \xAB ode \xBB',
      });
    if (m.kernel) {
      const ana = m.kernel.plugin === 'analysis';
      const anaGoal =
        m.kernel.goal.kind === 'differentiate' ||
        m.kernel.goal.kind === 'antiderivative' ||
        m.kernel.goal.kind === 'tangent';
      if (ana !== anaGoal)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'les objectifs differentiate, antiderivative et tangent vont avec le plugin \xAB analysis \xBB, et lui seul',
        });
      if ((m.kernel.goal.kind === 'tangent') !== !!m.kernel.at)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'at'],
          message: 'l\u2019abscisse du point (`at`) va avec l\u2019objectif tangent, et lui seul',
        });
      if (m.kernel.condition && m.kernel.goal.kind !== 'antiderivative')
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'condition'],
          message: 'une condition (`condition`) va avec l\u2019objectif antiderivative',
        });
      if (
        ana &&
        (m.kernel.method ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une d\xE9riv\xE9e ou une primitive a son corrig\xE9 (`path`), sans m\xE9thode, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices ni arrondi',
        });
    }
    if (m.kernel) {
      const py = m.kernel.plugin === 'python';
      const pyGoal = m.kernel.goal.kind === 'trace' || m.kernel.goal.kind === 'complete';
      if (py !== !!m.kernel.program || py !== pyGoal)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'program'],
          message:
            'les objectifs trace et complete vont avec un programme Python (plugin \xAB python \xBB, `program`), et eux seuls',
        });
      const prog = m.kernel.program;
      if (py && prog) {
        const complete = m.kernel.goal.kind === 'complete';
        const blanks = prog.code.split('\n').filter((l) => /^\s*_{3,}\s*$/.test(l)).length;
        if (complete && (blanks !== 1 || (!prog.checks && !prog.output) || prog.call))
          ctx.addIssue({
            code: 'custom',
            path: ['kernel', 'program'],
            message:
              'compl\xE9ter un programme : une seule ligne manquante \xAB ____ \xBB, des tests (`checks` ou `output`), pas d\u2019appel suivi',
          });
        if (!complete && (blanks || prog.checks || prog.output))
          ctx.addIssue({
            code: 'custom',
            path: ['kernel', 'program'],
            message: 'une ligne manquante et des tests vont avec l\u2019objectif complete',
          });
        if (prog.draws && !/\brandom\b/.test(prog.code))
          ctx.addIssue({
            code: 'custom',
            path: ['kernel', 'program', 'draws'],
            message: 'des tirages impos\xE9s vont avec un programme qui utilise random',
          });
      }
      if (
        py &&
        (m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une trace Python a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence ni arrondi',
        });
      if (
        py &&
        m.kernel.program &&
        m.kernel.start !== (m.kernel.program.call ?? m.kernel.goal.target)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'start'],
          message: '`start` est l\u2019appel suivi (`program.call`), sinon la variable cherch\xE9e',
        });
    }
    if (m.kernel) {
      const mat = m.kernel.plugin === 'matrix';
      if (mat !== (m.kernel.goal.kind === 'compute'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif compute va avec un calcul matriciel (plugin \xAB matrix \xBB), et lui seul',
        });
      if (m.kernel.matrices && !mat)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'matrices'],
          message: 'des matrices (`matrices`) vont avec le plugin \xAB matrix \xBB',
        });
      if (
        mat &&
        (m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'un calcul matriciel a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme ni arrondi',
        });
    }
    if (m.kernel) {
      const geo = m.kernel.plugin === 'geometry';
      const rec = !!m.kernel.induction;
      if (geo !== !!m.kernel.figure || (geo || rec) !== (m.kernel.goal.kind === 'prove'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'plugin'],
          message:
            'l\u2019objectif prove va avec une d\xE9monstration de g\xE9om\xE9trie (plugin \xAB geometry \xBB, une figure) ou une r\xE9currence (`induction`), et elles seules',
        });
      if (
        rec &&
        (geo ||
          m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'induction'],
          message:
            'une r\xE9currence (plugin \xAB algebra \xBB) a son corrig\xE9 (`path`), sans figure, m\xE9thode, intervalle, syst\xE8me ni arrondi',
        });
      if (
        geo &&
        (m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une d\xE9monstration de g\xE9om\xE9trie a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses ni arrondi',
        });
    }
    if (m.kernel) {
      const ar = m.kernel.plugin === 'arith';
      const arGoal =
        m.kernel.goal.kind === 'gcd' ||
        m.kernel.goal.kind === 'bezout' ||
        m.kernel.goal.kind === 'gcd_primes' ||
        m.kernel.goal.kind === 'lcm';
      if (ar !== arGoal)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'les objectifs gcd, bezout, gcd_primes et lcm vont avec l\u2019arithm\xE9tique (plugin \xAB arith \xBB), et elle seule',
        });
      if (
        ar &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille d\u2019arithm\xE9tique a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const li = m.kernel.plugin === 'limit';
      if (li !== (m.kernel.goal.kind === 'limit') || li !== !!m.kernel.point)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'point'],
          message:
            'l\u2019objectif limit va avec une feuille de limites (plugin \xAB limit \xBB, `point`), et elle seule',
        });
      if (
        li &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille de limites a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const ig = m.kernel.plugin === 'integral';
      if (ig !== (m.kernel.goal.kind === 'integrate'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif integrate va avec une feuille d\u2019int\xE9grales (plugin \xAB integral \xBB), et elle seule',
        });
      if (
        ig &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.point ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille d\u2019int\xE9grales a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const od = m.kernel.plugin === 'ode';
      if (od !== (m.kernel.goal.kind === 'solve_ode'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif solve_ode va avec une feuille d\u2019\xE9quation diff\xE9rentielle (plugin \xAB ode \xBB), et elle seule',
        });
      if (!od && m.kernel.ode)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'ode'],
          message:
            'la cl\xE9 `ode` va avec une feuille d\u2019\xE9quation diff\xE9rentielle, et elle seule',
        });
      if (
        od &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.lclaims ||
          m.kernel.point ||
          m.kernel.condition ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille d\u2019\xE9quation diff\xE9rentielle a son corrig\xE9 (`path`), sans m\xE9thode, forme, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, condition, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const pa = m.kernel.plugin === 'partial';
      if (pa !== (m.kernel.goal.kind === 'partial'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif partial va avec une feuille de d\xE9riv\xE9es partielles (plugin \xAB partial \xBB), et elle seule',
        });
      if (!pa && m.kernel.partial)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'partial'],
          message:
            'la cl\xE9 `partial` va avec une feuille de d\xE9riv\xE9es partielles, et elle seule',
        });
      if (
        pa &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.lclaims ||
          m.kernel.point ||
          m.kernel.condition ||
          m.kernel.ode ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille de d\xE9riv\xE9es partielles a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, condition, \xE9quation diff\xE9rentielle, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const rm = m.kernel.plugin === 'riemann';
      if (rm !== (m.kernel.goal.kind === 'riemann'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif riemann va avec une feuille de sommes de Riemann (plugin \xAB riemann \xBB), et elle seule',
        });
      if (
        rm &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.lclaims ||
          m.kernel.point ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille de sommes de Riemann a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, point, mode sp\xE9cial ni arrondi',
        });
    }
    if (m.kernel) {
      const fo = m.kernel.plugin === 'formula';
      if (fo !== (m.kernel.goal.kind === 'evaluate'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'l\u2019objectif evaluate va avec une feuille \xE0 formules (plugin \xAB formula \xBB), et elle seule',
        });
      if (
        fo &&
        (m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.geometry ||
          m.bounds ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille \xE0 formules a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, ni mode sp\xE9cial (complexes, congruences, unit\xE9s, g\xE9om\xE9trie, encadrement)',
        });
      if (fo && m.kernel.start.trim() !== m.kernel.goal.target)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'start'],
          message:
            '`start` est la grandeur cherch\xE9e (`goal.target`) dans une feuille \xE0 formules',
        });
    }
    if (m.kernel) {
      const sp = kernelSpecialPlugin(m);
      const spGoal = Object.values(KERNEL_SPECIAL_GOALS).includes(m.kernel.goal.kind);
      if ((sp !== null) !== spGoal || (sp && KERNEL_SPECIAL_GOALS[sp] !== m.kernel.goal.kind))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'goal', 'kind'],
          message:
            'les objectifs convert, residue, calculate et bound vont avec les plugins units, congruence, complex et bounds (dans cet ordre), et eux seuls',
        });
      const modeKeys = ['units', 'congruence', 'complex', 'bounds'].filter((k) => !!m[k]);
      if (sp && (modeKeys.length !== 1 || modeKeys[0] !== sp))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'plugin'],
          message: `le plugin \xAB ${sp} \xBB garde la cl\xE9 de son mode (\`${sp}\`), et elle seule`,
        });
      if (!sp && modeKeys.length)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille du noyau n\u2019a pas de mode sp\xE9cial, sauf avec son plugin (units, congruence, complex, bounds)',
        });
      if (
        sp &&
        (m.kernel.method ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.form ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'un mode sp\xE9cial du noyau a son corrig\xE9 (`path`), sans m\xE9thode, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, forme ni arrondi',
        });
    }
    if (m.kernel) {
      const cl = m.kernel.plugin === 'claims';
      const lc = m.kernel.plugin === 'limclaims';
      if (cl !== !!m.kernel.claims || (cl || lc) !== (m.kernel.goal.kind === 'decide'))
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'claims'],
          message:
            'l\u2019objectif decide va avec des affirmations \xE0 trancher (plugin \xAB claims \xBB, `claims` ; plugin \xAB limclaims \xBB, `lclaims`), et elles seules',
        });
      if (lc !== !!m.kernel.lclaims)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'lclaims'],
          message:
            '`lclaims` va avec des limites affirm\xE9es (plugin \xAB limclaims \xBB), et elles seules',
        });
      if (
        lc &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.vclaims ||
          m.kernel.tclaims ||
          m.kernel.point ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'des limites affirm\xE9es ont leur corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, autres affirmations, point, mode sp\xE9cial ni arrondi',
        });
      if (lc && m.kernel.lclaims && m.kernel.start.trim() !== m.kernel.lclaims[0].expr.trim())
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'start'],
          message: '`start` est l\u2019expression de la 1re limite affirm\xE9e',
        });
      if (lc && m.kernel.lclaims && m.choices && m.choices.length !== m.kernel.lclaims.length)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'lclaims'],
          message: 'une limite affirm\xE9e par choix du QCM, dans le m\xEAme ordre',
        });
      if (
        cl &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une feuille d\u2019affirmations a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, mode sp\xE9cial ni arrondi',
        });
      if (cl && m.kernel.claims && m.kernel.start.trim() !== m.kernel.claims[0].rels[0].trim())
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'start'],
          message: '`start` est la 1re relation de la 1re affirmation',
        });
      const vr = m.kernel.plugin === 'variations';
      const tb = m.kernel.plugin === 'tables';
      if (!cl && !vr && !tb && !lc && m.kernel.single)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'single'],
          message: '`single` (r\xE9ponse unique) va avec une feuille d\u2019affirmations',
        });
      if (vr !== (m.kernel.goal.kind === 'study') || vr !== !!m.kernel.vclaims)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'vclaims'],
          message:
            'l\u2019objectif study va avec l\u2019\xE9tude d\u2019une fonction (plugin \xAB variations \xBB, `vclaims`), et elle seule',
        });
      if (
        vr &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length)
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'une \xE9tude de fonction a son corrig\xE9 (`path`), sans m\xE9thode, forme, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
        });
      if (
        tb !== (m.kernel.goal.kind === 'fill') ||
        tb !== !!m.kernel.tclaims ||
        tb !== !!m.kernel.table
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'tclaims'],
          message:
            'l\u2019objectif fill va avec un tableau \xE0 remplir (plugin \xAB tables \xBB, `table` et `tclaims`), et lui seul',
        });
      if (
        tb &&
        (m.kernel.method ||
          m.kernel.form ||
          m.kernel.domain ||
          m.kernel.system ||
          m.kernel.hypotheses?.length ||
          m.kernel.figure ||
          m.kernel.induction ||
          m.kernel.program ||
          m.kernel.matrices ||
          m.kernel.claims ||
          m.kernel.vclaims ||
          m.complex ||
          m.congruence ||
          m.units ||
          m.bounds ||
          m.geometry ||
          m.rounding ||
          !m.kernel.path?.length ||
          !m.kernel.start.startsWith('\u229F'))
      )
        ctx.addIssue({
          code: 'custom',
          path: ['kernel'],
          message:
            'un tableau \xE0 remplir part du tableau de l\u2019\xE9nonc\xE9 (`start` = \xAB \u229F{\u2026} \xBB) et a son corrig\xE9 (`path`), sans m\xE9thode, forme, intervalle, syst\xE8me, hypoth\xE8ses, figure, r\xE9currence, programme, matrices, affirmations, mode sp\xE9cial ni arrondi',
        });
      if (tb && m.kernel.tclaims && m.choices && m.choices.length !== m.kernel.tclaims.length)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'tclaims'],
          message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
        });
      if (vr && m.kernel.vclaims && m.choices && m.choices.length !== m.kernel.vclaims.length)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'vclaims'],
          message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
        });
      if (cl && m.kernel.claims && m.choices && m.choices.length !== m.kernel.claims.length)
        ctx.addIssue({
          code: 'custom',
          path: ['kernel', 'claims'],
          message: 'une affirmation par choix du QCM, dans le m\xEAme ordre',
        });
    }
    if (m.kernel && !m.goal.includes(m.kernel.goal.target))
      ctx.addIssue({
        code: 'custom',
        path: ['kernel', 'goal', 'target'],
        message: `l'inconnue ${m.kernel.goal.target} doit \xEAtre dans goal`,
      });
    m.goal.forEach((g, i) => {
      if (
        m.kernel?.plugin === 'claims' ||
        m.kernel?.plugin === 'limclaims' ||
        m.kernel?.plugin === 'variations' ||
        m.kernel?.plugin === 'tables'
      )
        return;
      if (!m.symbols[g])
        ctx.addIssue({ code: 'custom', path: ['goal', i], message: `goal ${g} absent de symbols` });
    });
    Object.entries(m.symbols).forEach(([n, s]) => {
      if (s.given && s.value === void 0 && !s.exact?.length)
        ctx.addIssue({
          code: 'custom',
          path: ['symbols', n],
          message: 'grandeur donn\xE9e sans value',
        });
    });
  })
  .transform((m) => withNamedProducts(m));
var StoredScratchModelSchema = external_exports.object({
  engine_version: external_exports.number().int().min(1),
  model: ScratchModelSchema,
});

// packages/reasoner/src/kernel/rules/schema.ts
var RULE_KINDS = ['identity', 'equivalence', 'implication'];
var RULE_TARGETS = ['expression', 'equation', 'inequality'];
var PRECONDITION_KINDS = [
  'real',
  'integer',
  'natural',
  'nonzero',
  'positive',
  'negative',
  'nonnegative',
  'distinct',
];
var ON_UNKNOWN = ['refuse', 'branch', 'conditional'];
var RULE_LEVELS = ['6e', '5e', '4e', '3e', '2nde', '1re', 'tle', 'mpsi', 'ptsi', 'mp', 'pt'];
var PATTERN_VAR_RE = /^[A-Za-zα-ω][₀-₉]?$/;
var PATTERN_REF_RE = /^\?[A-Za-zα-ω][₀-₉]?$/;
var EXAMPLE_VAR_RE = /^[A-Za-zα-ω]{1,2}[₀-₉]?$/;
var PACK_ID_RE = /^[a-z][a-z0-9-]{1,39}$/;
var FORM_KEY_RE = /^[a-z][a-z0-9_]{0,23}$/;
var TAG_RE = /^[a-z][a-z0-9-]{0,31}$/;
var FormTextSchema = external_exports.string().trim().min(1).max(200);
var ExampleTextSchema = external_exports.string().trim().min(1).max(200);
function conditionRecord(ref) {
  return external_exports
    .record(
      external_exports.enum(PRECONDITION_KINDS),
      external_exports.union([
        external_exports.string().regex(ref),
        external_exports.array(external_exports.string().regex(ref)),
      ]),
    )
    .superRefine((rec, ctx) => {
      const keys = Object.keys(rec);
      if (keys.length !== 1) {
        ctx.addIssue({ code: 'custom', message: 'une condition = une seule cl\xE9' });
        return;
      }
      const k = keys[0];
      const v = rec[k];
      if (k === 'distinct') {
        if (!Array.isArray(v) || v.length < 2 || v.length > 4)
          ctx.addIssue({ code: 'custom', path: [k], message: '2 \xE0 4 termes distincts' });
      } else if (typeof v !== 'string') {
        ctx.addIssue({ code: 'custom', path: [k], message: 'un seul terme' });
      }
    });
}
var PreconditionSchema = conditionRecord(PATTERN_REF_RE);
var ExampleAssumeSchema = conditionRecord(EXAMPLE_VAR_RE);
var EffectSchema = external_exports
  .object({ flip_relation: external_exports.literal(true) })
  .strict();
var DirectionSchema = external_exports
  .object({
    from: external_exports.string().regex(FORM_KEY_RE),
    to: external_exports.string().regex(FORM_KEY_RE),
    goals: external_exports.array(GoalKindSchema).min(1).max(8),
  })
  .strict();
var RuleExampleSchema = external_exports
  .object({
    from: ExampleTextSchema,
    to: ExampleTextSchema,
    expect: external_exports.enum(['valid', 'invalid']),
    assume: external_exports.array(ExampleAssumeSchema).max(8).optional(),
  })
  .strict();
var RuleSpecSchema = external_exports
  .object({
    id: external_exports.string().regex(RULE_ID_RE),
    version: external_exports.number().int().min(1).max(999),
    kind: external_exports.enum(RULE_KINDS),
    applies_to: external_exports.enum(RULE_TARGETS).optional(),
    vars: external_exports
      .record(external_exports.string().regex(PATTERN_VAR_RE), SortSchema)
      .refine(
        (v) => Object.keys(v).length >= 1 && Object.keys(v).length <= 8,
        '1 \xE0 8 variables',
      ),
    forms: external_exports
      .record(external_exports.string().regex(FORM_KEY_RE), FormTextSchema)
      .refine((f) => Object.keys(f).length >= 2 && Object.keys(f).length <= 6, '2 \xE0 6 formes'),
    directions: external_exports.array(DirectionSchema).min(1).max(8),
    preconditions: external_exports.array(PreconditionSchema).max(8).optional(),
    on_unknown: external_exports.enum(ON_UNKNOWN).optional(),
    effects: external_exports.array(EffectSchema).max(4).optional(),
    cost: external_exports.number().int().min(0).max(100).optional(),
    label: external_exports.string().trim().min(1).max(120),
    /** propriété invoquée (« identité remarquable », « règle du produit nul ») */
    ref: external_exports.string().trim().min(1).max(200).optional(),
    tags: external_exports.array(external_exports.string().regex(TAG_RE)).max(8).optional(),
    levels: external_exports.array(external_exports.enum(RULE_LEVELS)).max(11).optional(),
    limits: external_exports
      .object({ max_matches: external_exports.number().int().min(1).max(1e3) })
      .strict()
      .optional(),
    /** rejoués au chargement : un exemple qui échoue fait refuser tout le paquet */
    examples: external_exports.array(RuleExampleSchema).min(1).max(16),
  })
  .strict();
var RULE_PACK_SCHEMA_VERSION = 1;
var RulePackSchema = external_exports
  .object({
    id: external_exports.string().regex(PACK_ID_RE),
    version: external_exports.number().int().min(1).max(999),
    schema: external_exports.literal(RULE_PACK_SCHEMA_VERSION),
    label: external_exports.string().trim().min(1).max(120).optional(),
    rules: external_exports.array(RuleSpecSchema).min(1).max(500),
  })
  .strict();

// packages/reasoner/src/kernel/rules/selftest.ts
var INT_POOL = Array.from({ length: 19 }, (_, i) => i - 9);
var NAT_POOL = Array.from({ length: 13 }, (_, i) => i);

// packages/reasoner/src/kernel-sheet.ts
var POLY_STEP_IDS = {
  allOnOneSide: 'poly.all_on_one_side@1',
  factor: 'poly.factor@1',
  canonical: 'poly.canonical@1',
  zeroProduct: 'poly.zero_product@1',
  squareRoot: 'poly.square_root@1',
  squareCompare: 'poly.square_compare@1',
  cubeRoot: 'poly.cube_root@1',
  cubeCompare: 'poly.cube_compare@1',
  signTable: 'poly.sign_table@1',
  /** moteur v42 : le tableau de signes dressé sur la feuille, puis lu */
  signTableFill: 'poly.sign_table_fill@1',
  signTableRead: 'poly.sign_table_read@1',
  clauses: 'poly.clauses@1',
  clearDenominator: 'poly.clear_denominator@1',
  sameDenominator: 'poly.same_denominator@1',
  discriminant: 'poly.discriminant@1',
  discriminantSign: 'poly.discriminant_sign@1',
  root: 'poly.root@1',
  roots: 'poly.roots@1',
  trinomialSign: 'poly.trinomial_sign@1',
  keep: 'poly.keep@1',
};
var CLEAR_DEN = {
  id: POLY_STEP_IDS.clearDenominator,
  card: '\xC9quations',
  label: 'Chasser le d\xE9nominateur',
  hora: 2,
  why: 'On multiplie les deux membres par le d\xE9nominateur, non nul pour les valeurs permises : plus de fraction, les solutions ne changent pas.',
};
var QUOTIENT_ZERO = {
  id: POLY_STEP_IDS.zeroProduct,
  card: '\xC9quations',
  label: 'Quotient nul',
  hora: 2,
  why: 'Un quotient est nul quand son num\xE9rateur est nul et son d\xE9nominateur ne l\u2019est pas : on \xE9carte la valeur interdite.',
};

// packages/reasoner/src/kernel-formula.ts
var isNumT = (t) => t.k === 'num';
function isNegation(t) {
  return (
    t.k === 'mul' && t.c.length === 2 && isNumT(t.c[0]) && eq(t.c[0].v, rat(-1)) && !isNumT(t.c[1])
  );
}
function isAtomicValue(t) {
  if (t.k !== 'fn' || t.f === 'deg' || t.f === 'abs' || t.f === 'fact') return false;
  const arg = t.a.k === 'fn' && t.a.f === 'deg' ? t.a.a : t.a;
  if (!isNumT(arg) && !isIrreducibleFraction(arg)) return false;
  const n = normalize2(t);
  return !(n.ok && rfRat(n.rf));
}
function isIrrationalAtom(t) {
  return (t.k === 'sym' && t.n === '\u03C0') || isAtomicValue(t);
}
function ratOf(t) {
  if (isNumT(t)) return t.v;
  if (isIrreducibleFraction(t)) {
    const d2 = t;
    return div(d2.a.v, d2.b.v);
  }
  if (isNegation(t)) {
    const r = ratOf(t.c[1]);
    return r ? neg2(r) : null;
  }
  return null;
}
function opsOf(t) {
  if (isIrreducibleFraction(t) || isAtomicValue(t)) return 0;
  switch (t.k) {
    case 'num':
    case 'sym':
      return 0;
    case 'add':
      return t.c.length - 1 + t.c.reduce((s, c) => s + opsOf(c), 0);
    case 'mul': {
      if (isNegation(t)) return opsOf(t.c[1]);
      const atoms = t.c.filter(isIrrationalAtom).length;
      const coef2 = (c) => {
        const q = ratOf(c);
        return q !== null && !isZero(q);
      };
      const free = atoms === 1 && t.c.some(coef2) ? 1 : 0;
      return t.c.length - 1 - free + t.c.reduce((s, c) => s + opsOf(c), 0);
    }
    case 'div':
      if (isIrrationalAtom(t.a) && ratOf(t.b) !== null) return 0;
      return 1 + opsOf(t.a) + opsOf(t.b);
    case 'pow':
    case 'binom':
      return 1 + opsOf(t.a) + opsOf(t.b);
    case 'fn':
      return (t.f === 'deg' ? 0 : 1) + opsOf(t.a);
  }
}
function shapeKey(t) {
  switch (t.k) {
    case 'num':
      return ratToText(t.v);
    case 'sym':
      return t.n;
    case 'add':
    case 'mul':
      return `${t.k}(${t.c.map(shapeKey).sort().join(',')})`;
    case 'div':
    case 'pow':
    case 'binom':
      return `${t.k}(${shapeKey(t.a)},${shapeKey(t.b)})`;
    case 'fn':
      return `${t.f}(${shapeKey(t.a)})`;
  }
}
function isIrreducibleFraction(t) {
  if (t.k !== 'div' || !isNumT(t.a) || !isNumT(t.b)) return false;
  const a = t.a.v;
  const b = t.b.v;
  if (!isInteger(a) || !isInteger(b) || b.n <= 1n) return false;
  const g = (x, y) => (y === 0n ? (x < 0n ? -x : x) : g(y, x % y));
  return g(a.n, b.n) === 1n;
}
function constOps(t) {
  return opsOf(t);
}
function constShapeKey(t) {
  return shapeKey(t);
}

// packages/reasoner/src/kernel-integral.ts
var INTEGRAL_STEP_IDS = {
  name: 'integral.name@1',
  parts: 'integral.parts@1',
  primitive: 'integral.primitive@1',
  recognize: 'integral.recognize@1',
  constant: 'integral.constant@1',
  linearity: 'integral.linearity@1',
  linearize: 'integral.linearize@1',
  decompose: 'integral.decompose@1',
  rewrite: 'integral.rewrite@1',
  chasles: 'integral.chasles@1',
  bracket: 'integral.bracket@1',
  bracketMerge: 'integral.bracket_merge@1',
  replace: 'integral.replace@1',
  recognizeI: 'integral.recognize_i@1',
  collect: 'integral.collect@1',
  divide: 'integral.divide@1',
  compute: 'kernel.compute@1',
};
var STEP2 = {
  name: {
    label: 'Nommer',
    hora: 1,
    why: 'On choisit u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer ; u\u2032 se d\xE9rive, v est une primitive de v\u2032.',
  },
  parts: {
    label: 'Int\xE9gration par parties',
    hora: 2,
    why: '\u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v : on d\xE9rive u, on prend une primitive de v\u2032.',
  },
  primitive: {
    label: 'Primitive',
    hora: 2,
    why: 'Une primitive F de la fonction : \u222B(a ; b) f(x) dx = [F(x)](a ; b).',
  },
  recognize: {
    label: 'Reconna\xEEtre une forme',
    hora: 3,
    why: 'La fonction est de la forme u\u2032e\u1D58, u\u2032 \xF7 u, u\u2032u\u207F\u2026 : on \xE9crit directement sa primitive.',
  },
  constant: {
    label: 'Int\xE9grale d\u2019une constante',
    hora: 1,
    why: '\u222B(a ; b) k dx = k \xD7 (b \u2212 a).',
  },
  linearity: {
    label: 'Lin\xE9arit\xE9',
    hora: 1,
    why: 'L\u2019int\xE9grale d\u2019une somme est la somme des int\xE9grales ; une constante sort de l\u2019int\xE9grale.',
  },
  linearize: {
    label: 'Lin\xE9ariser',
    hora: 2,
    why: 'cos\xB2x = (1 + cos 2x) \xF7 2, sin\xB2x = (1 \u2212 cos 2x) \xF7 2 : plus de puissance de cos ou de sin.',
  },
  decompose: {
    label: 'D\xE9composer en \xE9l\xE9ments simples',
    hora: 2,
    why: 'La fraction devient une somme de fractions plus simples, qui ont chacune une primitive.',
  },
  rewrite: {
    label: 'Transformer la fonction',
    hora: 1,
    why: 'Une \xE9criture \xE9gale de la fonction \xE0 int\xE9grer, plus facile \xE0 int\xE9grer.',
  },
  chasles: {
    label: 'Relation de Chasles',
    hora: 2,
    why: '\u222B(a ; b) = \u222B(a ; c) + \u222B(c ; b) : sur chaque morceau, la fonction s\u2019\xE9crit sans valeur absolue.',
  },
  bracket: {
    label: 'Remplacer x par les bornes',
    hora: 1,
    why: '[F(x)](a ; b) = F(b) \u2212 F(a) : la borne du haut, puis celle du bas.',
  },
  bracketMerge: {
    label: 'Regrouper les crochets',
    hora: 1,
    why: 'Des crochets aux m\xEAmes bornes se regroupent : [F](a ; b) + [G](a ; b) = [F + G](a ; b).',
  },
  replace: {
    label: 'Remplacer',
    hora: 1,
    why: 'On remplace une int\xE9grale par ce qu\u2019on a calcul\xE9 \xE0 part.',
  },
  recognizeI: {
    label: 'Reconna\xEEtre I',
    hora: 1,
    why: 'L\u2019int\xE9grale de d\xE9part r\xE9appara\xEEt : on l\u2019\xE9crit I, ce qui donne une \xE9quation en I.',
  },
  collect: {
    label: 'Regrouper les I',
    hora: 1,
    why: 'On passe les I du m\xEAme c\xF4t\xE9.',
  },
  divide: {
    label: 'Diviser',
    hora: 1,
    why: 'On divise les deux membres par le coefficient de I.',
  },
  compute: {
    label: 'Calculer',
    hora: 1,
    why: 'Un calcul sur les nombres.',
  },
};
var CARD2 = 'Int\xE9grales';
var IntegralModelError = class extends Error {};
var INT_RE = /^∫\((.+) ; (.+)\)$/;
var BRK_RE = /^\]\((.+) ; (.+)\)$/;
var DIFF_RE = /^d([a-zθ])$/;
var NAME_RE = /^([uv])(′?)\(([a-zθ])\)$/;
var isIntegralAtom = (a) => !!a && INT_RE.test(a);
var isBracketClose = (a) => !!a && BRK_RE.test(a);
var isDiffAtom = (a) => !!a && DIFF_RE.test(a);
var isSpecial = (a) => isIntegralAtom(a) || isBracketClose(a) || isDiffAtom(a) || a === '[';
function boundText(s) {
  return exprText2(normalize(lex(s.trim())));
}
function exprText2(atoms) {
  return atomsText(atoms)
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ')
    .trim();
}
function integralAtom(lo, hi) {
  return `\u222B(${boundText(lo)} ; ${boundText(hi)})`;
}
function bracketCloseAtom(lo, hi) {
  return `](${boundText(lo)} ; ${boundText(hi)})`;
}
function group(text, open) {
  let depth = 0;
  for (let i = open; i < text.length; i++) {
    const c = text[i];
    if (c === '(') depth++;
    else if (c === ')') {
      depth--;
      if (depth === 0) return { inner: text.slice(open + 1, i), end: i + 1 };
    }
  }
  return null;
}
function splitBounds(inner2) {
  let depth = 0;
  for (let i = 0; i < inner2.length; i++) {
    const c = inner2[i];
    if (c === '(') depth++;
    else if (c === ')') depth--;
    else if (c === ';' && depth === 0) return [inner2.slice(0, i), inner2.slice(i + 1)];
  }
  return null;
}
var LETTER_RE2 = /[A-Za-zÀ-ÖØ-öø-ÿα-ωΑ-Ω]/;
function kintLineAtoms(text) {
  const out = [];
  let buf = '';
  const flush = () => {
    if (buf.trim()) out.push(...lex(buf));
    buf = '';
  };
  const s = String(text);
  for (let i = 0; i < s.length; ) {
    const c = s[i];
    if (c === '\u222B' && s[i + 1] === '(') {
      const g = group(s, i + 1);
      const b = g && splitBounds(g.inner);
      if (g && b) {
        flush();
        out.push(integralAtom(b[0], b[1]));
        i = g.end;
        continue;
      }
    }
    if (c === '[') {
      flush();
      out.push('[');
      i++;
      continue;
    }
    if (c === ']' && s[i + 1] === '(') {
      const g = group(s, i + 1);
      const b = g && splitBounds(g.inner);
      if (g && b) {
        flush();
        out.push(bracketCloseAtom(b[0], b[1]));
        i = g.end;
        continue;
      }
    }
    if (
      c === 'd' &&
      /[a-zθ]/.test(s[i + 1] ?? '') &&
      !LETTER_RE2.test(s[i - 1] ?? '') &&
      !/[A-Za-zÀ-ÿα-ω₀-₉′(]/.test(s[i + 2] ?? '')
    ) {
      flush();
      out.push('d' + s[i + 1]);
      i += 2;
      continue;
    }
    buf += c;
    i++;
  }
  flush();
  return kintNormalize(wrapArgs(out)).atoms;
}
function wrapArgs(atoms) {
  const out = [];
  for (let i = 0; i < atoms.length; i++) {
    const a = atoms[i];
    out.push(a);
    const n = atoms[i + 1];
    if (
      isFunc(a) &&
      n !== void 0 &&
      n !== '(' &&
      (isVar(n) || isNum(n) || isConst(n)) &&
      !isSpecial(n)
    ) {
      out.push('(', n, ')');
      i++;
    }
  }
  return out;
}
var endsOp = (a) =>
  isOperand(a) || a === ')' || a === '\xB2' || isSupPow(a) || a === '!' || isPow(a);
var startsOp = (a) =>
  isVar(a) || isConst(a) || isFunc(a) || a === '(' || a === '\u221A' || isNum(a);
function kintNormalize(atoms) {
  const out = [];
  const src = [];
  atoms.forEach((a, i) => {
    const p = out[out.length - 1];
    if (p !== void 0 && p !== '\xD7') {
      const pSpecialOpen = isIntegralAtom(p) || p === '[';
      const pCloses = isBracketClose(p) || isDiffAtom(p);
      let times = false;
      if (isIntegralAtom(a) || a === '[') times = !pSpecialOpen && (pCloses || endsOp(p));
      else if (isBracketClose(a) || isDiffAtom(a)) times = false;
      else if (pCloses) times = startsOp(a) && !isNum(a) ? true : isNum(a);
      else if (!pSpecialOpen) times = endsOp(p) && startsOp(a) && !isNum(a);
      if (times) {
        out.push('\xD7');
        src.push(i);
      }
    }
    out.push(a);
    src.push(i);
  });
  return { atoms: out, src };
}
function kintText(atoms) {
  const parts = [];
  let run = [];
  const flush = () => {
    if (run.length) parts.push(exprText2(run));
    run = [];
  };
  for (const a of atoms) {
    if (isSpecial(a)) {
      flush();
      parts.push(a);
    } else run.push(a);
  }
  flush();
  let out = '';
  parts.forEach((p, i) => {
    const prev = parts[i - 1];
    if (!i) out = p;
    else if (prev === '[' || isBracketClose(p)) out += p;
    else out += ' ' + p;
  });
  return out.replace(/\s+/g, ' ').trim();
}
var lineOf = (atoms) => ({
  dis: [{ sides: [{ k: 's', n: kintText(atoms) }] }],
});
function kintLine(text) {
  return lineOf(kintLineAtoms(text));
}
var E = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function withE(t) {
  switch (t.k) {
    case 'sym':
      return t.n === 'e' ? E : t;
    case 'add':
    case 'mul':
      return { ...t, c: t.c.map(withE) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...t, a: withE(t.a), b: withE(t.b) };
    case 'fn':
      return { ...t, a: withE(t.a) };
    default:
      return t;
  }
}
function exprOf(atoms) {
  if (!atoms.length) return null;
  try {
    const p = parseStatement(atomsText(atoms));
    return p.ok && p.s.k === 'expr' ? withE(p.s.e) : null;
  } catch {
    return null;
  }
}
function exprOfText(text) {
  try {
    return exprOf(normalize(lex(text)));
  } catch {
    return null;
  }
}
var keyOf = (t) => {
  try {
    return termKey(canon(t));
  } catch {
    return termKey(t);
  }
};
var shape = (t) => {
  try {
    return constShapeKey(t);
  } catch {
    return termKey(t);
  }
};
function leadInt(t) {
  if (t.k === 'num') return t.v.d === 1n ? (t.v.n < 0n ? -t.v.n : t.v.n) : null;
  if (t.k === 'mul' && t.c[0]?.k === 'num') return leadInt(t.c[0]);
  return null;
}
var gcdB = (a, b) => (b === 0n ? a : gcdB(b, a % b));
function reducible(t) {
  switch (t.k) {
    case 'div': {
      const a = leadInt(t.a);
      const b = leadInt(t.b);
      const own = a !== null && b !== null && a > 0n && b > 1n && gcdB(a, b) > 1n ? 1 : 0;
      return own + reducible(t.a) + reducible(t.b);
    }
    case 'add':
    case 'mul':
      return t.c.reduce((s, c) => s + reducible(c), 0);
    case 'pow':
      return reducible(t.a) + reducible(t.b);
    case 'fn':
      return reducible(t.a);
    default:
      return 0;
  }
}
var opsOf2 = (t) => {
  try {
    return constOps(t) + reducible(t);
  } catch {
    return 99;
  }
};
var isOne = (t) => t.k === 'num' && t.v.n === 1n && t.v.d === 1n;
var isZeroT = (t) => t.k === 'num' && t.v.n === 0n;
function val(t, env = {}) {
  try {
    const v = withRadianArcs(() => evalFloat(t, env));
    return Number.isFinite(v) ? v : NaN;
  } catch {
    return NaN;
  }
}
var near = (a, b) =>
  Number.isFinite(a) &&
  Number.isFinite(b) &&
  Math.abs(a - b) <= 1e-9 * Math.max(1, Math.abs(a), Math.abs(b));
function trivial(t) {
  switch (t.k) {
    case 'fn': {
      const a = trivial(t.a);
      const r = { ...t, a };
      if ([...symbolsOf(a)].every((s) => s === '\u03C0')) {
        const v = val(r);
        for (const k of [-1, 0, 1])
          if (Number.isFinite(v) && Math.abs(v - k) < 1e-12) return num2(k);
      }
      return r;
    }
    case 'mul': {
      const c = t.c.map(trivial);
      if (c.some(isZeroT)) return num2(0);
      const kept = c.filter((f) => !isOne(f));
      return kept.length === 0 ? num2(1) : kept.length === 1 ? kept[0] : mul2(...kept);
    }
    case 'add': {
      const c = t.c.map(trivial).filter((f) => !isZeroT(f));
      return c.length === 0 ? num2(0) : c.length === 1 ? c[0] : add2(...c);
    }
    case 'div': {
      const a = trivial(t.a);
      const b = trivial(t.b);
      if (isZeroT(a)) return num2(0);
      return isOne(b) ? a : div2(a, b);
    }
    case 'pow': {
      const a = trivial(t.a);
      const b = trivial(t.b);
      if (isOne(b)) return a;
      if (isZeroT(b) || isOne(a)) return num2(1);
      if (isZeroT(a)) return num2(0);
      return { ...t, a, b };
    }
    default:
      return t;
  }
}
var XGK = [
  0.9914553711208126, 0.9491079123427585, 0.8648644233597691, 0.7415311855993945,
  0.5860872354676911, 0.4058451513773972, 0.20778495500789848, 0,
];
var WGK = [
  0.022935322010529224, 0.06309209262997856, 0.10479001032225019, 0.14065325971552592,
  0.1690047266392679, 0.19035057806478542, 0.20443294007529889, 0.20948214108472782,
];
var WG = [0.1294849661688697, 0.27970539148927664, 0.3818300505051189, 0.4179591836734694];
function gk15(f, a, b) {
  const c = (a + b) / 2;
  const h = (b - a) / 2;
  const fc = f(c);
  let k = fc * WGK[7];
  let g = fc * WG[3];
  for (let j = 0; j < 7; j++) {
    const dx = h * XGK[j];
    const s = f(c - dx) + f(c + dx);
    k += WGK[j] * s;
    if (j % 2 === 1) g += WG[(j - 1) / 2] * s;
  }
  return { k: k * h, err: Math.abs((k - g) * h) };
}
function integrateNum(f, a, b) {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return NaN;
  if (a === b) return 0;
  const whole = gk15(f, a, b);
  if (!Number.isFinite(whole.k)) return NaN;
  const tol = 1e-13 * Math.max(1, Math.abs(whole.k));
  let evals = 0;
  const rec = (lo, hi, r, depth) => {
    if (r.err <= tol * ((hi - lo) / (b - a) + 1e-3) || depth > 40 || evals > 4e3) return r.k;
    const m = (lo + hi) / 2;
    const left = gk15(f, lo, m);
    const right = gk15(f, m, hi);
    evals += 2;
    return rec(lo, m, left, depth + 1) + rec(m, hi, right, depth + 1);
  };
  const v = rec(a, b, whole, 0);
  return Number.isFinite(v) ? v : NaN;
}
var itemKey = (it) => (it.atom ? it.atom.key : 'I');
function atomKey(k, lo, hi, body) {
  return `${k}|${keyOf(lo)}|${keyOf(hi)}|${keyOf(body)}`;
}
function atomValue(ks, at) {
  const hit = ks.cache.get(at.key);
  if (hit !== void 0) return hit;
  let v;
  if (at.k === 'brk') v = val(at.body, { [ks.x]: at.b }) - val(at.body, { [ks.x]: at.a });
  else v = integrateNum((p) => val(at.body, { [ks.x]: p }), at.a, at.b);
  ks.cache.set(at.key, v);
  return v;
}
function formValue(ks, f, iValue = ks.value) {
  let v = f.cv;
  for (const it of f.items) v += it.cv * (it.atom ? atomValue(ks, it.atom) : iValue);
  return v;
}
function formOps(f, triv = false) {
  const o = (t) => opsOf2(triv ? trivial(t) : t);
  let n = o(f.c);
  for (const it of f.items) if (!isOne(it.coef)) n += o(it.coef);
  return n;
}
function linear(t, refs) {
  const has = (u) => [...symbolsOf(u)].some((s) => refs.has(s));
  if (!has(t)) return [{ coef: t, ref: null }];
  switch (t.k) {
    case 'sym':
      return [{ coef: num2(1), ref: t.n }];
    case 'add': {
      const out = [];
      for (const c of t.c) {
        const l = linear(c, refs);
        if (!l) return null;
        out.push(...l);
      }
      return out;
    }
    case 'mul': {
      const vary = t.c.filter(has);
      if (vary.length !== 1) return null;
      const consts = t.c.filter((c) => !has(c));
      const l = linear(vary[0], refs);
      if (!l) return null;
      return l.map((s) => ({
        coef: consts.length
          ? isOne(s.coef)
            ? consts.length === 1
              ? consts[0]
              : mul2(...consts)
            : mul2(...consts, s.coef)
          : s.coef,
        ref: s.ref,
      }));
    }
    case 'div': {
      if (has(t.b)) return null;
      const l = linear(t.a, refs);
      if (!l) return null;
      return l.map((s) => ({ coef: div2(s.coef, t.b), ref: s.ref }));
    }
    default:
      return null;
  }
}
function buildForm(sums, atoms, name2) {
  const groups = /* @__PURE__ */ new Map();
  const consts = [];
  for (const s of sums) {
    if (s.ref === null) {
      consts.push(s.coef);
      continue;
    }
    const atom = s.ref === name2 ? null : atoms.get(s.ref);
    const k = atom ? atom.key : 'I';
    const g = groups.get(k) ?? { atom, coefs: [] };
    g.coefs.push(s.coef);
    groups.set(k, g);
  }
  const items = [...groups.values()]
    .map((g) => {
      const coef2 = g.coefs.length === 1 ? g.coefs[0] : add2(...g.coefs);
      return { atom: g.atom, coef: coef2, cv: val(coef2) };
    })
    .filter((it) => !near(it.cv, 0) || !Number.isFinite(it.cv));
  const c = consts.length === 0 ? num2(0) : consts.length === 1 ? consts[0] : add2(...consts);
  const iCoef = items.filter((it) => !it.atom).reduce((s, it) => s + it.cv, 0);
  const wkey =
    items
      .map((it) => `${itemKey(it)}:${shape(it.coef)}`)
      .sort()
      .join(',') +
    '#' +
    (isZeroT(c) ? '' : shape(c));
  return { items, c, cv: val(c), iCoef, wkey };
}
var syntax = (title, message, index) => ({
  k: 'syntax',
  title,
  message,
  index,
});
function readLine(ks, A) {
  if (!A.length) return { k: 'empty' };
  const nm = NAME_RE.exec(A[0]);
  if (nm) {
    if (A.length === 1) return { k: 'incomplete' };
    if (A[1] !== '=') return syntax('Nomme une fonction', '\xC9cris \xAB u(x) = \u2026 \xBB.', 1);
    if (nm[3] !== ks.x)
      return syntax(
        'La variable',
        `\xC9cris ${nm[1]}${nm[2]}(${ks.x}) = \u2026 : la variable est ${ks.x}.`,
        0,
      );
    const rest = A.slice(2);
    if (!rest.length) return { k: 'incomplete' };
    if (rest.some(isSpecial) || rest.includes('='))
      return syntax(
        'Une fonction',
        'Apr\xE8s \xAB = \xBB, \xE9cris seulement une fonction de ' + ks.x + '.',
        2,
      );
    const syn2 = checkSyntax(rest);
    if (!syn2.ok) return syntax('\xC7a commence mal', syn2.msg, 2 + syn2.index);
    if (!syn2.complete) return { k: 'incomplete' };
    const e = exprOf(rest);
    if (!e) return syntax('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', A.length - 1);
    const head = nm[1] === 'u' ? (nm[2] ? 'du' : 'u') : nm[2] ? 'dv' : 'v';
    return { k: 'name', head, expr: e };
  }
  const atoms = /* @__PURE__ */ new Map();
  const outer2 = [];
  const outerSrc = [];
  let n = 0;
  for (let i = 0; i < A.length; i++) {
    const a = A[i];
    if (isIntegralAtom(a) || a === '[') {
      const int = isIntegralAtom(a);
      let j = i + 1;
      while (j < A.length && !(int ? isDiffAtom(A[j]) : isBracketClose(A[j]))) {
        if (isSpecial(A[j]))
          return syntax(
            int ? 'Ferme l\u2019int\xE9grale' : 'Ferme le crochet',
            int
              ? 'Une int\xE9grale se ferme par \xAB dx \xBB avant d\u2019\xE9crire autre chose.'
              : 'Un crochet se ferme par \xAB ](a ; b) \xBB avant d\u2019\xE9crire autre chose.',
            j,
          );
        j++;
      }
      if (j >= A.length) return { k: 'incomplete' };
      const body = A.slice(i + 1, j).filter(
        (x, k, arr) => !(x === '\xD7' && (k === 0 || k === arr.length - 1)),
      );
      if (!body.length)
        return syntax(
          int ? 'La fonction \xE0 int\xE9grer' : 'Dans le crochet',
          int
            ? '\xC9cris la fonction entre \u222B et dx.'
            : '\xC9cris une fonction entre les crochets.',
          j,
        );
      const syn2 = checkSyntax(normalize(body));
      if (!syn2.ok)
        return syntax(
          '\xC7a commence mal',
          syn2.msg,
          i + 1 + Math.min(syn2.index, body.length - 1),
        );
      if (!syn2.complete)
        return syntax('\xC7a ne se lit pas', 'La fonction n\u2019est pas finie.', j);
      const fx = exprOf(normalize(body));
      if (!fx) return syntax('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', j);
      const m = (int ? INT_RE : BRK_RE).exec(int ? a : A[j]);
      if (int && DIFF_RE.exec(A[j])[1] !== ks.x)
        return syntax(
          'La variable',
          `La variable est ${ks.x} : ferme l\u2019int\xE9grale par \xAB d${ks.x} \xBB.`,
          j,
        );
      const lo = exprOfText(m[1]);
      const hi = exprOfText(m[2]);
      if (!lo || !hi) return syntax('Les bornes', 'Une borne ne se lit pas.', int ? i : j);
      const at = {
        k: int ? 'int' : 'brk',
        lo,
        hi,
        a: val(lo),
        b: val(hi),
        body: fx,
        key: atomKey(int ? 'int' : 'brk', lo, hi, fx),
        text: int
          ? `${a} ${exprText2(normalize(body))} ${A[j]}`
          : `[${exprText2(normalize(body))}${A[j]}`,
      };
      const ph = `\u03C8${String(++n)
        .split('')
        .map((d2) => '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089'[Number(d2)])
        .join('')}`;
      atoms.set(ph, at);
      outer2.push(ph);
      outerSrc.push(i);
      i = j;
      continue;
    }
    if (isBracketClose(a))
      return syntax(
        'Ouvre le crochet',
        'Un crochet s\u2019ouvre par \xAB [ \xBB avant de se fermer.',
        i,
      );
    if (isDiffAtom(a))
      return syntax(
        '\xAB dx \xBB ferme une int\xE9grale',
        '\xC9cris d\u2019abord \xAB \u222B(a ; b) \xBB, puis la fonction.',
        i,
      );
    outer2.push(a);
    outerSrc.push(i);
  }
  const O = normalize(outer2);
  const syn = checkSyntax(O, { chains: true });
  if (!syn.ok)
    return syntax(
      '\xC7a commence mal',
      syn.msg,
      outerSrc[Math.min(syn.index, outerSrc.length - 1)] ?? 0,
    );
  if (!syn.complete) return { k: 'incomplete' };
  if (!O.includes('=')) return { k: 'noeq' };
  const refs = /* @__PURE__ */ new Set([...atoms.keys(), ks.name]);
  const parts = [[]];
  let depth = 0;
  for (const a of O) {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth === 0 && a === '=') parts.push([]);
    else parts[parts.length - 1].push(a);
  }
  const members = [];
  for (const p of parts) {
    const t = exprOf(p);
    if (!t)
      return syntax(
        '\xC7a ne se lit pas',
        'Un membre ne se lit pas : v\xE9rifie les parenth\xE8ses.',
        A.length - 1,
      );
    if ([...symbolsOf(t)].some((s) => !refs.has(s) && s !== '\u03C0'))
      return syntax(
        'Une lettre en trop',
        `Hors d\u2019une int\xE9grale ou d\u2019un crochet, ${ks.x} n\u2019a pas de valeur : \xE9cris des nombres, ${ks.name}, des int\xE9grales ou des crochets.`,
        A.length - 1,
      );
    const l = linear(t, refs);
    if (!l)
      return syntax(
        'Une int\xE9grale \xE0 part',
        'Une int\xE9grale (ou un crochet) se multiplie par un nombre, s\u2019ajoute ou se retranche ; elle ne se met pas dans une fonction.',
        A.length - 1,
      );
    members.push(buildForm(l, atoms, ks.name));
  }
  return { k: 'chain', members };
}
var RATIOS = [0.061, 0.137, 0.229, 0.318, 0.411, 0.503, 0.597, 0.689, 0.773, 0.857, 0.941];
function pointsOf(a, b) {
  const lo = Math.min(a, b);
  const hi = Math.max(a, b);
  if (!(hi > lo) || !Number.isFinite(lo) || !Number.isFinite(hi)) return [];
  return RATIOS.map((r) => lo + r * (hi - lo));
}
function vec(t, x, pts) {
  return pts.map((p) => val(t, { [x]: p }));
}
function sameVec(u, v) {
  let ok = 0;
  for (let i = 0; i < u.length; i++) {
    const a = u[i];
    const b = v[i];
    if (Number.isNaN(a) !== Number.isNaN(b)) return false;
    if (Number.isNaN(a)) continue;
    if (!closeTo(a, b) && !(Math.abs(a - b) < 1e-11)) return false;
    ok++;
  }
  return ok >= 5;
}
var sameFn = (f, g, x, pts) => sameVec(vec(f, x, pts), vec(g, x, pts));
function offsetFn(f, g, x, pts) {
  const u = vec(f, x, pts);
  const v = vec(g, x, pts);
  let k = null;
  let ok = 0;
  for (let i = 0; i < u.length; i++) {
    if (!Number.isFinite(u[i]) || !Number.isFinite(v[i])) {
      if (Number.isNaN(u[i]) !== Number.isNaN(v[i])) return false;
      continue;
    }
    const d2 = u[i] - v[i];
    if (k === null) k = d2;
    else if (!closeTo(d2 + 1, k + 1)) return false;
    ok++;
  }
  return ok >= 5;
}
function safeDerive(t, x) {
  try {
    return withArcDerivatives(() => derive(t, x));
  } catch {
    return null;
  }
}
function stepVerdict(base, steps, labels, imove, final) {
  const hora = steps.reduce((s, k) => s + STEP2[k].hora, 0);
  let main = 0;
  steps.forEach((k, i) => {
    if (STEP2[k].hora > STEP2[steps[main]].hora) main = i;
  });
  const shown = [...new Set(labels.map((l, i) => l || STEP2[steps[i]].label))];
  const why =
    [...new Set(steps)].map((k) => STEP2[k].why).join(' ') +
    (final ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...base,
    hora,
    final,
    rule: {
      id: INTEGRAL_STEP_IDS[steps[main]],
      card: CARD2,
      label: shown.join(' \u2192 '),
      hora,
      why,
    },
    imove: { ...imove, ...(final ? { final } : {}) },
  };
}
function jumpVerdict(base, imove, final, message) {
  return {
    kind: 'useless',
    ...base,
    jump: true,
    final,
    title: final ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      message ??
      (final
        ? 'C\u2019est la bonne valeur. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    imove: { ...imove, ...(final ? { final } : {}) },
  };
}
function trapOr(ks, base, why) {
  const text = kintText(base.atoms);
  const t = ks.traps.find((t2) => t2.text === text);
  if (t)
    return {
      kind: 'trap',
      ...base,
      title: t.title,
      message: t.why,
      trap: { line: t.line, title: t.title, why: t.why },
    };
  return { kind: 'false', ...base, ...why };
}
var classKey = (k) => `k:${Math.round(k * 1e9)}`;
function integralQuestionOf(model) {
  const spec = model.kernel;
  const name2 = spec.goal.target;
  const A = kintLineAtoms(spec.start);
  if (A[0] !== name2 || A[1] !== '=')
    throw new IntegralModelError(
      `Le d\xE9part s\u2019\xE9crit \xAB ${name2} = \u222B(a ; b) \u2026 dx \xBB.`,
    );
  const i = A.findIndex(isIntegralAtom);
  const j = A.findIndex(isDiffAtom);
  if (i !== 2 || j !== A.length - 1)
    throw new IntegralModelError(
      `Le d\xE9part s\u2019\xE9crit \xAB ${name2} = \u222B(a ; b) \u2026 dx \xBB : une seule int\xE9grale.`,
    );
  const x = DIFF_RE.exec(A[j])[1];
  const m = INT_RE.exec(A[i]);
  const body = exprOf(normalize(A.slice(i + 1, j)));
  const lo = exprOfText(m[1]);
  const hi = exprOfText(m[2]);
  if (!body || !lo || !hi)
    throw new IntegralModelError(`D\xE9part illisible : \xAB ${spec.start} \xBB.`);
  if ([...symbolsOf(body)].some((s) => s !== x && s !== '\u03C0'))
    throw new IntegralModelError(`La fonction \xE0 int\xE9grer ne d\xE9pend que de ${x}.`);
  const atom = {
    k: 'int',
    lo,
    hi,
    a: val(lo),
    b: val(hi),
    body,
    key: atomKey('int', lo, hi, body),
    text: kintText(A.slice(2)),
  };
  const ans = kintLineAtoms(spec.answer);
  if (ans[0] !== name2 || ans[1] !== '=' || ans.length < 3)
    throw new IntegralModelError(`La r\xE9ponse s\u2019\xE9crit \xAB ${name2} = valeur \xBB.`);
  if (ans.slice(2).some(isSpecial))
    throw new IntegralModelError('La r\xE9ponse est une valeur, sans int\xE9grale ni crochet.');
  const answer = exprOf(ans.slice(2));
  if (!answer || [...symbolsOf(answer)].some((s) => s !== '\u03C0'))
    throw new IntegralModelError(
      'La r\xE9ponse est une valeur (des nombres, e, \u03C0, ln\u2026).',
    );
  return { name: name2, x, atom, answer };
}
function createKIntState(model) {
  const spec = model.kernel;
  const q = integralQuestionOf(model);
  const ks = {
    model,
    name: q.name,
    x: q.x,
    startAtom: q.atom,
    value: NaN,
    answer: q.answer,
    answerValue: val(q.answer),
    answerOps: opsOf2(q.answer),
    classes: /* @__PURE__ */ new Map(),
    side: /* @__PURE__ */ new Map(),
    names: {},
    written: /* @__PURE__ */ new Set(),
    givenTexts: /* @__PURE__ */ new Set(),
    path: spec.path ?? [],
    traps: [],
    lines: 0,
    concluded: false,
    cache: /* @__PURE__ */ new Map(),
  };
  ks.value = atomValue(ks, q.atom);
  if (!Number.isFinite(ks.value))
    throw new IntegralModelError(
      'L\u2019int\xE9grale n\u2019a pas de valeur (la fonction n\u2019est pas d\xE9finie sur l\u2019intervalle).',
    );
  const startForm = {
    items: [{ atom: q.atom, coef: num2(1), cv: 1 }],
    c: num2(0),
    cv: 0,
    iCoef: 0,
    wkey: `${q.atom.key}:1#`,
  };
  ks.classes.set(classKey(1), [startForm]);
  ks.givenTexts = new Set(integralGivenTexts(model).map((t) => kintText(kintLineAtoms(t))));
  ks.traps = (model.traps ?? []).map((t) => ({
    text: kintText(kintLineAtoms(t.line)),
    line: kintLine(t.line),
    title: t.title ?? 'Attention',
    why: t.why,
  }));
  return ks;
}
function integralGivenTexts(model) {
  return [model.kernel.start, ...(model.givens ?? [])];
}
function diffForms(S, T) {
  const left = [...T.items];
  const gone = [];
  let recoef = false;
  for (const it of S.items) {
    const j = left.findIndex((o) => itemKey(o) === itemKey(it) && near(o.cv, it.cv));
    if (j >= 0) {
      if (shape(left[j].coef) !== shape(it.coef)) recoef = true;
      left.splice(j, 1);
    } else gone.push(it);
  }
  return { gone, came: left, recoef };
}
var sameBounds = (a, b) => near(a.a, b.a) && near(a.b, b.b);
function primForm(t, x) {
  const consts = [];
  const core = [];
  const walk = (f) => {
    if (f.k === 'mul') f.c.forEach(walk);
    else if (f.k === 'div' && !symbolsOf(f.b).has(x)) {
      consts.push(div2(num2(1), f.b));
      walk(f.a);
    } else if (!symbolsOf(f).has(x)) consts.push(f);
    else core.push(f);
  };
  if (t.k === 'add') return add2(...t.c.map((c) => primForm(c, x)));
  walk(t);
  if (core.length === 1 && core[0].k === 'add')
    return add2(...core[0].c.map((c) => primForm(consts.length ? mul2(...consts, c) : c, x)));
  const fs = [...consts, ...core];
  return fs.length === 1 ? fs[0] : mul2(...fs);
}
function primitiveKind(F, x) {
  let tpl = null;
  try {
    tpl = withArcDerivatives(() => stepTemplate(primForm(F, x), x, () => null));
  } catch {
    tpl = null;
  }
  if (!tpl) return null;
  if (tpl.rules.includes('product') || tpl.rules.includes('quotient')) return null;
  const r = tpl.rules.find((x2) => x2 !== 'usual');
  if (!r) return { kind: 'primitive', label: STEP2.primitive.label };
  const label =
    r === 'chain_exp'
      ? 'Reconna\xEEtre u\u2032e\u1D58'
      : r === 'chain_ln'
        ? 'Reconna\xEEtre u\u2032 \xF7 u'
        : r === 'chain_pow'
          ? 'Reconna\xEEtre u\u2032u\u207F'
          : r === 'chain_sqrt'
            ? 'Reconna\xEEtre u\u2032 \xF7 \u221Au'
            : r === 'chain_trig'
              ? 'Reconna\xEEtre u\u2032 cos u'
              : r === 'inverse'
                ? 'Reconna\xEEtre u\u2032 \xF7 u\xB2'
                : r === 'chain_arc'
                  ? arcLabel(F)
                  : STEP2.recognize.label;
  return { kind: 'recognize', label };
}
function arcLabel(F) {
  const has = (t, f) =>
    t.k === 'fn'
      ? t.f === f || has(t.a, f)
      : t.k === 'add' || t.k === 'mul'
        ? t.c.some((c) => has(c, f))
        : t.k === 'num' || t.k === 'sym'
          ? false
          : has(t.a, f) || has(t.b, f);
  return has(F, 'arcsin') || has(F, 'arccos')
    ? 'Reconna\xEEtre u\u2032 \xF7 \u221A(1 \u2212 u\xB2)'
    : 'Reconna\xEEtre u\u2032 \xF7 (1 + u\xB2)';
}
function partsSplit(P3, target, x, pts) {
  let sc;
  try {
    sc = splitConstant(P3, x);
  } catch {
    return null;
  }
  const core = [];
  const consts = [...sc.c];
  const flat = (f) => {
    if (f.k === 'mul') f.c.forEach(flat);
    else if (f.k === 'div' && !symbolsOf(f.b).has(x)) {
      consts.push(div2(num2(1), f.b));
      flat(f.a);
    } else if (!symbolsOf(f).has(x)) consts.push(f);
    else core.push(f);
  };
  sc.core.forEach(flat);
  const n = core.length;
  if (!n || n > 6) return null;
  for (let mask = 1; mask < 1 << n; mask++) {
    const U = core.filter((_, i) => mask & (1 << i));
    const V = [...consts, ...core.filter((_, i) => !(mask & (1 << i)))];
    if (!V.some((f) => [...symbolsOf(f)].includes(x))) continue;
    const u = U.length === 1 ? U[0] : mul2(...U);
    const v = V.length === 1 ? V[0] : mul2(...V);
    const dv2 = safeDerive(v, x);
    if (!dv2) continue;
    if (sameFn(mul2(u, dv2), target, x, pts)) return { u, v };
  }
  return null;
}
function trigDeg(t) {
  switch (t.k) {
    case 'fn':
      return t.f === 'cos' || t.f === 'sin' ? 1 : 0;
    case 'add':
      return Math.max(0, ...t.c.map(trigDeg));
    case 'mul':
      return t.c.reduce((s, c) => s + trigDeg(c), 0);
    case 'div':
      return trigDeg(t.a);
    case 'pow': {
      const n = t.b.k === 'num' && t.b.v.d === 1n ? Number(t.b.v.n) : 0;
      return n > 0 ? n * trigDeg(t.a) : 0;
    }
    default:
      return 0;
  }
}
function fracCount(t, x) {
  switch (t.k) {
    case 'div':
      return (symbolsOf(t.b).has(x) ? 1 : 0) + fracCount(t.a, x) + fracCount(t.b, x);
    case 'add':
    case 'mul':
      return t.c.reduce((s, c) => s + fracCount(c, x), 0);
    case 'pow':
      return fracCount(t.a, x);
    case 'fn':
      return fracCount(t.a, x);
    default:
      return 0;
  }
}
function rewriteKind(old, nw, x) {
  const d0 = trigDeg(old);
  if (d0 >= 2 && trigDeg(nw) < d0) return 'linearize';
  let f0 = 0;
  let f1 = 0;
  try {
    f0 = fracCount(old, x);
    f1 = fracCount(nw, x);
  } catch {}
  if (f0 === 1 && f1 >= 2) return 'decompose';
  return 'rewrite';
}
var sumFn = (items) =>
  items.length === 1
    ? isOne(items[0].coef)
      ? items[0].atom.body
      : mul2(items[0].coef, items[0].atom.body)
    : add2(...items.map((it) => (isOne(it.coef) ? it.atom.body : mul2(it.coef, it.atom.body))));
function gesture(ks, S, T) {
  const x = ks.x;
  const d2 = diffForms(S, T);
  const constSame = near(S.cv, T.cv);
  const constWritten = shape(S.c) === shape(T.c);
  if (!d2.gone.length && !d2.came.length) {
    if (S.wkey === T.wkey) return { k: 'same' };
    const o0 = formOps(S);
    const o1 = formOps(T);
    if (o1 < o0) {
      if (formOps(S, true) - o1 > 4) return { k: 'jump' };
      return { k: 'step', steps: ['compute'], labels: [''] };
    }
    return { k: 'same' };
  }
  const goneI = d2.gone.filter((it) => !it.atom);
  const cameI = d2.came.filter((it) => !it.atom);
  const goneInt = d2.gone.filter((it) => it.atom?.k === 'int');
  const goneBrk = d2.gone.filter((it) => it.atom?.k === 'brk');
  const cameInt = d2.came.filter((it) => it.atom?.k === 'int');
  const cameBrk = d2.came.filter((it) => it.atom?.k === 'brk');
  if (d2.gone.length === 1 && d2.gone[0].atom && !goneI.length) {
    const it = d2.gone[0];
    for (const L of ks.side.get(it.atom.key) ?? []) {
      const want = [...L.items.map((l) => ({ ...l, cv: l.cv * it.cv }))];
      const ok =
        want.length === d2.came.length &&
        want.every((w) => d2.came.some((c) => itemKey(c) === itemKey(w) && near(c.cv, w.cv))) &&
        near(T.cv, S.cv + it.cv * L.cv);
      if (ok) return { k: 'step', steps: ['replace'], labels: [''] };
    }
  }
  if (
    goneInt.length === 1 &&
    cameI.length === 1 &&
    d2.gone.length === 1 &&
    d2.came.length === 1 &&
    goneInt[0].atom.key === ks.startAtom.key &&
    near(goneInt[0].cv, cameI[0].cv) &&
    constSame
  )
    return { k: 'step', steps: ['recognizeI'], labels: [''] };
  if (goneI.length || cameI.length) return { k: 'jump' };
  if (goneBrk.length && !goneInt.length && !d2.came.length) {
    let sub4 = S.c;
    const pieces = isZeroT(S.c) ? [] : [S.c];
    for (const it of goneBrk) {
      const at = it.atom;
      const F = at.body;
      const diffT = add2(
        substitute(F, { [x]: at.hi }),
        mul2(num2(-1), substitute(F, { [x]: at.lo })),
      );
      pieces.push(isOne(it.coef) ? diffT : mul2(it.coef, diffT));
    }
    sub4 = pieces.length === 1 ? pieces[0] : add2(...pieces);
    const o0 = opsOf2(trivial(sub4));
    const o1 = opsOf2(T.c);
    if ((o1 === 0 && o0 >= 4) || o0 - o1 > 7) return { k: 'jump' };
    return {
      k: 'step',
      steps: ['bracket'],
      labels: [goneBrk.length > 1 ? 'Remplacer x par les bornes (les crochets)' : ''],
    };
  }
  if (goneBrk.length && cameBrk.length && !goneInt.length && !cameInt.length) {
    const ref2 = goneBrk[0].atom;
    if (![...goneBrk, ...cameBrk].every((it) => sameBounds(it.atom, ref2))) return { k: 'jump' };
    if (!constSame || !constWritten) return { k: 'jump' };
    const pts2 = pointsOf(ref2.a, ref2.b);
    const fOld = add2(...goneBrk.map((it) => mul2(it.coef, it.atom.body)));
    const fNew = add2(...cameBrk.map((it) => mul2(it.coef, it.atom.body)));
    if (!offsetFn(fOld, fNew, x, pts2)) return { k: 'jump' };
    return {
      k: 'step',
      steps: ['bracketMerge'],
      labels: [cameBrk.length !== goneBrk.length ? '' : 'Transformer le crochet'],
    };
  }
  if (!goneInt.length || goneBrk.length) return { k: 'jump' };
  if (!constSame || !constWritten) {
    if (!d2.came.length && goneInt.every((it) => !symbolsOf(it.atom.body).has(x)))
      return { k: 'step', steps: ['constant'], labels: [''] };
    return { k: 'jump' };
  }
  const ref = goneInt[0].atom;
  const target = sumFn(goneInt);
  const pts = pointsOf(ref.a, ref.b);
  const allSame = (its) => its.every((it) => sameBounds(it.atom, ref));
  if (goneInt.length === 1 && cameInt.length >= 2 && !cameBrk.length) {
    const pieces = [...cameInt].sort(
      (p, q) => Math.min(p.atom.a, p.atom.b) - Math.min(q.atom.a, q.atom.b),
    );
    const lo = Math.min(ref.a, ref.b);
    const hi = Math.max(ref.a, ref.b);
    let cur = lo;
    let chain = true;
    for (const p of pieces) {
      const a = Math.min(p.atom.a, p.atom.b);
      const b = Math.max(p.atom.a, p.atom.b);
      if (!near(a, cur)) chain = false;
      cur = b;
    }
    if (chain && near(cur, hi) && !allSame(cameInt)) {
      const okPieces = pieces.every((p) => {
        const ppts = pointsOf(p.atom.a, p.atom.b);
        return sameFn(mul2(p.coef, p.atom.body), mul2(goneInt[0].coef, ref.body), x, ppts);
      });
      if (okPieces) return { k: 'step', steps: ['chasles'], labels: [''] };
      return { k: 'jump' };
    }
  }
  if (goneInt.length >= 2 && cameBrk.length === goneInt.length && !cameInt.length) {
    const left = [...cameBrk];
    const kinds = [];
    const lbls = [];
    for (const it of goneInt) {
      const j = left.findIndex((B2) => {
        if (!sameBounds(B2.atom, it.atom)) return false;
        const dF = safeDerive(B2.atom.body, x);
        const ppts = pointsOf(it.atom.a, it.atom.b);
        return !!dF && sameFn(mul2(B2.coef, dF), mul2(it.coef, it.atom.body), x, ppts);
      });
      if (j < 0) return { k: 'jump' };
      const B = left.splice(j, 1)[0];
      if (!symbolsOf(it.atom.body).has(x)) {
        kinds.push('constant');
        lbls.push('');
        continue;
      }
      const pk = primitiveKind(B.atom.body, x);
      if (!pk)
        return {
          k: 'jump',
          message:
            'C\u2019est bien une primitive, mais elle ne se lit pas directement : passe par une int\xE9gration par parties pour la trouver. Tu peux garder cette ligne sans HORA.',
        };
      kinds.push(pk.kind);
      lbls.push(pk.label);
    }
    return { k: 'step', steps: kinds, labels: lbls };
  }
  if (!allSame(goneInt) || !allSame(cameInt) || !allSame(cameBrk)) return { k: 'jump' };
  if (!cameInt.length && cameBrk.length === 1) {
    const B = cameBrk[0];
    const dF = safeDerive(B.atom.body, x);
    if (!dF || !sameFn(mul2(B.coef, dF), target, x, pts))
      return {
        k: 'jump',
        luck: true,
        message:
          'Ce crochet a la m\xEAme valeur, mais ce n\u2019est pas une primitive de la fonction : c\u2019est un hasard. D\xE9rive ce qui est dans le crochet pour v\xE9rifier.',
      };
    if (!symbolsOf(target).has(x)) return { k: 'step', steps: ['constant'], labels: [''] };
    const pk = primitiveKind(B.atom.body, x);
    if (!pk)
      return {
        k: 'jump',
        message:
          'C\u2019est bien une primitive, mais elle ne se lit pas directement : passe par une int\xE9gration par parties pour la trouver. Tu peux garder cette ligne sans HORA.',
      };
    return { k: 'step', steps: [pk.kind], labels: [pk.label] };
  }
  if (cameInt.length === 1 && cameBrk.length === 1) {
    const B = cameBrk[0];
    const C = cameInt[0];
    const dP = safeDerive(B.atom.body, x);
    if (!dP) return { k: 'jump' };
    const lhs = add2(mul2(B.coef, dP), mul2(C.coef, C.atom.body));
    if (!sameFn(lhs, target, x, pts))
      return {
        k: 'jump',
        luck: true,
        message:
          'Ta ligne a la m\xEAme valeur, mais ce n\u2019est pas une int\xE9gration par parties juste : c\u2019est un hasard. V\xE9rifie u, v\u2032, u\u2032 et v.',
      };
    const perUnit = div2(target, B.coef);
    if (goneInt.length === 1 && partsSplit(B.atom.body, perUnit, x, pts))
      return { k: 'step', steps: ['parts'], labels: [''] };
    return {
      k: 'jump',
      message:
        'Ta ligne est juste, mais ce n\u2019est pas une int\xE9gration par parties : choisis u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer. Tu peux la garder sans HORA.',
    };
  }
  if (!cameBrk.length && cameInt.length) {
    const newFn = sumFn(cameInt);
    if (!sameFn(newFn, target, x, pts))
      return {
        k: 'jump',
        luck: true,
        message:
          'Les deux int\xE9grales ont la m\xEAme valeur, mais pas la m\xEAme fonction : c\u2019est un hasard. V\xE9rifie ta transformation (lin\xE9arisation, d\xE9veloppement, signe\u2026).',
      };
    if (goneInt.length === 1 && cameInt.length === 1) {
      const g = goneInt[0];
      const c = cameInt[0];
      if (keyOf(g.atom.body) === keyOf(c.atom.body)) return { k: 'same' };
      const ratio = (() => {
        const u = vec(g.atom.body, x, pts);
        const v = vec(c.atom.body, x, pts);
        let k = null;
        for (let i = 0; i < u.length; i++) {
          if (!Number.isFinite(u[i]) || !Number.isFinite(v[i]) || Math.abs(v[i]) < 1e-12) continue;
          const r = u[i] / v[i];
          if (k === null) k = r;
          else if (!closeTo(r, k)) return null;
        }
        return k;
      })();
      if (ratio !== null && !near(ratio, 1))
        return { k: 'step', steps: ['linearity'], labels: ['Sortir la constante'] };
      const kind = rewriteKind(g.atom.body, c.atom.body, x);
      return { k: 'step', steps: [kind], labels: [''] };
    }
    if (goneInt.length === 1 && cameInt.length >= 2) {
      const oldTerms = termsOf(target).map((t) => vec(t, x, pts));
      const newTerms = cameInt.map((it) => vec(mul2(it.coef, it.atom.body), x, pts));
      if (oldTerms.length >= cameInt.length && groupsByValues(oldTerms, newTerms))
        return { k: 'step', steps: ['linearity'], labels: [''] };
      const kind = rewriteKind(target, newFn, x);
      return {
        k: 'step',
        steps: [kind],
        labels: [kind === 'rewrite' ? 'Transformer et s\xE9parer' : ''],
      };
    }
    if (goneInt.length >= 2 && cameInt.length === 1)
      return { k: 'step', steps: ['linearity'], labels: ['R\xE9unir les int\xE9grales'] };
  }
  return { k: 'jump' };
}
function groupsByValues(got, want) {
  const n = got.length;
  const k = want.length;
  if (n > 10 || k > 5) return false;
  const width = got[0]?.length ?? 0;
  const sums = want.map(() => new Array(width).fill(0));
  const assign = (i) => {
    if (i === n) return sums.every((s, j) => sameVec(s, want[j]));
    for (let j = 0; j < k; j++) {
      for (let p = 0; p < width; p++) sums[j][p] += got[i][p];
      if (assign(i + 1)) return true;
      for (let p = 0; p < width; p++) sums[j][p] -= got[i][p];
    }
    return false;
  };
  return assign(0);
}
function diagnose(ks, S, T) {
  const x = ks.x;
  const d2 = diffForms(S, T);
  const goneInt = d2.gone.filter((it) => it.atom?.k === 'int');
  const goneBrk = d2.gone.filter((it) => it.atom?.k === 'brk');
  const cameInt = d2.came.filter((it) => it.atom?.k === 'int');
  const cameBrk = d2.came.filter((it) => it.atom?.k === 'brk');
  if (goneInt.length === 1 && cameBrk.length === 1 && cameInt.length === 1) {
    const ref = goneInt[0].atom;
    const pts = pointsOf(ref.a, ref.b);
    const target = sumFn(goneInt);
    const B = cameBrk[0];
    const C = cameInt[0];
    const dP = safeDerive(B.atom.body, x);
    if (dP && sameFn(add2(mul2(B.coef, dP), mul2(num2(-1), C.coef, C.atom.body)), target, x, pts))
      return {
        title: 'Le signe',
        message:
          'Int\xE9gration par parties : \u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v. Devant l\u2019int\xE9grale qui reste, c\u2019est \xAB \u2212 \xBB.',
      };
    if (partsSplit(B.atom.body, div2(target, B.coef), x, pts))
      return {
        title: 'V\xE9rifie u\u2032 \xD7 v',
        message:
          'Le crochet [u v] est bon ; l\u2019int\xE9grale qui reste est celle de u\u2032 \xD7 v : v\xE9rifie u\u2032 et v.',
      };
    return {
      title: 'Ce n\u2019est pas une int\xE9gration par parties',
      message:
        'Choisis u et v\u2032 avec u \xD7 v\u2032 = la fonction \xE0 int\xE9grer ; puis \u222Bu v\u2032 = [u v] \u2212 \u222Bu\u2032 v.',
    };
  }
  if (goneInt.length && cameBrk.length === 1 && !cameInt.length)
    return {
      title: 'Pas une primitive',
      message:
        'D\xE9rive ce qui est dans le crochet : tu dois retrouver la fonction \xE0 int\xE9grer.',
    };
  if (goneBrk.length && !d2.came.length) {
    let swapped = S.cv;
    for (const it of goneBrk) swapped += -it.cv * atomValue(ks, it.atom);
    if (near(swapped, T.cv))
      return {
        title: 'Dans le bon ordre',
        message:
          '[F(x)](a ; b) vaut F(b) \u2212 F(a) : la borne du haut d\u2019abord, puis on retranche celle du bas.',
      };
    return {
      title: 'Calcul faux',
      message: 'Remplace x par la borne du haut, puis par celle du bas, et retranche.',
    };
  }
  if (goneInt.length && cameInt.length && !cameBrk.length)
    return {
      title: 'Ce n\u2019est pas la m\xEAme int\xE9grale',
      message:
        'La nouvelle \xE9criture ne vaut pas la m\xEAme chose : v\xE9rifie ta transformation (lin\xE9arisation, d\xE9veloppement, signe\u2026).',
    };
  if (!d2.gone.length && !d2.came.length)
    return {
      title: 'Calcul faux',
      message: 'Ce n\u2019est pas la m\xEAme valeur : reprends ton calcul.',
    };
  return {
    title: 'Ce n\u2019est pas \xE9gal',
    message: 'Les deux membres n\u2019ont pas la m\xEAme valeur.',
  };
}
function knownPrefix(ks, A) {
  return ks.path.some((t) => {
    let atoms;
    try {
      atoms = kintLineAtoms(t);
    } catch {
      return false;
    }
    return atoms.length > A.length && A.every((a, i) => atoms[i] === a);
  });
}
function kintJudge(ks, chips, opts) {
  const raw = chips.flatMap((c) => c.atoms);
  const chipOf = [];
  chips.forEach((c, ci) => c.atoms.forEach(() => chipOf.push(ci)));
  const norm = kintNormalize(raw);
  const A = norm.atoms;
  if (!A.length) return { kind: 'empty', atoms: A, badChip: -1 };
  const prefix = knownPrefix(ks, A);
  const incomplete = () =>
    opts?.verify
      ? { kind: 'syntax', atoms: A, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
      : { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  const r = readLine(ks, A);
  if (r.k === 'empty') return { kind: 'empty', atoms: A, badChip: -1 };
  if (r.k === 'incomplete') return incomplete();
  if (r.k === 'syntax') {
    if (prefix && !opts?.verify) return { kind: 'building', atoms: A, complete: false };
    return {
      kind: 'syntax',
      atoms: A,
      title: r.title,
      message: r.message,
      badChip: chipOf[norm.src[r.index] ?? raw.length - 1] ?? chips.length - 1,
    };
  }
  if (r.k === 'noeq') {
    if (opts?.verify)
      return {
        kind: 'syntax',
        atoms: A,
        line: lineOf(A),
        title: 'Une \xE9galit\xE9',
        message: `\xC9cris une \xE9galit\xE9 : \xAB ${ks.name} = \u2026 \xBB.`,
      };
    return { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  }
  const base = { atoms: A, line: lineOf(A) };
  const v = r.k === 'name' ? judgeName(ks, base, r.head, r.expr) : judgeChain(ks, base, r.members);
  if (prefix && !opts?.verify) {
    if (v.kind === 'step') return { ...v, kind: 'ready', complete: true };
    return { kind: 'building', atoms: A, complete: true };
  }
  if (!opts?.verify && (v.kind === 'unjustified' || v.kind === 'false'))
    return { kind: 'pending', atoms: A, complete: true };
  return { ...v, complete: true };
}
function currentIntegrals(ks) {
  const out = [];
  const seen = /* @__PURE__ */ new Set();
  const forms = [...ks.classes.values()].flat().reverse();
  for (const f of [...forms, ...[...ks.side.values()].flat().reverse()])
    for (const it of f.items)
      if (it.atom?.k === 'int' && !seen.has(it.atom.key)) {
        seen.add(it.atom.key);
        out.push(it.atom);
      }
  return out;
}
function factorKeys(t) {
  const c = (() => {
    try {
      return canon(t);
    } catch {
      return t;
    }
  })();
  const fs = c.k === 'mul' ? c.c : [c];
  const out = [];
  for (const f of fs) {
    if (f.k === 'num') continue;
    if (f.k === 'pow' && f.b.k === 'num' && f.b.v.d === 1n && f.b.v.n > 0n && f.b.v.n < 6n)
      for (let i = 0; i < Number(f.b.v.n); i++) out.push(keyOf(f.a));
    else out.push(keyOf(f));
  }
  return out;
}
function isFactorOf(u, g) {
  const fu = factorKeys(u);
  const fg = factorKeys(g);
  if (!fu.length) return false;
  const left = [...fg];
  for (const k of fu) {
    const i = left.indexOf(k);
    if (i < 0) return false;
    left.splice(i, 1);
  }
  return true;
}
function judgeName(ks, base, head, e) {
  const x = ks.x;
  const text = kintText(base.atoms);
  const label = {
    u: 'Nommer u',
    dv: 'Nommer v\u2032',
    du: 'D\xE9river u',
    v: 'Une primitive de v\u2032',
  }[head];
  const move = { text, to: null, name: { head, expr: e } };
  const step = () => stepVerdict(base, ['name'], [label], move, false);
  const prev = ks.names[head];
  if (prev && keyOf(prev) === keyOf(e))
    return {
      kind: 'useless',
      ...base,
      title: 'D\xE9j\xE0 \xE9crit',
      message: 'Cette ligne est d\xE9j\xE0 sur ta feuille.',
    };
  if ([...symbolsOf(e)].some((s) => s !== x && s !== '\u03C0'))
    return {
      kind: 'syntax',
      ...base,
      title: 'Une fonction de ' + x,
      message: `\xC9cris une fonction de ${x} seulement.`,
    };
  const ints = currentIntegrals(ks);
  const iv = ints[0] ?? ks.startAtom;
  const pts = pointsOf(iv.a, iv.b);
  if (head === 'u' || head === 'dv') {
    if (head === 'u' && !symbolsOf(e).has(x))
      return {
        kind: 'unjustified',
        ...base,
        title: 'u d\xE9pend de ' + x,
        message:
          'u est la partie qu\u2019on d\xE9rive : choisis un facteur qui d\xE9pend de ' + x + '.',
      };
    const u = head === 'u' ? e : ks.names.u;
    if (head === 'dv' && u) {
      const ok2 = ints.some((g) => sameFn(mul2(u, e), g.body, x, pointsOf(g.a, g.b)));
      if (ok2) return step();
      return {
        kind: 'false',
        ...base,
        title: 'u \xD7 v\u2032',
        message: 'u \xD7 v\u2032 doit redonner la fonction \xE0 int\xE9grer.',
      };
    }
    const ok = ints.some((g) => isFactorOf(e, g.body) || (head === 'dv' && keyOf(e) === '1'));
    if (ok) return step();
    return {
      kind: 'unjustified',
      ...base,
      title: 'Un facteur de la fonction',
      message: `${head === 'u' ? 'u' : 'v\u2032'} est un des facteurs de la fonction \xE0 int\xE9grer.`,
    };
  }
  if (head === 'du') {
    const u = ks.names.u;
    if (!u)
      return {
        kind: 'unjustified',
        ...base,
        title: 'Nomme d\u2019abord u',
        message: '\xC9cris d\u2019abord \xAB u(x) = \u2026 \xBB.',
      };
    const du = safeDerive(u, x);
    if (du && sameFn(du, e, x, pts)) return step();
    return {
      kind: 'false',
      ...base,
      title: 'Pas la d\xE9riv\xE9e de u',
      message: 'D\xE9rive u : ce n\u2019est pas sa d\xE9riv\xE9e.',
    };
  }
  const dv2 = ks.names.dv;
  if (!dv2)
    return {
      kind: 'unjustified',
      ...base,
      title: 'Nomme d\u2019abord v\u2032',
      message: '\xC9cris d\u2019abord \xAB v\u2032(x) = \u2026 \xBB.',
    };
  const de = safeDerive(e, x);
  if (de && sameFn(de, dv2, x, pts)) return step();
  return {
    kind: 'false',
    ...base,
    title: 'Pas une primitive de v\u2032',
    message: 'D\xE9rive v : tu dois retrouver v\u2032.',
  };
}
function pureI(f) {
  if (f.items.length !== 1 || f.items[0].atom || !near(f.cv, 0) || !isZeroT(f.c)) return null;
  return f.items[0].cv;
}
function pureAtom(f) {
  if (f.items.length !== 1 || !f.items[0].atom || !isZeroT(f.c) || !isOne(f.items[0].coef))
    return null;
  return f.items[0].atom;
}
var allForms = (ks) => [...[...ks.classes.values()].flat(), ...[...ks.side.values()].flat()];
function judgeChain(ks, base, members) {
  const text = kintText(base.atoms);
  if (ks.givenTexts.has(text))
    return {
      kind: 'useless',
      ...base,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  const vals = members.map((m) => formValue(ks, m));
  if (vals.some((v) => !Number.isFinite(v)))
    return {
      kind: 'false',
      ...base,
      title: 'Pas de valeur',
      message:
        'Une int\xE9grale ou un crochet n\u2019a pas de valeur ici : la fonction n\u2019est pas d\xE9finie sur tout l\u2019intervalle.',
    };
  const k0 = pureI(members[0]);
  const a0 = k0 === null ? pureAtom(members[0]) : null;
  if (k0 === null && !a0)
    return {
      kind: 'unjustified',
      ...base,
      title: `Pars de ${ks.name}`,
      message: `\xC9cris \xAB ${ks.name} = \u2026 \xBB (ou une int\xE9grale de ta feuille, \xAB \u222B(a ; b) \u2026 dx = \u2026 \xBB).`,
    };
  if (a0 && !allForms(ks).some((f) => f.items.some((it) => it.atom?.key === a0.key)))
    return {
      kind: 'unjustified',
      ...base,
      title: 'Pas dans ton calcul',
      message: `Cette int\xE9grale n\u2019appara\xEEt pas encore dans le calcul de ${ks.name}.`,
    };
  const iVal = ks.value;
  const want = k0 !== null ? k0 * iVal : atomValue(ks, a0);
  for (let i = 1; i < members.length; i++) {
    if (!near(vals[i], want)) {
      const S = i === 1 ? bestSource(ks, members[0], k0, a0, members[1]) : members[i - 1];
      return trapOr(ks, base, diagnose(ks, S, members[i]));
    }
  }
  const to =
    k0 !== null
      ? { k: 'class', key: classKey(k0), forms: members.slice(1) }
      : { k: 'side', key: a0.key, forms: members.slice(1) };
  const move = { text, to };
  const steps = [];
  const labels = [];
  let jump = null;
  let luck = false;
  let same = 0;
  for (let i = 1; i < members.length; i++) {
    const T = members[i];
    const g = i === 1 ? firstGesture(ks, members[0], k0, a0, T) : gesture(ks, members[i - 1], T);
    if (g.k === 'step') {
      steps.push(...g.steps);
      labels.push(...g.labels);
    } else if (g.k === 'same') same++;
    else {
      jump = g.message ?? jump ?? void 0;
      if (g.luck) luck = true;
    }
  }
  const last = members[members.length - 1];
  const final =
    !ks.concluded &&
    k0 !== null &&
    near(k0, 1) &&
    !last.items.length &&
    near(last.cv, ks.answerValue) &&
    opsOf2(last.c) <= ks.answerOps;
  if (luck)
    return {
      ...jumpVerdict(base, { text, to: null }, false, jump ?? void 0),
      title: 'M\xEAme valeur par hasard',
    };
  if (jump !== null) return jumpVerdict(base, move, final, jump);
  if (!steps.length)
    return {
      kind: 'useless',
      ...base,
      title: same ? 'Rien de nouveau' : 'Juste, mais \xE7a ne t\u2019avance pas',
      message: same
        ? 'Cette \xE9criture est d\xE9j\xE0 sur ta feuille.'
        : 'Les deux \xE9critures sont \xE9gales, mais le calcul n\u2019avance pas.',
      imove: move,
      final,
    };
  return stepVerdict(base, steps, labels, move, final);
}
function sourcesOf(ks, k0, a0) {
  if (k0 !== null) return [...(ks.classes.get(classKey(k0)) ?? [])].reverse();
  const own = {
    items: [{ atom: a0, coef: num2(1), cv: 1 }],
    c: num2(0),
    cv: 0,
    iCoef: 0,
    wkey: `${a0.key}:1#`,
  };
  return [own, ...[...(ks.side.get(a0.key) ?? [])].reverse()];
}
function bestSource(ks, m0, k0, a0, T) {
  const src = sourcesOf(ks, k0, a0);
  let best = src[0] ?? m0;
  let score = -1;
  for (const S of src) {
    const d2 = diffForms(S, T);
    const s = S.items.length - d2.gone.length;
    if (s > score) {
      score = s;
      best = S;
    }
  }
  return best;
}
function firstGesture(ks, m0, k0, a0, T) {
  const src = sourcesOf(ks, k0, a0);
  let fallback = null;
  for (const S of src) {
    const g = gesture(ks, S, T);
    if (g.k === 'step') return g;
    if (g.k === 'same') fallback = g;
    else if (!fallback) fallback = g;
  }
  if (k0 !== null && !near(k0, 1) && !ks.classes.has(classKey(k0))) {
    for (const F of [...(ks.classes.get(classKey(1)) ?? [])].reverse()) {
      if (near(F.iCoef, 0) || !near(1 - F.iCoef, k0)) continue;
      const X = { ...F, items: F.items.filter((it) => it.atom) };
      X.wkey =
        X.items
          .map((it) => `${itemKey(it)}:${shape(it.coef)}`)
          .sort()
          .join(',') +
        '#' +
        (isZeroT(X.c) ? '' : shape(X.c));
      const g = gesture(ks, X, T);
      if (g.k === 'same') return { k: 'step', steps: ['collect'], labels: [''] };
      if (g.k === 'step')
        return { k: 'step', steps: ['collect', ...g.steps], labels: ['', ...g.labels] };
    }
  }
  if (k0 !== null && near(k0, 1)) {
    for (const [key, forms] of ks.classes) {
      if (key === classKey(1)) continue;
      const k = Number(key.slice(2)) / 1e9;
      for (const G of [...forms].reverse()) {
        if (G.items.length !== T.items.length) continue;
        const ok = G.items.every((gi) =>
          T.items.some((ti) => itemKey(ti) === itemKey(gi) && near(ti.cv, gi.cv / k)),
        );
        if (!ok || !near(T.cv, G.cv / k)) continue;
        if (formOps(T) > formOps(G) + 2) continue;
        return { k: 'step', steps: ['divide'], labels: [`Diviser par ${formatK(k)}`] };
      }
    }
  }
  return fallback ?? { k: 'jump' };
}
function formatK(k) {
  if (Number.isInteger(k)) return String(k).replace('-', '\u2212');
  return String(Math.round(k * 1e3) / 1e3)
    .replace('.', ',')
    .replace('-', '\u2212');
}
function kintCommit(ks, v) {
  const m = v.imove;
  if (!m) return;
  ks.written.add(m.text);
  ks.lines++;
  if (m.name) {
    const { head, expr } = m.name;
    if (head === 'u' && ks.names.u && keyOf(ks.names.u) !== keyOf(expr)) delete ks.names.du;
    if (head === 'dv' && ks.names.dv && keyOf(ks.names.dv) !== keyOf(expr)) delete ks.names.v;
    ks.names[head] = expr;
    return;
  }
  if (m.to) {
    const map = m.to.k === 'class' ? ks.classes : ks.side;
    map.set(m.to.key, [...(map.get(m.to.key) ?? []), ...m.to.forms]);
  }
  if (m.final) ks.concluded = true;
  else if (m.to?.k === 'class' && m.to.key === classKey(1)) {
    const last = m.to.forms[m.to.forms.length - 1];
    if (
      last &&
      !last.items.length &&
      near(last.cv, ks.answerValue) &&
      opsOf2(last.c) <= ks.answerOps
    )
      ks.concluded = true;
  }
}
function kintGoalReached(ks) {
  return ks.concluded;
}
function kintStartComputed(ks) {
  const forms = [...(ks.classes.get(classKey(1)) ?? []), ...(ks.side.get(ks.startAtom.key) ?? [])];
  return forms.some((f) => !f.items.length);
}
function membersOf(ks, text) {
  let A;
  try {
    A = kintLineAtoms(text);
  } catch {
    return null;
  }
  const r = readLine(ks, A);
  return r.k === 'chain' ? r.members : null;
}
function kintIsAnswer(ks, text) {
  const ms = membersOf(ks, text);
  if (!ms || ms.length < 2 || pureI(ms[0]) === null || !near(pureI(ms[0]), 1)) return false;
  const last = ms[ms.length - 1];
  return !last.items.length && near(last.cv, ks.answerValue);
}

// packages/reasoner/src/kernel-ode.ts
var ODE_STEP_IDS = {
  rewrite: 'ode.rewrite@1',
  homogeneous: 'ode.homogeneous@1',
  characteristic: 'ode.characteristic@1',
  discriminant: 'ode.discriminant@1',
  roots: 'ode.roots@1',
  general: 'ode.general@1',
  homogSolutions: 'ode.homogeneous_solutions@1',
  constant: 'ode.constant@1',
  particular: 'ode.particular@1',
  superpose: 'ode.superpose@1',
  derive: 'ode.derive@1',
  evaluate: 'ode.evaluate@1',
  condition: 'ode.condition@1',
  solveC: 'ode.solve_constant@1',
  member: 'ode.member@1',
  /** moteur v63 : la valeur de la solution en un point */
  value: 'ode.value@1',
  compute: 'kernel.compute@1',
};
var STEP3 = {
  rewrite: {
    label: 'Transformer l\u2019\xE9quation',
    hora: 1,
    why: 'Une \xE9quation \xE9quivalente : on passe un terme de l\u2019autre c\xF4t\xE9, on divise par un nombre non nul.',
  },
  homogeneous: {
    label: '\xC9quation homog\xE8ne',
    hora: 1,
    why: 'L\u2019\xE9quation homog\xE8ne (sans second membre) : on remplace le second membre par 0.',
  },
  characteristic: {
    label: '\xC9quation caract\xE9ristique',
    hora: 1,
    why: '\xC0 ay\u2033 + by\u2032 + cy = 0 correspond l\u2019\xE9quation caract\xE9ristique ar\xB2 + br + c = 0.',
  },
  discriminant: {
    label: 'Discriminant',
    hora: 1,
    why: 'Le discriminant de ar\xB2 + br + c : \u0394 = b\xB2 \u2212 4ac.',
  },
  roots: {
    label: 'Racines',
    hora: 1,
    why: 'Les racines de l\u2019\xE9quation caract\xE9ristique donnent les solutions.',
  },
  general: {
    label: 'Toutes les solutions',
    hora: 2,
    why: 'Toutes les solutions de l\u2019\xE9quation.',
  },
  homogSolutions: {
    label: 'Solutions de l\u2019\xE9quation homog\xE8ne',
    hora: 2,
    why: 'Les solutions de l\u2019\xE9quation homog\xE8ne.',
  },
  constant: {
    label: 'Solution constante',
    hora: 1,
    why: 'Une fonction constante y = k : sa d\xE9riv\xE9e est nulle, il reste une \xE9quation en k.',
  },
  particular: {
    label: 'Solution particuli\xE8re',
    hora: 1,
    why: 'Une solution de l\u2019\xE9quation compl\xE8te : en la rempla\xE7ant dans l\u2019\xE9quation, on retrouve l\u2019\xE9galit\xE9.',
  },
  superpose: {
    label: 'Toutes les solutions',
    hora: 1,
    why: 'Toutes les solutions = les solutions de l\u2019\xE9quation homog\xE8ne + une solution particuli\xE8re.',
  },
  derive: {
    label: 'D\xE9river',
    hora: 1,
    why: 'On d\xE9rive les solutions : les constantes restent des constantes.',
  },
  evaluate: {
    label: 'Calculer',
    hora: 1,
    why: 'On remplace x par sa valeur dans les solutions.',
  },
  condition: {
    label: 'Utiliser la condition',
    hora: 1,
    why: 'La condition donne une \xE9quation en la constante.',
  },
  solveC: {
    label: 'Trouver la constante',
    hora: 1,
    why: 'On r\xE9sout l\u2019\xE9quation en la constante.',
  },
  member: {
    label: 'Remplacer la constante',
    hora: 1,
    why: 'On remplace la constante par sa valeur dans les solutions.',
  },
  value: {
    label: 'Calculer la valeur',
    hora: 1,
    why: 'On remplace la variable par sa valeur dans la solution trouv\xE9e.',
  },
  compute: { label: 'Calculer', hora: 1, why: 'Un calcul.' },
};
var CARD3 = '\xC9quations diff\xE9rentielles';
var OdeModelError = class extends Error {};
var P1 = '\u039E\u039E\u039E';
var P2 = '\u039E\u039E\u039E\u039E';
var SUP_DIGITS3 = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
var isSupRun = (a) => a.length > 0 && [...a].every((c) => SUP_DIGITS3.includes(c));
function kodeLineAtoms(text, fn2 = 'y', x = 'x') {
  const f = fn2.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  let t = text
    .replace(new RegExp(`([A-Za-z])(?=${f}(?:\u2033|\u2032|'|\u2019))`, 'g'), '$1 ')
    .replace(
      new RegExp(
        `(?<![A-Za-z\xC0-\xFF])${f}(?:\u2033|\u2032\u2032|''|\u2019\u2019)(?!\\s*\\()`,
        'g',
      ),
      ` ${P2} `,
    )
    .replace(
      new RegExp(`(?<![A-Za-z\xC0-\xFF])${f}(?:\u2032|'|\u2019)(?!\\s*\\()`, 'g'),
      ` ${P1} `,
    );
  const out = [];
  for (const a of lex(t)) {
    const last = out[out.length - 1];
    if (isSupRun(a) && last !== void 0 && isSupRun(last)) {
      out[out.length - 1] = last + a;
      continue;
    }
    out.push(a);
  }
  const mapped = out.map((a) => {
    if (a === P1) return `${fn2}\u2032`;
    if (a === P2) return `${fn2}\u2033`;
    if (a === `${fn2}(${x})`) return fn2;
    if (a === `${fn2}\u2032(${x})`) return `${fn2}\u2032`;
    if (a === `${fn2}\u2032\u2032(${x})`) return `${fn2}\u2033`;
    const m = new RegExp(`^${f}\u2032\u2032\\((.+)\\)$`).exec(a);
    if (m) return `${fn2}\u2033(${m[1]})`;
    return a;
  });
  return normalize(mapped);
}
function kodeText(atoms) {
  return atomsText(atoms)
    .replace(/ ([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, '$1')
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ');
}
var lineOf2 = (atoms) => ({
  dis: [{ sides: [{ k: 's', n: kodeText(atoms) }] }],
});
function kodeLine(text, fn2 = 'y') {
  return lineOf2(kodeLineAtoms(text, fn2));
}
function caretAtoms(atoms) {
  const out = [];
  for (let i = 0; i < atoms.length; i++) {
    const a = atoms[i];
    if (isSupRun(a) && a !== '\xB2') {
      out.push('^', [...a].map((c) => String(SUP_DIGITS3.indexOf(c))).join(''));
      continue;
    }
    out.push(a);
  }
  return out;
}
var E2 = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function withE2(t) {
  switch (t.k) {
    case 'sym':
      return t.n === 'e' ? E2 : t;
    case 'add':
    case 'mul':
      return { ...t, c: t.c.map(withE2) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...t, a: withE2(t.a), b: withE2(t.b) };
    case 'fn':
      return { ...t, a: withE2(t.a) };
    default:
      return t;
  }
}
var termOf = (n) => withE2(fromNode(n));
function val2(t, env) {
  try {
    const v = evalFloat(t, env);
    return Number.isFinite(v) ? v : NaN;
  } catch {
    return NaN;
  }
}
function size(t) {
  switch (t.k) {
    case 'num':
      return t.v.d === 1n ? 1 : 2;
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + t.c.reduce((s, c) => s + size(c), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + size(t.a) + size(t.b);
    case 'fn':
      return 1 + size(t.a);
  }
}
var near2 = (a, b, scale = 1) =>
  Number.isFinite(a) &&
  Number.isFinite(b) &&
  Math.abs(a - b) <= 1e-7 * Math.max(1, scale, Math.abs(a), Math.abs(b));
function safeDerive2(t, x) {
  try {
    return derive(t, x);
  } catch {
    return null;
  }
}
var C_SAMPLES = [
  [0.7, -1.3],
  [-1.9, 0.45],
  [2.6, 1.7],
];
var Y_SAMPLES = [
  [0.37, -1.21, 0.83],
  [1.9, 0.44, -0.6],
  [-0.73, 2.1, 1.3],
];
var BASE_PTS = [-2.3, -1.7, -1.15, -0.6, -0.25, 0.2, 0.55, 0.95, 1.35, 1.8, 2.25];
var POS_PTS = [0.3, 0.7, 1.1, 1.6, 2.1, 2.7, 3.3];
function odeOf(ks, Et, pts) {
  const [y0, y1, y2] = ks.Y;
  const syms = symbolsOf(Et);
  for (const s of syms)
    if (s !== ks.x && s !== y0 && s !== y1 && s !== y2 && s !== '\u03C0') return null;
  if (!syms.has(y0) && !syms.has(y1) && !syms.has(y2)) return null;
  const a = [];
  for (const s of [y0, y1, y2]) {
    const c = safeDerive2(Et, s);
    if (!c) return null;
    const cs = symbolsOf(c);
    if (cs.has(y0) || cs.has(y1) || cs.has(y2)) return null;
    a.push(c);
  }
  let rest;
  try {
    rest = canon(substitute(Et, { [y0]: num2(0), [y1]: num2(0), [y2]: num2(0) }));
  } catch {
    return null;
  }
  for (const p of pts.slice(0, 5))
    for (const Ys of Y_SAMPLES) {
      const env = { [ks.x]: p, [y0]: Ys[0], [y1]: Ys[1], [y2]: Ys[2] };
      const lhs = val2(Et, env);
      const rhs = a.reduce((s, c, k) => s + val2(c, { [ks.x]: p }) * Ys[k], val2(rest, env));
      if (!near2(lhs, rhs)) return null;
    }
  const nz = (t) => pts.some((p) => Math.abs(val2(t, { [ks.x]: p })) > 1e-12);
  const order = nz(a[2]) ? 2 : nz(a[1]) ? 1 : 0;
  if (order === 0) return null;
  return { order, a: [a[0], a[1], a[2]], f: canon(mul2(num2(-1), rest)) };
}
function coefsAt(o, x, p) {
  return [...o.a.map((t) => val2(t, { [x]: p })), val2(o.f, { [x]: p })];
}
function sameOde(o1, o2, x, pts) {
  if (o1.order !== o2.order) return false;
  return pts.every((p) => {
    const u = coefsAt(o1, x, p);
    const v = coefsAt(o2, x, p);
    let j = 0;
    v.forEach((c, i) => {
      if (Math.abs(c) > Math.abs(v[j])) j = i;
    });
    if (!(Math.abs(v[j]) > 1e-12) || !Number.isFinite(u[j])) return false;
    const lam = u[j] / v[j];
    if (!(Math.abs(lam) > 1e-12)) return false;
    return u.every((c, i) => near2(c, lam * v[i], Math.abs(lam * v[i])));
  });
}
var homogOf = (o) => ({ ...o, f: num2(0) });
function residualOk(ks, o, F, env) {
  const d1 = safeDerive2(F, ks.x);
  const d2 = d1 ? safeDerive2(d1, ks.x) : null;
  if (!d1 || (o.order === 2 && !d2)) return false;
  const ds = [F, d1, d2 ?? num2(0)];
  return ks.pts.every((p) => {
    const e = { ...env, [ks.x]: p };
    const terms = [0, 1, 2].map((k) =>
      k > o.order ? 0 : val2(o.a[k], { [ks.x]: p }) * val2(ds[k], e),
    );
    const f = val2(o.f, { [ks.x]: p });
    const lhs = terms.reduce((s, t) => s + t, 0);
    const scale = Math.abs(f) + terms.reduce((s, t) => s + Math.abs(t), 0);
    return near2(lhs, f, scale);
  });
}
function constsIn(ks, F) {
  const s = symbolsOf(F);
  return ks.consts.filter((c) => s.has(c));
}
function strangers(ks, t) {
  return [...symbolsOf(t)].filter((s) => s !== ks.x && s !== '\u03C0' && !ks.consts.includes(s));
}
var envOf = (cs, vals) => Object.fromEntries(cs.map((c, i) => [c, vals[i] ?? 0]));
function affineIn(ks, F, cs) {
  const zero = envOf(
    cs,
    cs.map(() => 0),
  );
  return C_SAMPLES.every((cv) =>
    ks.pts.every((p) => {
      const base = val2(F, { ...zero, [ks.x]: p });
      let rhs = base;
      cs.forEach((_, i) => {
        const e = envOf(
          cs,
          cs.map((__, j) => (j === i ? 1 : 0)),
        );
        rhs += (cv[i] ?? 0) * (val2(F, { ...e, [ks.x]: p }) - base);
      });
      return near2(val2(F, { ...envOf(cs, cv), [ks.x]: p }), rhs);
    }),
  );
}
function rank(rows) {
  const m = rows.map((r) => {
    const s = Math.max(...r.map((v) => Math.abs(v)));
    return s > 0 ? r.map((v) => v / s) : r.slice();
  });
  let rk = 0;
  const cols = m[0]?.length ?? 0;
  for (let c = 0; c < cols && rk < m.length; c++) {
    let piv = rk;
    for (let i = rk + 1; i < m.length; i++) if (Math.abs(m[i][c]) > Math.abs(m[piv][c])) piv = i;
    if (Math.abs(m[piv][c]) < 1e-7) continue;
    [m[rk], m[piv]] = [m[piv], m[rk]];
    for (let i = 0; i < m.length; i++) {
      if (i === rk) continue;
      const f = m[i][c] / m[rk][c];
      for (let j = c; j < cols; j++) m[i][j] -= f * m[rk][j];
    }
    rk++;
  }
  return rk;
}
function basisRows(ks, F, cs) {
  const zero = envOf(
    cs,
    cs.map(() => 0),
  );
  return cs.map((_, i) => {
    const e = envOf(
      cs,
      cs.map((__, j) => (j === i ? 1 : 0)),
    );
    return ks.pts.map((p) => val2(F, { ...e, [ks.x]: p }) - val2(F, { ...zero, [ks.x]: p }));
  });
}
function classify(ks, F) {
  const cs = constsIn(ks, F);
  const tries = ks.homog
    ? [['full', ks.ode]]
    : [
        ['full', ks.ode],
        ['homog', homogOf(ks.ode)],
      ];
  if (!cs.length) {
    for (const [of, o] of tries) if (residualOk(ks, o, F, {})) return { k: 'one', of };
    return { k: 'none', why: 'plain' };
  }
  if (!affineIn(ks, F, cs)) return { k: 'none', why: 'notAffine' };
  const order = ks.ode.order;
  for (const [of, o] of tries) {
    if (C_SAMPLES.every((cv) => residualOk(ks, o, F, envOf(cs, cv)))) {
      const rk = rank(basisRows(ks, F, cs));
      return rk >= order ? { k: 'general', of, cs } : { k: 'partial', of, cs };
    }
  }
  const zero = envOf(
    cs,
    cs.map(() => 0),
  );
  const P3 = substitute(F, Object.fromEntries(Object.entries(zero).map(([k, v]) => [k, num2(v)])));
  const Bterm = canon(add2(F, mul2(num2(-1), P3)));
  if (!ks.homog && C_SAMPLES.every((cv) => residualOk(ks, homogOf(ks.ode), Bterm, envOf(cs, cv))))
    return { k: 'none', why: 'particular' };
  return { k: 'none', why: 'homog' };
}
function memberOf(ks, fam, G) {
  const cs = fam.cs;
  const zero = envOf(
    cs,
    cs.map(() => 0),
  );
  const P3 = ks.pts.map((p) => val2(fam.F, { ...zero, [ks.x]: p }));
  const B = basisRows(ks, fam.F, cs);
  const g = ks.pts.map((p) => val2(G, { [ks.x]: p }) - P3[ks.pts.indexOf(p)]);
  const n = cs.length;
  const M = Array.from({ length: n }, (_, i) =>
    Array.from({ length: n }, (__, j) => B[i].reduce((s, v, k) => s + v * B[j][k], 0)),
  );
  const rhs = Array.from({ length: n }, (_, i) => B[i].reduce((s, v, k) => s + v * g[k], 0));
  const c = solveSmall(M, rhs);
  if (!c) return null;
  const ok = ks.pts.every((_, k) =>
    near2(
      B.reduce((s, row, i) => s + c[i] * row[k], 0),
      g[k],
    ),
  );
  return ok ? c : null;
}
function solveSmall(M, b) {
  if (M.length === 1) {
    const a = M[0][0];
    return Math.abs(a) > 1e-12 ? [b[0] / a] : null;
  }
  if (M.length === 2) {
    const [[a, bb], [c, d2]] = M;
    const det = a * d2 - bb * c;
    if (Math.abs(det) < 1e-12 * Math.max(1, Math.abs(a * d2), Math.abs(bb * c))) return null;
    return [(b[0] * d2 - bb * b[1]) / det, (a * b[1] - c * b[0]) / det];
  }
  return null;
}
function affineVec(t, cs) {
  const r = val2(
    t,
    envOf(
      cs,
      cs.map(() => 0),
    ),
  );
  if (!Number.isFinite(r)) return null;
  const w = cs.map(
    (_, i) =>
      val2(
        t,
        envOf(
          cs,
          cs.map((__, j) => (j === i ? 1 : 0)),
        ),
      ) - r,
  );
  if (w.some((v) => !Number.isFinite(v))) return null;
  const ok = C_SAMPLES.every((cv) =>
    near2(
      val2(t, envOf(cs, cv)),
      w.reduce((s, v, i) => s + v * cv[i], r),
    ),
  );
  return ok ? { w, r } : null;
}
function refFamily(ks) {
  for (let i = ks.families.length - 1; i >= 0; i--)
    if (ks.families[i].of === 'full') return ks.families[i];
  return null;
}
function deriveK(t, x, k) {
  let u = t;
  for (let i = 0; i < k && u; i++) u = safeDerive2(u, x);
  return u;
}
function condVec(ks, fam, c) {
  const d2 = deriveK(fam.F, ks.x, c.k);
  if (!d2) return null;
  const at = substitute(d2, { [ks.x]: num2(c.x0) });
  const a = affineVec(at, fam.cs);
  return a ? { w: a.w, r: c.v - a.r } : null;
}
function cStar(ks, fam) {
  const rows = ks.conds.map((c) => condVec(ks, fam, c));
  if (rows.some((r) => !r) || rows.length < fam.cs.length) return null;
  const R = rows;
  const n = fam.cs.length;
  const M = Array.from({ length: n }, (_, i) =>
    Array.from({ length: n }, (__, j) => R.reduce((s, row) => s + row.w[i] * row.w[j], 0)),
  );
  const b = Array.from({ length: n }, (_, i) => R.reduce((s, row) => s + row.w[i] * row.r, 0));
  return solveSmall(M, b);
}
var augmented = (e) => [...e.w, e.r];
function proportional(u, v) {
  let j = 0;
  v.forEach((c, i) => {
    if (Math.abs(c) > Math.abs(v[j])) j = i;
  });
  if (!(Math.abs(v[j]) > 1e-12)) return false;
  const lam = u[j] / v[j];
  if (!(Math.abs(lam) > 1e-12)) return false;
  return u.every((c, i) => near2(c, lam * v[i], Math.abs(lam * v[i])));
}
var R_PTS = [-1.3, 0.4, 2.2, 3.1];
function quadOf(t, r) {
  const v = R_PTS.map((p) => val2(t, { [r]: p }));
  if (v.some((x) => !Number.isFinite(x))) return null;
  const [x0, x1, x2] = R_PTS;
  const [y0, y1, y2] = v;
  const d0 = (x0 - x1) * (x0 - x2);
  const d1 = (x1 - x0) * (x1 - x2);
  const d2 = (x2 - x0) * (x2 - x1);
  const q2 = y0 / d0 + y1 / d1 + y2 / d2;
  const q1 = (-y0 * (x1 + x2)) / d0 - (y1 * (x0 + x2)) / d1 - (y2 * (x0 + x1)) / d2;
  const q0 = (y0 * x1 * x2) / d0 + (y1 * x0 * x2) / d1 + (y2 * x0 * x1) / d2;
  const x3 = R_PTS[3];
  if (!near2(q2 * x3 * x3 + q1 * x3 + q0, v[3])) return null;
  const clean = (c) => (Math.abs(c) < 1e-10 ? 0 : c);
  return [clean(q2), clean(q1), clean(q0)];
}
function roots(q) {
  const [a, b, c] = q;
  const d2 = b * b - 4 * a * c;
  if (Math.abs(d2) < 1e-12 * Math.max(1, b * b)) return [{ re: -b / (2 * a), im: 0 }];
  if (d2 > 0) {
    const s2 = Math.sqrt(d2);
    return [
      { re: (-b - s2) / (2 * a), im: 0 },
      { re: (-b + s2) / (2 * a), im: 0 },
    ];
  }
  const s = Math.sqrt(-d2);
  return [
    { re: -b / (2 * a), im: -s / (2 * a) },
    { re: -b / (2 * a), im: s / (2 * a) },
  ];
}
function cxOf(t) {
  const s = symbolsOf(t);
  if ([...s].some((n) => n !== 'i' && n !== '\u03C0')) return null;
  const v0 = val2(t, { i: 0 });
  const v1 = val2(t, { i: 1 });
  const v2 = val2(t, { i: 2 });
  if (![v0, v1, v2].every(Number.isFinite)) return null;
  const im = v1 - v0;
  if (!near2(v2, v0 + 2 * im)) return null;
  return { re: v0, im };
}
var cxNear = (a, b) => near2(a.re, b.re) && near2(a.im, b.im);
function stepVerdict2(base, kind, omove, final, label, why) {
  const s = STEP3[kind];
  return {
    kind: 'step',
    ...base,
    hora: s.hora,
    final,
    rule: {
      id: ODE_STEP_IDS[kind],
      card: CARD3,
      label: label ?? s.label,
      hora: s.hora,
      why: (why ?? s.why) + (final ? ' C\u2019est la r\xE9ponse.' : ''),
    },
    omove: { ...omove, ...(final ? { final } : {}) },
  };
}
function jumpVerdict2(base, omove, final, message) {
  return {
    kind: 'useless',
    ...base,
    jump: true,
    final,
    title: final ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      message ??
      (final
        ? 'C\u2019est la r\xE9ponse. D\xE9taille ton raisonnement, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    omove: { ...omove, ...(final ? { final } : {}) },
  };
}
function useless(base, title, message, omove) {
  return { kind: 'useless', ...base, title, message, ...(omove ? { omove } : {}) };
}
function trapOr2(ks, base, why) {
  const text = kodeText(base.atoms);
  const t = ks.traps.find((t2) => t2.text === text);
  if (t)
    return {
      kind: 'trap',
      ...base,
      title: t.title,
      message: t.why,
      trap: { line: t.line, title: t.title, why: t.why },
    };
  return { kind: 'false', ...base, ...why };
}
function domainFilter(model, x) {
  const d2 = model.kernel?.domain;
  if (!d2) return () => true;
  let rels = [];
  try {
    const line = parseLine(normalize(lex(d2)), { chains: true });
    rels = line.dis.flatMap((q) => {
      const cmps = q.chain ?? (q.cmp ? [q.cmp] : []);
      return cmps.map((cmp2, i) => ({
        l: termOf(q.sides[i]),
        r: termOf(q.sides[i + 1]),
        cmp: cmp2,
      }));
    });
  } catch {
    throw new OdeModelError(`Intervalle illisible : \xAB ${d2} \xBB.`);
  }
  return (p) =>
    rels.every(({ l, r, cmp: cmp2 }) => {
      const a = val2(l, { [x]: p });
      const b = val2(r, { [x]: p });
      if (cmp2 === '>') return a > b;
      if (cmp2 === '<') return a < b;
      if (cmp2 === '\u2265') return a >= b;
      if (cmp2 === '\u2264') return a <= b;
      return true;
    });
}
function readAtoms(A) {
  let line;
  try {
    line = parseLine(normalize(caretAtoms(A)), { chains: true });
  } catch {
    return { k: 'incomplete' };
  }
  if (line.dis.length > 1) {
    if (line.dis.some((d2) => d2.cmp || d2.chain || d2.rels || d2.sides.length !== 2))
      return {
        k: 'syntax',
        title: 'Des \xE9galit\xE9s',
        message: '\xC9cris \xAB r = \u2026 ou r = \u2026 \xBB.',
      };
    return { k: 'or', clauses: line.dis.map((d2) => d2.sides) };
  }
  const eq2 = line.dis[0];
  if (eq2.cmp || eq2.chain || eq2.rels || eq2.mod !== void 0)
    return {
      k: 'syntax',
      title: 'Une \xE9galit\xE9',
      message:
        '\xC9cris une \xE9galit\xE9 : \xAB y = \u2026 \xBB, \xAB y\u2032 = \u2026 \xBB, \xAB y(0) = \u2026 \xBB.',
    };
  if (eq2.sides.length < 2) return { k: 'incomplete' };
  return { k: 'eq', sides: eq2.sides };
}
function condOf(text, fn2, x) {
  const A = kodeLineAtoms(text, fn2, x);
  const r = readAtoms(A);
  const bad = () =>
    new OdeModelError(
      `Une condition s\u2019\xE9crit \xAB ${fn2}(0) = 1 \xBB ou \xAB ${fn2}\u2032(0) = 0 \xBB : \xAB ${text} \xBB.`,
    );
  if (r.k !== 'eq' || r.sides.length !== 2) throw bad();
  const h = r.sides[0];
  const m = h.k === 's' ? headRe(fn2).exec(h.n) : null;
  if (!m) throw bad();
  const k = m[1] === '\u2033' ? 2 : m[1].length;
  const x0 = val2(exprOfText2(m[2]), {});
  const v = val2(termOf(r.sides[1]), {});
  if (!Number.isFinite(x0) || !Number.isFinite(v)) throw bad();
  return { k, x0, head: h.n, v, text: kodeText(A) };
}
var headRe = (fn2) =>
  new RegExp(`^${fn2.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(\u2032*|\u2033)\\((.+)\\)$`);
function exprOfText2(text) {
  const line = parseLine(normalize(lex(text)));
  return termOf(line.dis[0].sides[0]);
}
function odeQuestionOf(model) {
  const spec = model.kernel;
  const fn2 = spec.goal.target;
  if (!/^[a-zA-Z]$/.test(fn2))
    throw new OdeModelError('La fonction inconnue est une lettre (\xAB y \xBB).');
  const x = spec.ode?.variable ?? 'x';
  if (!/^[a-z]$/.test(x) || x === fn2 || ['e', 'i', 'r'].includes(x))
    throw new OdeModelError(
      'La variable est une lettre (\xAB x \xBB, \xAB t \xBB) autre que la fonction.',
    );
  return { fn: fn2, x, consts: spec.ode?.constants ?? ['C', 'A', 'B', 'C\u2081', 'C\u2082', 'K'] };
}
function createKOdeState(model) {
  const spec = model.kernel;
  const q = odeQuestionOf(model);
  const { fn: fn2, x } = q;
  const Y = [fn2, `${fn2}\u2032`, `${fn2}\u2033`];
  const inDomain = domainFilter(model, x);
  const ks = {
    model,
    fn: fn2,
    x,
    Y,
    consts: q.consts,
    ode: { order: 1, a: [num2(0), num2(0), num2(0)], f: num2(0) },
    homog: false,
    constCoef: false,
    pts: [],
    conds: [],
    goal: 'general',
    answerShape: null,
    answerText: '',
    target: null,
    values: /* @__PURE__ */ new Map(),
    eqs: [],
    homogWritten: false,
    families: [],
    ones: [],
    derivs: [],
    evals: /* @__PURE__ */ new Map(),
    cEqs: [],
    cFamily: null,
    cKnown: false,
    charQ: null,
    deltas: /* @__PURE__ */ new Set(),
    rootsWritten: false,
    written: /* @__PURE__ */ new Set(),
    givenTexts: /* @__PURE__ */ new Set(),
    path: spec.path ?? [],
    traps: [],
    lines: 0,
    concluded: false,
  };
  const startA = kodeLineAtoms(spec.start, fn2, x);
  const sr = readAtoms(startA);
  if (sr.k !== 'eq' || sr.sides.length !== 2)
    throw new OdeModelError(`Le d\xE9part est une \xE9quation : \xAB ${spec.start} \xBB.`);
  const Et = canon(add2(termOf(sr.sides[0]), mul2(num2(-1), termOf(sr.sides[1]))));
  const cand = [...BASE_PTS, ...POS_PTS].filter(inDomain);
  const o0 = odeOf(ks, Et, cand);
  if (!o0)
    throw new OdeModelError(
      `Le d\xE9part n\u2019est pas une \xE9quation diff\xE9rentielle lin\xE9aire en ${fn2}, ${fn2}\u2032, ${fn2}\u2033 : \xAB ${spec.start} \xBB.`,
    );
  ks.pts = [...new Set(cand)]
    .filter((p) => {
      const c = coefsAt(o0, x, p);
      return c.every(Number.isFinite) && Math.abs(c[o0.order]) > 1e-9;
    })
    .sort((a, b) => a - b)
    .slice(0, 11);
  if (ks.pts.length < 6)
    throw new OdeModelError('Pas assez de points pour v\xE9rifier l\u2019\xE9quation.');
  ks.ode = o0;
  ks.homog = ks.pts.every((p) => Math.abs(val2(o0.f, { [x]: p })) < 1e-12);
  ks.constCoef = [...o0.a, o0.f].every((t) => !symbolsOf(t).has(x));
  if (shapeOf2(sr.sides) !== 'autre') ks.eqs.push({ of: 'full', shape: shapeOf2(sr.sides) });
  ks.conds = (spec.ode?.initial ?? []).map((t) => condOf(t, fn2, x));
  if (ks.conds.some((c) => c.k >= o0.order))
    throw new OdeModelError(
      `Une condition porte sur ${fn2} ou ses d\xE9riv\xE9es d\u2019ordre < ${o0.order}.`,
    );
  const ansA = kodeLineAtoms(spec.answer, fn2, x);
  ks.answerText = kodeText(ansA);
  const ar = readAtoms(ansA);
  if (ar.k !== 'eq' || ar.sides.length !== 2)
    throw new OdeModelError(`La r\xE9ponse est une \xE9galit\xE9 : \xAB ${spec.answer} \xBB.`);
  const h = ar.sides[0];
  const rhs = termOf(ar.sides[1]);
  const hasY = [...symbolsOf(rhs)].some((s) => ks.Y.includes(s));
  const vm = h.k === 's' ? headRe(fn2).exec(h.n) : null;
  if (vm && vm[1] === '' && [...symbolsOf(rhs)].every((s) => s === '\u03C0')) {
    const x0 = val2(exprOfText2(vm[2]), {});
    const v = val2(rhs, {});
    if (!Number.isFinite(x0) || !Number.isFinite(v))
      throw new OdeModelError(`La r\xE9ponse est une valeur : \xAB ${fn2}(0) = \u2026 \xBB.`);
    if (ks.conds.length < o0.order)
      throw new OdeModelError(`Il faut ${o0.order} conditions pour trouver la valeur.`);
    if (ks.conds.some((c) => c.k === 0 && near2(c.x0, x0)))
      throw new OdeModelError(
        'La valeur cherch\xE9e est d\xE9j\xE0 une condition de l\u2019\xE9nonc\xE9.',
      );
    const ref = odeValueAt(ks, x0);
    if (ref === null)
      throw new OdeModelError(
        'Les conditions ne fixent pas la solution (\xE0 l\u2019ordre 2 : y et y\u2032 au m\xEAme point).',
      );
    if (!near2(v, ref, Math.abs(ref)))
      throw new OdeModelError(`La r\xE9ponse n\u2019est pas la valeur de la solution (${ref}).`);
    ks.goal = 'value';
    ks.target = { x0, head: h.n, arg: vm[2], v: ref, size: size(rhs) };
  } else if (h.k === 's' && h.n === fn2 && !hasY) {
    const cs = constsIn(ks, rhs);
    ks.goal = cs.length ? 'general' : ks.conds.length ? 'unique' : 'particular';
    if (ks.goal === 'unique' && ks.conds.length < o0.order)
      throw new OdeModelError(`Il faut ${o0.order} conditions pour une seule solution.`);
    const c = classify(ks, rhs);
    if (ks.goal === 'general' && !(c.k === 'general' && c.of === 'full'))
      throw new OdeModelError('La r\xE9ponse n\u2019est pas l\u2019ensemble des solutions.');
    if (ks.goal !== 'general' && !(c.k === 'one' && c.of === 'full'))
      throw new OdeModelError('La r\xE9ponse n\u2019est pas une solution de l\u2019\xE9quation.');
    if (ks.goal === 'unique' && !condsHold(ks, rhs))
      throw new OdeModelError('La r\xE9ponse ne v\xE9rifie pas les conditions.');
  } else {
    const o = lineOde(ks, ar.sides);
    if (!o || !sameOde(o, ks.ode, x, ks.pts))
      throw new OdeModelError('La r\xE9ponse n\u2019est pas l\u2019\xE9quation r\xE9\xE9crite.');
    ks.goal = 'rewrite';
    ks.answerShape = shapeOf2(ar.sides);
  }
  ks.givenTexts = new Set(odeGivenTexts(model).map((t) => kodeText(kodeLineAtoms(t, fn2, x))));
  ks.traps = (model.traps ?? []).map((t) => ({
    text: kodeText(kodeLineAtoms(t.line, fn2, x)),
    line: kodeLine(t.line, fn2),
    title: t.title ?? 'Attention',
    why: t.why,
  }));
  return ks;
}
function odeGivenTexts(model) {
  const k = model.kernel;
  return [k.start, ...(k.ode?.initial ?? []), ...(k.domain ? [k.domain] : [])];
}
function shapeOf2(sides) {
  const h = sides[0];
  return h.k === 's' ? `h:${h.n}` : 'autre';
}
function lineOde(ks, sides) {
  if (sides.length !== 2) return null;
  let Et;
  try {
    Et = canon(add2(termOf(sides[0]), mul2(num2(-1), termOf(sides[1]))));
  } catch {
    return null;
  }
  return odeOf(ks, Et, ks.pts.length ? ks.pts : BASE_PTS);
}
function odeValueAt(ks, xt) {
  const o = ks.ode;
  const c0 = ks.conds.find((c) => c.k === 0);
  if (!c0) return null;
  const c1 = o.order === 2 ? ks.conds.find((c) => c.k === 1 && near2(c.x0, c0.x0)) : null;
  if (o.order === 2 && !c1) return null;
  if (near2(xt, c0.x0)) return c0.v;
  const fixed = ks.constCoef ? coefsAt(o, ks.x, c0.x0) : null;
  const N = ks.constCoef ? 2e3 : 600;
  const h = (xt - c0.x0) / N;
  const rhs = (p2, s2) => {
    const [a0, a1, a2, f] = fixed ?? coefsAt(o, ks.x, p2);
    if (o.order === 1) return [(f - a0 * s2[0]) / a1];
    return [s2[1], (f - a1 * s2[1] - a0 * s2[0]) / a2];
  };
  let s = o.order === 1 ? [c0.v] : [c0.v, c1.v];
  let p = c0.x0;
  for (let i = 0; i < N; i++) {
    const k1 = rhs(p, s);
    const k2 = rhs(
      p + h / 2,
      s.map((v, j) => v + (h / 2) * k1[j]),
    );
    const k3 = rhs(
      p + h / 2,
      s.map((v, j) => v + (h / 2) * k2[j]),
    );
    const k4 = rhs(
      p + h,
      s.map((v, j) => v + h * k3[j]),
    );
    s = s.map((v, j) => v + (h / 6) * (k1[j] + 2 * k2[j] + 2 * k3[j] + k4[j]));
    p += h;
  }
  return s.every(Number.isFinite) ? s[0] : null;
}
function condsHold(ks, F) {
  return ks.conds.every((c) => {
    const d2 = deriveK(F, ks.x, c.k);
    return !!d2 && near2(val2(d2, { [ks.x]: c.x0 }), c.v);
  });
}
function knownPrefix2(ks, A) {
  return ks.path.some((t) => {
    let atoms;
    try {
      atoms = kodeLineAtoms(t, ks.fn, ks.x);
    } catch {
      return false;
    }
    return atoms.length > A.length && A.every((a, i) => atoms[i] === a);
  });
}
function kodeJudge(ks, chips, opts) {
  const raw = chips.flatMap((c) => c.atoms);
  const A = normalize(raw);
  if (!A.length) return { kind: 'empty', atoms: A, badChip: -1 };
  const prefix = knownPrefix2(ks, A);
  const incomplete = () =>
    opts?.verify
      ? { kind: 'syntax', atoms: A, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
      : { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  const r = readAtoms(A);
  if (r.k === 'incomplete') return incomplete();
  if (r.k === 'syntax') {
    if (prefix && !opts?.verify) return { kind: 'building', atoms: A, complete: false };
    return { kind: 'syntax', atoms: A, line: lineOf2(A), title: r.title, message: r.message };
  }
  const base = { atoms: A, line: lineOf2(A) };
  let v;
  try {
    v = judgeRead(ks, base, r);
  } catch {
    v = {
      kind: 'syntax',
      ...base,
      title: '\xC7a ne se lit pas',
      message: 'Cette ligne ne se lit pas : v\xE9rifie l\u2019\xE9criture.',
    };
  }
  if (prefix && !opts?.verify) {
    if (v.kind === 'step') return { ...v, kind: 'ready', complete: true };
    return { kind: 'building', atoms: A, complete: true };
  }
  if (!opts?.verify && (v.kind === 'unjustified' || v.kind === 'false'))
    return { kind: 'pending', atoms: A, complete: true };
  return { ...v, complete: true };
}
function judgeRead(ks, base, r) {
  const text = kodeText(base.atoms);
  if (ks.givenTexts.has(text))
    return useless(
      base,
      'C\u2019est l\u2019\xE9nonc\xE9',
      'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (ks.written.has(text))
    return useless(
      base,
      'D\xE9j\xE0 \xE9crit',
      'Tu as d\xE9j\xE0 \xE9crit cette ligne : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (r.k === 'or') return judgeRoots(ks, base, r.clauses, text);
  const sides = r.sides;
  const h = sides[0];
  const rest = sides.slice(1).map(termOf);
  const restSyms = new Set(rest.flatMap((t) => [...symbolsOf(t)]));
  const restHasY = ks.Y.some((s) => restSyms.has(s));
  const hn = h.k === 's' ? h.n : null;
  if (hn === ks.fn && !restHasY) return judgeSolution(ks, base, rest, text);
  if (
    (hn === ks.Y[1] || hn === ks.Y[2]) &&
    !restHasY &&
    rest.some((t) => constsIn(ks, t).length > 0)
  )
    return judgeDeriv(ks, base, hn === ks.Y[1] ? 1 : 2, rest, text);
  if (hn && headRe(ks.fn).test(hn)) return judgeEval(ks, base, hn, rest, text);
  if (hn === '\u0394') return judgeDelta(ks, base, rest, text);
  const all = /* @__PURE__ */ new Set([
    ...(h.k === 's' ? [hn] : [...symbolsOf(termOf(h))]),
    ...restSyms,
  ]);
  if (ks.Y.some((s) => all.has(s))) {
    if (sides.length !== 2)
      return {
        kind: 'syntax',
        ...base,
        title: 'Une \xE9quation',
        message: '\xC9cris l\u2019\xE9quation sur une ligne : \xAB y\u2032 = \u2026 \xBB.',
      };
    return judgeEq(ks, base, sides, text);
  }
  const letters = [...all].filter((s) => s !== '\u03C0');
  if (letters.length && letters.every((s) => s === 'r')) {
    if (hn === 'r' && sides.length === 2 && !symbolsOf(rest[0]).has('r'))
      return judgeRoots(ks, base, [sides], text);
    return judgeChar(ks, base, sides, text);
  }
  if (letters.length && letters.every((s) => ks.consts.includes(s)))
    return judgeCEq(ks, base, sides, text);
  return {
    kind: 'syntax',
    ...base,
    title: '\xC7a ne se lit pas',
    message: `\xC9cris \xAB ${ks.fn} = \u2026 \xBB, \xAB ${ks.fn}\u2032 = \u2026 \xBB, \xAB ${ks.fn}(0) = \u2026 \xBB ou une \xE9quation en la constante.`,
  };
}
function judgeEq(ks, base, sides, text) {
  const o = lineOde(ks, sides);
  if (!o)
    return {
      kind: 'false',
      ...base,
      title: 'Pas une \xE9quation lin\xE9aire',
      message: `L\u2019\xE9quation s\u2019\xE9crit avec ${ks.fn}, ${ks.fn}\u2032${ks.ode.order === 2 ? `, ${ks.fn}\u2033` : ''}, des nombres et ${ks.x}.`,
    };
  const shape2 = shapeOf2(sides);
  const isolated = sides[0].k === 's' && (sides[0].n === ks.Y[1] || sides[0].n === ks.Y[2]);
  const label = isolated ? `Isoler ${sides[0].n}` : STEP3.rewrite.label;
  if (sameOde(o, ks.ode, ks.x, ks.pts)) {
    if (ks.eqs.some((e) => e.of === 'full' && e.shape === shape2))
      return useless(
        base,
        'Rien de nouveau',
        'C\u2019est la m\xEAme \xE9quation, \xE9crite autrement : passe \xE0 l\u2019\xE9tape suivante.',
      );
    const final = ks.goal === 'rewrite' && shape2 === ks.answerShape;
    return stepVerdict2(
      base,
      'rewrite',
      { text, kind: 'eq', of: 'full', shape: shape2 },
      final,
      label,
    );
  }
  if (!ks.homog && sameOde(o, homogOf(ks.ode), ks.x, ks.pts)) {
    if (ks.homogWritten) {
      if (ks.eqs.some((e) => e.of === 'homog' && e.shape === shape2))
        return useless(
          base,
          'Rien de nouveau',
          'Tu as d\xE9j\xE0 \xE9crit l\u2019\xE9quation homog\xE8ne.',
        );
      return stepVerdict2(
        base,
        'rewrite',
        { text, kind: 'eq', of: 'homog', shape: shape2 },
        false,
        label,
      );
    }
    return stepVerdict2(
      base,
      'homogeneous',
      { text, kind: 'eq', of: 'homog', shape: shape2 },
      false,
    );
  }
  return trapOr2(ks, base, {
    title: 'Pas la m\xEAme \xE9quation',
    message:
      'Ce n\u2019est pas une r\xE9\xE9criture de l\u2019\xE9quation : un terme qui change de c\xF4t\xE9 change de signe, et on divise tous les termes par le m\xEAme nombre.',
  });
}
function generalLabel(ks, of) {
  const o = of === 'homog' ? homogOf(ks.ode) : ks.ode;
  const fn2 = ks.fn;
  if (o.order === 1) {
    const noY = ks.pts.every((p) => Math.abs(val2(o.a[0], { [ks.x]: p })) < 1e-12);
    if (noY)
      return {
        label: 'Primitives',
        why: `Les solutions de ${fn2}\u2032 = f(${ks.x}) sont les primitives de f : F(${ks.x}) + C.`,
      };
    const fZero = of === 'homog' || ks.homog;
    if (ks.constCoef)
      return fZero
        ? {
            label: `Solutions de ${fn2}\u2032 = a${fn2}`,
            why: `Les solutions de ${fn2}\u2032 = a${fn2} sont les fonctions ${ks.x} \u21A6 Ce^(a${ks.x}), C r\xE9el.`,
          }
        : {
            label: `Solutions de ${fn2}\u2032 = a${fn2} + b`,
            why: `Les solutions de ${fn2}\u2032 = a${fn2} + b (a \u2260 0) sont les fonctions ${ks.x} \u21A6 Ce^(a${ks.x}) \u2212 b \xF7 a, C r\xE9el.`,
          };
    return fZero
      ? {
          label: `Solutions de ${fn2}\u2032 + a(${ks.x})${fn2} = 0`,
          why: `Les solutions de ${fn2}\u2032 + a(${ks.x})${fn2} = 0 sont les fonctions ${ks.x} \u21A6 Ce^(\u2212A(${ks.x})), A une primitive de a.`,
        }
      : { label: STEP3.general.label, why: STEP3.general.why };
  }
  if (ks.constCoef) {
    const [a0, a1, a2] = o.a.map((t) => val2(t, {}));
    const d2 = a1 * a1 - 4 * a2 * a0;
    const prefix =
      of === 'homog' && !ks.homog ? 'Solutions de l\u2019\xE9quation homog\xE8ne' : 'Solutions';
    if (Math.abs(d2) < 1e-12 * Math.max(1, a1 * a1))
      return {
        label: `${prefix} : racine double`,
        why: `Une racine double r : ${fn2} = (C\u2081${ks.x} + C\u2082)e^(r${ks.x}).`,
      };
    if (d2 > 0)
      return {
        label: `${prefix} : deux racines r\xE9elles`,
        why: `Deux racines r\xE9elles r\u2081 et r\u2082 : ${fn2} = C\u2081e^(r\u2081${ks.x}) + C\u2082e^(r\u2082${ks.x}).`,
      };
    return {
      label: `${prefix} : racines complexes`,
      why: `Deux racines complexes \u03B1 \xB1 i\u03B2 : ${fn2} = e^(\u03B1${ks.x})(C\u2081cos(\u03B2${ks.x}) + C\u2082sin(\u03B2${ks.x})).`,
    };
  }
  return { label: STEP3.general.label, why: STEP3.general.why };
}
function judgeSolution(ks, base, rest, text) {
  const F = rest[rest.length - 1];
  const odd = strangers(ks, F);
  if (odd.length)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une lettre de trop',
      message: `\xAB ${odd[0]} \xBB n\u2019est ni ${ks.x} ni une constante de la feuille.`,
    };
  if (rest.length > 1) {
    const ref = rest[0];
    const cs = [...new Set(rest.flatMap((t) => constsIn(ks, t)))];
    const same = rest.every((t) =>
      C_SAMPLES.every((cv) =>
        ks.pts.every((p) =>
          near2(
            val2(t, { ...envOf(cs, cv), [ks.x]: p }),
            val2(ref, { ...envOf(cs, cv), [ks.x]: p }),
          ),
        ),
      ),
    );
    if (!same)
      return trapOr2(ks, base, {
        title: 'Pas la m\xEAme fonction',
        message: 'Les membres de ta ligne ne sont pas \xE9gaux : v\xE9rifie ton calcul.',
      });
  }
  const c = classify(ks, F);
  const sz = size(F);
  if (c.k === 'general') {
    const already = ks.families.filter((f) => f.of === c.of);
    if (already.length) {
      if (sz < Math.min(...already.map((f) => f.size)))
        return stepVerdict2(
          base,
          'compute',
          { text, kind: 'family', of: c.of, F, size: sz },
          c.of === 'full' && ks.goal === 'general',
        );
      return useless(
        base,
        'Rien de nouveau',
        'Ce sont les m\xEAmes solutions, \xE9crites autrement : passe \xE0 l\u2019\xE9tape suivante.',
        { text, kind: 'family', of: c.of, F, size: sz },
      );
    }
    const final = c.of === 'full' && ks.goal === 'general';
    if (c.of === 'homog') {
      const g2 = generalLabel(ks, 'homog');
      return stepVerdict2(
        base,
        'homogSolutions',
        { text, kind: 'family', of: 'homog', F, size: sz },
        false,
        ks.ode.order === 2 && ks.constCoef ? g2.label : STEP3.homogSolutions.label,
        g2.why,
      );
    }
    const hasHomog = ks.families.some((f) => f.of === 'homog');
    if (hasHomog && ks.ones.length)
      return stepVerdict2(
        base,
        'superpose',
        { text, kind: 'family', of: 'full', F, size: sz },
        final,
      );
    const g = generalLabel(ks, 'full');
    return stepVerdict2(
      base,
      'general',
      { text, kind: 'family', of: 'full', F, size: sz },
      final,
      g.label,
      g.why,
    );
  }
  if (c.k === 'partial')
    return trapOr2(ks, base, {
      title: 'Il manque des solutions',
      message:
        ks.ode.order === 2
          ? 'Une \xE9quation d\u2019ordre 2 a deux solutions ind\xE9pendantes : il faut deux constantes.'
          : 'Toutes les solutions : il faut une constante C.',
    });
  if (c.k === 'one') {
    if (c.of === 'homog')
      return trapOr2(ks, base, {
        title: 'Solution de l\u2019\xE9quation homog\xE8ne',
        message: `Cette fonction v\xE9rifie l\u2019\xE9quation homog\xE8ne, pas l\u2019\xE9quation compl\xE8te : il manque le second membre.`,
      });
    const omove = { text, kind: 'one', F, size: sz };
    if (ks.ones.some((o) => near2(fnDistance(ks, o.F, F), 0))) {
      const prev = ks.ones.filter((o) => near2(fnDistance(ks, o.F, F), 0));
      const final = isFinalOne(ks, F);
      if (sz < Math.min(...prev.map((o) => o.size)))
        return stepVerdict2(base, 'compute', omove, final);
      return useless(
        base,
        'Rien de nouveau',
        'C\u2019est la m\xEAme fonction, \xE9crite autrement.',
        omove,
      );
    }
    const isConst2 = ks.pts.every((p) =>
      near2(val2(F, { [ks.x]: p }), val2(F, { [ks.x]: ks.pts[0] })),
    );
    const fam = refFamily(ks);
    const canParticular = !ks.homog && !ks.ones.length;
    const particularStep = () =>
      stepVerdict2(base, isConst2 ? 'constant' : 'particular', omove, false);
    if (ks.goal === 'unique' || ks.goal === 'value') {
      const last = ks.goal === 'unique';
      if (condsHold(ks, F)) {
        if (fam && ks.cKnown && ks.cFamily && memberOf(ks, fam, F))
          return stepVerdict2(base, 'member', omove, last, memberLabel(fam));
        return jumpVerdict2(
          base,
          omove,
          last,
          fam
            ? `C\u2019est la solution. Montre comment tu trouves ${fam.cs.join(' et ')} : \xE9cris ce que donne ${ks.conds.map((c2) => c2.text).join(' et ')}. Tu peux garder cette ligne sans HORA.`
            : void 0,
        );
      }
      if (canParticular) return particularStep();
      const bad = ks.conds.find((cd) => {
        const d2 = deriveK(F, ks.x, cd.k);
        return !d2 || !near2(val2(d2, { [ks.x]: cd.x0 }), cd.v);
      });
      return useless(
        base,
        'Juste, mais \xE0 c\xF4t\xE9',
        `Cette fonction est bien une solution, mais elle ne v\xE9rifie pas ${bad?.text ?? 'les conditions'}.`,
      );
    }
    if (ks.goal === 'particular') {
      if (fam && memberOf(ks, fam, F))
        return stepVerdict2(base, 'member', omove, true, 'Un cas particulier');
      if (isConst2) return stepVerdict2(base, 'constant', omove, true);
      return jumpVerdict2(base, omove, true);
    }
    if (ks.goal === 'general' && canParticular) return particularStep();
    return useless(
      base,
      'Juste, mais \xE0 c\xF4t\xE9',
      ks.goal === 'general'
        ? `C\u2019est une solution, mais la question demande toutes les solutions (avec une constante).`
        : `C\u2019est une solution, mais la question demande de r\xE9\xE9crire l\u2019\xE9quation.`,
      omove,
    );
  }
  if (c.why === 'notAffine')
    return trapOr2(ks, base, {
      title: 'Pas toutes les solutions',
      message:
        'Les solutions s\u2019\xE9crivent avec la constante en facteur : C \xD7 (une fonction) + (une solution).',
    });
  if (c.why === 'particular')
    return trapOr2(ks, base, {
      title: 'La solution particuli\xE8re',
      message:
        'La partie avec la constante est juste, mais la fonction qu\u2019on ajoute n\u2019est pas une solution de l\u2019\xE9quation compl\xE8te.',
    });
  return trapOr2(ks, base, {
    title: constsIn(ks, F).length ? 'Ce ne sont pas des solutions' : 'Pas une solution',
    message: `V\xE9rifie : avec ${ks.fn} = \u2026, calcule ${ks.fn}\u2032${ks.ode.order === 2 ? ` et ${ks.fn}\u2033` : ''}, puis remplace dans l\u2019\xE9quation : on ne retrouve pas l\u2019\xE9galit\xE9.`,
  });
}
function memberLabel(fam) {
  return fam.cs.length > 1 ? `Remplacer ${fam.cs.join(' et ')}` : `Remplacer ${fam.cs[0]}`;
}
function isFinalOne(ks, F) {
  if (ks.goal === 'unique') return condsHold(ks, F);
  return ks.goal === 'particular';
}
function reducible2(t) {
  const isNumT2 = (u) => u.k === 'num';
  const isZero2 = (u) => u.k === 'num' && u.v.n === 0n;
  const isOne2 = (u) => u.k === 'num' && u.v.n === u.v.d;
  switch (t.k) {
    case 'num':
    case 'sym':
      return false;
    case 'add':
      return t.c.some(isZero2) || t.c.filter(isNumT2).length > 1 || t.c.some(reducible2);
    case 'mul':
      return (
        t.c.some(isZero2) ||
        t.c.some(isOne2) ||
        t.c.filter(isNumT2).length > 1 ||
        t.c.some(reducible2)
      );
    case 'div':
      return (
        isOne2(t.b) ||
        isZero2(t.a) ||
        (isNumT2(t.a) && isNumT2(t.b)) ||
        reducible2(t.a) ||
        reducible2(t.b)
      );
    case 'pow':
      return (
        isZero2(t.b) ||
        isOne2(t.b) ||
        (isNumT2(t.a) && isNumT2(t.b)) ||
        reducible2(t.a) ||
        reducible2(t.b)
      );
    case 'fn':
      return (t.f === 'exp' && isZero2(t.a)) || (t.f === 'ln' && isOne2(t.a)) || reducible2(t.a);
    default:
      return false;
  }
}
function judgeValue(ks, base, head, rest, text) {
  const tgt = ks.target;
  const odd = [...new Set(rest.flatMap((t) => [...symbolsOf(t)]))].filter((s) => s !== '\u03C0');
  if (odd.length)
    return {
      kind: 'syntax',
      ...base,
      title: odd.includes(ks.x) ? 'Une valeur' : 'Une lettre de trop',
      message: odd.includes(ks.x)
        ? `${head} est un nombre : remplace ${ks.x} par ${tgt.arg}.`
        : `\xAB ${odd[0]} \xBB n\u2019a pas sa place dans une valeur.`,
    };
  if (!rest.every((t) => near2(val2(t, {}), tgt.v, Math.abs(tgt.v))))
    return trapOr2(ks, base, {
      title: 'Pas la bonne valeur',
      message: `Remplace ${ks.x} par ${tgt.arg} dans la solution qui v\xE9rifie ${ks.conds.map((c) => c.text).join(' et ')}, puis calcule.`,
    });
  const F = rest[rest.length - 1];
  const sz = size(F);
  const final = sz <= tgt.size + 2 && !reducible2(F);
  const omove = { text, kind: 'value', head, size: sz };
  const prev = ks.values.get(head);
  if (prev !== void 0) {
    if (sz < prev || (final && !ks.concluded)) return stepVerdict2(base, 'compute', omove, final);
    return useless(base, 'Rien de nouveau', `Tu as d\xE9j\xE0 calcul\xE9 ${head}.`);
  }
  const known2 = (ks.cKnown && !!refFamily(ks)) || ks.ones.some((o) => condsHold(ks, o.F));
  if (!known2)
    return jumpVerdict2(
      base,
      omove,
      final,
      `${final ? 'C\u2019est la r\xE9ponse.' : 'Ta ligne est juste.'} Montre comment : trouve d\u2019abord la solution qui v\xE9rifie ${ks.conds.map((c) => c.text).join(' et ')}, puis remplace ${ks.x} par ${tgt.arg}. Tu peux la garder sans HORA.`,
    );
  return stepVerdict2(
    base,
    'value',
    omove,
    final,
    `Calculer ${head}`,
    `On remplace ${ks.x} par ${tgt.arg} dans la solution trouv\xE9e.`,
  );
}
function fnDistance(ks, F, G) {
  return Math.max(...ks.pts.map((p) => Math.abs(val2(F, { [ks.x]: p }) - val2(G, { [ks.x]: p }))));
}
function judgeDeriv(ks, base, order, rest, text) {
  const G = rest[rest.length - 1];
  if (strangers(ks, G).length)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une lettre de trop',
      message: `\xAB ${strangers(ks, G)[0]} \xBB n\u2019est ni ${ks.x} ni une constante de la feuille.`,
    };
  const fams = ks.families;
  if (!fams.length)
    return {
      kind: 'unjustified',
      ...base,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord les solutions : \xAB ${ks.fn} = \u2026 \xBB.`,
    };
  const sameFn2 = (a, b, cs) =>
    C_SAMPLES.every((cv) =>
      ks.pts.every((p) =>
        near2(val2(a, { ...envOf(cs, cv), [ks.x]: p }), val2(b, { ...envOf(cs, cv), [ks.x]: p })),
      ),
    );
  for (let i = fams.length - 1; i >= 0; i--) {
    const fam = fams[i];
    const d2 = deriveK(fam.F, ks.x, order);
    if (d2 && rest.every((t) => sameFn2(t, d2, fam.cs))) {
      const sz = size(G);
      const prev = ks.derivs.filter((x) => x.order === order && sameFn2(x.F, d2, fam.cs));
      const omove = { text, kind: 'deriv', F: G, size: sz, order };
      if (prev.length) {
        if (sz < Math.min(...prev.map((x) => x.size)))
          return stepVerdict2(base, 'compute', omove, false);
        return useless(base, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit cette d\xE9riv\xE9e.');
      }
      return stepVerdict2(
        base,
        'derive',
        omove,
        false,
        order === 2 ? `D\xE9river deux fois` : 'D\xE9river',
      );
    }
  }
  return trapOr2(ks, base, {
    title: 'Pas la d\xE9riv\xE9e',
    message: `D\xE9rive chaque terme des solutions ; ${fams[fams.length - 1].cs.join(', ')} reste${fams[fams.length - 1].cs.length > 1 ? 'nt' : ''} une constante.`,
  });
}
function judgeEval(ks, base, head, rest, text) {
  const m = headRe(ks.fn).exec(head);
  const k = m[1] === '\u2033' ? 2 : m[1].length;
  let x0;
  try {
    x0 = val2(exprOfText2(m[2]), {});
  } catch {
    x0 = NaN;
  }
  if (!Number.isFinite(x0))
    return {
      kind: 'syntax',
      ...base,
      title: 'Un nombre',
      message: `\xC9cris la valeur de ${ks.x} : \xAB ${ks.fn}(0) \xBB.`,
    };
  const cond = ks.conds.find((c) => c.k === k && near2(c.x0, x0));
  const noConst = rest.every((t) => !constsIn(ks, t).length);
  const tgt =
    ks.goal === 'value' && ks.target && k === 0 && near2(x0, ks.target.x0) ? ks.target : null;
  if (tgt && noConst) return judgeValue(ks, base, head, rest, text);
  if (noConst && cond && rest.every((t) => near2(val2(t, {}), cond.v)))
    return useless(
      base,
      'C\u2019est l\u2019\xE9nonc\xE9',
      `${cond.text} : c\u2019est une donn\xE9e de l\u2019\xE9nonc\xE9.`,
    );
  const fam = refFamily(ks);
  if (!fam)
    return {
      kind: 'unjustified',
      ...base,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord toutes les solutions : \xAB ${ks.fn} = \u2026 \xBB, avec la constante.`,
    };
  const d2 = deriveK(fam.F, ks.x, k);
  const at = d2 ? substitute(d2, { [ks.x]: num2(x0) }) : null;
  const want = at ? affineVec(at, fam.cs) : null;
  const ok =
    !!want &&
    rest.every((t) => {
      if (strangers(ks, t).length) return false;
      const a = affineVec(t, fam.cs);
      return !!a && near2(a.r, want.r) && a.w.every((w, i) => near2(w, want.w[i]));
    });
  if (!ok)
    return trapOr2(ks, base, {
      title: 'Pas la bonne valeur',
      message: `Remplace ${ks.x} par ${m[2]} dans ${k ? `la d\xE9riv\xE9e des solutions` : 'les solutions'}, puis calcule.`,
    });
  const sz = size(rest[rest.length - 1]);
  const omove = { text, kind: 'eval', head, size: sz };
  const prev = ks.evals.get(head);
  if (prev !== void 0) {
    if (sz < prev) return stepVerdict2(base, 'compute', omove, false);
    return useless(base, 'Rien de nouveau', `Tu as d\xE9j\xE0 calcul\xE9 ${head}.`);
  }
  if (!cond && !tgt)
    return useless(
      base,
      'Juste, mais \xE0 c\xF4t\xE9',
      `${head} n\u2019est pas dans les conditions de l\u2019\xE9nonc\xE9 : calcule ${ks.conds.map((c) => c.head).join(' et ') || 'autre chose'}.`,
    );
  return stepVerdict2(
    base,
    'evaluate',
    omove,
    false,
    `Calculer ${head}`,
    `On remplace ${ks.x} par ${m[2]} dans ${k ? 'la d\xE9riv\xE9e des solutions' : 'les solutions'}.`,
  );
}
function judgeCEq(ks, base, sides, text) {
  const fam = refFamily(ks);
  if (!fam)
    return {
      kind: 'unjustified',
      ...base,
      title: 'D\u2019abord les solutions',
      message: `\xC9cris d\u2019abord toutes les solutions : \xAB ${ks.fn} = \u2026 \xBB, avec la constante.`,
    };
  if (sides.length !== 2)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une \xE9galit\xE9',
      message: 'Une seule \xE9galit\xE9 par ligne.',
    };
  const t = canon(add2(termOf(sides[0]), mul2(num2(-1), termOf(sides[1]))));
  const odd = [...symbolsOf(t)].filter((s) => s !== '\u03C0' && !fam.cs.includes(s));
  if (odd.length)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une lettre de trop',
      message: `Les constantes des solutions sont ${fam.cs.join(' et ')}.`,
    };
  const a = affineVec(t, fam.cs);
  if (!a)
    return {
      kind: 'false',
      ...base,
      title: 'Une \xE9quation du premier degr\xE9',
      message: `La condition donne une \xE9quation du premier degr\xE9 en ${fam.cs.join(' et ')}.`,
    };
  const eq2 = { w: a.w, r: -a.r };
  if (eq2.w.every((w) => Math.abs(w) < 1e-12))
    return useless(base, 'Rien de nouveau', `Ta ligne ne dit rien sur ${fam.cs.join(' ni ')}.`);
  const star = cStar(ks, fam);
  if (!star)
    return useless(
      base,
      'Rien ne fixe la constante',
      `L\u2019\xE9nonc\xE9 ne donne pas de condition pour trouver ${fam.cs.join(' et ')}.`,
    );
  const lhs = eq2.w.reduce((s, w, i) => s + w * star[i], 0);
  if (!near2(lhs, eq2.r))
    return trapOr2(ks, base, {
      title: 'Pas la bonne \xE9quation',
      message: `\xC9cris ce que donne${ks.conds.length > 1 ? 'nt' : ''} ${ks.conds.map((c) => c.text).join(' et ')} avec les solutions.`,
    });
  const sameFam = ks.cFamily && ks.cFamily.join() === fam.cs.join();
  const est = sameFam ? ks.cEqs : [];
  const isSym = (n, ok) => n.k === 's' && ok(n.n);
  const solved =
    (isSym(sides[0], (s) => fam.cs.includes(s)) && !constsIn(ks, termOf(sides[1])).length) ||
    (isSym(sides[1], (s) => fam.cs.includes(s)) && !constsIn(ks, termOf(sides[0])).length);
  const solvedOne = eq2.w.filter((w) => Math.abs(w) > 1e-12).length === 1;
  const one = solvedOne ? fam.cs[eq2.w.findIndex((w) => Math.abs(w) > 1e-12)] : null;
  const omove = { text, kind: 'ceq', w: eq2.w, r: eq2.r, solved };
  const twins = est.filter((e) => proportional(augmented(eq2), augmented(e)));
  if (twins.length) {
    if (solved && !twins.some((e) => e.solved))
      return stepVerdict2(
        base,
        'solveC',
        omove,
        false,
        one ? `Trouver ${one}` : STEP3.solveC.label,
        one ? `On r\xE9sout l\u2019\xE9quation en ${one}.` : STEP3.solveC.why,
      );
    return useless(
      base,
      'Rien de nouveau',
      'C\u2019est la m\xEAme \xE9quation, \xE9crite autrement.',
    );
  }
  const cond = ks.conds.find((c) => {
    const cv = condVec(ks, fam, c);
    return !!cv && proportional(augmented(eq2), augmented(cv));
  });
  if (cond)
    return stepVerdict2(
      base,
      'condition',
      omove,
      false,
      `Utiliser ${cond.text}`,
      `La condition ${cond.text} donne une \xE9quation en ${fam.cs.join(' et ')}.`,
    );
  const rows = est.map(augmented);
  if (rows.length && rank([...rows, augmented(eq2)]) === rank(rows))
    return stepVerdict2(
      base,
      'solveC',
      omove,
      false,
      one ? `Trouver ${one}` : 'Combiner les \xE9quations',
      one
        ? `On r\xE9sout l\u2019\xE9quation en ${one}.`
        : 'On combine les \xE9quations en les constantes.',
    );
  return jumpVerdict2(
    base,
    omove,
    false,
    `Ta ligne est juste. \xC9cris d\u2019abord ce que donne ${ks.conds.map((c) => c.text).join(' et ')}, une \xE9tape par ligne, pour gagner des HORA. Tu peux la garder sans HORA.`,
  );
}
function startQ(ks) {
  if (ks.ode.order !== 2 || !ks.constCoef) return null;
  const [a0, a1, a2] = ks.ode.a.map((t) => val2(t, {}));
  return [a2, a1, a0];
}
function judgeChar(ks, base, sides, text) {
  const q0 = startQ(ks);
  if (!q0)
    return useless(
      base,
      'Pas d\u2019\xE9quation caract\xE9ristique ici',
      'L\u2019\xE9quation caract\xE9ristique sert aux \xE9quations d\u2019ordre 2 \xE0 coefficients constants.',
    );
  if (sides.length !== 2)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une \xE9quation',
      message: '\xC9cris \xAB r\xB2 + \u2026 = 0 \xBB.',
    };
  const t = canon(add2(termOf(sides[0]), mul2(num2(-1), termOf(sides[1]))));
  const q = quadOf(t, 'r');
  if (q && proportional(q, q0)) {
    if (ks.charQ)
      return useless(
        base,
        'Rien de nouveau',
        'Tu as d\xE9j\xE0 \xE9crit l\u2019\xE9quation caract\xE9ristique.',
      );
    return stepVerdict2(base, 'characteristic', { text, kind: 'char', q }, false);
  }
  return trapOr2(ks, base, {
    title: 'Pas la bonne \xE9quation caract\xE9ristique',
    message: `\xC0 ${ks.fn}\u2033 correspond r\xB2, \xE0 ${ks.fn}\u2032 correspond r, \xE0 ${ks.fn} correspond 1 : on garde les coefficients.`,
  });
}
function judgeDelta(ks, base, rest, text) {
  const q0 = startQ(ks);
  if (!q0)
    return useless(
      base,
      'Pas de discriminant ici',
      'Le discriminant sert \xE0 l\u2019\xE9quation caract\xE9ristique (ordre 2).',
    );
  const qs = [q0, ...(ks.charQ ? [ks.charQ] : [])];
  const vals = rest.map((t) => (symbolsOf(t).size ? NaN : val2(t, {})));
  const good = qs.find((q) => {
    const d2 = q[1] * q[1] - 4 * q[0] * q[2];
    return vals.every((v) => near2(v, d2));
  });
  if (!good)
    return trapOr2(ks, base, {
      title: 'Pas le bon discriminant',
      message:
        '\u0394 = b\xB2 \u2212 4ac, avec les coefficients de l\u2019\xE9quation caract\xE9ristique.',
    });
  const key = String(Math.round(vals[0] * 1e9));
  const omove = { text, kind: 'delta', delta: vals[0] };
  if (ks.deltas.has(key)) {
    if (rest.length === 1 && size(rest[0]) <= 2)
      return useless(base, 'Rien de nouveau', 'Tu as d\xE9j\xE0 calcul\xE9 \u0394.');
    return useless(base, 'Rien de nouveau', 'Tu as d\xE9j\xE0 calcul\xE9 \u0394.');
  }
  return stepVerdict2(base, 'discriminant', omove, false);
}
function judgeRoots(ks, base, clauses, text) {
  const q0 = startQ(ks);
  if (!q0)
    return useless(
      base,
      'Pas de racines ici',
      'Les racines de l\u2019\xE9quation caract\xE9ristique servent aux \xE9quations d\u2019ordre 2 \xE0 coefficients constants.',
    );
  const vals = [];
  for (const cl of clauses) {
    const h = cl[0];
    if (h.k !== 's' || h.n !== 'r' || cl.length !== 2)
      return {
        kind: 'syntax',
        ...base,
        title: 'Les racines',
        message: '\xC9cris \xAB r = \u2026 ou r = \u2026 \xBB.',
      };
    const c = cxOf(termOf(cl[1]));
    if (!c)
      return {
        kind: 'syntax',
        ...base,
        title: 'Un nombre',
        message: 'Une racine est un nombre (r\xE9el ou complexe, avec i).',
      };
    vals.push(c);
  }
  const want = roots(q0);
  const allIn = vals.every((v) => want.some((w) => cxNear(v, w)));
  const covers = want.every((w) => vals.some((v) => cxNear(v, w)));
  if (!allIn)
    return trapOr2(ks, base, {
      title: 'Pas les racines',
      message:
        'V\xE9rifie : remplace r par ta valeur dans l\u2019\xE9quation caract\xE9ristique, on doit trouver 0.',
    });
  if (!covers)
    return {
      kind: 'false',
      ...base,
      title: 'Il manque une racine',
      message:
        'L\u2019\xE9quation caract\xE9ristique a deux racines : \xE9cris-les toutes les deux (\xAB r = \u2026 ou r = \u2026 \xBB).',
    };
  if (ks.rootsWritten)
    return useless(base, 'Rien de nouveau', 'Tu as d\xE9j\xE0 \xE9crit les racines.');
  const label =
    want.length === 1
      ? 'Racine double'
      : want[0].im !== 0
        ? 'Racines complexes'
        : 'Deux racines r\xE9elles';
  return stepVerdict2(base, 'roots', { text, kind: 'roots' }, false, label);
}
function kodeCommit(ks, v) {
  const m = v.omove;
  if (!m) return;
  ks.written.add(m.text);
  ks.lines++;
  switch (m.kind) {
    case 'eq':
      ks.eqs.push({ of: m.of, shape: m.shape });
      if (m.of === 'homog') ks.homogWritten = true;
      break;
    case 'family': {
      const cs = constsIn(ks, m.F);
      ks.families.push({ of: m.of, F: m.F, cs, size: m.size });
      if (m.of === 'full' && (!ks.cFamily || ks.cFamily.join() !== cs.join())) {
        ks.cFamily = cs;
        ks.cEqs = [];
        ks.cKnown = false;
      }
      break;
    }
    case 'one':
      ks.ones.push({ F: m.F, size: m.size });
      break;
    case 'deriv':
      ks.derivs.push({ order: m.order, F: m.F, size: m.size });
      break;
    case 'eval':
      ks.evals.set(m.head, Math.min(m.size, ks.evals.get(m.head) ?? Infinity));
      break;
    case 'value':
      ks.values.set(m.head, Math.min(m.size, ks.values.get(m.head) ?? Infinity));
      break;
    case 'ceq': {
      const fam = refFamily(ks);
      if (fam && (!ks.cFamily || ks.cFamily.join() !== fam.cs.join())) {
        ks.cFamily = fam.cs;
        ks.cEqs = [];
      }
      ks.cEqs.push({ w: m.w, r: m.r, solved: !!m.solved });
      if (fam)
        ks.cKnown = fam.cs.every((_, i) =>
          ks.cEqs.some(
            (e) =>
              e.solved &&
              Math.abs(e.w[i]) > 1e-12 &&
              e.w.every((w, j) => j === i || Math.abs(w) < 1e-12),
          ),
        );
      break;
    }
    case 'char':
      ks.charQ = m.q;
      break;
    case 'delta':
      ks.deltas.add(String(Math.round(m.delta * 1e9)));
      break;
    case 'roots':
      ks.rootsWritten = true;
      break;
    default:
      break;
  }
  if (m.final) ks.concluded = true;
}
function kodeGoalReached(ks) {
  return ks.concluded;
}
function readText(ks, text) {
  let A;
  try {
    A = kodeLineAtoms(text, ks.fn, ks.x);
  } catch {
    return null;
  }
  return { base: { atoms: A, line: lineOf2(A) }, r: readAtoms(A) };
}
function kodeIsAnswer(ks, text) {
  const rd = readText(ks, text);
  if (!rd || rd.r.k !== 'eq' || rd.r.sides.length !== 2) return false;
  const sides = rd.r.sides;
  const h = sides[0];
  if (ks.goal === 'rewrite') {
    const o = lineOde(ks, sides);
    return !!o && sameOde(o, ks.ode, ks.x, ks.pts) && shapeOf2(sides) === ks.answerShape;
  }
  if (ks.goal === 'value') {
    const tgt = ks.target;
    const m = h.k === 's' ? headRe(ks.fn).exec(h.n) : null;
    if (!m || m[1] !== '') return false;
    let V;
    try {
      if (!near2(val2(exprOfText2(m[2]), {}), tgt.x0)) return false;
      V = termOf(sides[1]);
    } catch {
      return false;
    }
    if (![...symbolsOf(V)].every((s) => s === '\u03C0')) return false;
    return near2(val2(V, {}), tgt.v, Math.abs(tgt.v));
  }
  if (h.k !== 's' || h.n !== ks.fn) return false;
  let F;
  try {
    F = termOf(sides[1]);
  } catch {
    return false;
  }
  if ([...symbolsOf(F)].some((s) => ks.Y.includes(s)) || strangers(ks, F).length) return false;
  const c = classify(ks, F);
  if (ks.goal === 'general') return c.k === 'general' && c.of === 'full';
  if (c.k !== 'one' || c.of !== 'full') return false;
  return ks.goal === 'particular' || condsHold(ks, F);
}
function kodeAnswerWritten(ks, text) {
  if (ks.goal === 'rewrite' || ks.goal === 'general' || ks.goal === 'value') return ks.concluded;
  const rd = readText(ks, text);
  if (!rd || rd.r.k !== 'eq' || rd.r.sides.length !== 2) return false;
  let F;
  try {
    F = termOf(rd.r.sides[1]);
  } catch {
    return false;
  }
  return ks.ones.some((o) => near2(fnDistance(ks, o.F, F), 0));
}

// packages/reasoner/src/kernel-partial.ts
var PARTIAL_STEP_IDS = {
  first: 'partial.first@1',
  second: 'partial.second@1',
  gradient: 'partial.gradient@1',
  laplacian: 'partial.laplacian@1',
  point: 'partial.point@1',
  simplify: 'partial.simplify@1',
  substitute: 'partial.substitute@1',
  curve: 'partial.curve@1',
  compose: 'partial.compose@1',
  chain: 'partial.chain@1',
  derive: 'partial.derive@1',
  compute: 'kernel.compute@1',
};
var STEP4 = {
  first: {
    label: 'D\xE9river par rapport \xE0 x',
    hora: 2,
    why: 'Une d\xE9riv\xE9e partielle : on d\xE9rive par rapport \xE0 une variable, l\u2019autre est une constante.',
  },
  second: {
    label: 'D\xE9river une d\xE9riv\xE9e partielle',
    hora: 2,
    why: 'Une d\xE9riv\xE9e seconde : on d\xE9rive une d\xE9riv\xE9e partielle d\xE9j\xE0 calcul\xE9e.',
  },
  gradient: {
    label: 'Gradient',
    hora: 1,
    why: 'Le gradient est le couple des d\xE9riv\xE9es partielles.',
  },
  laplacian: {
    label: 'Laplacien',
    hora: 1,
    why: 'Le laplacien est la somme des deux d\xE9riv\xE9es secondes.',
  },
  point: {
    label: 'Calculer en un point',
    hora: 1,
    why: 'On remplace les variables par les coordonn\xE9es du point.',
  },
  simplify: {
    label: 'Simplifier la fonction',
    hora: 1,
    why: 'Une \xE9criture plus simple de la fonction.',
  },
  substitute: {
    label: 'Remplacer',
    hora: 1,
    why: 'On remplace par ce qui est d\xE9j\xE0 calcul\xE9.',
  },
  curve: {
    label: 'D\xE9river x(t)',
    hora: 1,
    why: 'La d\xE9riv\xE9e d\u2019une coordonn\xE9e de la courbe.',
  },
  compose: {
    label: 'Composer',
    hora: 1,
    why: 'On remplace x et y par x(t) et y(t) dans la fonction.',
  },
  chain: {
    label: 'R\xE8gle de la cha\xEEne',
    hora: 2,
    why: 'g\u2032(t) = x\u2032(t) \xD7 \u2202f/\u2202x + y\u2032(t) \xD7 \u2202f/\u2202y, les d\xE9riv\xE9es partielles prises en (x(t), y(t)).',
  },
  derive: {
    label: 'D\xE9river',
    hora: 2,
    why: 'Une fonction d\u2019une variable : on la d\xE9rive.',
  },
  compute: { label: 'Calculer', hora: 1, why: 'Un calcul.' },
};
var CARD4 = 'D\xE9riv\xE9es partielles';
var PartialModelError = class extends Error {};
var esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function partialSpecOf(model) {
  const k = model.kernel;
  const m = /^\s*([A-Za-z])\s*\(\s*([\p{L}])\s*[,;]\s*([\p{L}])\s*\)\s*=/u.exec(k.start);
  if (!m)
    throw new PartialModelError(
      `Le d\xE9part d\xE9finit la fonction : \xAB f(x, y) = \u2026 \xBB (\xAB ${k.start} \xBB).`,
    );
  const fn2 = m[1];
  const vars = [m[2], m[3]];
  if (vars[0] === vars[1] || vars.includes(fn2))
    throw new PartialModelError('Deux variables distinctes, autres que la fonction.');
  const c = k.partial?.curve;
  return { fn: fn2, vars, curve: c ? { t: c.t, g: c.g, x: c.x, y: c.y } : null };
}
var P = '\u039E\u039E\u039E';
var CODES =
  '\u0391\u0392\u0393\u0395\u0396\u0397\u0399\u039A\u039B\u039C\u039D\u039F\u03A1\u03A4\u03A5\u03A6\u03A7\u03A8\u03D8\u03DA\u03DC\u03E0';
var SEP = `${P}\u03A9`;
var SUP_DIGITS4 = '\u2070\xB9\xB2\xB3\u2074\u2075\u2076\u2077\u2078\u2079';
var isSupRun2 = (a) => a.length > 0 && [...a].every((c) => SUP_DIGITS4.includes(c));
function isPartialHeadAtom(a) {
  return /^[∂∇Δ]/.test(a) || /^[\p{L}][′″]*\(.+\)$/u.test(a);
}
function argsOf(raw) {
  return raw
    .split(/\s*[,;]\s*/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}
function kpartLineAtoms(text, spec) {
  const heads = [];
  const put = (h) => {
    let i = heads.indexOf(h);
    if (i < 0) i = heads.push(h) - 1;
    return ` ${P}${CODES[i] ?? '\u03DE'} `;
  };
  const F = esc(spec.fn);
  const V = `(${spec.vars.map(esc).join('|')})`;
  const PT = '(?:\\s*\\(([^()]*)\\))?';
  const fn2 = spec.fn;
  const vars = spec.vars;
  const point = (raw) => {
    if (raw === void 0) return '';
    const a = argsOf(raw);
    return a.length === 2 && a[0] === vars[0] && a[1] === vars[1] ? '' : `(${a.join(', ')})`;
  };
  let t = text
    .replace(/[’']{2}/g, '\u2033')
    .replace(/[’']/g, '\u2032')
    .replace(/′′/g, '\u2033');
  t = t
    .replace(
      new RegExp(`\u2202\\s*\xB2\\s*${F}\\s*/\\s*\u2202\\s*${V}\\s*\u2202\\s*${V}${PT}`, 'gu'),
      (_m, a, b, p) => put(`\u2202\xB2${fn2}/\u2202${a}\u2202${b}${point(p)}`),
    )
    .replace(
      new RegExp(`\u2202\\s*\xB2\\s*${F}\\s*/\\s*\u2202\\s*${V}\\s*\xB2${PT}`, 'gu'),
      (_m, a, p) => put(`\u2202\xB2${fn2}/\u2202${a}\xB2${point(p)}`),
    )
    .replace(new RegExp(`\u2202\\s*${F}\\s*/\\s*\u2202\\s*${V}${PT}`, 'gu'), (_m, a, p) =>
      put(`\u2202${fn2}/\u2202${a}${point(p)}`),
    )
    .replace(new RegExp(`\u2207\\s*${F}${PT}`, 'gu'), (_m, p) => put(`\u2207${fn2}${point(p)}`))
    .replace(new RegExp(`\u0394\\s*${F}${PT}`, 'gu'), (_m, p) => put(`\u0394${fn2}${point(p)}`));
  const c = spec.curve;
  if (c) {
    const T = esc(c.t);
    t = t
      .replace(new RegExp(`(?<![\\p{L}])${V}\\s*\u2032\\s*\\(\\s*${T}\\s*\\)`, 'gu'), (_m, v) =>
        put(`${v}\u2032(${c.t})`),
      )
      .replace(
        new RegExp(`(?<![\\p{L}])${esc(c.g)}\\s*(\u2033|\u2032)?\\s*\\(([^()]*)\\)`, 'gu'),
        (_m, p, a) => put(`${c.g}${p ?? ''}(${a.trim()})`),
      )
      .replace(new RegExp(`(?<![\\p{L}])${V}\\s*\\(\\s*${T}\\s*\\)`, 'gu'), (_m, v) => ` ${v} `);
  }
  t = t.replace(new RegExp(`(?<![\\p{L}])${F}\\s*\\(([^()]*)\\)`, 'gu'), (_m, a) => {
    const p = point(a);
    return put(p ? `${fn2}${p}` : `${fn2}(${vars.join(', ')})`);
  });
  t = t.replace(/\s*;\s*|,\s+/g, ` ${SEP} `);
  const out = [];
  for (const a of lex(t)) {
    const last = out[out.length - 1];
    if (isSupRun2(a) && last !== void 0 && isSupRun2(last)) {
      out[out.length - 1] = last + a;
      continue;
    }
    out.push(a);
  }
  const mapped = out.map((a) => {
    if (a === SEP) return ',';
    if (a.startsWith(P) && a.length === P.length + 1) {
      const i = CODES.indexOf(a[P.length]);
      if (i >= 0 && heads[i] !== void 0) return heads[i];
    }
    return a;
  });
  return normalize(mapped);
}
function kpartText(atoms) {
  const hs = [];
  const A = atoms.map((a) => {
    if (isPartialHeadAtom(a)) {
      hs.push(a);
      return `${P}${CODES[hs.length - 1] ?? '\u03DE'}`;
    }
    return a === ',' ? SEP : a;
  });
  let s = atomsText(A)
    .replace(/ ([⁰¹²³⁴⁵⁶⁷⁸⁹]+)/g, '$1')
    .replace(/\//g, '\xF7')
    .replace(/\s*÷\s*/g, ' \xF7 ')
    .replace(new RegExp(`\\s*${SEP}\\s*`, 'g'), ', ');
  hs.forEach((h, i) => {
    s = s.split(`${P}${CODES[i] ?? '\u03DE'}`).join(h);
  });
  return s;
}
var lineOf3 = (atoms) => ({
  dis: [{ sides: [{ k: 's', n: kpartText(atoms) }] }],
});
function kpartLine(text, spec) {
  return lineOf3(kpartLineAtoms(text, spec));
}
function caretAtoms2(atoms) {
  const out = [];
  for (const a of atoms) {
    if (isSupRun2(a) && a !== '\xB2') {
      out.push('^', [...a].map((c) => String(SUP_DIGITS4.indexOf(c))).join(''));
      continue;
    }
    out.push(a);
  }
  return out;
}
var E3 = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function withE3(t) {
  switch (t.k) {
    case 'sym':
      return t.n === 'e' ? E3 : t;
    case 'add':
    case 'mul':
      return { ...t, c: t.c.map(withE3) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...t, a: withE3(t.a), b: withE3(t.b) };
    case 'fn':
      return { ...t, a: withE3(t.a) };
    default:
      return t;
  }
}
function val3(t, env) {
  try {
    const v = evalFloat(t, env);
    return Number.isFinite(v) ? v : NaN;
  } catch {
    return NaN;
  }
}
function size2(t) {
  switch (t.k) {
    case 'num':
      return t.v.d === 1n ? 1 : 2;
    case 'sym':
      return 1;
    case 'add':
    case 'mul':
      return 1 + t.c.reduce((s, c) => s + size2(c), 0);
    case 'div':
    case 'pow':
    case 'binom':
      return 1 + size2(t.a) + size2(t.b);
    case 'fn':
      return 1 + size2(t.a);
  }
}
var near3 = (a, b) =>
  Number.isFinite(a) &&
  Number.isFinite(b) &&
  Math.abs(a - b) <= 1e-7 * Math.max(1, Math.abs(a), Math.abs(b));
function exprTerm(text) {
  const A = normalize(caretAtoms2(lex(text)));
  const line = parseLine(A, { chains: true });
  const s = line.dis[0]?.sides;
  if (!s || s.length !== 1 || line.dis.length !== 1)
    throw new PartialModelError(`\xAB ${text} \xBB`);
  return withE3(fromNode(s[0]));
}
var GRID = [
  [0.7, 1.3],
  [1.9, -0.6],
  [-1.1, 0.45],
  [2.3, 1.7],
  [-0.8, -1.4],
  [0.35, 2.2],
  [1.25, 0.9],
  [-1.7, 0.6],
  [0.55, -0.85],
];
var T_PTS = [-1.3, -0.7, -0.2, 0.3, 0.8, 1.2, 1.7, 2.1, 2.6];
function headOf(ks, a) {
  if (ks.heads.has(a)) return ks.heads.get(a);
  const h = parseHead(ks.spec, a);
  if (h) ks.heads.set(a, h);
  return h;
}
function parseHead(spec, a) {
  const fn2 = esc(spec.fn);
  const V = `(${spec.vars.map(esc).join('|')})`;
  const PT = '(?:\\(([^()]*)\\))?';
  const mk = (kind, vars, pt) => {
    const p = pt === void 0 ? void 0 : argsOf(pt);
    const base =
      kind === 'd1' || kind === 'cd'
        ? `${kind}:${vars[0]}`
        : kind === 'd2'
          ? `d2:${[...vars].sort((u, w) => spec.vars.indexOf(u) - spec.vars.indexOf(w)).join(',')}`
          : kind;
    return {
      key: p ? `${base}@${p.join(',')}` : base,
      text: a,
      kind,
      vars,
      ...(p ? { pt: p } : {}),
    };
  };
  let m;
  if (a === spec.fn || a === `${spec.fn}(${spec.vars.join(', ')})`) return mk('f', []);
  if ((m = new RegExp(`^${fn2}\\(([^()]*)\\)$`, 'u').exec(a))) return mk('f', [], m[1]);
  if ((m = new RegExp(`^\u2202\xB2${fn2}/\u2202${V}\u2202${V}${PT}$`, 'u').exec(a)))
    return mk('d2', [m[1], m[2]], m[3]);
  if ((m = new RegExp(`^\u2202\xB2${fn2}/\u2202${V}\xB2${PT}$`, 'u').exec(a)))
    return mk('d2', [m[1], m[1]], m[2]);
  if ((m = new RegExp(`^\u2202${fn2}/\u2202${V}${PT}$`, 'u').exec(a)))
    return mk('d1', [m[1]], m[2]);
  if ((m = new RegExp(`^\u2207${fn2}${PT}$`, 'u').exec(a))) return mk('grad', [], m[1]);
  if ((m = new RegExp(`^\u0394${fn2}${PT}$`, 'u').exec(a))) return mk('lap', [], m[1]);
  const c = spec.curve;
  if (c) {
    if ((m = new RegExp(`^${V}\u2032\\(${esc(c.t)}\\)$`, 'u').exec(a))) return mk('cd', [m[1]]);
    if ((m = new RegExp(`^${esc(c.g)}(\u2033|\u2032)?\\(([^()]*)\\)$`, 'u').exec(a))) {
      const kind = m[1] === '\u2033' ? 'g2' : m[1] === '\u2032' ? 'g1' : 'g';
      return m[2] === c.t ? mk(kind, []) : mk(kind, [], m[2]);
    }
  }
  return null;
}
function unpointed(ks, h) {
  const kind = h.kind;
  const key = h.key.replace(/@.*$/, '');
  const text =
    kind === 'f'
      ? ks.fn
      : kind === 'g' || kind === 'g1' || kind === 'g2'
        ? `${ks.curve.g}${kind === 'g1' ? '\u2032' : kind === 'g2' ? '\u2033' : ''}(${ks.curve.t})`
        : h.text.replace(/\([^()]*\)$/, '');
  return { key, text, kind, vars: h.vars };
}
function headTerm(ks, h) {
  if (ks.termCache.has(h.key)) return ks.termCache.get(h.key);
  let out = null;
  try {
    const [v1, v2] = ks.vars;
    const G = () => canon(substitute(ks.F, { [v1]: ks.curve.X, [v2]: ks.curve.Y }));
    let base;
    switch (h.kind) {
      case 'f':
        base = ks.F;
        break;
      case 'd1':
        base = derive(ks.F, h.vars[0]);
        break;
      case 'd2':
        base = derive(derive(ks.F, h.vars[1]), h.vars[0]);
        break;
      case 'grad':
        base = [derive(ks.F, v1), derive(ks.F, v2)];
        break;
      case 'lap':
        base = canon(add2(derive(derive(ks.F, v1), v1), derive(derive(ks.F, v2), v2)));
        break;
      case 'cd':
        base = derive(h.vars[0] === v1 ? ks.curve.X : ks.curve.Y, ks.curve.t);
        break;
      case 'g':
        base = G();
        break;
      case 'g1':
        base = derive(G(), ks.curve.t);
        break;
      case 'g2':
        base = derive(derive(G(), ks.curve.t), ks.curve.t);
        break;
    }
    if (h.pt) {
      const inT = h.kind === 'g' || h.kind === 'g1' || h.kind === 'g2';
      const names = inT ? [ks.curve.t] : ks.vars;
      if (h.pt.length !== names.length) return null;
      const sub4 = Object.fromEntries(names.map((n, i) => [n, exprTerm(h.pt[i])]));
      base = Array.isArray(base)
        ? [canon(substitute(base[0], sub4)), canon(substitute(base[1], sub4))]
        : canon(substitute(base, sub4));
    }
    out = base;
  } catch {
    out = null;
  }
  ks.termCache.set(h.key, out);
  return out;
}
function symOf(ks, h) {
  let s = ks.syms.get(h.key);
  if (!s) {
    s = `\u03A8${ks.syms.size}`;
    ks.syms.set(h.key, s);
  }
  return s;
}
function parseExpr2(ks, atoms) {
  const heads = [];
  const mapped = atoms.map((a) => {
    const h = headOf(ks, a);
    if (!h) return a;
    heads.push(h);
    return symOf(ks, h);
  });
  let line;
  try {
    line = parseLine(normalize(caretAtoms2(mapped)), { chains: true });
  } catch {
    return null;
  }
  const d2 = line.dis[0];
  if (line.dis.length !== 1 || !d2 || d2.cmp || d2.rels || d2.sides.length !== 1) return null;
  try {
    return { S: withE3(fromNode(d2.sides[0])), heads };
  } catch {
    return null;
  }
}
function valueOf(ks, S, heads) {
  const sub4 = {};
  for (const h of heads) {
    const v = headTerm(ks, h);
    if (!v || Array.isArray(v)) return null;
    sub4[symOf(ks, h)] = v;
  }
  try {
    return canon(substitute(S, sub4));
  } catch {
    return null;
  }
}
function readSide(ks, atoms) {
  if (!atoms.length) return 'incomplete';
  let depth = 0;
  const top = [];
  for (let i = 0; i < atoms.length; i++) {
    const a = atoms[i];
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth < 0) return 'incomplete';
    if (a === ',') {
      if (depth !== 1) return { err: 'couple' };
      top.push(i);
    }
  }
  if (depth !== 0) return 'incomplete';
  const vars = new Set(ks.vars);
  if (top.length) {
    if (top.length !== 1 || atoms[0] !== '(' || atoms[atoms.length - 1] !== ')')
      return { err: 'couple' };
    let d2 = 0;
    for (let i = 0; i < atoms.length - 1; i++) {
      if (atoms[i] === '(') d2++;
      if (atoms[i] === ')') d2--;
      if (d2 === 0) return { err: 'couple' };
    }
    const p1 = atoms.slice(1, top[0]);
    const p2 = atoms.slice(top[0] + 1, atoms.length - 1);
    if (!p1.length || !p2.length) return 'incomplete';
    const e1 = parseExpr2(ks, p1);
    const e2 = parseExpr2(ks, p2);
    if (!e1 || !e2) return 'incomplete';
    const heads = [...e1.heads, ...e2.heads];
    if (heads.some((h) => h.kind === 'grad')) return { err: 'grad' };
    const t1 = valueOf(ks, e1.S, e1.heads);
    const t2 = valueOf(ks, e2.S, e2.heads);
    if (!t1 || !t2) return { err: 'read' };
    const sy = /* @__PURE__ */ new Set([...symbolsOf(e1.S), ...symbolsOf(e2.S)]);
    return {
      atoms,
      heads,
      S: null,
      T: null,
      couple: [t1, t2],
      single: null,
      size: size2(e1.S) + size2(e2.S),
      hasVars: [...sy].some((s) => vars.has(s)),
      hasT: !!ks.curve && sy.has(ks.curve.t),
    };
  }
  const e = parseExpr2(ks, atoms);
  if (!e) return 'incomplete';
  const single2 = atoms.length === 1 ? (e.heads[0] ?? null) : null;
  if (e.heads.some((h) => h.kind === 'grad')) {
    if (!single2) return { err: 'grad' };
    const v = headTerm(ks, single2);
    if (!v || !Array.isArray(v)) return { err: 'read' };
    return {
      atoms,
      heads: e.heads,
      S: e.S,
      T: null,
      couple: v,
      single: single2,
      size: 1,
      hasVars: false,
      hasT: false,
    };
  }
  const T = valueOf(ks, e.S, e.heads);
  if (!T) return { err: 'read' };
  return {
    atoms,
    heads: e.heads,
    S: e.S,
    T,
    couple: null,
    single: single2,
    size: size2(e.S),
    hasVars: [...symbolsOf(e.S)].some((s) => vars.has(s)),
    hasT: !!ks.curve && symbolsOf(e.S).has(ks.curve.t),
  };
}
function readAtoms2(ks, A) {
  const cut = [];
  let depth = 0;
  A.forEach((a, i) => {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (a === '=' && depth === 0) cut.push(i);
  });
  if (!cut.length) return { k: 'incomplete' };
  if (cut.length > 1)
    return {
      k: 'syntax',
      title: 'Une \xE9galit\xE9',
      message: `\xC9cris une \xE9galit\xE9 par ligne : \xAB \u2202${ks.fn}/\u2202${ks.vars[0]} = \u2026 \xBB.`,
    };
  const l = readSide(ks, A.slice(0, cut[0]));
  const r = readSide(ks, A.slice(cut[0] + 1));
  if (l === 'incomplete' || r === 'incomplete') return { k: 'incomplete' };
  for (const s of [l, r])
    if ('err' in s) {
      if (s.err === 'couple')
        return {
          k: 'syntax',
          title: 'Un couple',
          message: '\xC9cris un couple entre parenth\xE8ses : \xAB (\u2026, \u2026) \xBB.',
        };
      if (s.err === 'grad')
        return {
          k: 'syntax',
          title: 'Le gradient est un couple',
          message: `\xC9cris \xAB \u2207${ks.fn} = (\u2026, \u2026) \xBB.`,
        };
      return {
        k: 'syntax',
        title: '\xC7a ne se lit pas',
        message: 'V\xE9rifie l\u2019\xE9criture de ta ligne.',
      };
    }
  return { k: 'eq', sides: [l, r] };
}
function envsFor(ks, sides) {
  if (!ks.curve) return ks.grid;
  const t = ks.curve.t;
  const usesT = sides.some(
    (s) =>
      s.heads.some((h) => ['cd', 'g', 'g1', 'g2'].includes(h.kind)) ||
      (s.T ? symbolsOf(s.T).has(t) : false) ||
      (s.couple ? s.couple.some((c) => symbolsOf(c).has(t)) : false),
  );
  return usesT ? ks.tEnvs : ks.grid;
}
function valsOf(T, envs) {
  return envs.map((e) => val3(T, e));
}
function sameVals(a, b) {
  let n = 0;
  for (let i = 0; i < a.length; i++) {
    const fa = Number.isFinite(a[i]);
    const fb = Number.isFinite(b[i]);
    if (fa !== fb) return false;
    if (!fa) continue;
    if (!near3(a[i], b[i])) return false;
    n++;
  }
  return n >= 4;
}
function strangerOf(ks, sides) {
  const ok = /* @__PURE__ */ new Set([...ks.vars, '\u03C0', ...(ks.curve ? [ks.curve.t] : [])]);
  for (const s of sides)
    for (const t of s.couple ?? (s.T ? [s.T] : []))
      for (const n of symbolsOf(t)) if (!ok.has(n)) return n;
  return null;
}
function truthOf(ks, L, R) {
  if (!!L.couple !== !!R.couple) return 'shape';
  const envs = envsFor(ks, [L, R]);
  if (L.couple && R.couple)
    return sameVals(valsOf(L.couple[0], envs), valsOf(R.couple[0], envs)) &&
      sameVals(valsOf(L.couple[1], envs), valsOf(R.couple[1], envs))
      ? 'eq'
      : 'neq';
  return sameVals(valsOf(L.T, envs), valsOf(R.T, envs)) ? 'eq' : 'neq';
}
function sideIs(ks, R, T) {
  if (!T || !R.T) return false;
  const envs = envsFor(ks, [R]);
  return sameVals(valsOf(R.T, envs), valsOf(T, envs));
}
function createKPartState(model) {
  const spec = model.kernel;
  const ps = partialSpecOf(model);
  const ks = {
    model,
    spec: ps,
    fn: ps.fn,
    vars: ps.vars,
    F: { k: 'num', v: { n: 0n, d: 1n } },
    Fsize: 0,
    curve: null,
    grid: [],
    tEnvs: [],
    target: { key: '', text: '' },
    answer: { size: 0, heads: 0, text: '' },
    facts: /* @__PURE__ */ new Map(),
    written: /* @__PURE__ */ new Set(),
    givenTexts: /* @__PURE__ */ new Set(),
    path: spec.path ?? [],
    traps: [],
    heads: /* @__PURE__ */ new Map(),
    syms: /* @__PURE__ */ new Map(),
    termCache: /* @__PURE__ */ new Map(),
    lines: 0,
    concluded: false,
  };
  const startA = kpartLineAtoms(spec.start, ps);
  const eq2 = startA.indexOf('=');
  const rhs = parseExpr2(ks, startA.slice(eq2 + 1));
  if (eq2 !== 1 || !rhs || rhs.heads.length)
    throw new PartialModelError(
      `Le d\xE9part est \xAB f(x, y) = expression \xBB : \xAB ${spec.start} \xBB.`,
    );
  ks.F = canon(rhs.S);
  ks.Fsize = size2(rhs.S);
  for (const s of symbolsOf(ks.F))
    if (!ks.vars.includes(s) && s !== '\u03C0')
      throw new PartialModelError(`La fonction n\u2019a que les variables ${ks.vars.join(', ')}.`);
  if (ps.curve) {
    if (ks.vars[0] !== 'x' || ks.vars[1] !== 'y')
      throw new PartialModelError('Le long d\u2019une courbe, les variables sont x et y.');
    const t = ps.curve.t;
    if ([ks.fn, ...ks.vars, 'e', 'i'].includes(t) || ps.curve.g === ks.fn)
      throw new PartialModelError('La variable t et la fonction g ont d\u2019autres lettres.');
    const X = exprTerm(ps.curve.x);
    const Y = exprTerm(ps.curve.y);
    for (const s of [...symbolsOf(X), ...symbolsOf(Y)])
      if (s !== t && s !== '\u03C0')
        throw new PartialModelError('La courbe ne d\xE9pend que de t.');
    ks.curve = { t, g: ps.curve.g, X, Y };
    ks.tEnvs = T_PTS.map((s) => ({ [t]: s, x: val3(X, { [t]: s }), y: val3(Y, { [t]: s }) }));
  }
  ks.grid = GRID.map(([a, b]) => ({ [ks.vars[0]]: a, [ks.vars[1]]: b }));
  const tgtA = kpartLineAtoms(spec.goal.target, ps);
  const tgt = readSide(ks, tgtA);
  if (tgt === 'incomplete' || 'err' in tgt || !tgt.heads.length)
    throw new PartialModelError(
      `La question est une d\xE9riv\xE9e : \xAB ${spec.goal.target} \xBB.`,
    );
  ks.target = { key: sideKey(ks, tgt), text: kpartText(tgtA) };
  const ansA = kpartLineAtoms(spec.answer, ps);
  const ar = readAtoms2(ks, ansA);
  if (ar.k !== 'eq')
    throw new PartialModelError(`La r\xE9ponse est une \xE9galit\xE9 : \xAB ${spec.answer} \xBB.`);
  const [L, R] = ar.sides;
  if (sideKey(ks, L) !== ks.target.key)
    throw new PartialModelError('La r\xE9ponse commence par la question.');
  if (strangerOf(ks, [L, R]))
    throw new PartialModelError('Une lettre inconnue dans la r\xE9ponse.');
  if (truthOf(ks, L, R) !== 'eq') throw new PartialModelError('La r\xE9ponse est fausse.');
  ks.answer = { size: R.size, heads: R.heads.length, text: kpartText(ansA) };
  ks.givenTexts = new Set(partialGivenTexts(model).map((t) => kpartText(kpartLineAtoms(t, ps))));
  ks.traps = (model.traps ?? []).map((t) => ({
    text: kpartText(kpartLineAtoms(t.line, ps)),
    line: kpartLine(t.line, ps),
    title: t.title ?? 'Attention',
    why: t.why,
  }));
  return ks;
}
function partialGivenTexts(model) {
  const k = model.kernel;
  const c = k.partial?.curve;
  if (!c) return [k.start];
  const ps = partialSpecOf(model);
  return [
    k.start,
    `${ps.vars[0]} = ${c.x}`,
    `${ps.vars[1]} = ${c.y}`,
    `${c.g}(${c.t}) = ${ps.fn}(${ps.vars.join(', ')})`,
  ];
}
function sideKey(ks, s) {
  if (s.single) return `h:${s.single.key}`;
  try {
    return `e:${termKey(canon(s.S))}`;
  } catch {
    return `t:${kpartText(s.atoms)}`;
  }
}
function stepVerdict3(base, kind, omove, final, label, why) {
  const s = STEP4[kind];
  return {
    kind: 'step',
    ...base,
    hora: s.hora,
    final,
    rule: {
      id: PARTIAL_STEP_IDS[kind],
      card: CARD4,
      label: label ?? s.label,
      hora: s.hora,
      why: (why ?? s.why) + (final ? ' C\u2019est la r\xE9ponse.' : ''),
    },
    omove: { ...omove, ...(final ? { final } : {}) },
  };
}
function jumpVerdict3(base, omove, final, message) {
  return {
    kind: 'useless',
    ...base,
    jump: true,
    final,
    title: final ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      message ??
      (final
        ? 'C\u2019est la r\xE9ponse. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    omove: { ...omove, ...(final ? { final } : {}) },
  };
}
function useless2(base, title, message, omove) {
  return { kind: 'useless', ...base, title, message, ...(omove ? { omove } : {}) };
}
function falseVerdict(base, title, message) {
  return { kind: 'false', ...base, title, message };
}
var known = (ks, key) => ks.facts.has(`h:${key}`);
function knownPrefix3(ks, A) {
  return ks.path.some((t) => {
    let atoms;
    try {
      atoms = kpartLineAtoms(t, ks.spec);
    } catch {
      return false;
    }
    return atoms.length > A.length && A.every((a, i) => atoms[i] === a);
  });
}
function kpartJudge(ks, chips, opts) {
  const A = normalize(chips.flatMap((c) => c.atoms));
  if (!A.length) return { kind: 'empty', atoms: A, badChip: -1 };
  const prefix = knownPrefix3(ks, A);
  const incomplete = () =>
    opts?.verify
      ? { kind: 'syntax', atoms: A, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
      : { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  const r = readAtoms2(ks, A);
  if (r.k === 'incomplete') return incomplete();
  if (r.k === 'syntax') {
    if (prefix && !opts?.verify) return { kind: 'building', atoms: A, complete: false };
    return { kind: 'syntax', atoms: A, line: lineOf3(A), title: r.title, message: r.message };
  }
  const base = { atoms: A, line: lineOf3(A) };
  let v;
  try {
    v = judgeRead2(ks, base, r.sides[0], r.sides[1]);
  } catch {
    v = {
      kind: 'syntax',
      ...base,
      title: '\xC7a ne se lit pas',
      message: 'Cette ligne ne se lit pas : v\xE9rifie l\u2019\xE9criture.',
    };
  }
  if (prefix && !opts?.verify) {
    if (v.kind === 'step') return { ...v, kind: 'ready', complete: true };
    return { kind: 'building', atoms: A, complete: true };
  }
  if (!opts?.verify && (v.kind === 'unjustified' || v.kind === 'false'))
    return { kind: 'pending', atoms: A, complete: true };
  return { ...v, complete: true };
}
function judgeRead2(ks, base, L, R) {
  const text = kpartText(base.atoms);
  if (ks.givenTexts.has(text))
    return useless2(
      base,
      'C\u2019est l\u2019\xE9nonc\xE9',
      'Cette ligne est dans l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
    );
  if (ks.written.has(text))
    return useless2(
      base,
      'D\xE9j\xE0 \xE9crit',
      'Tu as d\xE9j\xE0 \xE9crit cette ligne : \xE9cris l\u2019\xE9tape suivante.',
    );
  const trap = ks.traps.find((t) => t.text === text);
  if (trap)
    return {
      kind: 'trap',
      ...base,
      title: trap.title,
      message: trap.why,
      trap: { line: trap.line, title: trap.title, why: trap.why },
    };
  if (!L.heads.length)
    return {
      kind: 'syntax',
      ...base,
      title: 'Ce que tu calcules',
      message: `Commence ta ligne par ce que tu calcules : \xAB \u2202${ks.fn}/\u2202${ks.vars[0]} = \u2026 \xBB.`,
    };
  const st = strangerOf(ks, [L, R]);
  if (st)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une lettre inconnue',
      message: `Que vaut ${st} ? Les variables sont ${ks.vars.join(' et ')}${ks.curve ? `, et ${ks.curve.t}` : ''}.`,
    };
  const truth = truthOf(ks, L, R);
  if (truth !== 'eq') return diagnose2(ks, base, L, R, truth);
  const key = sideKey(ks, L);
  const final =
    key === ks.target.key && R.size <= ks.answer.size && R.heads.length <= ks.answer.heads;
  const omove = {
    text,
    key,
    size: R.size,
    heads: R.heads.map((h) => h.key),
    vars: R.hasVars,
  };
  const prev = ks.facts.get(key);
  if (prev) return repeatVerdict(ks, base, R, prev, omove, final);
  return firstVerdict(ks, base, L, R, omove, final);
}
function firstVerdict(ks, base, L, R, omove, final) {
  const h = L.single;
  const fn2 = ks.fn;
  const missing = (keys, texts) => {
    const i = keys.findIndex((k) => !known(ks, k));
    return i < 0 ? null : texts[i];
  };
  if (!h) {
    if (R.heads.length) return jumpVerdict3(base, omove, final);
    const need = L.heads.filter((x) => x.kind !== 'f' && !known(ks, x.key));
    if (need.length)
      return jumpVerdict3(
        base,
        omove,
        final,
        `\xC9cris d\u2019abord \xAB ${need[0].text} = \u2026 \xBB.`,
      );
    return stepVerdict3(
      base,
      'substitute',
      omove,
      final,
      'Remplacer',
      'On remplace chaque d\xE9riv\xE9e par son expression.',
    );
  }
  if (h.pt) {
    const b = unpointed(ks, h);
    if (R.heads.length) return jumpVerdict3(base, omove, final);
    const label =
      h.kind === 'f'
        ? `Calculer ${fn2}(${h.pt.join(', ')})`
        : h.kind === 'g' || h.kind === 'g1' || h.kind === 'g2'
          ? `Calculer en ${ks.curve.t} = ${h.pt[0]}`
          : `Calculer en (${h.pt.join(', ')})`;
    if (b.kind === 'f' || known(ks, b.key)) return stepVerdict3(base, 'point', omove, final, label);
    return jumpVerdict3(base, omove, final, `\xC9cris d\u2019abord \xAB ${b.text} = \u2026 \xBB.`);
  }
  const [v1, v2] = ks.vars;
  const d1 = (v) => `\u2202${fn2}/\u2202${v}`;
  switch (h.kind) {
    case 'f':
      if (R.heads.length || R.size >= ks.Fsize)
        return useless2(
          base,
          'Rien de nouveau',
          'C\u2019est la fonction de l\u2019\xE9nonc\xE9 : \xE9cris l\u2019\xE9tape suivante.',
        );
      return stepVerdict3(base, 'simplify', omove, final, `Simplifier ${fn2}`);
    case 'd1': {
      if (R.heads.length)
        return useless2(
          base,
          '\xC9cris l\u2019expression',
          `\xC9cris ${h.text} avec ${v1} et ${v2}.`,
        );
      const v = h.vars[0];
      const w = v === v1 ? v2 : v1;
      return stepVerdict3(
        base,
        'first',
        omove,
        final,
        `D\xE9river par rapport \xE0 ${v}`,
        `On d\xE9rive par rapport \xE0 ${v} : ${w} est une constante.`,
      );
    }
    case 'd2': {
      if (R.heads.length)
        return useless2(
          base,
          '\xC9cris l\u2019expression',
          `\xC9cris ${h.text} avec ${v1} et ${v2}.`,
        );
      const [a, b] = h.vars;
      if (known(ks, `d1:${b}`))
        return stepVerdict3(
          base,
          'second',
          omove,
          final,
          `D\xE9river ${d1(b)} par rapport \xE0 ${a}`,
        );
      if (a !== b && known(ks, `d1:${a}`))
        return stepVerdict3(
          base,
          'second',
          omove,
          final,
          `D\xE9river ${d1(a)} par rapport \xE0 ${b}`,
          'Une d\xE9riv\xE9e crois\xE9e : l\u2019ordre des d\xE9rivations ne change rien (th\xE9or\xE8me de Schwarz).',
        );
      return jumpVerdict3(
        base,
        omove,
        final,
        `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${d1(b)} = \u2026 \xBB, puis d\xE9rive-la : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
      );
    }
    case 'grad': {
      if (R.heads.length)
        return stepVerdict3(
          base,
          'gradient',
          omove,
          final,
          'Gradient',
          'Le gradient est le couple des d\xE9riv\xE9es partielles.',
        );
      const m = missing([`d1:${v1}`, `d1:${v2}`], [d1(v1), d1(v2)]);
      if (m)
        return jumpVerdict3(
          base,
          omove,
          final,
          `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${m} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
        );
      return stepVerdict3(base, 'gradient', omove, final);
    }
    case 'lap': {
      if (R.heads.length) return stepVerdict3(base, 'laplacian', omove, final);
      const m = missing(
        [`d2:${v1},${v1}`, `d2:${v2},${v2}`],
        [`\u2202\xB2${fn2}/\u2202${v1}\xB2`, `\u2202\xB2${fn2}/\u2202${v2}\xB2`],
      );
      if (m)
        return jumpVerdict3(
          base,
          omove,
          final,
          `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${m} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
        );
      return stepVerdict3(base, 'laplacian', omove, final);
    }
    case 'cd': {
      const v = h.vars[0];
      return stepVerdict3(base, 'curve', omove, final, `D\xE9river ${v}(${ks.curve.t})`);
    }
    case 'g':
      if (R.heads.length) return jumpVerdict3(base, omove, final);
      return stepVerdict3(base, 'compose', omove, final);
    case 'g1': {
      const c = ks.curve;
      if (R.heads.some((x) => x.kind === 'd1')) return stepVerdict3(base, 'chain', omove, final);
      if (known(ks, 'g'))
        return stepVerdict3(base, 'derive', omove, final, `D\xE9river ${c.g}(${c.t})`);
      const m = missing(
        [`d1:${v1}`, `d1:${v2}`, `cd:${v1}`, `cd:${v2}`],
        [d1(v1), d1(v2), `${v1}\u2032(${c.t})`, `${v2}\u2032(${c.t})`],
      );
      if (!m) return stepVerdict3(base, 'chain', omove, final);
      return jumpVerdict3(
        base,
        omove,
        final,
        `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${m} = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
      );
    }
    case 'g2': {
      const c = ks.curve;
      if (known(ks, 'g1'))
        return stepVerdict3(base, 'derive', omove, final, `D\xE9river ${c.g}\u2032(${c.t})`);
      return jumpVerdict3(
        base,
        omove,
        final,
        `Ta ligne est juste. \xC9cris d\u2019abord \xAB ${c.g}\u2032(${c.t}) = \u2026 \xBB : tu gagneras des HORA. Tu peux garder cette ligne sans HORA.`,
      );
    }
  }
}
function repeatVerdict(ks, base, R, prev, omove, final) {
  const now = new Set(omove.heads);
  if (R.heads.length < prev.heads.length) {
    const gone = prev.heads.filter((k) => !now.has(k));
    const need = gone.filter((k) => !k.startsWith('f') && !known(ks, k));
    if (need.length) return jumpVerdict3(base, omove, final);
    return stepVerdict3(
      base,
      'substitute',
      omove,
      final,
      'Remplacer',
      'On remplace chaque d\xE9riv\xE9e par son expression.',
    );
  }
  if (ks.curve && prev.vars && !R.hasVars && R.hasT && R.heads.length <= prev.heads.length)
    return stepVerdict3(
      base,
      'substitute',
      omove,
      final,
      `Remplacer ${ks.vars[0]} et ${ks.vars[1]}`,
      `On remplace ${ks.vars[0]} et ${ks.vars[1]} par leurs expressions en ${ks.curve.t}.`,
    );
  if (R.size < prev.size) {
    const recog = omove.heads.includes('f') && !prev.heads.includes('f');
    return stepVerdict3(
      base,
      'compute',
      omove,
      final,
      recog ? `Reconna\xEEtre ${ks.fn}` : 'Calculer',
      recog ? `On reconna\xEEt l\u2019expression de ${ks.fn}.` : 'Un calcul.',
    );
  }
  if (final) return stepVerdict3(base, 'compute', omove, final);
  return useless2(
    base,
    'Juste, mais \xE7a ne t\u2019avance pas',
    'Ta ligne est juste, mais elle n\u2019avance pas le calcul : simplifie, ou \xE9cris l\u2019\xE9tape suivante.',
  );
}
function diagnose2(ks, base, L, R, truth) {
  const h = L.single;
  const fn2 = ks.fn;
  const [v1, v2] = ks.vars;
  if (truth === 'shape') {
    if (L.couple)
      return falseVerdict(
        base,
        'Le gradient est un couple',
        `Le gradient a deux coordonn\xE9es : \xAB \u2207${fn2} = (\u2202${fn2}/\u2202${v1}, \u2202${fn2}/\u2202${v2}) \xBB.`,
      );
    return falseVerdict(
      base,
      'Pas un couple',
      'Ici, on attend un nombre ou une expression, pas un couple.',
    );
  }
  if (h && h.kind === 'grad' && L.couple && R.couple) {
    const envs = envsFor(ks, [L, R]);
    const a0 = valsOf(L.couple[0], envs);
    const a1 = valsOf(L.couple[1], envs);
    const b0 = valsOf(R.couple[0], envs);
    const b1 = valsOf(R.couple[1], envs);
    if (sameVals(a0, b1) && sameVals(a1, b0))
      return falseVerdict(
        base,
        'Dans l\u2019ordre',
        `Le gradient s\u2019\xE9crit (\u2202${fn2}/\u2202${v1}, \u2202${fn2}/\u2202${v2}) : la d\xE9riv\xE9e par rapport \xE0 ${v1} d\u2019abord.`,
      );
    if (!sameVals(a0, b0))
      return falseVerdict(
        base,
        'La premi\xE8re coordonn\xE9e',
        `La premi\xE8re coordonn\xE9e est \u2202${fn2}/\u2202${v1} : elle ne va pas.`,
      );
    return falseVerdict(
      base,
      'La seconde coordonn\xE9e',
      `La seconde coordonn\xE9e est \u2202${fn2}/\u2202${v2} : elle ne va pas.`,
    );
  }
  if (h && !h.pt) {
    const term = (k, vars) => {
      const t = headTerm(ks, { key: `${k}:${vars.join(',')}`, text: '', kind: k, vars });
      return t && !Array.isArray(t) ? t : null;
    };
    if (h.kind === 'd1') {
      const v = h.vars[0];
      const w = v === v1 ? v2 : v1;
      if (sideIs(ks, R, term('d1', [w])))
        return falseVerdict(
          base,
          'Pas la bonne variable',
          `Tu as d\xE9riv\xE9 par rapport \xE0 ${w}. Pour \u2202${fn2}/\u2202${v}, on d\xE9rive par rapport \xE0 ${v} : ${w} est une constante.`,
        );
      if (sideIs(ks, R, ks.F))
        return falseVerdict(
          base,
          'Tu n\u2019as pas d\xE9riv\xE9',
          `C\u2019est ${fn2} elle-m\xEAme : d\xE9rive-la par rapport \xE0 ${v}.`,
        );
      return falseVerdict(
        base,
        'Pas la bonne d\xE9riv\xE9e',
        `D\xE9rive par rapport \xE0 ${v} en gardant ${w} constant.`,
      );
    }
    if (h.kind === 'd2') {
      const [a, b] = h.vars;
      if (sideIs(ks, R, term('d1', [b])) || sideIs(ks, R, term('d1', [a])))
        return falseVerdict(
          base,
          'D\xE9rive deux fois',
          `C\u2019est une d\xE9riv\xE9e premi\xE8re : d\xE9rive-la encore une fois${a === b ? ` par rapport \xE0 ${a}` : ''}.`,
        );
      if (a !== b && (sideIs(ks, R, term('d2', [a, a])) || sideIs(ks, R, term('d2', [b, b]))))
        return falseVerdict(
          base,
          'Une fois par rapport \xE0 chaque variable',
          `\u2202\xB2${fn2}/\u2202${a}\u2202${b} : on d\xE9rive une fois par rapport \xE0 ${b}, puis une fois par rapport \xE0 ${a}.`,
        );
      return falseVerdict(
        base,
        'Pas la bonne d\xE9riv\xE9e seconde',
        'V\xE9rifie chacune des deux d\xE9rivations.',
      );
    }
    if (h.kind === 'lap')
      return falseVerdict(
        base,
        'Pas le laplacien',
        `\u0394${fn2} = \u2202\xB2${fn2}/\u2202${v1}\xB2 + \u2202\xB2${fn2}/\u2202${v2}\xB2 : v\xE9rifie les deux d\xE9riv\xE9es secondes.`,
      );
    if (h.kind === 'f')
      return falseVerdict(
        base,
        'Ce n\u2019est pas \xE9gal',
        `Ce n\u2019est pas la fonction ${fn2} de l\u2019\xE9nonc\xE9.`,
      );
    if (h.kind === 'cd')
      return falseVerdict(
        base,
        'Pas la bonne d\xE9riv\xE9e',
        `D\xE9rive ${h.vars[0]}(${ks.curve.t}) par rapport \xE0 ${ks.curve.t}.`,
      );
    if (h.kind === 'g')
      return falseVerdict(
        base,
        `Ce n\u2019est pas ${ks.curve.g}(${ks.curve.t})`,
        `${ks.curve.g}(${ks.curve.t}) = ${fn2}(${v1}, ${v2}) : remplace ${v1} et ${v2} par leurs expressions en ${ks.curve.t}.`,
      );
    if (h.kind === 'g1' && R.heads.some((x) => x.kind === 'd1' || x.kind === 'cd'))
      return falseVerdict(
        base,
        'La r\xE8gle de la cha\xEEne',
        `${ks.curve.g}\u2032(${ks.curve.t}) = ${v1}\u2032(${ks.curve.t}) \xD7 \u2202${fn2}/\u2202${v1} + ${v2}\u2032(${ks.curve.t}) \xD7 \u2202${fn2}/\u2202${v2}.`,
      );
    if (h.kind === 'g1' || h.kind === 'g2')
      return falseVerdict(base, 'Pas la bonne d\xE9riv\xE9e', 'V\xE9rifie ta d\xE9rivation.');
  }
  if (h && h.pt)
    return falseVerdict(
      base,
      'Pas la bonne valeur',
      h.kind === 'g' || h.kind === 'g1' || h.kind === 'g2'
        ? `Remplace ${ks.curve.t} par ${h.pt[0]}, puis calcule.`
        : `Remplace ${v1} et ${v2} par les coordonn\xE9es du point, puis calcule.`,
    );
  return falseVerdict(
    base,
    'Ce n\u2019est pas \xE9gal',
    'Les deux membres de ta ligne ne sont pas \xE9gaux.',
  );
}
function kpartCommit(ks, v) {
  const m = v.omove;
  if (!m) return;
  ks.written.add(m.text);
  ks.lines++;
  ks.facts.set(m.key, { size: m.size, heads: m.heads, vars: m.vars });
  if (m.final) ks.concluded = true;
}
function kpartGoalReached(ks) {
  return ks.concluded;
}
function readText2(ks, text) {
  try {
    return readAtoms2(ks, kpartLineAtoms(text, ks.spec));
  } catch {
    return null;
  }
}
function kpartIsAnswer(ks, text) {
  const r = readText2(ks, text);
  if (!r || r.k !== 'eq') return false;
  const [L, R] = r.sides;
  if (sideKey(ks, L) !== ks.target.key || strangerOf(ks, [L, R])) return false;
  return truthOf(ks, L, R) === 'eq';
}

// packages/reasoner/src/kernel-riemann.ts
var RIEMANN_STEP_IDS = {
  rewrite: 'riemann.rewrite@1',
  reindex: 'riemann.reindex@1',
  logPower: 'riemann.log_power@1',
  logProduct: 'riemann.log_product@1',
  riemann: 'riemann.riemann@1',
  conclude: 'riemann.conclude@1',
  compose: 'riemann.compose@1',
  compute: 'kernel.compute@1',
};
var STEP5 = {
  rewrite: {
    label: 'Faire appara\xEEtre f(k \xF7 n)',
    hora: 1,
    why: 'On met 1 \xF7 n en facteur et on \xE9crit ce qu\u2019on additionne comme une fonction de k \xF7 n : (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
  },
  reindex: {
    label: 'Changer d\u2019indice',
    hora: 1,
    why: 'On renomme l\u2019indice (j = k \u2212 n\u2026) : les m\xEAmes termes, additionn\xE9s autrement.',
  },
  logPower: {
    label: 'Logarithme d\u2019une puissance',
    hora: 1,
    why: 'ln(a\u1D47) = b \xD7 ln(a).',
  },
  logProduct: {
    label: 'Logarithme d\u2019un produit',
    hora: 1,
    why: 'Le logarithme d\u2019un produit est la somme des logarithmes : le produit devient une somme.',
  },
  riemann: {
    label: 'Somme de Riemann',
    hora: 2,
    why: 'Si f est continue sur [a ; b], (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n), pour k \xF7 n allant de a \xE0 b, tend vers \u222B(a ; b) f(x) dx.',
  },
  conclude: {
    label: 'Conclure',
    hora: 1,
    why: 'La suite tend vers l\u2019int\xE9grale, et l\u2019int\xE9grale est calcul\xE9e.',
  },
  compose: {
    label: 'Composer par exp',
    hora: 1,
    why: 'exp est continue : si ln(u\u2099) tend vers \u2113, u\u2099 = exp(ln(u\u2099)) tend vers exp(\u2113).',
  },
  compute: {
    label: 'Calculer',
    hora: 1,
    why: 'On calcule la valeur de la limite.',
  },
};
var CARD5 = 'Sommes de Riemann';
var ARROW = '\u2192';
var RiemannModelError = class extends Error {};
var SUM_RE = /^([ΣΠ])\(([a-z]) = (.+) ; (.+)\)$/;
var NAME_RE2 = /^([uv])(′?)\(([a-zθ])\)$/;
var isSumAtom = (a) => !!a && SUM_RE.test(a);
function boundText2(s) {
  return atomsText(normalize(lex(s.trim())))
    .replace(/\//g, ' \xF7 ')
    .replace(/\s*÷\s*/g, ' \xF7 ')
    .replace(/(\d) × (?=[a-zα-ω])/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}
function sumAtom(sign2, k, lo, hi) {
  return `${sign2}(${k} = ${boundText2(lo)} ; ${boundText2(hi)})`;
}
function group2(text, open) {
  let depth = 0;
  for (let i = open; i < text.length; i++) {
    const c = text[i];
    if (c === '(') depth++;
    else if (c === ')') {
      depth--;
      if (depth === 0) return { inner: text.slice(open + 1, i), end: i + 1 };
    }
  }
  return null;
}
function splitBounds2(inner2) {
  let depth = 0;
  for (let i = 0; i < inner2.length; i++) {
    const c = inner2[i];
    if (c === '(') depth++;
    else if (c === ')') depth--;
    else if (c === ';' && depth === 0) return [inner2.slice(0, i), inner2.slice(i + 1)];
  }
  return null;
}
var endsOp2 = (a) =>
  isOperand(a) || a === ')' || a === '\xB2' || isSupPow(a) || a === '!' || isPow(a);
var startsOp2 = (a) =>
  isVar(a) || isConst(a) || isFunc(a) || a === '(' || a === '\u221A' || isNum(a);
function kriemNormalize(atoms) {
  const out = [];
  const src = [];
  atoms.forEach((a, i) => {
    const p = out[out.length - 1];
    if (p !== void 0 && p !== '\xD7') {
      const pOpen = isIntegralAtom(p) || p === '[' || isSumAtom(p);
      const pCloses = isBracketClose(p) || isDiffAtom(p);
      let times = false;
      if (isIntegralAtom(a) || a === '[' || isSumAtom(a)) times = !pOpen && (pCloses || endsOp2(p));
      else if (isBracketClose(a) || isDiffAtom(a)) times = false;
      else if (pCloses) times = startsOp2(a) || isNum(a);
      else if (!pOpen) times = endsOp2(p) && startsOp2(a) && !isNum(a);
      if (times) {
        out.push('\xD7');
        src.push(i);
      }
    }
    out.push(a);
    src.push(i);
  });
  return { atoms: out, src };
}
function kriemLineAtoms(text) {
  const t = String(text).replace(/->/g, ARROW);
  const out = [];
  let buf = '';
  const flush = () => {
    if (buf.trim()) out.push(...kintLineAtoms(buf));
    buf = '';
  };
  for (let i = 0; i < t.length; ) {
    const c = t[i];
    if ((c === '\u03A3' || c === '\u03A0') && t[i + 1] === '(') {
      const g = group2(t, i + 1);
      const b = g && splitBounds2(g.inner);
      const m = b && /^\s*([a-z])\s*=\s*(.+)$/.exec(b[0]);
      if (g && b && m) {
        flush();
        out.push(sumAtom(c, m[1], m[2], b[1]));
        i = g.end;
        continue;
      }
    }
    if (c === ARROW) {
      flush();
      out.push(ARROW);
      i++;
      continue;
    }
    buf += c;
    i++;
  }
  flush();
  return kriemNormalize(out).atoms;
}
function kriemText(atoms) {
  const side = (A) => {
    const parts = [];
    let run = [];
    const flush = () => {
      if (run.length) parts.push(kintText(run));
      run = [];
    };
    for (const a of A) {
      if (isSumAtom(a)) {
        flush();
        parts.push(a);
      } else run.push(a);
    }
    flush();
    return parts.join(' ').replace(/\s+/g, ' ').trim();
  };
  const i = atoms.indexOf(ARROW);
  if (i < 0) return side(atoms);
  const l = side(atoms.slice(0, i));
  const r = side(atoms.slice(i + 1));
  return `${l ? l + ' ' : ''}${ARROW}${r ? ' ' + r : ''}`;
}
var lineOf4 = (atoms) => ({
  dis: [{ sides: [{ k: 's', n: kriemText(atoms) }] }],
});
var chipsOf = (atoms) => atoms.map((a) => ({ atoms: [a], text: a }));
function kriemLine(text) {
  return lineOf4(kriemLineAtoms(text));
}
var E4 = { k: 'fn', f: 'exp', a: { k: 'num', v: { n: 1n, d: 1n } } };
function withE4(t) {
  switch (t.k) {
    case 'sym':
      return t.n === 'e' ? E4 : t;
    case 'add':
    case 'mul':
      return { ...t, c: t.c.map(withE4) };
    case 'div':
    case 'pow':
    case 'binom':
      return { ...t, a: withE4(t.a), b: withE4(t.b) };
    case 'fn':
      return { ...t, a: withE4(t.a) };
    default:
      return t;
  }
}
function exprOf2(atoms) {
  if (!atoms.length) return null;
  try {
    const p = parseStatement(atomsText(atoms));
    return p.ok && p.s.k === 'expr' ? withE4(p.s.e) : null;
  } catch {
    return null;
  }
}
function exprOfText3(text) {
  try {
    return exprOf2(normalize(lex(text)));
  } catch {
    return null;
  }
}
var keyOf2 = (t) => {
  try {
    return termKey(canon(t));
  } catch {
    return termKey(t);
  }
};
var shapeOf3 = (t) => {
  try {
    return constShapeKey(t);
  } catch {
    return termKey(t);
  }
};
var opsOf3 = (t) => {
  try {
    return constOps(t);
  } catch {
    return 99;
  }
};
function val4(t, env = {}) {
  try {
    const v = withRadianArcs(() => evalFloat(t, env));
    return Number.isFinite(v) ? v : NaN;
  } catch {
    return NaN;
  }
}
var near4 = (a, b, tol = 1e-9) =>
  Number.isFinite(a) &&
  Number.isFinite(b) &&
  Math.abs(a - b) <= tol * Math.max(1, Math.abs(a), Math.abs(b));
var NS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20, 24];
function sumValue(s, n) {
  const lo = val4(s.lo, { n });
  const hi = val4(s.hi, { n });
  const L = Math.round(lo);
  const H = Math.round(hi);
  if (!Number.isFinite(lo) || !Number.isFinite(hi)) return NaN;
  if (Math.abs(lo - L) > 1e-9 || Math.abs(hi - H) > 1e-9 || H - L > 2e4) return NaN;
  let acc = s.sign === '\u03A3' ? 0 : 1;
  for (let k = L; k <= H; k++) {
    const v = val4(s.body, { [s.k]: k, n });
    if (!Number.isFinite(v)) return NaN;
    acc = s.sign === '\u03A3' ? acc + v : acc * v;
  }
  return acc;
}
function formValue2(f, n, extra = {}) {
  const env = { n, ...extra };
  for (const [ph, s] of f.sums) {
    const v = sumValue(s, n);
    if (!Number.isFinite(v)) return NaN;
    env[ph] = v;
  }
  return val4(f.outer, env);
}
function sameSeq(u, v) {
  let ok = 0;
  for (const n of NS) {
    const a = u(n);
    const b = v(n);
    if (Number.isNaN(a) && Number.isNaN(b)) continue;
    if (!near4(a, b)) return false;
    ok++;
  }
  return ok >= 6;
}
var syntaxR = (title, message, index) => ({ k: 'syntax', title, message, index });
var PH = 0;
var sub3 = (d2) =>
  String(d2)
    .split('')
    .map((c) => '\u2080\u2081\u2082\u2083\u2084\u2085\u2086\u2087\u2088\u2089'[Number(c)])
    .join('');
function readSide2(A, offset) {
  const sums = /* @__PURE__ */ new Map();
  const ints = /* @__PURE__ */ new Map();
  const outer2 = [];
  const outerSrc = [];
  for (let i = 0; i < A.length; i++) {
    const a = A[i];
    if (isSumAtom(a)) {
      let j = i + 1;
      let depth2 = 0;
      for (; j < A.length; j++) {
        const b = A[j];
        if (b === '(') depth2++;
        else if (b === ')') {
          if (depth2 === 0) break;
          depth2--;
        } else if (depth2 === 0 && (b === '=' || ((b === '+' || b === '\u2212') && j > i + 1)))
          break;
        if (isSumAtom(b) || isIntegralAtom(b) || b === '[')
          return syntaxR(
            'Une somme \xE0 la fois',
            'Ce qu\u2019on additionne ne contient ni autre somme, ni int\xE9grale.',
            offset + j,
          );
      }
      const term = A.slice(i + 1, j);
      if (!term.length) {
        if (j >= A.length) return { k: 'incomplete' };
        return syntaxR(
          'Ce qu\u2019on additionne',
          'Apr\xE8s \xAB \u03A3(k = 1 ; n) \xBB, \xE9cris le terme de la somme.',
          offset + i,
        );
      }
      const syn2 = checkSyntax(normalize(term));
      if (!syn2.ok)
        return syntaxR(
          '\xC7a commence mal',
          syn2.msg,
          offset + i + 1 + Math.min(syn2.index, term.length - 1),
        );
      if (!syn2.complete) {
        if (j >= A.length) return { k: 'incomplete' };
        return syntaxR(
          '\xC7a ne se lit pas',
          'Le terme de la somme n\u2019est pas fini.',
          offset + j,
        );
      }
      const body = exprOf2(normalize(term));
      const m = SUM_RE.exec(a);
      const lo = exprOfText3(m[3]);
      const hi = exprOfText3(m[4]);
      if (!body || !lo || !hi)
        return syntaxR('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', offset + j - 1);
      const k = m[2];
      if (k === 'n')
        return syntaxR(
          'L\u2019indice',
          'L\u2019indice de la somme n\u2019est pas n : \xE9cris \xAB \u03A3(k = 1 ; n) \xBB.',
          offset + i,
        );
      if ([...symbolsOf(body)].some((s) => s !== k && s !== 'n' && s !== '\u03C0'))
        return syntaxR(
          'Une lettre en trop',
          `Le terme de la somme ne d\xE9pend que de ${k} et de n.`,
          offset + j - 1,
        );
      if ([...symbolsOf(lo), ...symbolsOf(hi)].some((s) => s !== 'n'))
        return syntaxR(
          'Les bornes',
          'Les bornes de la somme ne d\xE9pendent que de n.',
          offset + i,
        );
      const ph = `\u03C3${sub3(++PH)}`;
      sums.set(ph, {
        sign: m[1],
        k,
        lo,
        hi,
        body,
        key: `${m[1]}|${keyOf2(lo)}|${keyOf2(hi)}|${keyOf2(substitute(body, { [k]: { k: 'sym', n: '\u03BA' } }))}`,
      });
      outer2.push(ph);
      outerSrc.push(i);
      i = j - 1;
      continue;
    }
    if (isIntegralAtom(a)) {
      let j = i + 1;
      while (j < A.length && !isDiffAtom(A[j])) {
        if (isIntegralAtom(A[j]) || isSumAtom(A[j]) || A[j] === '[')
          return syntaxR(
            'Ferme l\u2019int\xE9grale',
            'Une int\xE9grale se ferme par \xAB dx \xBB avant d\u2019\xE9crire autre chose.',
            offset + j,
          );
        j++;
      }
      if (j >= A.length) return { k: 'incomplete' };
      const body = A.slice(i + 1, j).filter(
        (x2, k, arr) => !(x2 === '\xD7' && (k === 0 || k === arr.length - 1)),
      );
      if (!body.length)
        return syntaxR(
          'La fonction \xE0 int\xE9grer',
          '\xC9cris la fonction entre \u222B et dx.',
          offset + j,
        );
      const syn2 = checkSyntax(normalize(body));
      if (!syn2.ok)
        return syntaxR(
          '\xC7a commence mal',
          syn2.msg,
          offset + i + 1 + Math.min(syn2.index, body.length - 1),
        );
      if (!syn2.complete)
        return syntaxR('\xC7a ne se lit pas', 'La fonction n\u2019est pas finie.', offset + j);
      const fx = exprOf2(normalize(body));
      const m = /^∫\((.+) ; (.+)\)$/.exec(a);
      const lo = exprOfText3(m[1]);
      const hi = exprOfText3(m[2]);
      const x = /^d([a-zθ])$/.exec(A[j])[1];
      if (!fx || !lo || !hi)
        return syntaxR('\xC7a ne se lit pas', 'V\xE9rifie les parenth\xE8ses.', offset + j);
      if (x === 'n' || x === 'k')
        return syntaxR(
          'La variable',
          `Dans l\u2019int\xE9grale, la variable n\u2019est ni n ni l\u2019indice : \xE9cris \xAB dx \xBB et une fonction de x.`,
          offset + j,
        );
      if ([...symbolsOf(fx)].some((s) => s !== x && s !== '\u03C0'))
        return syntaxR(
          'Une lettre en trop',
          `La fonction \xE0 int\xE9grer ne d\xE9pend que de ${x} : remplace k \xF7 n par ${x}.`,
          offset + j - 1,
        );
      if ([...symbolsOf(lo), ...symbolsOf(hi)].some((s) => s !== '\u03C0'))
        return syntaxR(
          'Les bornes',
          'Les bornes de l\u2019int\xE9grale sont des nombres.',
          offset + i,
        );
      const ph = `\u03C6${sub3(++PH)}`;
      ints.set(ph, {
        lo,
        hi,
        a: val4(lo),
        b: val4(hi),
        x,
        body: fx,
        text: kintText(A.slice(i, j + 1)),
      });
      outer2.push(ph);
      outerSrc.push(i);
      i = j;
      continue;
    }
    if (a === '[' || isBracketClose(a))
      return syntaxR(
        'Un crochet \xE0 part',
        'Calcule l\u2019int\xE9grale sur sa propre ligne : \xAB \u222B(a ; b) \u2026 dx = [ \u2026 ](a ; b) \xBB.',
        offset + i,
      );
    if (isDiffAtom(a))
      return syntaxR(
        '\xAB dx \xBB ferme une int\xE9grale',
        '\xC9cris d\u2019abord \xAB \u222B(a ; b) \xBB, puis la fonction.',
        offset + i,
      );
    outer2.push(a);
    outerSrc.push(i);
  }
  const O = normalize(outer2);
  if (!O.length) return { k: 'incomplete' };
  const syn = checkSyntax(O, { chains: true });
  if (!syn.ok)
    return syntaxR(
      '\xC7a commence mal',
      syn.msg,
      offset + (outerSrc[Math.min(syn.index, outerSrc.length - 1)] ?? 0),
    );
  if (!syn.complete) return { k: 'incomplete' };
  const parts = [[]];
  let depth = 0;
  for (const a of O) {
    if (a === '(') depth++;
    if (a === ')') depth--;
    if (depth === 0 && a === '=') parts.push([]);
    else parts[parts.length - 1].push(a);
  }
  const members = [];
  for (const p of parts) {
    if (!p.length) return { k: 'incomplete' };
    const t = exprOf2(p);
    if (!t)
      return syntaxR(
        '\xC7a ne se lit pas',
        'Un membre ne se lit pas : v\xE9rifie les parenth\xE8ses.',
        offset + A.length - 1,
      );
    const used = symbolsOf(t);
    const ms = new Map([...sums].filter(([ph]) => used.has(ph)));
    const mi = new Map([...ints].filter(([ph]) => used.has(ph)));
    members.push({ outer: t, sums: ms, ints: mi, wkey: formKey(t, ms, mi) });
  }
  return { k: 'ok', members };
}
function formKey(t, sums, ints) {
  const map = {};
  for (const [ph, s] of sums) map[ph] = { k: 'sym', n: `\xAB${s.key}\xBB` };
  for (const [ph, i] of ints) map[ph] = { k: 'sym', n: `\xAB${i.text}\xBB` };
  return shapeOf3(substitute(t, map));
}
function readLine2(A) {
  if (!A.length) return { k: 'empty' };
  const arrows = A.map((a, i) => (a === ARROW ? i : -1)).filter((i) => i >= 0);
  if (arrows.length > 1)
    return syntaxR(
      'Une limite par ligne',
      '\xC9cris une seule fl\xE8che \xAB \u2192 \xBB par ligne.',
      arrows[1],
    );
  if (arrows.length === 1) {
    const i = arrows[0];
    const L = A.slice(0, i);
    const R = A.slice(i + 1);
    if (!L.length)
      return syntaxR(
        'La suite',
        'Avant \xAB \u2192 \xBB, \xE9cris la suite (\xAB S\u2099 \u2192 \u2026 \xBB).',
        i,
      );
    if (L.includes('=') || R.includes('='))
      return syntaxR(
        'Une relation par ligne',
        'Une ligne est une \xE9galit\xE9, ou une limite \xAB S\u2099 \u2192 \u2026 \xBB, pas les deux.',
        i,
      );
    const l = readSide2(L, 0);
    if (l.k !== 'ok') return l;
    if (!R.length) return { k: 'incomplete' };
    const r = readSide2(R, i + 1);
    if (r.k !== 'ok') return r;
    return { k: 'lim', left: l.members[0], right: r.members[0] };
  }
  const s = readSide2(A, 0);
  if (s.k !== 'ok') return s;
  if (s.members.length < 2) return { k: 'noeq' };
  return { k: 'eq', members: s.members };
}
function linearIn(t, ph) {
  const has = (u) => symbolsOf(u).has(ph);
  if (!has(t)) return null;
  switch (t.k) {
    case 'sym':
      return t.n === ph ? num2(1) : null;
    case 'mul': {
      const vary = t.c.filter(has);
      if (vary.length !== 1) return null;
      const inner2 = linearIn(vary[0], ph);
      if (!inner2) return null;
      const rest = t.c.filter((c) => !has(c));
      return rest.length ? { k: 'mul', c: [...rest, inner2] } : inner2;
    }
    case 'div': {
      if (has(t.b)) return null;
      const inner2 = linearIn(t.a, ph);
      return inner2 ? { k: 'div', a: inner2, b: t.b } : null;
    }
    default:
      return null;
  }
}
function affineBounds(s) {
  const fit = (t) => {
    const v1 = val4(t, { n: 1 });
    const v2 = val4(t, { n: 2 });
    if (!Number.isFinite(v1) || !Number.isFinite(v2)) return null;
    const sl = v2 - v1;
    const c = v1 - sl;
    if (Math.abs(sl - Math.round(sl)) > 1e-9 || Math.abs(c - Math.round(c)) > 1e-9) return null;
    for (const n of NS) if (!near4(val4(t, { n }), sl * n + c)) return null;
    return { s: Math.round(sl), c: Math.round(c) };
  };
  const lo = fit(s.lo);
  const hi = fit(s.hi);
  if (!lo || !hi || hi.s <= lo.s || lo.s < 0) return null;
  return { A: lo.s, B: hi.s };
}
var RATIOS2 = [0.061, 0.137, 0.229, 0.318, 0.411, 0.503, 0.597, 0.689, 0.773, 0.857, 0.941];
var pointsOf2 = (a, b) => RATIOS2.map((r) => a + r * (b - a));
function kOverN(body, k, a, b, scale) {
  const at = (x, n) => scale(n) * val4(body, { [k]: x * n, n });
  let ok = 0;
  for (const x of pointsOf2(a, b)) {
    const ref = at(x, 19);
    for (const n of [7, 53, 211]) {
      const v = at(x, n);
      if (Number.isNaN(ref) && Number.isNaN(v)) continue;
      if (!near4(v, ref, 1e-8)) return null;
    }
    if (Number.isFinite(ref)) ok++;
  }
  if (ok < 6) return null;
  return (x) => at(x, 19);
}
function stripInvN(t) {
  const isN = (u) => u.k === 'sym' && u.n === 'n';
  const isInvN = (u) =>
    u.k === 'div' && u.a.k === 'num' && u.a.v.n === 1n && u.a.v.d === 1n && isN(u.b);
  if (t.k === 'div' && isN(t.b)) return t.a;
  if (t.k === 'mul') {
    const i = t.c.findIndex(isInvN);
    if (i >= 0) {
      const rest = t.c.filter((_, j) => j !== i);
      return rest.length === 1 ? rest[0] : { k: 'mul', c: rest };
    }
  }
  return null;
}
function riemOf(f) {
  if (f.sums.size !== 1 || f.ints.size) return null;
  const [ph, s] = [...f.sums][0];
  if (s.sign !== '\u03A3') return null;
  const C = linearIn(f.outer, ph);
  if (!C || [...symbolsOf(C)].some((x) => x !== 'n' && x !== '\u03C0')) return null;
  const bnd = affineBounds(s);
  if (!bnd) return null;
  const { A, B } = bnd;
  const ln = [3, 7, 20].map((n) => val4(C, { n }) * n);
  if (ln.every((v) => near4(v, ln[0])) && !near4(ln[0], 0)) {
    const g = kOverN(s.body, s.k, A, B, () => 1);
    return g ? { lambda: ln[0], a: A, b: B, g } : null;
  }
  const c0 = [3, 7, 20].map((n) => val4(C, { n }));
  if (c0.every((v) => near4(v, c0[0])) && !near4(c0[0], 0)) {
    const inner2 = stripInvN(s.body);
    if (!inner2) return null;
    const g = kOverN(inner2, s.k, A, B, () => 1);
    return g ? { lambda: c0[0], a: A, b: B, g } : null;
  }
  return null;
}
function semRiemOf(f) {
  if (f.sums.size !== 1 || f.ints.size) return null;
  const [ph, s] = [...f.sums][0];
  if (s.sign !== '\u03A3') return null;
  const C = linearIn(f.outer, ph);
  if (!C || [...symbolsOf(C)].some((x) => x !== 'n' && x !== '\u03C0')) return null;
  const bnd = affineBounds(s);
  if (!bnd) return null;
  const g = kOverN(s.body, s.k, bnd.A, bnd.B, (n) => n * val4(C, { n }));
  return g ? { lambda: 1, a: bnd.A, b: bnd.B, g } : null;
}
var prodCount = (f) => [...f.sums.values()].filter((s) => s.sign === '\u03A0').length;
var sumCount = (f) => [...f.sums.values()].filter((s) => s.sign === '\u03A3').length;
function lnPow(f) {
  const prods = new Set([...f.sums].filter(([, s]) => s.sign === '\u03A0').map(([ph]) => ph));
  let found = false;
  const walk = (t) => {
    if (found) return;
    if (t.k === 'fn') {
      if (t.f === 'ln' && t.a.k === 'pow' && [...symbolsOf(t.a.a)].some((s) => prods.has(s)))
        found = true;
      walk(t.a);
    } else if (t.k === 'add' || t.k === 'mul') t.c.forEach(walk);
    else if (t.k === 'div' || t.k === 'pow' || t.k === 'binom') {
      walk(t.a);
      walk(t.b);
    }
  };
  walk(f.outer);
  return found;
}
var boundsKey = (f) =>
  [...f.sums.values()]
    .filter((s) => s.sign === '\u03A3')
    .map((s) => `${keyOf2(s.lo)}|${keyOf2(s.hi)}`)
    .sort()
    .join(',');
function gesture2(F, R) {
  if (F.wkey === R.wkey) return { k: 'same' };
  const steps = [];
  const toSum = prodCount(F) > prodCount(R) && sumCount(R) > sumCount(F);
  if (toSum) {
    if (lnPow(F)) steps.push('logPower');
    steps.push('logProduct');
  } else if (lnPow(F) && !lnPow(R)) steps.push('logPower');
  if (sumCount(F) && sumCount(R) && boundsKey(F) !== boundsKey(R)) steps.push('reindex');
  if (sumCount(F) && !toSum && !riemOf(F) && riemOf(R)) steps.push('rewrite');
  return steps.length ? { k: 'step', steps } : { k: 'flat' };
}
var FORMAT = (v) => {
  if (!Number.isFinite(v)) return '?';
  const r = Math.round(v * 1e4) / 1e4;
  return String(r).replace('.', ',').replace('-', '\u2212');
};
var subjectKey = (t) => keyOf2(t);
function riemannQuestionOf(model) {
  const spec = model.kernel;
  const X = spec.goal.target;
  const A = kriemLineAtoms(spec.start);
  if (A[0] !== X || A[1] !== '=')
    throw new RiemannModelError(
      `Le d\xE9part s\u2019\xE9crit \xAB ${X} = \u03A3(k = 1 ; n) \u2026 \xBB.`,
    );
  const r = readSide2(A.slice(2), 2);
  if (r.k !== 'ok' || r.members.length !== 1)
    throw new RiemannModelError(`D\xE9part illisible : \xAB ${spec.start} \xBB.`);
  const start = r.members[0];
  if (!start.sums.size || start.ints.size)
    throw new RiemannModelError('Le d\xE9part est une somme (ou un produit), sans int\xE9grale.');
  if ([...symbolsOf(start.outer)].some((s) => s !== 'n' && s !== '\u03C0' && !start.sums.has(s)))
    throw new RiemannModelError('Le d\xE9part ne d\xE9pend que de n.');
  const ans = kriemLineAtoms(spec.answer);
  const ai = ans.indexOf(ARROW);
  if (ai < 0 || ans[0] !== X || ai !== 1)
    throw new RiemannModelError(`La r\xE9ponse s\u2019\xE9crit \xAB ${X} \u2192 valeur \xBB.`);
  const answer = exprOf2(ans.slice(ai + 1));
  if (!answer || [...symbolsOf(answer)].some((s) => s !== '\u03C0'))
    throw new RiemannModelError('La r\xE9ponse est une valeur (des nombres, e, \u03C0, ln\u2026).');
  return { X, start, answer };
}
function createKRiemState(model) {
  const spec = model.kernel;
  const q = riemannQuestionOf(model);
  const Xt = { k: 'sym', n: q.X };
  const st = {
    model,
    X: q.X,
    start: q.start,
    startText: kriemText(kriemLineAtoms(spec.start)),
    answer: q.answer,
    answerValue: val4(q.answer),
    answerOps: opsOf3(q.answer),
    forms: /* @__PURE__ */ new Map([[subjectKey(Xt), { subject: Xt, forms: [q.start] }]]),
    lims: /* @__PURE__ */ new Map(),
    subs: [],
    written: /* @__PURE__ */ new Set(),
    givenTexts: /* @__PURE__ */ new Set(),
    path: spec.path ?? [],
    intPath: [],
    traps: [],
    lines: 0,
    concluded: false,
  };
  if (!Number.isFinite(st.answerValue))
    throw new RiemannModelError('La r\xE9ponse n\u2019a pas de valeur.');
  st.givenTexts = new Set(riemannGivenTexts(model).map((t) => kriemText(kriemLineAtoms(t))));
  st.intPath = st.path.filter((t) => isIntegralLine(kriemLineAtoms(t)));
  st.traps = (model.traps ?? []).map((t) => ({
    text: kriemText(kriemLineAtoms(t.line)),
    line: kriemLine(t.line),
    title: t.title ?? 'Attention',
    why: t.why,
  }));
  return st;
}
function riemannGivenTexts(model) {
  return [model.kernel.start, ...(model.givens ?? [])];
}
var defValue = (st, n) => formValue2(st.start, n);
function subjectValue(st, L, n) {
  const x = defValue(st, n);
  if (!Number.isFinite(x)) return NaN;
  return val4(L, { [st.X]: x, n });
}
var truthOf2 = (st, L) => val4(L, { [st.X]: st.answerValue });
function subjectOk(st, f) {
  if (f.sums.size || f.ints.size) return false;
  const s = symbolsOf(f.outer);
  return s.has(st.X) && [...s].every((x) => x === st.X || x === '\u03C0');
}
function formsOf(st, L) {
  const known2 = st.forms.get(subjectKey(L));
  if (known2) return [...known2.forms].reverse();
  const out = [];
  const x = st.forms.get(subjectKey({ k: 'sym', n: st.X }));
  for (const F of [...x.forms].reverse()) {
    const outer2 = substitute(L, { [st.X]: F.outer });
    out.push({ outer: outer2, sums: F.sums, ints: F.ints, wkey: formKey(outer2, F.sums, F.ints) });
  }
  return out;
}
function stepVerdict4(base, steps, move, final) {
  const uniq = [...new Set(steps)];
  const hora = uniq.reduce((s, k) => s + STEP5[k].hora, 0);
  let main = uniq[0];
  for (const k of uniq) if (STEP5[k].hora > STEP5[main].hora) main = k;
  const label =
    uniq.includes('logPower') && uniq.includes('logProduct')
      ? [
          'Passer au logarithme',
          ...uniq.filter((k) => k !== 'logPower' && k !== 'logProduct').map((k) => STEP5[k].label),
        ].join(' \u2192 ')
      : uniq.map((k) => STEP5[k].label).join(' \u2192 ');
  const why = uniq.map((k) => STEP5[k].why).join(' ') + (final ? ' C\u2019est la r\xE9ponse.' : '');
  return {
    kind: 'step',
    ...base,
    hora,
    final,
    rule: { id: RIEMANN_STEP_IDS[main], card: CARD5, label, hora, why },
    rmove: move,
  };
}
function jumpVerdict4(base, move, final, message) {
  return {
    kind: 'useless',
    ...base,
    jump: true,
    final,
    title: final ? 'Juste !' : 'Juste, mais tu sautes des \xE9tapes',
    message:
      message ??
      (final
        ? 'C\u2019est la bonne limite. D\xE9taille ton calcul, une \xE9tape par ligne, pour gagner des HORA. Tu peux garder cette ligne sans HORA.'
        : 'Ta ligne est juste. D\xE9taille-la, une \xE9tape \xE0 la fois, pour gagner des HORA. Tu peux la garder sans HORA.'),
    ...(move ? { rmove: move } : {}),
  };
}
function trapOr3(st, base, why) {
  const text = kriemText(base.atoms);
  const t = st.traps.find((t2) => t2.text === text);
  if (t)
    return {
      kind: 'trap',
      ...base,
      title: t.title,
      message: t.why,
      trap: { line: t.line, title: t.title, why: t.why },
    };
  return { kind: 'false', ...base, ...why };
}
function subjectName(st, L) {
  return L.k === 'sym' ? L.n : `cette expression de ${st.X}`;
}
function diagnoseEq(st, L, R) {
  const lv = (n) => subjectValue(st, L, n);
  const rv = (n) => formValue2(R, n);
  const ratio = NS.map((n) => rv(n) / lv(n)).filter((v) => Number.isFinite(v));
  const name2 = subjectName(st, L);
  if (ratio.length >= 6) {
    const byN = NS.map((n) => rv(n) / lv(n) / n).filter((v) => Number.isFinite(v));
    const timesN = NS.map((n) => (rv(n) / lv(n)) * n).filter((v) => Number.isFinite(v));
    if (byN.length >= 6 && byN.every((v) => near4(v, 1, 1e-7)))
      return {
        title: 'Un facteur n de trop',
        message: `Ton \xE9criture vaut n fois ${name2} : il y a un facteur n de trop.`,
      };
    if (timesN.length >= 6 && timesN.every((v) => near4(v, 1, 1e-7)))
      return {
        title: 'Il manque un facteur n',
        message: `Ton \xE9criture vaut ${name2} \xF7 n : il manque un facteur n (si tu sors 1 \xF7 n de la somme, multiplie ce qu\u2019il reste par n).`,
      };
    if (ratio.every((v) => near4(v, ratio[0], 1e-7)) && !near4(ratio[0], 1))
      return {
        title: 'Un facteur ne va pas',
        message: `Ton \xE9criture vaut ${FORMAT(ratio[0])} fois ${name2}.`,
      };
  }
  return {
    title: 'Ce n\u2019est pas \xE9gal',
    message: `Pour n = 3, ${name2} vaut ${FORMAT(lv(3))} et ton \xE9criture ${FORMAT(rv(3))}.`,
  };
}
function judgeEq2(st, base, members) {
  const text = kriemText(base.atoms);
  if (st.givenTexts.has(text))
    return {
      kind: 'useless',
      ...base,
      title: 'C\u2019est l\u2019\xE9nonc\xE9',
      message: 'Cette ligne est d\xE9j\xE0 dans l\u2019\xE9nonc\xE9.',
    };
  const left = members[0];
  if (!subjectOk(st, left))
    return {
      kind: 'unjustified',
      ...base,
      title: `Pars de ${st.X}`,
      message: `\xC9cris \xAB ${st.X} = \u2026 \xBB (ou \xAB ln(${st.X}) = \u2026 \xBB).`,
    };
  const L = left.outer;
  for (const R of members.slice(1)) {
    if (R.ints.size)
      return {
        kind: 'false',
        ...base,
        title: 'Une limite, pas une \xE9galit\xE9',
        message: `${subjectName(st, L)} n\u2019est pas \xE9gale \xE0 une int\xE9grale : elle tend vers elle. \xC9cris \xAB ${st.X} \u2192 \u222B(\u2026) \u2026 dx \xBB.`,
      };
    if (symbolsOf(R.outer).has(st.X))
      return {
        kind: 'unjustified',
        ...base,
        title: 'Une \xE9criture de la suite',
        message: `\xC0 droite du \xAB = \xBB, \xE9cris la suite avec n (une somme, un produit), sans ${st.X}.`,
      };
    if ([...symbolsOf(R.outer)].some((x) => x !== 'n' && x !== '\u03C0' && !R.sums.has(x)))
      return {
        kind: 'syntax',
        ...base,
        title: 'Une lettre en trop',
        message: 'Hors de la somme, l\u2019\xE9criture ne d\xE9pend que de n.',
      };
  }
  for (let i = 1; i < members.length; i++) {
    const R = members[i];
    if (
      !sameSeq(
        (n) => subjectValue(st, L, n),
        (n) => formValue2(R, n),
      )
    )
      return trapOr3(st, base, diagnoseEq(st, L, R));
  }
  const skey = subjectKey(L);
  const move = { k: 'eq', skey, subject: L, forms: members.slice(1), text };
  const steps = [];
  let same = 0;
  let flat = 0;
  for (let i = 1; i < members.length; i++) {
    const T = members[i];
    let g = null;
    if (i === 1) {
      for (const S of formsOf(st, L)) {
        const h = gesture2(S, T);
        if (h.k === 'step') {
          g = h;
          break;
        }
        if (!g || h.k === 'same') g = h;
      }
    } else g = gesture2(members[i - 1], T);
    if (!g) continue;
    if (g.k === 'step') steps.push(...g.steps);
    else if (g.k === 'same') same++;
    else flat++;
  }
  if (!steps.length)
    return {
      kind: 'useless',
      ...base,
      title: same && !flat ? 'Rien de nouveau' : 'Juste, mais \xE7a ne t\u2019avance pas',
      message:
        same && !flat
          ? 'Cette \xE9criture est d\xE9j\xE0 sur ta feuille.'
          : 'Les deux \xE9critures sont \xE9gales, mais le calcul n\u2019avance pas : vise (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
      rmove: move,
    };
  return stepVerdict4(base, steps, move, false);
}
function intMatches(I, coef2, r) {
  const sameBounds2 = near4(I.a, r.a) && near4(I.b, r.b);
  const f = (x) => coef2 * val4(I.body, { [I.x]: x });
  const fx = pointsOf2(r.a, r.b);
  const eq2 = (h) => {
    let ok = 0;
    for (const x of fx) {
      const u = h(x);
      const v = r.lambda * r.g(x);
      if (Number.isNaN(u) && Number.isNaN(v)) continue;
      if (!near4(u, v, 1e-8)) return false;
      ok++;
    }
    return ok >= 6;
  };
  const sameFn2 = eq2(f);
  if (sameBounds2 && sameFn2) return 'yes';
  if (sameFn2) return 'bounds';
  if (sameBounds2) {
    const ratios = fx.map((x) => f(x) / (r.lambda * r.g(x))).filter((v) => Number.isFinite(v));
    if (ratios.length >= 6 && ratios.every((v) => near4(v, ratios[0], 1e-8))) return 'coef';
    return 'fn';
  }
  return 'no';
}
function boundsText(r) {
  return `k \xF7 n va de ${FORMAT(r.a)} \xE0 ${FORMAT(r.b)}`;
}
function judgeLimIntegral(st, base, L, R) {
  const text = kriemText(base.atoms);
  if (R.ints.size !== 1 || R.sums.size)
    return {
      kind: 'syntax',
      ...base,
      title: 'Une int\xE9grale',
      message:
        '\xC0 droite de la fl\xE8che, \xE9cris une int\xE9grale (\xE9ventuellement multipli\xE9e par un nombre).',
    };
  const [ph, I] = [...R.ints][0];
  const C = linearIn(R.outer, ph);
  if (!C || [...symbolsOf(C)].some((x) => x !== '\u03C0'))
    return {
      kind: 'syntax',
      ...base,
      title: 'Une int\xE9grale',
      message:
        'L\u2019int\xE9grale se multiplie par un nombre ; elle ne se met pas dans une fonction.',
    };
  const coef2 = val4(C);
  const value = coef2 * integrateNum((x) => val4(I.body, { [I.x]: x }), I.a, I.b);
  const truth = truthOf2(st, L);
  const forms = formsOf(st, L);
  const riems = forms.map(riemOf).filter((r) => !!r);
  const sems = forms.map(semRiemOf).filter((r) => !!r);
  if (!near4(value, truth, 1e-7)) {
    for (const r of [...riems, ...sems]) {
      const m = intMatches(I, coef2, r);
      if (m === 'bounds')
        return trapOr3(st, base, {
          title: 'Les bornes',
          message: `La fonction est la bonne, pas les bornes : ${boundsText(r)}.`,
        });
      if (m === 'fn')
        return trapOr3(st, base, {
          title: 'Pas la bonne fonction',
          message:
            'Les bornes vont ; pour la fonction, remplace k \xF7 n par x dans ce qu\u2019on additionne.',
        });
      if (m === 'coef')
        return trapOr3(st, base, {
          title: 'Le coefficient',
          message:
            'La fonction et les bornes vont, pas le nombre devant : regarde le facteur devant la somme.',
        });
    }
    return trapOr3(st, base, {
      title: 'Ce n\u2019est pas la limite',
      message: riems.length
        ? 'Remplace k \xF7 n par x dans ce qu\u2019on additionne, et regarde les valeurs de k \xF7 n pour les bornes.'
        : 'Fais d\u2019abord appara\xEEtre une somme de Riemann : (1 \xF7 n) \xD7 \u03A3 f(k \xF7 n).',
    });
  }
  const move = {
    k: 'riem',
    skey: subjectKey(L),
    subject: L,
    value,
    int: I.text,
    coef: coef2,
    text,
  };
  const lim = st.lims.get(subjectKey(L));
  if (lim?.ints.some((i) => st.subs[i.sub]?.text === I.text && near4(i.coef, coef2)))
    return {
      kind: 'useless',
      ...base,
      title: 'Rien de nouveau',
      message: 'Cette limite est d\xE9j\xE0 sur ta feuille.',
    };
  if (riems.some((r) => intMatches(I, coef2, r) === 'yes'))
    return stepVerdict4(base, ['riemann'], move, false);
  if (sems.some((r) => intMatches(I, coef2, r) === 'yes'))
    return jumpVerdict4(
      base,
      move,
      false,
      `Juste, mais fais d\u2019abord appara\xEEtre la somme de Riemann : \xE9cris \xAB ${st.X} = (1 \xF7 n) \xD7 \u03A3\u2026 \xBB avec ce qu\u2019on additionne fonction de k \xF7 n.`,
    );
  return jumpVerdict4(
    base,
    move,
    false,
    'Juste, mais \xE9cris l\u2019int\xE9grale qui vient de la somme : remplace k \xF7 n par x.',
  );
}
function judgeLimValue(st, base, L, R) {
  const text = kriemText(base.atoms);
  if (R.sums.size || symbolsOf(R.outer).has('n') || symbolsOf(R.outer).has(st.X))
    return {
      kind: 'false',
      ...base,
      title: 'Une limite ne d\xE9pend pas de n',
      message: '\xC0 droite de la fl\xE8che, \xE9cris un nombre (ou une int\xE9grale), sans n.',
    };
  const t = R.outer;
  const v = val4(t);
  const truth = truthOf2(st, L);
  const skey = subjectKey(L);
  const isX = L.k === 'sym' && L.n === st.X;
  const final = isX && near4(v, st.answerValue) && opsOf3(t) <= st.answerOps;
  if (!near4(v, truth, 1e-9)) {
    const lim2 = st.lims.get(skey);
    if (lim2?.ints.length) {
      const i = lim2.ints[0];
      const sv = st.subs[i.sub]?.value ?? NaN;
      if (near4(v, sv) && !near4(i.coef, 1))
        return trapOr3(st, base, {
          title: 'Le coefficient',
          message: `${subjectName(st, L)} tend vers ${FORMAT(i.coef)} fois l\u2019int\xE9grale : n\u2019oublie pas le nombre devant.`,
        });
    }
    return trapOr3(st, base, {
      title: 'Ce n\u2019est pas la limite',
      message: 'Ce nombre n\u2019est pas la limite : calcule l\u2019int\xE9grale, puis conclus.',
    });
  }
  const move = { k: 'val', skey, subject: L, value: v, t, text, final };
  const lim = st.lims.get(skey);
  if (lim?.writings.length) {
    const wk = shapeOf3(t);
    if (lim.writings.some((w) => w.wkey === wk))
      return {
        kind: 'useless',
        ...base,
        title: 'Rien de nouveau',
        message: 'Cette limite est d\xE9j\xE0 sur ta feuille.',
      };
    const o = opsOf3(t);
    const best = Math.min(...lim.writings.map((w) => w.ops));
    if (o < best) {
      if (best - o > 4) return jumpVerdict4(base, move, final);
      return stepVerdict4(base, ['compute'], move, final);
    }
    return {
      kind: 'useless',
      ...base,
      title: 'Juste, mais \xE7a ne t\u2019avance pas',
      message:
        'Les deux \xE9critures de la limite sont \xE9gales, mais le calcul n\u2019avance pas.',
      rmove: move,
      final,
    };
  }
  if (lim?.ints.length) {
    const computed = lim.ints.some((i) => st.subs[i.sub] && kintStartComputed(st.subs[i.sub].ks));
    if (computed) return stepVerdict4(base, ['conclude'], move, final);
    return jumpVerdict4(
      base,
      move,
      final,
      'Juste, mais calcule d\u2019abord l\u2019int\xE9grale sur ta feuille : \xAB \u222B(\u2026) \u2026 dx = \u2026 \xBB.',
    );
  }
  for (const [, M] of st.lims) {
    if (!M.writings.length) continue;
    const isExpOf = sameSeq(
      (n) => subjectValue(st, L, n),
      (n) => Math.exp(subjectValue(st, M.subject, n)),
    );
    if (!isExpOf) continue;
    const isExpForm = t.k === 'fn' && t.f === 'exp' && near4(val4(t.a), M.value);
    if (isExpForm) return stepVerdict4(base, ['compose'], move, final);
    return jumpVerdict4(
      base,
      move,
      final,
      'Juste, mais une \xE9tape \xE0 la fois : compose d\u2019abord par exp, \xAB \u2026 \u2192 e^(\u2026) \xBB, puis calcule.',
    );
  }
  return jumpVerdict4(base, move, final);
}
function isIntegralLine(A) {
  return !!A.length && (isIntegralAtom(A[0]) || A[0] === '[' || NAME_RE2.test(A[0]));
}
var fmtDec = (v) => {
  const s = v.toFixed(12).replace(/0+$/, '').replace(/\.$/, '');
  return s.replace('.', ',').replace('-', '\u2212');
};
function makeSub(st, text) {
  const A = kriemLineAtoms(text);
  const r = readSide2(A, 0);
  if (r.k !== 'ok' || r.members.length !== 1 || r.members[0].ints.size !== 1)
    throw new RiemannModelError(`Int\xE9grale illisible : \xAB ${text} \xBB.`);
  const I = [...r.members[0].ints.values()][0];
  const value = integrateNum((x) => val4(I.body, { [I.x]: x }), I.a, I.b);
  const model = {
    ...st.model,
    symbols: { I: {} },
    goal: ['I'],
    traps: [],
    choices: void 0,
    givens: void 0,
    kernel: {
      plugin: 'integral',
      goal: { kind: 'integrate', target: 'I' },
      start: `I = ${I.text}`,
      answer: `I = ${fmtDec(value)}`,
      path: [`I = ${I.text}`],
    },
  };
  const out = { ks: createKIntState(model), text: I.text, value };
  out.ks.path = st.intPath.map((t) => subText(out, t));
  return out;
}
function leadIntegral(A) {
  if (!isIntegralAtom(A[0])) return null;
  const j = A.findIndex(isDiffAtom);
  return j > 0 ? kintText(A.slice(0, j + 1)) : null;
}
function expectedIntegral(st, text) {
  const A = kriemLineAtoms(text);
  const r = readSide2(A, 0);
  if (r.k !== 'ok' || r.members.length !== 1 || r.members[0].ints.size !== 1) return false;
  const I = [...r.members[0].ints.values()][0];
  for (const { forms } of st.forms.values())
    for (const F of forms) {
      const rr = riemOf(F) ?? semRiemOf(F);
      if (!rr) continue;
      const m = intMatches(I, 1, rr);
      if (m === 'yes') return true;
      if (m === 'coef' || m === 'fn') {
        const g = { ...rr, lambda: 1 };
        if (intMatches(I, 1, g) === 'yes') return true;
      }
    }
  return false;
}
var RANK = {
  step: 10,
  ready: 9,
  useless: 7,
  building: 6,
  pending: 5,
  open: 4,
  unjustified: 3,
  trap: 2,
  false: 1,
  syntax: 0,
  empty: -1,
};
var scoreOf = (v) =>
  RANK[v.kind] * 100 + (v.hora ?? 0) + (v.kind === 'useless' ? (v.jump ? 20 : 10) : 0);
var orphan = (v) =>
  v.kind === 'unjustified' && (v.title === 'Pas dans ton calcul' || v.title === 'Pars de I');
function subLine(sub4, A) {
  const lead = leadIntegral(A);
  if (lead !== sub4.text) return { atoms: A, shift: 0 };
  const j = A.findIndex(isDiffAtom);
  return { atoms: ['I', ...A.slice(j + 1)], shift: j };
}
var subText = (sub4, text) => {
  try {
    const { atoms } = subLine(sub4, kriemLineAtoms(text));
    return kintText(atoms);
  } catch {
    return text;
  }
};
function wrapInt(v, A, shift, badChip, sub4, fresh) {
  const out = {
    ...v,
    atoms: A,
    final: false,
  };
  delete out.imove;
  if (v.line) out.line = lineOf4(A);
  if (v.badChip !== void 0 && v.badChip >= 0)
    out.badChip = badChip(v.badChip === 0 ? 0 : v.badChip + shift);
  if (out.rule)
    out.rule = { ...out.rule, why: out.rule.why.replace(' C\u2019est la r\xE9ponse.', '') };
  if (v.kind === 'step' || v.kind === 'useless' || v.kind === 'ready')
    out.rmove = { k: 'int', sub: sub4, ...(fresh ? { fresh } : {}), v, text: kriemText(A) };
  return out;
}
function waiting(st, A, v, real) {
  if (!(v.kind === 'ready' || (v.kind === 'building' && v.complete)) || knownPrefix4(st, A))
    return v;
  if (real.kind === 'unjustified' || real.kind === 'false')
    return { ...real, kind: 'pending', complete: true };
  return real;
}
function judgeIntegral(st, A, badChip, opts) {
  let best = null;
  for (let i = 0; i < st.subs.length; i++) {
    const sl = subLine(st.subs[i], A);
    const chips = chipsOf(sl.atoms);
    const real = kintJudge(st.subs[i].ks, chips, { verify: true });
    if (orphan(real)) continue;
    const v = opts?.verify ? real : waiting(st, A, kintJudge(st.subs[i].ks, chips, opts), real);
    if (!best || scoreOf(v) > scoreOf(best.v)) best = { i, v, shift: sl.shift };
  }
  if (best) return wrapInt(best.v, A, best.shift, badChip, best.i);
  const lead = leadIntegral(A);
  if (lead && expectedIntegral(st, lead)) {
    try {
      const s = makeSub(st, lead);
      const sl = subLine(s, A);
      const chips = chipsOf(sl.atoms);
      const v = opts?.verify
        ? kintJudge(s.ks, chips, opts)
        : waiting(st, A, kintJudge(s.ks, chips, opts), kintJudge(s.ks, chips, { verify: true }));
      return wrapInt(v, A, sl.shift, badChip, -1, lead);
    } catch {}
  }
  const last = A[A.length - 1];
  const complete = A.includes('=') && (endsOp2(last) || isDiffAtom(last) || isBracketClose(last));
  if (!opts?.verify && !complete) return { kind: 'open', atoms: A, complete: false };
  return {
    kind: opts?.verify ? 'unjustified' : 'pending',
    atoms: A,
    line: lineOf4(A),
    complete: true,
    title: 'D\u2019o\xF9 vient cette int\xE9grale ?',
    message: `\xC9cris d\u2019abord la limite de ${st.X} comme une int\xE9grale : \xAB ${st.X} \u2192 \u222B(\u2026) \u2026 dx \xBB.`,
  };
}
function knownPrefix4(st, A) {
  return st.path.some((t) => {
    let atoms;
    try {
      atoms = kriemNormalize(kriemLineAtoms(t)).atoms;
    } catch {
      return false;
    }
    if (st.written.has(kriemText(atoms))) return false;
    return atoms.length > A.length && A.every((a, i) => atoms[i] === a);
  });
}
function kriemJudge(st, chips, opts) {
  const raw = chips.flatMap((c) => c.atoms);
  const chipOf = [];
  chips.forEach((c, ci) => c.atoms.forEach(() => chipOf.push(ci)));
  const norm = kriemNormalize(raw);
  const A = norm.atoms;
  if (!A.length) return { kind: 'empty', atoms: A, badChip: -1 };
  if (isIntegralLine(A))
    return judgeIntegral(
      st,
      A,
      (i) => chipOf[norm.src[i] ?? raw.length - 1] ?? chips.length - 1,
      opts,
    );
  const prefix = knownPrefix4(st, A);
  const incomplete = () =>
    opts?.verify
      ? { kind: 'syntax', atoms: A, title: 'Ligne inachev\xE9e', message: 'Termine ta ligne.' }
      : { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  const r = readLine2(A);
  if (r.k === 'empty') return { kind: 'empty', atoms: A, badChip: -1 };
  if (r.k === 'incomplete') return incomplete();
  if (r.k === 'syntax') {
    if (prefix && !opts?.verify) return { kind: 'building', atoms: A, complete: false };
    return {
      kind: 'syntax',
      atoms: A,
      title: r.title,
      message: r.message,
      badChip: chipOf[norm.src[r.index] ?? raw.length - 1] ?? chips.length - 1,
    };
  }
  if (r.k === 'noeq') {
    if (opts?.verify)
      return {
        kind: 'syntax',
        atoms: A,
        line: lineOf4(A),
        title: 'Une \xE9galit\xE9 ou une limite',
        message: `\xC9cris \xAB ${st.X} = \u2026 \xBB ou \xAB ${st.X} \u2192 \u2026 \xBB.`,
      };
    return { kind: prefix ? 'building' : 'open', atoms: A, complete: false };
  }
  const base = { atoms: A, line: lineOf4(A) };
  let v;
  if (r.k === 'eq') v = judgeEq2(st, base, r.members);
  else if (!subjectOk(st, r.left))
    v = {
      kind: 'unjustified',
      ...base,
      title: `Pars de ${st.X}`,
      message: `\xC9cris \xAB ${st.X} \u2192 \u2026 \xBB (ou \xAB ln(${st.X}) \u2192 \u2026 \xBB).`,
    };
  else if (r.right.ints.size) v = judgeLimIntegral(st, base, r.left.outer, r.right);
  else v = judgeLimValue(st, base, r.left.outer, r.right);
  if (prefix && !opts?.verify) {
    if (v.kind === 'step') return { ...v, kind: 'ready', complete: true };
    return { kind: 'building', atoms: A, complete: true };
  }
  if (!opts?.verify && (v.kind === 'unjustified' || v.kind === 'false'))
    return { kind: 'pending', atoms: A, complete: true };
  return { ...v, complete: true };
}
function kriemCommit(st, v) {
  const m = v.rmove;
  if (!m) return;
  st.written.add(m.text);
  st.lines++;
  if (m.k === 'int') {
    let i = m.sub;
    if (i < 0 && m.fresh) {
      const s2 = makeSub(st, m.fresh);
      st.subs.push(s2);
      i = st.subs.length - 1;
    }
    const s = st.subs[i];
    if (s) kintCommit(s.ks, m.v);
    return;
  }
  if (m.k === 'eq') {
    const cur = st.forms.get(m.skey) ?? {
      subject: m.subject,
      forms: formsOf(st, m.subject).reverse(),
    };
    cur.forms.push(...m.forms);
    st.forms.set(m.skey, cur);
    return;
  }
  const lim = st.lims.get(m.skey) ?? {
    subject: m.subject,
    value: m.value,
    ints: [],
    writings: [],
  };
  if (m.k === 'riem') {
    let i = st.subs.findIndex((s) => s.text === m.int);
    if (i < 0) {
      try {
        st.subs.push(makeSub(st, m.int));
        i = st.subs.length - 1;
      } catch {
        i = -1;
      }
    }
    if (i >= 0) lim.ints.push({ sub: i, coef: m.coef });
  } else {
    lim.writings.push({ t: m.t, wkey: shapeOf3(m.t), ops: opsOf3(m.t) });
    if (m.final) st.concluded = true;
  }
  st.lims.set(m.skey, lim);
}
function kriemGoalReached(st) {
  return st.concluded;
}
function readText3(text) {
  try {
    return readLine2(kriemLineAtoms(text));
  } catch {
    return null;
  }
}
function kriemIsAnswer(st, text) {
  const r = readText3(text);
  if (!r || r.k !== 'lim') return false;
  const L = r.left.outer;
  if (!(L.k === 'sym' && L.n === st.X)) return false;
  if (r.right.sums.size || r.right.ints.size || symbolsOf(r.right.outer).has('n')) return false;
  return near4(val4(r.right.outer), st.answerValue);
}
export {
  createKIntState,
  createKOdeState,
  createKPartState,
  createKRiemState,
  kintCommit,
  kintGoalReached,
  kintIsAnswer,
  kintJudge,
  kintLineAtoms,
  kodeAnswerWritten,
  kodeCommit,
  kodeGoalReached,
  kodeIsAnswer,
  kodeJudge,
  kodeLineAtoms,
  kpartCommit,
  kpartGoalReached,
  kpartIsAnswer,
  kpartJudge,
  kpartLineAtoms,
  kriemCommit,
  kriemGoalReached,
  kriemIsAnswer,
  kriemJudge,
  kriemLineAtoms,
};
